
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("kxxIM", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteIntegration", () => $03fce0b364830eb1$export$eb6ccee20cc51d7b);

var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $hbE7z = parcelRequire("hbE7z");
var $gCtL7 = parcelRequire("gCtL7");

var $gITaz = parcelRequire("gITaz");

var $52i70 = parcelRequire("52i70");

var $azJRA = parcelRequire("azJRA");

var $kGQen = parcelRequire("kGQen");

var $guiFP = parcelRequire("guiFP");

var $bKxX9 = parcelRequire("bKxX9");

var $5JgJ2 = parcelRequire("5JgJ2");


var $jnUZa = parcelRequire("jnUZa");

var $lq8s9 = parcelRequire("lq8s9");

var $b4jyX = parcelRequire("b4jyX");

var $aVGC7 = parcelRequire("aVGC7");

var $gVlMC = parcelRequire("gVlMC");

var $5bGMz = parcelRequire("5bGMz");

var $aPuGw = parcelRequire("aPuGw");

var $cGl0F = parcelRequire("cGl0F");

var $fRDll = parcelRequire("fRDll");
const $03fce0b364830eb1$export$eb6ccee20cc51d7b = (props)=>{
    // eslint-disable-next-line jira/react-magnetic-di/no-unneeded
    (0, $asu8X.di)((0, $kGQen.default));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ isOpen: isOpen }] = (0, $gCtL7.useCommandPaletteIsOpen)();
    const { quickSearchCommand: quickSearchCommand } = (0, $52i70.useQuickSearchCommand)({
        keepSearch: true
    });
    (0, $azJRA.useCommandPaletteRegistry)();
    const onErrorAnalytics = (0, $eUqFw.useCallback)((attribution, error, id, attributes)=>{
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: `jira.commandPalette.${id}`,
                packageName: 'jiraCommandPaletteIntegration',
                teamName: attribution || 'deliveroo'
            },
            attributes: attributes
        });
    }, []);
    (0, $gVlMC.useRegisterSections)();
    (0, $aVGC7.useRegisterDismissCommand)();
    (0, $jnUZa.useCloseDotMenu)();
    (0, $b4jyX.useDisableCompalIfEmbed)();
    (0, $aPuGw.useRegisterInitialCommands)();
    if ((0, $bKxX9.ff)('compal-sunset-and-remove-dot-menu_66j8q')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $lq8s9.useCompalBridge)();
    const Wrapper = isOpen ? (0, $kGQen.default) : (0, $eUqFw.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": (0, $a4122e01fb37b64d$export$70d2130cb02f61fa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hbE7z.CommandPaletteModal), {
        defaultFooterContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5bGMz.FooterFeedbackContent), null),
        onAnalytics: (0, $gITaz.handleAnalytics),
        onErrorAnalytics: onErrorAnalytics,
        defaultPlaceholder: (0, $bKxX9.ff)('compal-issue-actions-very-high-priority_f5w5r') ? formatMessage((0, $cGl0F.messages).defaultPlaceholder) : formatMessage((0, $cGl0F.messages).defaultPlaceholderWithQuickSearch, {
            searchModeIcon: '"/"'
        }),
        defaultFallback: {
            onError: {
                label: formatMessage((0, $cGl0F.messages).onErrorFallback)
            },
            onNoResults: {
                label: formatMessage((0, $cGl0F.messages).noResultsFound)
            }
        },
        rootFallback: {
            label: formatMessage((0, $cGl0F.messages).noResultsFound),
            fallbackCommand: quickSearchCommand,
            fallbackSection: {
                name: formatMessage((0, $cGl0F.messages).recommendedSection)
            }
        },
        ...props
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fRDll.RegisterDynamicCommands), null)));
};

});
parcelRegister("hbE7z", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteModal", () => $af6fe0e00b2b0f62$export$9b347310d90ce55);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $aOw1G = parcelRequire("aOw1G");
var $dxopF = parcelRequire("dxopF");

var $5JgJ2 = parcelRequire("5JgJ2");

var $duQ8C = parcelRequire("duQ8C");

var $ftpwV = parcelRequire("ftpwV");

var $gCtL7 = parcelRequire("gCtL7");


var $beEi4 = parcelRequire("beEi4");

var $IiyBk = parcelRequire("IiyBk");

var $2eeKm = parcelRequire("2eeKm");
const $af6fe0e00b2b0f62$export$9b347310d90ce55 = ({ defaultPlaceholder: defaultPlaceholder, defaultFooterContent: defaultFooterContent, onAnalytics: onAnalytics, onErrorAnalytics: onErrorAnalytics, defaultFallback: defaultFallback, rootFallback: rootFallback })=>{
    const [{ commandPaletteSessionId: commandPaletteSessionId, isOpen: isOpen, hasPopupOverlay: hasPopupOverlay }, { close: close, markAsLoaded: markAsLoaded, setAnalytics: setAnalytics }] = (0, $gCtL7.useCommandPalette)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        setAnalytics(onAnalytics, onErrorAnalytics);
    }, [
        onAnalytics,
        onErrorAnalytics,
        setAnalytics
    ]);
    const sendAnalyticsEvent = (0, $eUqFw.useCallback)((action)=>{
        const ev = createAnalyticsEvent({
            action: action,
            actionSubject: 'commandPalette'
        });
        if (onAnalytics) onAnalytics(ev, (0, $ftpwV.UI_EVENT_TYPE), {
            attributes: {
                commandPaletteSessionId: commandPaletteSessionId
            }
        });
    }, [
        commandPaletteSessionId,
        createAnalyticsEvent,
        onAnalytics
    ]);
    const onEscPressed = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Escape' && isOpen) {
            event.preventDefault();
            event.stopPropagation();
            sendAnalyticsEvent('closed');
            (0, $duQ8C.default)('command-palette-closed');
            close();
        }
    }, [
        isOpen,
        sendAnalyticsEvent,
        close
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasPopupOverlay) return;
        document.addEventListener('keydown', onEscPressed, true);
        return ()=>{
            document.removeEventListener('keydown', onEscPressed, true);
        };
    }, [
        hasPopupOverlay,
        onEscPressed
    ]);
    (0, $eUqFw.useEffect)(()=>{
        markAsLoaded();
    }, [
        markAsLoaded
    ]);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        sendAnalyticsEvent('closed');
        (0, $duQ8C.default)('command-palette-closed');
        close();
    }, [
        sendAnalyticsEvent,
        close
    ]);
    const onOpenComplete = (0, $eUqFw.useCallback)(()=>{
        sendAnalyticsEvent('viewed');
    }, [
        sendAnalyticsEvent
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onClose,
        shouldCloseOnOverlayClick: true,
        shouldCloseOnEscapePress: true,
        autoFocus: false,
        testId: (0, $c685a56a65b053ee$export$7622d28bacf170d1),
        onOpenComplete: onOpenComplete,
        width: 752,
        isBlanketHidden: true,
        label: formatMessage((0, $beEi4.messages).modalLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eeKm.ModalWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $IiyBk.ModalContent), {
        defaultFallback: defaultFallback,
        rootFallback: rootFallback,
        defaultPlaceholder: defaultPlaceholder,
        defaultFooterContent: defaultFooterContent,
        onClose: onClose
    }))));
};

});
const $c685a56a65b053ee$export$7622d28bacf170d1 = 'command-palette.ui.modal.modal-dialog';

parcelRegister("beEi4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2312a94b8973a812$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $2312a94b8973a812$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    modalLabel: {
        "id": "command-palette.modal.modal-label",
        "defaultMessage": "Command palette modal"
    }
});

});

parcelRegister("IiyBk", function(module, exports) {

$parcel$export(module.exports, "ModalContent", () => $7e2ec997f005079b$export$6da19a24bf249f17);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $jK1pm = parcelRequire("jK1pm");

var $LddR2 = parcelRequire("LddR2");

var $73ZV3 = parcelRequire("73ZV3");

var $gklnd = parcelRequire("gklnd");

var $gCtL7 = parcelRequire("gCtL7");
var $8fRY7 = parcelRequire("8fRY7");

var $3gQ3j = parcelRequire("3gQ3j");

var $2GM9h = parcelRequire("2GM9h");

var $7qtGC = parcelRequire("7qtGC");

var $k46bC = parcelRequire("k46bC");


var $fdlvn = parcelRequire("fdlvn");

var $01XIV = parcelRequire("01XIV");

var $9Z5tL = parcelRequire("9Z5tL");
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $7e2ec997f005079b$var$NOOP = ()=>{};
const $7e2ec997f005079b$export$6da19a24bf249f17 = ({ defaultFallback: defaultFallback, rootFallback: rootFallback, defaultPlaceholder: defaultPlaceholder, defaultFooterContent: defaultFooterContent, onClose: onClose })=>{
    const { total: total, fallback: fallback, results: results, renderAfterCommands: renderAfterCommands, activeCommand: activeCommand } = (0, $8fRY7.useMatches)({
        defaultFallback: defaultFallback,
        rootFallback: rootFallback
    });
    const [{ expandedCommand: expandedCommand }, { setChildCommands: setChildCommands, setLoadingList: setLoadingList }] = (0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r') ? [
        {
            expandedCommand: undefined
        },
        {
            setChildCommands: $7e2ec997f005079b$var$NOOP,
            setLoadingList: $7e2ec997f005079b$var$NOOP
        }
    ] : (0, $gCtL7.useCommandPalette)();
    const [registryData] = (0, $gCtL7.useCommandPaletteRegistryCurrentAttribution)();
    const renderBody = (0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r') ? undefined : ()=>{
        const ExpandedBody = (0, $gklnd.getActiveCommandList)(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.components?.Body || (0, $LddR2.components).Body;
        if (ExpandedBody) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ExpandedBody, {
            setChildResult: setChildCommands,
            setLoading: setLoadingList,
            fallback: fallback,
            results: results,
            total: total,
            renderAfterCommands: renderAfterCommands
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $73ZV3.CommandPaletteBody), {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            fallback: {
                onNoResults: fallback
            },
            results: results,
            total: total,
            renderAfterCommands: renderAfterCommands
        });
    };
    (0, $2GM9h.usePerformPendingCommandOnClose)();
    (0, $3gQ3j.usePerformMode)();
    // Typing as any so we can pass the prop to the UFO Segment using ffs without typescript/react errors
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $01XIV.default), {
        onClose: onClose,
        defaultPlaceholder: defaultPlaceholder,
        results: results,
        activeCommand: activeCommand
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "command-palette-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k46bC.CommandBodyErrorBoundary), {
        teamName: registryData?.registryData?.teamName || 'deliveroo',
        attributes: registryData?.analyticsAttributes,
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $73ZV3.NoResultsContainer), {
                "data-testid": (0, $062cbd8a7bbd6c69$export$3545956e927a0d0a)
            }, fallback?.onError?.renderLabel?.() || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            fallback?.onError?.label),
        expandedCommand: expandedCommand
    }, (0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qtGC.Body), {
        fallback: fallback,
        results: results,
        total: total,
        renderAfterCommands: renderAfterCommands
    }) : renderBody?.())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Z5tL.ScreenReaderContent), {
        activeCommand: activeCommand,
        results: results
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fdlvn.Footer), {
        defaultFooterContent: defaultFooterContent,
        activeCommand: activeCommand
    }));
};

});
parcelRegister("LddR2", function(module, exports) {

$parcel$export(module.exports, "components", () => $de43b6bd284ffa0f$export$9b5ac10f59f76296);

var $eUqFw = parcelRequire("eUqFw");

var $73ZV3 = parcelRequire("73ZV3");

var $gwWoQ = parcelRequire("gwWoQ");

var $b4qUd = parcelRequire("b4qUd");

var $48xUp = parcelRequire("48xUp");
const $de43b6bd284ffa0f$export$9b5ac10f59f76296 = {
    CommandRow: $gwWoQ.CommandRow,
    Name: (0, $eUqFw.Fragment),
    LeftIcon: (0, $eUqFw.Fragment),
    Wrapper: (0, $eUqFw.Fragment),
    Footer: $b4qUd.Footer,
    Body: (0, $73ZV3.CommandPaletteBody),
    Header: $48xUp.Header
};

});
parcelRegister("73ZV3", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteBody", () => $d0ddd4262a5c5e52$export$b1023de69a8756e6);
$parcel$export(module.exports, "NoResultsContainer", () => $d0ddd4262a5c5e52$export$2ab569a6937cb4e4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $bFzGY = parcelRequire("bFzGY");

var $bKxX9 = parcelRequire("bKxX9");

var $eI5EY = parcelRequire("eI5EY");

var $gCtL7 = parcelRequire("gCtL7");

var $8FbYY = parcelRequire("8FbYY");

var $5IPbY = parcelRequire("5IPbY");

var $80x7h = parcelRequire("80x7h");

var $f9a4v = parcelRequire("f9a4v");

var $1c3Ul = parcelRequire("1c3Ul");

var $985MX = parcelRequire("985MX");

var $dDiRc = parcelRequire("dDiRc");

var $4PPUt = parcelRequire("4PPUt");
const $d0ddd4262a5c5e52$export$b1023de69a8756e6 = ({ results: results, total: total, fallback: fallback, renderAfterCommands: renderAfterCommands })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ activeIndex: activeIndex, isSearchFieldFocused: isSearchFieldFocused, loadingList: loadingList, expandedCommand: expandedCommand, search: search, registry: registry, activeRegistry: activeRegistry }, { setActiveIndex: setActiveIndex, executeCommand: executeCommand, removeCommandsById: removeCommandsById }] = (0, $gCtL7.useCommandPalette)();
    const [prevActiveIndex, setPrevActiveIndex] = (0, $eUqFw.useState)(activeIndex);
    const onHoverCommand = (index)=>{
        if (index === undefined) return;
        setActiveIndex(index);
    };
    const onClickCommand = (0, $eUqFw.useCallback)((event, result)=>{
        executeCommand(result.command, {
            method: 'mouse',
            createAnalyticsEvent: createAnalyticsEvent,
            attributes: {
                ...(0, $8FbYY.getAnalyticsAttributesFromResult)(result),
                ...(0, $8FbYY.getRegistryData)(registry, activeRegistry, result?.command.id)
            }
        }, (0, $8FbYY.isSecondaryTrigger)(event));
    }, [
        activeRegistry,
        createAnalyticsEvent,
        executeCommand,
        registry
    ]);
    const onMouseDownCommand = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const resultsRefs = (0, $eUqFw.useRef)([]);
    const modalBodyRef = (0, $eUqFw.useRef)(null);
    const onArrowScroll = (0, $eUqFw.useCallback)((newActiveIndex)=>{
        setActiveIndex(newActiveIndex);
    }, [
        setActiveIndex
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!modalBodyRef.current || prevActiveIndex === activeIndex) return;
        setPrevActiveIndex(activeIndex);
        const scrollTo = activeIndex > prevActiveIndex ? (0, $dDiRc.SCROLL_DIRECTION).END : (0, $dDiRc.SCROLL_DIRECTION).START;
        const scrollToIndex = (0, $4PPUt.getScrollToIndex)(results, activeIndex, scrollTo);
        const scrolledToResult = resultsRefs.current[scrollToIndex];
        if (scrolledToResult && !(0, $4PPUt.isElementVisibleInContainer)(scrolledToResult, modalBodyRef.current)) {
            const lastIndex = results.length - 1;
            const firstIndex = results.findIndex((result)=>!result.isGroup);
            if (lastIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, modalBodyRef.current.scrollHeight);
            else if (firstIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, 0);
            else (0, $4PPUt.scrollResultIntoView)(scrolledToResult, scrollTo);
        }
    }, [
        activeIndex,
        prevActiveIndex,
        results
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!modalBodyRef.current?.scrollTo) return;
        modalBodyRef.current.scrollTo(0, 0);
    }, [
        expandedCommand,
        search
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!isSearchFieldFocused) return ()=>{};
        const handleArrowScroll = (ev)=>{
            if (ev.key === 'ArrowUp') {
                ev.preventDefault();
                activeIndex > 0 && onArrowScroll(activeIndex - 1);
            }
            if (ev.key === 'ArrowDown') {
                ev.preventDefault();
                activeIndex < total - 1 && onArrowScroll(activeIndex + 1);
            }
        };
        window.addEventListener('keydown', handleArrowScroll);
        return ()=>{
            window.removeEventListener('keydown', handleArrowScroll);
        };
    }, [
        isSearchFieldFocused,
        total,
        activeIndex,
        setActiveIndex,
        onArrowScroll
    ]);
    const noResultsFallback = (0, $eUqFw.useMemo)(()=>fallback?.onNoResults?.renderLabel?.() || fallback?.onNoResults?.label, [
        fallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f9a4v.CommandPaletteSearchResultListWrapper), {
        ref: modalBodyRef,
        ...(0, $eI5EY.fg)('a11y_violations_fixes') && {
            noResultsFallback: noResultsFallback
        }
    }, !loadingList && noResultsFallback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0ddd4262a5c5e52$export$2ab569a6937cb4e4, {
        "data-testid": (0, $dDiRc.NO_RESULTS_TEST_ID)
    }, noResultsFallback), results.map((result, index)=>{
        if (result.isGroup) {
            let GroupContainerComponent;
            if ((0, $bKxX9.ff)('compal-issue-actions-very-high-priority_f5w5r')) GroupContainerComponent = $d0ddd4262a5c5e52$var$GroupContainerAfterToken;
            else GroupContainerComponent = $d0ddd4262a5c5e52$var$GroupContainerOld;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5IPbY.CommandPaletteSearchResultGroupItem), {
                ref: (commandRef)=>{
                    if (commandRef) resultsRefs.current[index] = commandRef;
                },
                group: result.group,
                key: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(GroupContainerComponent, {
                "data-testid": (0, $dDiRc.GROUP_TEST_ID),
                isFirstResult: index === 0
            }, result.renderGroup ? result.renderGroup() : result.group));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $985MX.CommandRowErrorBoundary), {
            key: index,
            teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
            onError: ()=>removeCommandsById([
                    result.command.id
                ]),
            attributes: (0, $8FbYY.getRegistryData)(registry, activeRegistry, result?.command.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80x7h.CommandPaletteSearchResultListItem), {
            ref: (commandRef)=>{
                if (commandRef) resultsRefs.current[index] = commandRef;
            },
            id: result.command.id,
            active: result.active,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1c3Ul.CommandRow), {
            index: index,
            isSearchFieldFocused: isSearchFieldFocused,
            result: result,
            onHoverCommand: (ev)=>{
                // Safari is weird and likes to fire mouseover events when the mouse is not moving
                if (ev.movementX === 0 && ev.movementY === 0) return;
                onHoverCommand(result.index);
            },
            onClickCommand: (event)=>onClickCommand(event, result),
            onMouseDownCommand: onMouseDownCommand
        })));
    }), renderAfterCommands?.({}));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d0ddd4262a5c5e52$var$GroupContainerOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_h2xaw7": (0, $9t7rW.default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1skh _k48p1nn1 _syaz1wmz _1p1dangw _1yt41f6d",
            __cmplp.className
        ])
    });
});
const $d0ddd4262a5c5e52$var$GroupContainerAfterToken = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_h2xaw7": (0, $9t7rW.default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81oud _vwz41kw7 _syaz1wmz _1yt41f6d",
            __cmplp.className
        ])
    });
});
const $d0ddd4262a5c5e52$export$2ab569a6937cb4e4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _syaz1e9r _1yt4wd81",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5IPbY", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultGroupItem", () => $43e423a37776a525$export$591c26128e5fd757);

var $eUqFw = parcelRequire("eUqFw");

const $43e423a37776a525$export$591c26128e5fd757 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ group: group, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        "data-testid": (0, $d08d4eae9e022dcf$export$617744f059bfc3ba),
        id: group ? `${0, $d08d4eae9e022dcf$export$f24a36b1556217a1}-${group}` : undefined,
        ...rest
    }));

});
const $d08d4eae9e022dcf$export$5758a25d98c7bb27 = 'compal-listbox';
const $d08d4eae9e022dcf$export$f61172db5aff4b22 = `${$d08d4eae9e022dcf$export$5758a25d98c7bb27}-item`;
const $d08d4eae9e022dcf$export$f24a36b1556217a1 = `${$d08d4eae9e022dcf$export$5758a25d98c7bb27}-group`;
const $d08d4eae9e022dcf$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $d08d4eae9e022dcf$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $d08d4eae9e022dcf$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $d08d4eae9e022dcf$export$65eac2e53f304ab6 = 'compal-listbox-screen-reader';


parcelRegister("80x7h", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListItem", () => $55b21d7cef5b1dbb$export$1f8fa9d1eef77b32);

var $eUqFw = parcelRequire("eUqFw");

const $55b21d7cef5b1dbb$export$1f8fa9d1eef77b32 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ id: id, active: active, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        "data-testid": (0, $d08d4eae9e022dcf$export$617744f059bfc3ba),
        role: "option",
        id: `${(0, $d08d4eae9e022dcf$export$f61172db5aff4b22)}-${id}`,
        "aria-selected": active,
        ...rest
    }));

});

parcelRegister("f9a4v", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListWrapper", () => $d3691614f8dde395$export$95554f6fb39a83c2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");


var $ezG3R = parcelRequire("ezG3R");
const $d3691614f8dde395$export$95554f6fb39a83c2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ noResultsFallback: noResultsFallback, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d3691614f8dde395$var$Wrapper, {
        "data-testid": (0, $d08d4eae9e022dcf$export$85eefac753ab5bdb),
        id: (0, $d08d4eae9e022dcf$export$5758a25d98c7bb27),
        role: noResultsFallback && (0, $eI5EY.fg)('a11y_violations_fixes') ? 'group' : 'listbox',
        ref: ref,
        "aria-label": (0, $1ybV0.ff)('compal-issue-actions-follow-up-improvements_y49xu') ? formatMessage((0, $ezG3R.messages).commandPaletteSearchResultListBoxLabel) : undefined,
        ...props
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d3691614f8dde395$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71l4u42 _18m91wug _vchhusvi _1yt41bpf _1e0c1txw _2lx21bp4 _zulp1b66 _1tke8vuz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ezG3R", function(module, exports) {

$parcel$export(module.exports, "messages", () => $dae431d5b55d597f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $dae431d5b55d597f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    commandPaletteSearchResultListBoxLabel: {
        "id": "command-palette.common.command-palette-search-dropdown.command-palette-search-result-list-wrapper.command-palette-search-result-list-box-label",
        "defaultMessage": "List of commands"
    }
});

});


parcelRegister("1c3Ul", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $673add314e0db490$export$3ef5d254c3c573e3);

var $eUqFw = parcelRequire("eUqFw");

var $8FbYY = parcelRequire("8FbYY");

var $gwWoQ = parcelRequire("gwWoQ");
const $673add314e0db490$export$3ef5d254c3c573e3 = ({ index: index, result: result, isSearchFieldFocused: isSearchFieldFocused, onHoverCommand: onHoverCommand, onClickCommand: onClickCommand, onMouseDownCommand: onMouseDownCommand })=>{
    const { command: command } = result;
    const isActive = !!(result.active && isSearchFieldFocused);
    const isFirstCommand = result.index === 0;
    const rowProps = {
        index: index,
        isActive: isActive,
        command: command,
        isFirstCommand: isFirstCommand,
        onMouseMove: onHoverCommand,
        onClick: onClickCommand,
        onMouseDown: onMouseDownCommand,
        analyticsAttributes: (0, $8FbYY.getAnalyticsAttributesFromResult)(result)
    };
    if (command.components?.CommandRow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.CommandRow, rowProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwWoQ.CommandRow), rowProps);
};

});
parcelRegister("gwWoQ", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $6e9750c220ca1b53$export$3ef5d254c3c573e3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $8rQuz = parcelRequire("8rQuz");

var $5t8Df = parcelRequire("5t8Df");


var $8LHLg = parcelRequire("8LHLg");

var $7cPAX = parcelRequire("7cPAX");
const $6e9750c220ca1b53$export$3ef5d254c3c573e3 = ({ index: index, command: command, isActive: isActive, isFirstCommand: isFirstCommand, analyticsAttributes: analyticsAttributes, ...rest })=>{
    const InnerContainer = $6e9750c220ca1b53$var$CommandContainerInner;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandContainerWrapper, {
        "data-testid": command.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandContainer, {
        index: index,
        active: isActive,
        "data-active": isActive,
        "data-testid": (0, $d665202372e0655f$export$b0017db5728101cc)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InnerContainer, {
        "data-testid": (0, $d665202372e0655f$export$47c379a40b00a339),
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandLeftIconAndNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandIconsContainer, {
        "data-testid": (0, $d665202372e0655f$export$d6dd1cf63aae711c)
    }, command.components?.LeftIcon && ((0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        testId: (0, $d665202372e0655f$export$7b41978523c7dd4a),
        alignItems: "center",
        justifyContent: "center",
        xcss: [
            $6e9750c220ca1b53$var$iconStyles,
            isActive && $6e9750c220ca1b53$var$iconActiveStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.LeftIcon, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandLeftIconContainer, {
        "data-testid": (0, $d665202372e0655f$export$7b41978523c7dd4a),
        active: isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.LeftIcon, null))), command.mode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5t8Df.OutlinedLozenge), {
        "data-testid": (0, $d665202372e0655f$export$72c5368f559dd523)
    }, command.mode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8LHLg.RenderCommandName), {
        command: command,
        isActive: isActive
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7cPAX.RightContent), {
        command: command,
        isFirstCommand: isFirstCommand,
        isActive: isActive
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6e9750c220ca1b53$var$CommandContainerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81oud _syazjjyb _1yt4swc3",
            !!__cmplp.active && "_syazaj1x _bfhk29zg _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus194a",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandContainerInner = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt467l7 _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandIconsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1b66 _zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$iconStyles = (0, $1ZAYh.xcss)({
    width: '24px',
    height: '24px',
    // @ts-expect-error ts(2322) - this color should be set directly within icon after migration, but requires bigger change in types.
    color: 'color.icon.subtle'
});
const $6e9750c220ca1b53$var$iconActiveStyles = (0, $1ZAYh.xcss)({
    // @ts-expect-error ts(2322) - this color should be set directly within icon after migration.
    color: 'color.icon'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6e9750c220ca1b53$var$CommandLeftIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1tcg _4t3i1tcg _vwz41tcg _1bah1h6o _1wpz1y6m _1f027vkz _nbgx7vkz",
            __cmplp.active ? "_syaz2zfp" : "_syazbkuv",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandLeftIconAndNameContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _16jlkb7n _1o9zkb7n _i0dlf1ug _vwz41tcg _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5t8Df", function(module, exports) {

$parcel$export(module.exports, "OutlinedLozenge", () => $cfdd8a3faf592ae6$export$224f9ad7f31e0de6);
$parcel$export(module.exports, "FilledLozenge", () => $cfdd8a3faf592ae6$export$586a428fe10f5ae0);
$parcel$export(module.exports, "SearchLozenge", () => $cfdd8a3faf592ae6$export$2ccc7861eeb7b337);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfdd8a3faf592ae6$var$Lozenge = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _2rko1l7b _1o9zidpf _4t3igktf _1bsbgktf _11c8qk37 _vwz41crf _syaz1aqp",
            __cmplp.className
        ])
    });
});
const $cfdd8a3faf592ae6$export$224f9ad7f31e0de6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $cfdd8a3faf592ae6$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81u0j _k48p1pd9 _1p1dangw _bfhk1j9a _19it1x8r _syazuxqy _vchhusvi",
            __cmplp.className
        ])
    });
});
const $cfdd8a3faf592ae6$export$586a428fe10f5ae0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $cfdd8a3faf592ae6$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _11c81u0j _1p1dangw _1pbykb7n _1cs8stnw _1kt9b3bt _1s6k1d2d _154psxj9 _rfx31l7b _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
            __cmplp.className
        ])
    });
});
const $cfdd8a3faf592ae6$export$2ccc7861eeb7b337 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $cfdd8a3faf592ae6$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4otz2 _1bsb1ris _11c81oud _vwz4dlk8 _bfhk1yrq",
            __cmplp.className
        ])
    });
});

});

const $d665202372e0655f$export$b0017db5728101cc = 'command-palette.ui.modal.body.command-container';
const $d665202372e0655f$export$47c379a40b00a339 = 'command-palette.common.ui.command-palette-row-view.inner-container';
const $d665202372e0655f$export$7b41978523c7dd4a = 'command-palette.ui.modal.body.command-left-icon-container';
const $d665202372e0655f$export$72c5368f559dd523 = 'command-palette.ui.modal.body.command-mode';
const $d665202372e0655f$export$d6dd1cf63aae711c = 'command-palette.ui.modal.body.command-icon-container';

parcelRegister("8LHLg", function(module, exports) {

$parcel$export(module.exports, "RenderCommandName", () => $6ee7061fe3a2c77e$export$931d3f1d35f6c058);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $dtaN9 = parcelRequire("dtaN9");


var $1ybV0 = parcelRequire("1ybV0");

var $jCRsd = parcelRequire("jCRsd");

const $6ee7061fe3a2c77e$export$931d3f1d35f6c058 = ({ command: command, isActive: isActive })=>{
    const renderCommandName = (0, $eUqFw.useCallback)(()=>{
        if (command.components?.Name) return (0, $1ybV0.ff)('compal-issue-actions-very-high-priority-fast-follow') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.Name, {
            isActive: isActive
        }, command.name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.Name, {
            isActive: isActive
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jCRsd.TruncateWithTooltipOnActive), {
            isActive: isActive
        }, command.name);
    }, [
        command,
        isActive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandNameContainer, {
        "data-testid": (0, $1095276f0211050b$export$1858c2a91b8b53ba),
        active: isActive
    }, command.breadcrumb?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandBreadcrumbContainer, {
        "data-testid": (0, $1095276f0211050b$export$5e3a644e2bbe06f3)
    }, command.breadcrumb.map((BreadCrumb, index, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandBreadcrumbItem, {
            isParent: index !== arr.length - 1,
            "data-testid": (0, $1095276f0211050b$export$fb5462105b23e3e5),
            active: isActive
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BreadCrumb, {
            isActive: isActive
        })), index !== arr.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandChevronContainer, {
            "data-testid": (0, $1095276f0211050b$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
            label: "separator"
        }))))) : renderCommandName());
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6ee7061fe3a2c77e$var$CommandNameContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _vwz41tcg",
            __cmplp.active ? "_syaz1qfn" : "_syaz1a45",
            __cmplp.className
        ])
    });
});
const $6ee7061fe3a2c77e$var$CommandBreadcrumbContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $6ee7061fe3a2c77e$var$CommandBreadcrumbItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isParent: isParent, active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_zek046": (0, $9t7rW.default)(__cmplp.active ? `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$exports).N400})` : `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$exports).N200})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            !!__cmplp.isParent && "_syaz1bu1",
            __cmplp.className
        ])
    });
});
const $6ee7061fe3a2c77e$var$CommandChevronContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4kb7n _syazjwct",
            __cmplp.className
        ])
    });
});

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';

parcelRegister("jCRsd", function(module, exports) {

$parcel$export(module.exports, "TruncateWithTooltipOnActive", () => $57c74f3e056e4b78$export$4495aca3d261add0);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lcnyw = parcelRequire("lcnyw");

var $lXgc2 = parcelRequire("lXgc2");


var $lDcdk = parcelRequire("lDcdk");
const $57c74f3e056e4b78$var$TooltipRenderer = ({ children: children, shouldShowTooltip: shouldShowTooltip })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: !!shouldShowTooltip,
        autoFocus: false,
        placement: "bottom-end",
        popupComponent: (0, $lXgc2.PopupComponent),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.tooltip-content"
            }, children),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TriggerComponent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.trigger-component",
                ...triggerProps
            }),
        zIndex: (0, $lcnyw.layers).tooltip()
    });
const $57c74f3e056e4b78$export$70f47de153e915ed = ()=>(0, $eUqFw.useRef)(null);
const $57c74f3e056e4b78$export$4495aca3d261add0 = ({ children: children, isActive: isActive, customTooltip: customTooltip, showTooltip: showTooltip, preventTruncate: preventTruncate })=>{
    const containerRef = $57c74f3e056e4b78$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $lDcdk.useTruncatedTooltip)({
        containerRef: containerRef,
        tooltipDelay: (0, $79f2d7e0eace9088$export$f9e3e7ede9ba929d)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        ref: containerRef,
        xcss: [
            $57c74f3e056e4b78$var$tooltipContainerStyles,
            !preventTruncate && $57c74f3e056e4b78$var$truncateTooltipStyles
        ]
    }, children), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57c74f3e056e4b78$var$TooltipRenderer, {
        shouldShowTooltip: showTooltip || shouldShowTruncatedTooltip
    }, showTooltip && customTooltip ? customTooltip : children));
};
const $57c74f3e056e4b78$var$tooltipContainerStyles = (0, $1ZAYh.xcss)({
    position: 'relative',
    flexGrow: 1,
    textTransform: 'none'
});
const $57c74f3e056e4b78$var$truncateTooltipStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("lXgc2", function(module, exports) {

$parcel$export(module.exports, "TooltipComponent", () => $50856cc63ccf025e$export$e18e2f8e82cdc428);
$parcel$export(module.exports, "TriggerComponent", () => $50856cc63ccf025e$export$534fc570264a52a4);
$parcel$export(module.exports, "TooltipTrigger", () => $50856cc63ccf025e$export$8c610744efcf8a1d);
$parcel$export(module.exports, "PopupComponent", () => $50856cc63ccf025e$export$9fac2d040f3ed438);
$parcel$export(module.exports, "TruncateWithTooltipContainer", () => $50856cc63ccf025e$export$8cae238d61c8405a);
$parcel$export(module.exports, "TooltipContent", () => $50856cc63ccf025e$export$e9003e2be37ec060);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $g3tFP = parcelRequire("g3tFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1SWMO = parcelRequire("1SWMO");
const $50856cc63ccf025e$export$e18e2f8e82cdc428 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50856cc63ccf025e$var$StyledTooltipPrimitive, {
        ...props,
        ref: ref
    }));
const $50856cc63ccf025e$export$534fc570264a52a4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50856cc63ccf025e$export$8c610744efcf8a1d, {
        ...props,
        role: "button",
        ref: ref,
        "aria-label": formatMessage((0, $1SWMO.messages).tooltipTriggerAriaLabel)
    });
});
const $50856cc63ccf025e$export$9fac2d040f3ed438 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50856cc63ccf025e$var$StyledPopupPrimitive, {
        ...props,
        ref: ref
    }, children)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $50856cc63ccf025e$var$StyledTooltipPrimitive = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $g3tFP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pbydx66 _1bsbp3fh _1yt41ppf _bfhk1j9a _16qsacve",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $50856cc63ccf025e$var$StyledPopupPrimitive = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pbydx66 _1bsbp3fh _1yt41ppf _bfhk1j9a _16qsacve",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $50856cc63ccf025e$export$8cae238d61c8405a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1p1dglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $50856cc63ccf025e$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1jfi _11c8qk37",
            __cmplp.className
        ])
    });
});
const $50856cc63ccf025e$export$8c610744efcf8a1d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1SWMO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ce912c60a1269c55$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ce912c60a1269c55$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    tooltipTriggerAriaLabel: {
        "id": "command-palette.common.truncate-with-tooltip.components.tooltip-trigger-aria-label",
        "defaultMessage": "Command palette tool tip"
    }
});

});


const $79f2d7e0eace9088$export$f9e3e7ede9ba929d = 400;

parcelRegister("lDcdk", function(module, exports) {

$parcel$export(module.exports, "useTruncatedTooltip", () => $8c918be484ad3aec$export$94b118b3187f12c);

var $eUqFw = parcelRequire("eUqFw");

var $8FbYY = parcelRequire("8FbYY");
const $8c918be484ad3aec$export$22c0312879c61300 = ()=>(0, $eUqFw.useState)(false);
const $8c918be484ad3aec$export$1ac6e474a0163418 = ()=>(0, $eUqFw.useState)(false);
const $8c918be484ad3aec$export$94b118b3187f12c = ({ containerRef: containerRef, tooltipDelay: tooltipDelay })=>{
    const [shouldShowTruncatedTooltip, setShouldShowTruncatedTooltip] = $8c918be484ad3aec$export$22c0312879c61300();
    const [isTruncated, setIsTruncated] = $8c918be484ad3aec$export$1ac6e474a0163418();
    const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, $8FbYY.useSetTimeoutAutoClear)();
    const setTimeoutFunc = setTimeoutAutoClear;
    (0, $eUqFw.useEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        if (container.offsetWidth < container.scrollWidth) setIsTruncated(true);
        else setIsTruncated(false);
    }, [
        setIsTruncated,
        containerRef
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isTruncated && tooltipDelay === 0) {
            setShouldShowTruncatedTooltip(true);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        if (isTruncated && tooltipDelay > 0) {
            setTimeoutFunc(()=>setShouldShowTruncatedTooltip(true), tooltipDelay);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        setShouldShowTruncatedTooltip(false);
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
    }, [
        isTruncated,
        setShouldShowTruncatedTooltip,
        tooltipDelay,
        setTimeoutFunc
    ]);
    return {
        shouldShowTruncatedTooltip: shouldShowTruncatedTooltip
    };
};

});


const $1095276f0211050b$export$1858c2a91b8b53ba = 'command-palette.ui.modal.body.command-name-container';
const $1095276f0211050b$export$5e3a644e2bbe06f3 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-container';
const $1095276f0211050b$export$fb5462105b23e3e5 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-item';
const $1095276f0211050b$export$4675b4d60d9881d4 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.separator';


parcelRegister("7cPAX", function(module, exports) {

$parcel$export(module.exports, "RightContent", () => $b3a3550b1d4e6bec$export$11dbab4b39f15d6b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dwj4T = parcelRequire("dwj4T");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8FbYY = parcelRequire("8FbYY");


var $hBQBI = parcelRequire("hBQBI");

var $iMtOt = parcelRequire("iMtOt");

var $6gNFs = parcelRequire("6gNFs");

var $cAOzG = parcelRequire("cAOzG");
const $b3a3550b1d4e6bec$export$11dbab4b39f15d6b = ({ command: command, isActive: isActive, isFirstCommand: isFirstCommand = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const transitionStep = (0, $6gNFs.useHoverTransitionStep)(command, isActive, isFirstCommand);
    const commandHasChildren = (0, $eUqFw.useMemo)(()=>(0, $8FbYY.hasChildren)(command), [
        command
    ]);
    const shouldRenderRightContent = commandHasChildren || !!command.shortcut;
    if (!shouldRenderRightContent) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3a3550b1d4e6bec$var$RightContentWrapper, null, commandHasChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3a3550b1d4e6bec$var$CommandRightChevronContainer, {
        "data-testid": (0, $d5b555147cabbe39$export$e3e144c17be58a44),
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))), {
        label: formatMessage((0, $hBQBI.messages).rightChevronLabel)
    })), !!command.shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3a3550b1d4e6bec$var$ShortcutContainer, {
        "data-testid": (0, $d5b555147cabbe39$export$f3036e9d26f81cd9),
        shouldHaveTransition: commandHasChildren,
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMtOt.Shortcuts), {
        shortcut: command.shortcut
    })));
};
const $b3a3550b1d4e6bec$var$animationFadeIn = null;
const $b3a3550b1d4e6bec$var$animationFadeOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a3550b1d4e6bec$var$RightContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c11p5 _18u01b66 _syaz1a45",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a3550b1d4e6bec$var$CommandRightChevronContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ii7kb7n _yyhykb7n _4cvr1h6o _1e0c1txw _1bsb1tcg _4t3i1tcg _vwz41tcg _5sag1ttt _1pgl1ytf _1o51q7pw _tzy4idpf _syazbkuv",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "_j7hq1wwu",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a3550b1d4e6bec$var$ShortcutContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldHaveTransition: shouldHaveTransition, transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ii7kb7n _yyhykb7n _5sag1ttt _1pgl1ytf _1o51q7pw _1e0c1txw _1bahesu3",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1wwu",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9d7d0ffff46f5f00$var$_chevronRight = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("fCmfi")));
function $9d7d0ffff46f5f00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $9d7d0ffff46f5f00$var$_chevronRight.default,
        iconType: "utility"
    }));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = module.exports.default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;

});

const $d5b555147cabbe39$export$f3036e9d26f81cd9 = 'command-palette.ui.modal.body.command-shortcut-container';
const $d5b555147cabbe39$export$e3e144c17be58a44 = 'command-palette.ui.modal.body.command-chevron-container';
const $d5b555147cabbe39$export$e792b5b2b6c9ee7 = 'command-palette.ui.modal.body.command-right-icon-container';

parcelRegister("hBQBI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2fa0ed9a30870185$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $2fa0ed9a30870185$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rightChevronLabel: {
        "id": "command-palette.common.components.command-row.right-content.right-chevron-label",
        "defaultMessage": "Command with children icon"
    }
});

});

parcelRegister("iMtOt", function(module, exports) {

$parcel$export(module.exports, "Shortcuts", () => $7fcd400f64ed3fa3$export$b326d77e4b8b7664);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ftpwV = parcelRequire("ftpwV");

var $8FbYY = parcelRequire("8FbYY");

var $5t8Df = parcelRequire("5t8Df");


var $ff5gx = parcelRequire("ff5gx");
const $7fcd400f64ed3fa3$var$KeyElement = ({ shortcut: shortcut })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$export$cde89099db64abe3, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5t8Df.FilledLozenge), {
        "data-testid": (0, $258bfb6c4afc66c3$export$cd62afa4691c297)
    }, shortcut));
const $7fcd400f64ed3fa3$var$DivisorElement = ({ divisor: divisor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$ShortcutDivider, {
        "data-testid": (0, $258bfb6c4afc66c3$export$e06ad7c09a29974b)
    }, divisor);
/**
 * Transform shortcut string into object
 */ const $7fcd400f64ed3fa3$var$parseShortcut = (shortcut, replacers, acc = [], types = [])=>{
    const replacer = replacers.shift();
    if (!replacer) {
        acc.push({
            type: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY,
            key: shortcut
        });
        types.push((0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY);
        return [
            acc,
            types
        ];
    }
    shortcut.split(replacer.char).forEach((str, index, self)=>{
        $7fcd400f64ed3fa3$var$parseShortcut(str, replacers.slice(0), acc, types);
        if (index < self.length - 1) {
            acc.push({
                type: replacer.replacement
            });
            types.push(replacer.replacement);
        }
    });
    return [
        acc,
        types
    ];
};
const $7fcd400f64ed3fa3$export$cfaeb054b183bb20 = ()=>(0, $5JgJ2.default)();
const $7fcd400f64ed3fa3$export$b326d77e4b8b7664 = ({ shortcut: shortcut })=>{
    const { formatMessage: formatMessage } = $7fcd400f64ed3fa3$export$cfaeb054b183bb20();
    const [shortcuts, types] = (0, $eUqFw.useMemo)(()=>$7fcd400f64ed3fa3$var$parseShortcut(shortcut, (0, $8FbYY.getShortcutSpecialCharacters)()), [
        shortcut
    ]);
    const basicShortcutMessage = (0, $eUqFw.useMemo)(()=>{
        if (types.length === 3) {
            if (types[0] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY && types[2] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY) {
                if (types[1] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN) return (0, $ff5gx.messages).shortcutThen;
                if (types[1] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR) return (0, $ff5gx.messages).shortcutOr;
                if (types[1] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).PLUS) return (0, $ff5gx.messages).shortcutPlus;
            }
        }
        return null;
    }, [
        types
    ]);
    const formatTypeToMessage = (0, $eUqFw.useCallback)((type)=>{
        switch(type){
            case (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN:
                return formatMessage((0, $ff5gx.messages).divisorThen);
            case (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR:
                return formatMessage((0, $ff5gx.messages).divisorOr);
            default:
                return formatMessage((0, $ff5gx.messages).divisorPlus);
        }
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$ShortcutContainer, {
        "data-testid": (0, $258bfb6c4afc66c3$export$ec8260df4f23714c),
        "aria-hidden": true
    }, basicShortcutMessage ? formatMessage(basicShortcutMessage, {
        shortcutA: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$KeyElement, {
            shortcut: shortcuts[0].key
        }),
        shortcutB: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$KeyElement, {
            shortcut: shortcuts[2].key
        }),
        divisor: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$DivisorElement, {
                divisor: chunk
            })
    }) : shortcuts.map((obj, index)=>{
        if (obj.type === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$KeyElement, {
            key: index,
            shortcut: obj.key
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$DivisorElement, {
            key: index,
            divisor: formatTypeToMessage(obj.type)
        });
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7fcd400f64ed3fa3$var$ShortcutDivider = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8otz2",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7fcd400f64ed3fa3$var$ShortcutContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlidpf _1o9zkb7n _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7fcd400f64ed3fa3$export$cde89099db64abe3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
const $258bfb6c4afc66c3$export$cd62afa4691c297 = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-icon';
const $258bfb6c4afc66c3$export$e06ad7c09a29974b = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-divider';
const $258bfb6c4afc66c3$export$ec8260df4f23714c = 'command-palette.ui.modal.modal-content.body.command-row.shortcuts.shortcut-container';

parcelRegister("ff5gx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9663167573e5dde6$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9663167573e5dde6$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    shortcutThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-then",
        "defaultMessage": "{shortcutA} <divisor>then</divisor> {shortcutB}"
    },
    shortcutOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-or",
        "defaultMessage": "{shortcutA} <divisor>or</divisor> {shortcutB}"
    },
    shortcutPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-plus",
        "defaultMessage": "{shortcutA} <divisor>+</divisor> {shortcutB}"
    },
    divisorThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-then",
        "defaultMessage": "then"
    },
    divisorOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-or",
        "defaultMessage": "or"
    },
    divisorPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-plus",
        "defaultMessage": "+"
    }
});

});


parcelRegister("6gNFs", function(module, exports) {

$parcel$export(module.exports, "useHoverTransitionStep", () => $a5599ff6bbc2ab8e$export$eefd045a02bab4c6);

var $eUqFw = parcelRequire("eUqFw");

var $8YJjX = parcelRequire("8YJjX");

var $guiFP = parcelRequire("guiFP");

var $8FbYY = parcelRequire("8FbYY");

var $cAOzG = parcelRequire("cAOzG");
const $a5599ff6bbc2ab8e$export$eefd045a02bab4c6 = (command, isActive, isFirstCommand)=>{
    const [hasTransitionedFirstCommand, setHasTransitionedFirstCommand] = (0, $eUqFw.useState)(false);
    const [transitionStep, setTransitionStep] = (0, $eUqFw.useState)((0, $cAOzG.TRANSITION_STEP).INITIAL);
    const timerRef = (0, $eUqFw.useRef)(null);
    const isReducedMotion = (0, $8YJjX.useIsReducedMotion)();
    const commandHasChildren = (0, $8FbYY.hasChildren)(command);
    (0, $eUqFw.useEffect)(()=>{
        setTransitionStep((0, $cAOzG.TRANSITION_STEP).INITIAL);
        if (timerRef.current) clearTimeout(timerRef.current);
    }, [
        command
    ]);
    const startTimerForNextStep = (nextStep, durationMs)=>{
        timerRef.current = setTimeout(()=>{
            setTransitionStep(nextStep);
            timerRef.current = null;
        }, durationMs);
    };
    const handleReducedMotionTransition = (0, $eUqFw.useCallback)(()=>{
        if (isActive) setTransitionStep((0, $cAOzG.TRANSITION_STEP).FINISHED);
        else setTransitionStep((0, $cAOzG.TRANSITION_STEP).INITIAL);
    }, [
        isActive
    ]);
    const handleWithMotionTransition = (0, $eUqFw.useCallback)(()=>{
        switch(transitionStep){
            case (0, $cAOzG.TRANSITION_STEP).INITIAL:
                if (isActive) {
                    setTransitionStep((0, $cAOzG.TRANSITION_STEP).DELAYING);
                    startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).TRANSITIONING, isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand ? (0, $cAOzG.TRANSITION_INITIAL_DELAY_TIME_MS) : (0, $cAOzG.TRANSITION_HOVER_DELAY_TIME_MS));
                }
                break;
            case (0, $cAOzG.TRANSITION_STEP).DELAYING:
                if (!isActive) {
                    timerRef.current && clearTimeout(timerRef.current);
                    timerRef.current = null;
                    setTransitionStep((0, $cAOzG.TRANSITION_STEP).INITIAL);
                }
                break;
            case (0, $cAOzG.TRANSITION_STEP).TRANSITIONING:
                if (isActive) {
                    if (isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand) setHasTransitionedFirstCommand(true);
                    if (!timerRef.current) startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).FINISHED, (0, $cAOzG.TRANSITION_DURATION_MS));
                }
                break;
            case (0, $cAOzG.TRANSITION_STEP).FINISHED:
                if (!isActive) setTransitionStep((0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT);
                break;
            case (0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT, (0, $cAOzG.TRANSITION_HOVER_DELAY_TIME_MS));
                break;
            case (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).INITIAL, (0, $cAOzG.TRANSITION_DURATION_MS));
                break;
            default:
                (0, $guiFP.default)({
                    error: new Error('Invalid transition step for command'),
                    meta: {
                        id: 'useTransitionStep',
                        packageName: 'jiraCommandPalette',
                        teamName: 'deliveroo'
                    }
                });
        }
    }, [
        command.shortcut,
        hasTransitionedFirstCommand,
        isActive,
        isFirstCommand,
        transitionStep
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (commandHasChildren) {
            if (isReducedMotion) handleReducedMotionTransition();
            else handleWithMotionTransition();
        }
    }, [
        commandHasChildren,
        isReducedMotion,
        handleReducedMotionTransition,
        handleWithMotionTransition
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isFirstCommand) setHasTransitionedFirstCommand(false);
    }, [
        isFirstCommand
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        }, []);
    return transitionStep;
};

});
parcelRegister("cAOzG", function(module, exports) {

$parcel$export(module.exports, "TRANSITION_STEP", () => $2290b1f6fafc03ce$export$42d8d7c94c5a11e9);
$parcel$export(module.exports, "TRANSITION_INITIAL_DELAY_TIME_MS", () => $2290b1f6fafc03ce$export$82cfc253a6c33f59);
$parcel$export(module.exports, "TRANSITION_HOVER_DELAY_TIME_MS", () => $2290b1f6fafc03ce$export$e092796a9af3633b);
$parcel$export(module.exports, "TRANSITION_DURATION_MS", () => $2290b1f6fafc03ce$export$1cad4f611a1c0229);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $2290b1f6fafc03ce$export$42d8d7c94c5a11e9;
(function(TRANSITION_STEP) {
    TRANSITION_STEP["INITIAL"] = "initial";
    TRANSITION_STEP["DELAYING"] = "delaying";
    TRANSITION_STEP["TRANSITIONING"] = "transitioning";
    TRANSITION_STEP["FINISHED"] = "finished";
    TRANSITION_STEP["DELAYING_FADE_OUT"] = "delaying-fade-out";
    TRANSITION_STEP["TRANSITIONING_FADE_OUT"] = "transitioning-fade-out";
})($2290b1f6fafc03ce$export$42d8d7c94c5a11e9 || ($2290b1f6fafc03ce$export$42d8d7c94c5a11e9 = {}));
const $2290b1f6fafc03ce$export$82cfc253a6c33f59 = 600;
const $2290b1f6fafc03ce$export$e092796a9af3633b = 300;
const $2290b1f6fafc03ce$export$1cad4f611a1c0229 = 350;

});





parcelRegister("985MX", function(module, exports) {

$parcel$export(module.exports, "CommandRowErrorBoundary", () => $5142cc04bb4fcd8a$export$223f3c3c93a14a83);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");
const $5142cc04bb4fcd8a$export$223f3c3c93a14a83 = ({ children: children, teamName: teamName, onError: onError, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "command-palette-row",
        packageName: "jiraCommandPalette",
        fallback: "unmount",
        teamName: teamName,
        onError: onError,
        attributes: attributes
    }, children);

});

parcelRegister("dDiRc", function(module, exports) {

$parcel$export(module.exports, "GROUP_TEST_ID", () => $1d3aece513b288cb$export$d83f892940e54128);
$parcel$export(module.exports, "NO_RESULTS_TEST_ID", () => $1d3aece513b288cb$export$bf182a53106ca02e);
$parcel$export(module.exports, "SCROLL_DIRECTION", () => $1d3aece513b288cb$export$a6d65a8fb7b912d6);
const $1d3aece513b288cb$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $1d3aece513b288cb$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $1d3aece513b288cb$export$d83f892940e54128 = 'command-palette.ui.modal.body.group-container';
const $1d3aece513b288cb$export$707f57180c76458e = 'command-palette.ui.modal.body.spinner-container';
const $1d3aece513b288cb$export$bf182a53106ca02e = 'command-palette.ui.modal.body.no-results-container';
var $1d3aece513b288cb$export$a6d65a8fb7b912d6;
(function(SCROLL_DIRECTION) {
    SCROLL_DIRECTION["START"] = "start";
    SCROLL_DIRECTION["END"] = "end";
})($1d3aece513b288cb$export$a6d65a8fb7b912d6 || ($1d3aece513b288cb$export$a6d65a8fb7b912d6 = {}));

});

parcelRegister("4PPUt", function(module, exports) {

$parcel$export(module.exports, "isElementVisibleInContainer", () => $4d787935cca8e899$export$b9dc8b6556026098);
$parcel$export(module.exports, "getScrollToIndex", () => $4d787935cca8e899$export$56068eb4c4e3a63c);
$parcel$export(module.exports, "scrollResultIntoView", () => $4d787935cca8e899$export$6be8a7238febd54f);

var $8FbYY = parcelRequire("8FbYY");

var $dDiRc = parcelRequire("dDiRc");
const $4d787935cca8e899$export$b9dc8b6556026098 = (element, container)=>{
    const modalBodyRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    return elementRect.top >= modalBodyRect.top && elementRect.bottom <= modalBodyRect.bottom;
};
const $4d787935cca8e899$export$56068eb4c4e3a63c = (results, newActiveIndex, scrollTo)=>{
    const commandResultIndex = results.findIndex((result)=>!result.isGroup && result.index === newActiveIndex);
    if (scrollTo === (0, $dDiRc.SCROLL_DIRECTION).START && commandResultIndex > 0) {
        // Verify if there is any active command before this id
        const prevActiveCommandIndex = results.findIndex((result, index)=>index < commandResultIndex && !result.isGroup && (0, $8FbYY.hasAction)(result.command));
        if (prevActiveCommandIndex === -1) return 0;
    }
    if (scrollTo === (0, $dDiRc.SCROLL_DIRECTION).END) {
        // Verify if there is any active command after this id
        const afterActiveCommandIndex = results.findIndex((result, index)=>index > commandResultIndex && !result.isGroup && (0, $8FbYY.hasAction)(result.command));
        if (afterActiveCommandIndex === -1) return results.length - 1;
        // Scrolling down, so group headings don't need to be taken into account
        return commandResultIndex;
    }
    const isCommandAfterGroupHeading = commandResultIndex > 0 && results[commandResultIndex - 1].isGroup;
    return isCommandAfterGroupHeading ? commandResultIndex - 1 : commandResultIndex;
};
const $4d787935cca8e899$export$6be8a7238febd54f = (scrollToResult, scrollTo)=>{
    if (!scrollToResult?.parentElement) return;
    const parent = scrollToResult.parentElement;
    const elemRect = scrollToResult.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();
    const gapScroll = 4;
    if (scrollTo === (0, $dDiRc.SCROLL_DIRECTION).END) {
        const commandPosition = elemRect.bottom - parentRect.top;
        const amountToScroll = commandPosition - parentRect.height;
        const pos = amountToScroll + gapScroll + parent.scrollTop;
        scrollToResult.parentElement.scrollTo({
            top: pos
        });
    } else {
        const commandPosition = parentRect.top - elemRect.top;
        const amountToScroll = parent.scrollTop - commandPosition;
        const pos = amountToScroll - gapScroll;
        scrollToResult.parentElement.scrollTo({
            top: pos
        });
    }
};

});


parcelRegister("b4qUd", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $846e4b3bae55c666$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

const $846e4b3bae55c666$export$a06f1c675e846f6f = ({ defaultFooterContent: defaultFooterContent, children: children })=>{
    const footerChildren = children || defaultFooterContent;
    if (!footerChildren) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($846e4b3bae55c666$var$ModalFooter, {
        "data-testid": (0, $933f109161dc97b5$export$aca3e1b45b29f2bb)
    }, footerChildren);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $846e4b3bae55c666$var$ModalFooter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_mrkb1kw7 _1o0z1kw7 _x3doh6cr _1yt49l6b",
            __cmplp.className
        ])
    });
});

});
const $933f109161dc97b5$export$aca3e1b45b29f2bb = 'command-palette.ui.modal.footer.footer';


parcelRegister("48xUp", function(module, exports) {

$parcel$export(module.exports, "Header", () => $3708226beef9cde7$export$8b251419efc915eb);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


const $3708226beef9cde7$export$8b251419efc915eb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3708226beef9cde7$var$headerStyles,
        testId: (0, $baf314009244cc15$export$bf5b960a2e79e6cf)
    }, children);
const $3708226beef9cde7$var$headerStyles = (0, $1ZAYh.xcss)({
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit',
    padding: 'space.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderBottom: `solid 1px ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$exports).N40})`}`
});

});
const $baf314009244cc15$export$bf5b960a2e79e6cf = 'command-palette.ui.modal.header.modal-header';



parcelRegister("8fRY7", function(module, exports) {

$parcel$export(module.exports, "useMatches", () => $2134122c3a265d3b$export$2378eb7f5ff86053);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $8FbYY = parcelRequire("8FbYY");

var $gklnd = parcelRequire("gklnd");

var $8imHH = parcelRequire("8imHH");

var $gCtL7 = parcelRequire("gCtL7");

var $aSL7C = parcelRequire("aSL7C");

var $53qoR = parcelRequire("53qoR");
var $5PHzl = parcelRequire("5PHzl");
const $2134122c3a265d3b$export$2378eb7f5ff86053 = ({ defaultFallback: defaultFallback, rootFallback: rootFallback })=>{
    const [{ commands: commands, expandedCommand: expandedCommand, childResult: childResult, loadingList: loadingList, sections: sections, fallbackOverride: fallbackOverride }] = (0, $gCtL7.useCommandPalette)();
    const [search] = (0, $aSL7C.useCommandPaletteSearchDebounced)();
    const hasLoadChildren = (0, $8FbYY.hasChildren)(expandedCommand);
    const selectedCommands = (0, $eUqFw.useMemo)(()=>hasLoadChildren ? childResult?.commands || [] : commands, [
        hasLoadChildren,
        childResult?.commands,
        commands
    ]);
    const selectedSections = (0, $eUqFw.useMemo)(()=>hasLoadChildren ? childResult?.sections : (0, $8FbYY.mergeSections)(sections), [
        hasLoadChildren,
        childResult?.sections,
        sections
    ]);
    const filterCommandsOverride = (0, $eUqFw.useMemo)(()=>(0, $gklnd.getActiveCommandList)(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.filterAndSortOverrideFn, [
        expandedCommand
    ]);
    const flattenedResults = (0, $5PHzl.useSortAndFilter)(search, selectedCommands, selectedSections, filterCommandsOverride);
    if ((0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const fallback = (0, $eUqFw.useMemo)(()=>(0, $53qoR.getFallback)({
                rootFallback: rootFallback,
                defaultFallback: defaultFallback,
                expandedCommand: expandedCommand,
                noResults: Boolean(flattenedResults.results.length === 0 && !loadingList),
                fallbackOverride: fallbackOverride
            }), [
            defaultFallback,
            expandedCommand,
            fallbackOverride,
            flattenedResults.results.length,
            loadingList,
            rootFallback
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return (0, $eUqFw.useMemo)(()=>{
            if ((0, $gklnd.getActiveCommandList)(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.shouldShowNoCommandsWhileLoading && loadingList) return {
                results: [],
                total: 0
            };
            const fallbackCommandResult = (0, $8imHH.getFallbackCommandResult)(fallback);
            if (fallbackCommandResult) return fallbackCommandResult;
            return {
                ...flattenedResults,
                fallback: fallback
            };
        }, [
            expandedCommand,
            fallback,
            flattenedResults,
            loadingList
        ]);
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $eUqFw.useMemo)(()=>{
        if ((0, $gklnd.getActiveCommandList)(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.shouldShowNoCommandsWhileLoading && loadingList) return {
            results: [],
            total: 0
        };
        const fallback = (0, $53qoR.getFallback)({
            rootFallback: rootFallback,
            defaultFallback: defaultFallback,
            expandedCommand: expandedCommand,
            noResults: Boolean(flattenedResults.results.length === 0 && !loadingList)
        });
        const fallbackCommandResult = (0, $8imHH.getFallbackCommandResult)(fallback);
        if (fallbackCommandResult) return fallbackCommandResult;
        return {
            ...flattenedResults,
            fallback: fallback
        };
    }, [
        defaultFallback,
        expandedCommand,
        flattenedResults,
        loadingList,
        rootFallback
    ]);
};

});
parcelRegister("8imHH", function(module, exports) {

$parcel$export(module.exports, "getFallbackCommandResult", () => $8e953faab5e3cd3c$export$f6daf99735e387a3);
const $8e953faab5e3cd3c$export$f6daf99735e387a3 = (fallback)=>{
    if (!fallback || !fallback?.onNoResults?.fallbackCommand) return undefined;
    const { fallbackCommand: fallbackCommand, fallbackSection: fallbackSection } = fallback.onNoResults;
    const section = fallbackSection;
    const fallbackCommandHeader = fallbackCommand && section ? {
        ...section.renderName ? {
            renderGroup: section.renderName
        } : {
            group: section.name
        },
        isGroup: true
    } : undefined;
    return {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        results: [
            fallbackCommandHeader,
            {
                command: fallbackCommand,
                active: true,
                index: 0
            }
        ].filter(Boolean),
        total: 1,
        activeCommand: fallbackCommand,
        fallback: fallback
    };
};

});

parcelRegister("aSL7C", function(module, exports) {

$parcel$export(module.exports, "useCommandPaletteSearchDebounced", () => $5fa25d081fdb5da4$export$f36a4bb9041c3f69);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $1ybV0 = parcelRequire("1ybV0");

var $gCtL7 = parcelRequire("gCtL7");
const $5fa25d081fdb5da4$export$f36a4bb9041c3f69 = (debounceTime = (0, $1ybV0.ff)('compal-issue-actions-follow-up-improvements_y49xu') ? 250 : 150)=>{
    const [{ search: search }, { handleSearch: handleSearch }] = (0, $gCtL7.useCommandPaletteSearch)();
    const [debouncedSearch, setDebouncedSearch] = (0, $eUqFw.useState)(search);
    const debouncedSetSearch = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(setDebouncedSearch, debounceTime), [
        debounceTime
    ]);
    (0, $eUqFw.useEffect)(()=>{
        debouncedSetSearch(search);
    }, [
        debouncedSetSearch,
        search
    ]);
    (0, $eUqFw.useEffect)(()=>()=>debouncedSetSearch.cancel(), [
        debouncedSetSearch
    ]);
    const setSearch = (0, $eUqFw.useCallback)((newSearch)=>{
        debouncedSetSearch.cancel();
        handleSearch(newSearch);
        setDebouncedSearch(newSearch);
    }, [
        debouncedSetSearch,
        handleSearch
    ]);
    return (0, $eUqFw.useMemo)(()=>[
            debouncedSearch,
            setSearch
        ], [
        debouncedSearch,
        setSearch
    ]);
};

});

parcelRegister("53qoR", function(module, exports) {

$parcel$export(module.exports, "getFallback", () => $27ca4ce9c66540b7$export$ad095be9c56d0fc8);

var $1ybV0 = parcelRequire("1ybV0");

var $gklnd = parcelRequire("gklnd");
const $27ca4ce9c66540b7$export$ad095be9c56d0fc8 = ({ defaultFallback: defaultFallback, rootFallback: rootFallback, expandedCommand: expandedCommand, noResults: noResults, fallbackOverride: fallbackOverride })=>{
    const rootNoResultsFallback = rootFallback ? {
        onNoResults: rootFallback
    } : undefined;
    if ((0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r') && fallbackOverride) return {
        ...rootNoResultsFallback,
        ...fallbackOverride,
        ...!noResults && {
            onNoResults: undefined
        }
    };
    const wasSecondaryTriggered = expandedCommand?.wasSecondaryTriggered;
    const activeCommandList = (0, $gklnd.getActiveCommandList)(expandedCommand, wasSecondaryTriggered);
    const commandFallback = activeCommandList?.fallback;
    if (!defaultFallback && !commandFallback && !rootNoResultsFallback) return undefined;
    return {
        ...rootNoResultsFallback,
        ...expandedCommand ? defaultFallback : {},
        ...commandFallback,
        ...!noResults && {
            onNoResults: undefined
        }
    };
};

});

parcelRegister("5PHzl", function(module, exports) {

$parcel$export(module.exports, "useSortAndFilter", () => $2b7a21cdc20c7dd2$export$329b92741e754bfe);

var $eUqFw = parcelRequire("eUqFw");

var $j3e3N = parcelRequire("j3e3N");

var $5jlX5 = parcelRequire("5jlX5");

var $gCtL7 = parcelRequire("gCtL7");

var $7k5zI = parcelRequire("7k5zI");

var $e6JYx = parcelRequire("e6JYx");
var $fYKIO = parcelRequire("fYKIO");

var $dnnca = parcelRequire("dnnca");
const $2b7a21cdc20c7dd2$export$329b92741e754bfe = (search, selectedCommands, selectedSections, filterCommandsOverride)=>{
    const queryKeywordCount = (0, $eUqFw.useMemo)(()=>search.trim().split(' ').filter(Boolean).length, [
        search
    ]);
    const searchableCommands = (0, $fYKIO.useSearchableCommands)(selectedCommands);
    const [{ activeIndex: activeIndex }] = (0, $gCtL7.useCommandPalette)();
    const fuse = (0, $eUqFw.useMemo)(()=>(0, $e6JYx.createFuseFromCommands)(searchableCommands, queryKeywordCount), [
        searchableCommands,
        queryKeywordCount
    ]);
    const sortedAndFilteredCommands = (0, $eUqFw.useMemo)(()=>{
        if (filterCommandsOverride) return filterCommandsOverride(search, selectedCommands, selectedSections);
        let filteredCommands;
        if (!search.trim().toLowerCase().length) filteredCommands = selectedCommands.map((command)=>({
                ...command,
                searchRelevancyScore: 1
            }));
        else {
            const fuseResults = (0, $e6JYx.searchFuseIndex)(fuse, search);
            filteredCommands = (0, $7k5zI.filterCommandsFromSearch)(search, fuseResults, searchableCommands);
        }
        return (0, $dnnca.sortCommands)(filteredCommands, selectedSections);
    }, [
        filterCommandsOverride,
        fuse,
        search,
        searchableCommands,
        selectedCommands,
        selectedSections
    ]);
    const groupedCommands = (0, $eUqFw.useMemo)(()=>(0, $5jlX5.getGroupedCommands)(sortedAndFilteredCommands, selectedSections), [
        selectedSections,
        sortedAndFilteredCommands
    ]);
    const commandMatches = (0, $eUqFw.useMemo)(()=>(0, $j3e3N.getFlattenedResults)(groupedCommands, activeIndex), [
        groupedCommands,
        activeIndex
    ]);
    return commandMatches;
};

});
parcelRegister("j3e3N", function(module, exports) {

$parcel$export(module.exports, "getFlattenedResults", () => $6e214caed0922360$export$2915eee4e3cdb2f0);
const $6e214caed0922360$export$2915eee4e3cdb2f0 = (groupedCommands, activeIndex)=>{
    const ungroupedCommands = groupedCommands.ungrouped.slice(0);
    let results = ungroupedCommands;
    const sortedGroups = Object.values(groupedCommands.grouped);
    sortedGroups.forEach(({ id: id, group: group, renderGroup: renderGroup, commands: groupCommands })=>{
        results = results.concat({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...renderGroup ? {
                renderGroup: renderGroup
            } : {
                group: group
            },
            isGroup: true,
            id: id
        }, groupCommands);
    });
    const hasAction = (listed)=>Boolean(listed.command.primaryAction || listed.command.secondaryAction);
    let index = 0;
    let totalActionableCommands = 0;
    let activeCommand;
    let sectionIndex = -1;
    let indexWithinSection = 0;
    let sectionId;
    results = results.map((result)=>{
        if (result.isGroup) {
            const newResult = result;
            indexWithinSection = 0;
            sectionIndex += 1;
            newResult.index = sectionIndex;
            sectionId = result.id;
        }
        if (!result.isGroup) {
            const newResult = result;
            if (hasAction(result)) {
                newResult.index = index;
                index += 1;
                totalActionableCommands += 1;
                newResult.active = activeIndex === result.index;
            }
            newResult.indexWithinSection = indexWithinSection;
            newResult.sectionIndex = sectionIndex;
            newResult.sectionId = sectionId;
            indexWithinSection += 1;
            if (newResult.active) activeCommand = newResult.command;
            return newResult;
        }
        return result;
    });
    return {
        results: results,
        total: totalActionableCommands,
        activeCommand: activeCommand
    };
};

});

parcelRegister("5jlX5", function(module, exports) {

$parcel$export(module.exports, "getGroupedCommands", () => $842c9982d94ef79e$export$30f49bc6f46f80dd);
const $842c9982d94ef79e$export$30f49bc6f46f80dd = (commands, sections)=>commands.reduce((acc, command)=>{
        const listedCommand = {
            command: command
        };
        const createGroup = (id, section)=>{
            if (!acc.grouped.some((group)=>group.id === id)) acc.grouped.push({
                ...section.renderName ? {
                    renderGroup: section.renderName
                } : {
                    group: section.name
                },
                id: id,
                priority: section.priority,
                commands: []
            });
        };
        /**
			 * Add command to the group
			 */ const addCommandGroup = (name, newCommand)=>{
            acc.grouped.find((group)=>group.id === name)?.commands.push(newCommand);
        };
        const section = !!command.section && sections?.[command.section];
        if (section) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const id = command.section;
            createGroup?.(id, section);
            addCommandGroup(id, listedCommand);
        } else acc.ungrouped.push(listedCommand);
        acc.length += 1;
        return acc;
    }, {
        grouped: [],
        ungrouped: [],
        length: 0
    });

});

parcelRegister("7k5zI", function(module, exports) {

$parcel$export(module.exports, "filterCommandsFromSearch", () => $0657263b5fdbe860$export$552543cdf42ae2bf);
const $0657263b5fdbe860$export$552543cdf42ae2bf = (search, fuseResults, commands)=>{
    const trimmedSearch = search.trim().toLowerCase();
    if (!trimmedSearch.length) return commands.map((command)=>({
            ...command,
            searchRelevancyScore: 1
        }));
    return commands.flatMap((command)=>{
        const fuseResult = fuseResults.find((result)=>result.item.id === command.id);
        if (fuseResult) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return [
            {
                ...command,
                searchRelevancyScore: fuseResult.score
            }
        ]; // includeScore is true, will always return a number
        return [];
    });
};

});

parcelRegister("e6JYx", function(module, exports) {

$parcel$export(module.exports, "createFuseFromCommands", () => $2f96686b07ae475d$export$3047320e6ed5178f);
$parcel$export(module.exports, "searchFuseIndex", () => $2f96686b07ae475d$export$17e53d0bddbf4060);

var $2AK38 = parcelRequire("2AK38");

var $1ybV0 = parcelRequire("1ybV0");

var $8x8rz = parcelRequire("8x8rz");
const $2f96686b07ae475d$export$dee16a5b7a115788 = (queryKeywordCount = 1)=>({
        ...(0, $8x8rz.FUSE_SEARCH_OPTIONS),
        keys: ((0, $1ybV0.ff)('compal-issue-actions-very-high-priority-fast-follow') ? (0, $8x8rz.FUSE_SEARCH_OPTIONS) : (0, $8x8rz.FUSE_SEARCH_OPTIONS_OLD)).keys?.map((key)=>typeof key === 'object' && 'name' in key ? {
                ...key,
                weight: key.name === 'searchKeywordsArray' ? (key.weight ?? 1) / Math.max(queryKeywordCount, 1) : key.weight
            } : key)
    });
const $2f96686b07ae475d$export$3047320e6ed5178f = (allCommands, queryKeywordCount = 1)=>new (0, $2AK38.default)(allCommands, $2f96686b07ae475d$export$dee16a5b7a115788(queryKeywordCount));
const $2f96686b07ae475d$export$17e53d0bddbf4060 = (fuse, query)=>fuse.search({
        $or: [
            {
                name: query
            },
            {
                shortcut: query
            },
            {
                sectionName: query
            },
            {
                $or: query.split(' ').map((word)=>({
                        searchKeywordsArray: word
                    }))
            }
        ]
    });

});
parcelRegister("2AK38", function(module, exports) {

$parcel$export(module.exports, "default", () => $40eb71d46c880976$export$2e2bcd8739ae039);
/**
 * Fuse.js v7.0.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2023 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $40eb71d46c880976$var$isArray(value) {
    return !Array.isArray ? $40eb71d46c880976$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $40eb71d46c880976$var$INFINITY = 1 / 0;
function $40eb71d46c880976$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$40eb71d46c880976$var$INFINITY ? '-0' : result;
}
function $40eb71d46c880976$var$toString(value) {
    return value == null ? '' : $40eb71d46c880976$var$baseToString(value);
}
function $40eb71d46c880976$var$isString(value) {
    return typeof value === 'string';
}
function $40eb71d46c880976$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $40eb71d46c880976$var$isBoolean(value) {
    return value === true || value === false || $40eb71d46c880976$var$isObjectLike(value) && $40eb71d46c880976$var$getTag(value) == '[object Boolean]';
}
function $40eb71d46c880976$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $40eb71d46c880976$var$isObjectLike(value) {
    return $40eb71d46c880976$var$isObject(value) && value !== null;
}
function $40eb71d46c880976$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $40eb71d46c880976$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $40eb71d46c880976$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $40eb71d46c880976$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const $40eb71d46c880976$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $40eb71d46c880976$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $40eb71d46c880976$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $40eb71d46c880976$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $40eb71d46c880976$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $40eb71d46c880976$var$hasOwn = Object.prototype.hasOwnProperty;
class $40eb71d46c880976$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $40eb71d46c880976$var$createKey(key);
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $40eb71d46c880976$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($40eb71d46c880976$var$isString(key) || $40eb71d46c880976$var$isArray(key)) {
        src = key;
        path = $40eb71d46c880976$var$createKeyPath(key);
        id = $40eb71d46c880976$var$createKeyId(key);
    } else {
        if (!$40eb71d46c880976$var$hasOwn.call(key, 'name')) throw new Error($40eb71d46c880976$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($40eb71d46c880976$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($40eb71d46c880976$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $40eb71d46c880976$var$createKeyPath(name);
        id = $40eb71d46c880976$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $40eb71d46c880976$var$createKeyPath(key) {
    return $40eb71d46c880976$var$isArray(key) ? key : key.split('.');
}
function $40eb71d46c880976$var$createKeyId(key) {
    return $40eb71d46c880976$var$isArray(key) ? key.join('.') : key;
}
function $40eb71d46c880976$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$40eb71d46c880976$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$40eb71d46c880976$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($40eb71d46c880976$var$isString(value) || $40eb71d46c880976$var$isNumber(value) || $40eb71d46c880976$var$isBoolean(value))) list.push($40eb71d46c880976$var$toString(value));
            else if ($40eb71d46c880976$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $40eb71d46c880976$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $40eb71d46c880976$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $40eb71d46c880976$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $40eb71d46c880976$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $40eb71d46c880976$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $40eb71d46c880976$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $40eb71d46c880976$var$Config = {
    ...$40eb71d46c880976$var$BasicOptions,
    ...$40eb71d46c880976$var$MatchOptions,
    ...$40eb71d46c880976$var$FuzzyOptions,
    ...$40eb71d46c880976$var$AdvancedOptions
};
const $40eb71d46c880976$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $40eb71d46c880976$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($40eb71d46c880976$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $40eb71d46c880976$var$FuseIndex {
    constructor({ getFn: getFn = $40eb71d46c880976$var$Config.getFn, fieldNormWeight: fieldNormWeight = $40eb71d46c880976$var$Config.fieldNormWeight } = {}){
        this.norm = $40eb71d46c880976$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($40eb71d46c880976$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($40eb71d46c880976$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$40eb71d46c880976$var$isDefined(doc) || $40eb71d46c880976$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$40eb71d46c880976$var$isDefined(value)) return;
            if ($40eb71d46c880976$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$40eb71d46c880976$var$isDefined(value)) continue;
                    if ($40eb71d46c880976$var$isString(value) && !$40eb71d46c880976$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($40eb71d46c880976$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($40eb71d46c880976$var$isString(value) && !$40eb71d46c880976$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $40eb71d46c880976$var$createIndex(keys, docs, { getFn: getFn = $40eb71d46c880976$var$Config.getFn, fieldNormWeight: fieldNormWeight = $40eb71d46c880976$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $40eb71d46c880976$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($40eb71d46c880976$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $40eb71d46c880976$var$parseIndex(data, { getFn: getFn = $40eb71d46c880976$var$Config.getFn, fieldNormWeight: fieldNormWeight = $40eb71d46c880976$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $40eb71d46c880976$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $40eb71d46c880976$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $40eb71d46c880976$var$Config.distance, ignoreLocation: ignoreLocation = $40eb71d46c880976$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $40eb71d46c880976$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $40eb71d46c880976$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $40eb71d46c880976$var$MAX_BITS = 32;
function $40eb71d46c880976$var$search(text, pattern, patternAlphabet, { location: location = $40eb71d46c880976$var$Config.location, distance: distance = $40eb71d46c880976$var$Config.distance, threshold: threshold = $40eb71d46c880976$var$Config.threshold, findAllMatches: findAllMatches = $40eb71d46c880976$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $40eb71d46c880976$var$Config.minMatchCharLength, includeMatches: includeMatches = $40eb71d46c880976$var$Config.includeMatches, ignoreLocation: ignoreLocation = $40eb71d46c880976$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $40eb71d46c880976$var$MAX_BITS) throw new Error($40eb71d46c880976$var$PATTERN_LENGTH_TOO_LARGE($40eb71d46c880976$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $40eb71d46c880976$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $40eb71d46c880976$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $40eb71d46c880976$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $40eb71d46c880976$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $40eb71d46c880976$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $40eb71d46c880976$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $40eb71d46c880976$var$BitapSearch {
    constructor(pattern, { location: location = $40eb71d46c880976$var$Config.location, threshold: threshold = $40eb71d46c880976$var$Config.threshold, distance: distance = $40eb71d46c880976$var$Config.distance, includeMatches: includeMatches = $40eb71d46c880976$var$Config.includeMatches, findAllMatches: findAllMatches = $40eb71d46c880976$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $40eb71d46c880976$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $40eb71d46c880976$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $40eb71d46c880976$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $40eb71d46c880976$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $40eb71d46c880976$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $40eb71d46c880976$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $40eb71d46c880976$var$MAX_BITS), i);
                i += $40eb71d46c880976$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $40eb71d46c880976$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $40eb71d46c880976$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $40eb71d46c880976$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $40eb71d46c880976$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $40eb71d46c880976$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $40eb71d46c880976$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $40eb71d46c880976$var$ExactMatch extends $40eb71d46c880976$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $40eb71d46c880976$var$InverseExactMatch extends $40eb71d46c880976$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $40eb71d46c880976$var$PrefixExactMatch extends $40eb71d46c880976$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $40eb71d46c880976$var$InversePrefixExactMatch extends $40eb71d46c880976$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $40eb71d46c880976$var$SuffixExactMatch extends $40eb71d46c880976$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $40eb71d46c880976$var$InverseSuffixExactMatch extends $40eb71d46c880976$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $40eb71d46c880976$var$FuzzyMatch extends $40eb71d46c880976$var$BaseMatch {
    constructor(pattern, { location: location = $40eb71d46c880976$var$Config.location, threshold: threshold = $40eb71d46c880976$var$Config.threshold, distance: distance = $40eb71d46c880976$var$Config.distance, includeMatches: includeMatches = $40eb71d46c880976$var$Config.includeMatches, findAllMatches: findAllMatches = $40eb71d46c880976$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $40eb71d46c880976$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $40eb71d46c880976$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $40eb71d46c880976$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $40eb71d46c880976$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $40eb71d46c880976$var$IncludeMatch extends $40eb71d46c880976$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $40eb71d46c880976$var$searchers = [
    $40eb71d46c880976$var$ExactMatch,
    $40eb71d46c880976$var$IncludeMatch,
    $40eb71d46c880976$var$PrefixExactMatch,
    $40eb71d46c880976$var$InversePrefixExactMatch,
    $40eb71d46c880976$var$InverseSuffixExactMatch,
    $40eb71d46c880976$var$SuffixExactMatch,
    $40eb71d46c880976$var$InverseExactMatch,
    $40eb71d46c880976$var$FuzzyMatch
];
const $40eb71d46c880976$var$searchersLen = $40eb71d46c880976$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $40eb71d46c880976$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $40eb71d46c880976$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $40eb71d46c880976$var$parseQuery(pattern, options = {}) {
    return pattern.split($40eb71d46c880976$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($40eb71d46c880976$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $40eb71d46c880976$var$searchersLen){
                const searcher = $40eb71d46c880976$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $40eb71d46c880976$var$searchersLen){
                const searcher = $40eb71d46c880976$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $40eb71d46c880976$var$MultiMatchSet = new Set([
    $40eb71d46c880976$var$FuzzyMatch.type,
    $40eb71d46c880976$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $40eb71d46c880976$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $40eb71d46c880976$var$Config.isCaseSensitive, includeMatches: includeMatches = $40eb71d46c880976$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $40eb71d46c880976$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $40eb71d46c880976$var$Config.ignoreLocation, findAllMatches: findAllMatches = $40eb71d46c880976$var$Config.findAllMatches, location: location = $40eb71d46c880976$var$Config.location, threshold: threshold = $40eb71d46c880976$var$Config.threshold, distance: distance = $40eb71d46c880976$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $40eb71d46c880976$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($40eb71d46c880976$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $40eb71d46c880976$var$registeredSearchers = [];
function $40eb71d46c880976$var$register(...args) {
    $40eb71d46c880976$var$registeredSearchers.push(...args);
}
function $40eb71d46c880976$var$createSearcher(pattern, options) {
    for(let i = 0, len = $40eb71d46c880976$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $40eb71d46c880976$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $40eb71d46c880976$var$BitapSearch(pattern, options);
}
const $40eb71d46c880976$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $40eb71d46c880976$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $40eb71d46c880976$var$isExpression = (query)=>!!(query[$40eb71d46c880976$var$LogicalOperator.AND] || query[$40eb71d46c880976$var$LogicalOperator.OR]);
const $40eb71d46c880976$var$isPath = (query)=>!!query[$40eb71d46c880976$var$KeyType.PATH];
const $40eb71d46c880976$var$isLeaf = (query)=>!$40eb71d46c880976$var$isArray(query) && $40eb71d46c880976$var$isObject(query) && !$40eb71d46c880976$var$isExpression(query);
const $40eb71d46c880976$var$convertToExplicit = (query)=>({
        [$40eb71d46c880976$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $40eb71d46c880976$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $40eb71d46c880976$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$40eb71d46c880976$var$isExpression(query)) return next($40eb71d46c880976$var$convertToExplicit(query));
        if ($40eb71d46c880976$var$isLeaf(query)) {
            const key = isQueryPath ? query[$40eb71d46c880976$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$40eb71d46c880976$var$KeyType.PATTERN] : query[key];
            if (!$40eb71d46c880976$var$isString(pattern)) throw new Error($40eb71d46c880976$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $40eb71d46c880976$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $40eb71d46c880976$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($40eb71d46c880976$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$40eb71d46c880976$var$isExpression(query)) query = $40eb71d46c880976$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $40eb71d46c880976$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $40eb71d46c880976$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $40eb71d46c880976$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$40eb71d46c880976$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$40eb71d46c880976$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $40eb71d46c880976$var$transformScore(result, data) {
    data.score = result.score;
}
function $40eb71d46c880976$var$format(results, docs, { includeMatches: includeMatches = $40eb71d46c880976$var$Config.includeMatches, includeScore: includeScore = $40eb71d46c880976$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($40eb71d46c880976$var$transformMatches);
    if (includeScore) transformers.push($40eb71d46c880976$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $40eb71d46c880976$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$40eb71d46c880976$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $40eb71d46c880976$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $40eb71d46c880976$var$FuseIndex)) throw new Error($40eb71d46c880976$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $40eb71d46c880976$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$40eb71d46c880976$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $40eb71d46c880976$var$isString(query) ? $40eb71d46c880976$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $40eb71d46c880976$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($40eb71d46c880976$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $40eb71d46c880976$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $40eb71d46c880976$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$40eb71d46c880976$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $40eb71d46c880976$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $40eb71d46c880976$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($40eb71d46c880976$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $40eb71d46c880976$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$40eb71d46c880976$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$40eb71d46c880976$var$isDefined(value)) return [];
        let matches = [];
        if ($40eb71d46c880976$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$40eb71d46c880976$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$40eb71d46c880976$export$2e2bcd8739ae039.version = '7.0.0';
$40eb71d46c880976$export$2e2bcd8739ae039.createIndex = $40eb71d46c880976$var$createIndex;
$40eb71d46c880976$export$2e2bcd8739ae039.parseIndex = $40eb71d46c880976$var$parseIndex;
$40eb71d46c880976$export$2e2bcd8739ae039.config = $40eb71d46c880976$var$Config;
$40eb71d46c880976$export$2e2bcd8739ae039.parseQuery = $40eb71d46c880976$var$parse;
$40eb71d46c880976$var$register($40eb71d46c880976$var$ExtendedSearch);

});

parcelRegister("8x8rz", function(module, exports) {

$parcel$export(module.exports, "FUSE_SEARCH_OPTIONS", () => $d1b816e26af11b07$export$833d69a1b36f826e);
$parcel$export(module.exports, "FUSE_SEARCH_OPTIONS_OLD", () => $d1b816e26af11b07$export$9fb60d6e1c71edb5);

var $8FbYY = parcelRequire("8FbYY");
const $d1b816e26af11b07$export$833d69a1b36f826e = {
    threshold: 0.3,
    keys: [
        {
            name: 'shortcut',
            getFn: (command)=>(0, $8FbYY.removeShortcutSpecialCharacters)(command.shortcut ?? ''),
            weight: Math.pow(2, 6)
        },
        {
            name: 'name',
            weight: Math.pow(2, 5)
        },
        {
            name: 'searchKeywordsArray',
            weight: Math.pow(2, 2)
        },
        {
            name: 'sectionName',
            weight: Math.pow(2, 1)
        }
    ],
    includeScore: true,
    shouldSort: false,
    distance: 1000,
    ignoreFieldNorm: true
};
const $d1b816e26af11b07$export$9fb60d6e1c71edb5 = {
    threshold: 0.3,
    keys: [
        {
            name: 'shortcut',
            getFn: (command)=>(0, $8FbYY.removeShortcutSpecialCharacters)(command.shortcut ?? ''),
            weight: Math.pow(2, 4)
        },
        {
            name: 'name',
            weight: Math.pow(2, 3)
        },
        {
            name: 'searchKeywordsArray',
            weight: Math.pow(2, 2)
        },
        {
            name: 'sectionName',
            weight: Math.pow(2, 1)
        }
    ],
    includeScore: true,
    shouldSort: false,
    distance: 1000,
    ignoreFieldNorm: true
};

});


parcelRegister("fYKIO", function(module, exports) {

$parcel$export(module.exports, "useSearchableCommands", () => $2dc7d96346a20a0f$export$9fc7cf5dc38ed809);

var $eUqFw = parcelRequire("eUqFw");

var $6jiFZ = parcelRequire("6jiFZ");

var $gCtL7 = parcelRequire("gCtL7");

const $2dc7d96346a20a0f$var$getSearchableChildrenCommands = (action)=>{
    if (action?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && action.commands !== undefined) return action.commands;
    return [];
};
const $2dc7d96346a20a0f$export$9fc7cf5dc38ed809 = (commands)=>{
    const [{ sections: sections }] = (0, $gCtL7.useCommandPalette)();
    return (0, $eUqFw.useMemo)(()=>$2dc7d96346a20a0f$export$529e2322cf5eecf3(commands, sections), [
        commands,
        sections
    ]);
};
const $2dc7d96346a20a0f$var$getSectionName = (command, sectionMap)=>{
    const sectionId = command.section ?? '';
    const section = sectionMap.get(sectionId);
    if (!section) return '';
    if (section.name) return section.name;
    const textContent = (elem)=>{
        if (!elem) return '';
        if (typeof elem === 'string') return elem;
        const children = elem.props && elem.props.children;
        return children instanceof Array ? children.map(textContent).join('') : textContent(children);
    };
    return textContent(section.renderName?.() ?? '');
};
const $2dc7d96346a20a0f$export$529e2322cf5eecf3 = (commands, sections)=>{
    const sectionMap = new Map(sections.flatMap((section)=>Object.entries(section)));
    const findCommands = (currentCommands, depth = 1)=>{
        const allCommands = [];
        const commandsToPrepare = currentCommands;
        commandsToPrepare.forEach((command)=>{
            allCommands.push({
                ...command,
                searchKeywordsArray: command.keywords?.split(' ') ?? [],
                sectionName: $2dc7d96346a20a0f$var$getSectionName(command, sectionMap)
            });
            const searchableChildren = [];
            const searchablePrimaryChildren = $2dc7d96346a20a0f$var$getSearchableChildrenCommands(command.primaryAction);
            const searchableSecondaryChildren = $2dc7d96346a20a0f$var$getSearchableChildrenCommands(command.secondaryAction);
            if (depth < (0, $14e8bab5a775d827$export$f1496885619d1f75) && searchablePrimaryChildren.length) searchableChildren.push(...findCommands(searchablePrimaryChildren, depth + 1));
            if (depth < (0, $14e8bab5a775d827$export$f1496885619d1f75) && searchableSecondaryChildren.length) searchableChildren.push(...findCommands(searchableSecondaryChildren, depth + 1));
            searchableChildren.forEach((childCommand)=>{
                const breadcrumb = [
                    command?.components?.Name || (()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, command.name))
                ];
                if (childCommand.breadcrumb?.length) breadcrumb.push(...childCommand.breadcrumb);
                else breadcrumb.push(childCommand?.components?.Name || (()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, childCommand.name)));
                const parentCommands = [
                    command
                ];
                if (childCommand.parentCommands?.length) parentCommands.push(...childCommand.parentCommands);
                allCommands.push({
                    ...childCommand,
                    searchKeywordsArray: childCommand.keywords?.split(' ') ?? [],
                    section: command.section,
                    sectionName: $2dc7d96346a20a0f$var$getSectionName(command, sectionMap),
                    parentCommands: parentCommands,
                    breadcrumb: breadcrumb
                });
            });
        });
        return allCommands;
    };
    return findCommands(commands);
};

});
const $14e8bab5a775d827$export$f1496885619d1f75 = 3;


parcelRegister("dnnca", function(module, exports) {

$parcel$export(module.exports, "sortCommands", () => $81b66f380ae2a3fb$export$e679a6aefb43ec97);

const $81b66f380ae2a3fb$var$getSectionOffset = (section)=>1 + (section.priority ?? 0) * (0, $8959d85978eaab13$export$af5cf775e0899047);
const $81b66f380ae2a3fb$export$e679a6aefb43ec97 = (commands, selectedSections)=>{
    const sortByPriority = (commandsToSort)=>commandsToSort.sort((a, b)=>(a.priority || 0) - (b.priority || 0));
    const sortedSections = Object.entries(selectedSections ?? {}).sort(([idA, valA], [idB, valB])=>{
        const aScore = Math.min(...commands.filter((command)=>command.section === idA).map((command)=>command.searchRelevancyScore ?? 1), 1) * $81b66f380ae2a3fb$var$getSectionOffset(valA);
        const bScore = Math.min(...commands.filter((command)=>command.section === idB).map((command)=>command.searchRelevancyScore ?? 1), 1) * $81b66f380ae2a3fb$var$getSectionOffset(valB);
        if (aScore !== bScore) return aScore - bScore;
        const priorityA = valA.priority || 0;
        const priorityB = valB.priority || 0;
        return priorityA - priorityB;
    });
    return sortByPriority(commands).sort((a, b)=>{
        if (a.section && !b.section) return 1;
        if (!a.section && b.section) return -1;
        if (a.section === b.section) return (a.searchRelevancyScore ?? 1) - (b.searchRelevancyScore ?? 1);
        return sortedSections.findIndex(([id])=>id === a.section) - sortedSections.findIndex(([id])=>id === b.section);
    });
};

});
const $8959d85978eaab13$export$af5cf775e0899047 = 10e3;




parcelRegister("3gQ3j", function(module, exports) {

$parcel$export(module.exports, "usePerformMode", () => $8438b9c14f0db76f$export$8d997d005eb1dc1c);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $8FbYY = parcelRequire("8FbYY");

var $gCtL7 = parcelRequire("gCtL7");
const $8438b9c14f0db76f$export$8d997d005eb1dc1c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry }, { executeCommand: executeCommand }] = (0, $gCtL7.useCommandPaletteUsePerformModeState)();
    const hasLoadChildren = (0, $8FbYY.hasChildren)(expandedCommand);
    const selectedCommands = (0, $eUqFw.useMemo)(()=>hasLoadChildren ? childResult?.commands || [] : commands, [
        hasLoadChildren,
        childResult?.commands,
        commands
    ]);
    const foundCommand = (0, $eUqFw.useMemo)(()=>selectedCommands.find((command)=>command.mode && command.mode === search), [
        search,
        selectedCommands
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (foundCommand) executeCommand(foundCommand, {
            method: 'mode',
            createAnalyticsEvent: createAnalyticsEvent,
            attributes: (0, $8FbYY.getRegistryData)(registry, activeRegistry, foundCommand.id)
        });
    }, [
        executeCommand,
        createAnalyticsEvent,
        registry,
        activeRegistry,
        foundCommand
    ]);
};

});

parcelRegister("2GM9h", function(module, exports) {

$parcel$export(module.exports, "usePerformPendingCommandOnClose", () => $3c64f63fe3880488$export$25863b30ab942012);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");
const $3c64f63fe3880488$export$25863b30ab942012 = ()=>{
    const { performDialogCloseCommand: performDialogCloseCommand } = (0, $gCtL7.useActionsCommandPalette)();
    (0, $eUqFw.useEffect)(()=>()=>{
            performDialogCloseCommand();
        }, [
        performDialogCloseCommand
    ]);
};

});

parcelRegister("7qtGC", function(module, exports) {

$parcel$export(module.exports, "Body", () => $29cfdb581dfe46db$export$4b2c32e08f77ff18);

var $eUqFw = parcelRequire("eUqFw");

var $LddR2 = parcelRequire("LddR2");

var $gklnd = parcelRequire("gklnd");

var $gCtL7 = parcelRequire("gCtL7");
const $29cfdb581dfe46db$export$4b2c32e08f77ff18 = ({ fallback: fallback, results: results, total: total, renderAfterCommands: renderAfterCommands })=>{
    const [{ expandedCommand: expandedCommand }, { setChildCommands: setChildCommands, setLoadingList: setLoadingList, setFallbackOverride: setFallbackOverride }] = (0, $gCtL7.useCommandPaletteExpandedCommand)();
    const ExpandedBody = (0, $eUqFw.useMemo)(()=>(0, $gklnd.getActiveCommandList)(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.components?.Body || (0, $LddR2.components).Body, [
        expandedCommand
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ExpandedBody, {
        setChildResult: setChildCommands,
        setLoading: setLoadingList,
        fallback: fallback,
        results: results,
        total: total,
        renderAfterCommands: renderAfterCommands,
        setFallbackOverride: setFallbackOverride
    });
};

});

parcelRegister("k46bC", function(module, exports) {

$parcel$export(module.exports, "CommandBodyErrorBoundary", () => $b1227cf2c1f1d83d$export$3f5cc8366a41f7db);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $gCtL7 = parcelRequire("gCtL7");
const $b1227cf2c1f1d83d$export$3f5cc8366a41f7db = ({ teamName: teamName, attributes: attributes, fallback: fallback, children: children, expandedCommand: expandedCommandOld })=>{
    const [{ expandedCommand: expandedCommandNew }] = (0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r') ? (0, $gCtL7.useCommandPaletteExpandedCommand)() : [
        {
            expandedCommand: undefined
        }
    ];
    const expandedCommand = (0, $eUqFw.useMemo)(()=>(0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r') ? expandedCommandNew : expandedCommandOld, [
        expandedCommandNew,
        expandedCommandOld
    ]);
    const [capturedError, setCapturedError] = (0, $eUqFw.useState)();
    const [prevExpandedCommand, setPrevExpandedCommand] = (0, $eUqFw.useState)(expandedCommand);
    const [hasReset, setHasReset] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (hasReset) {
            setCapturedError(undefined);
            setHasReset(false);
        }
    }, [
        hasReset
    ]);
    const onRetry = (0, $eUqFw.useCallback)(()=>{
        setHasReset(true);
    }, []);
    // This is so that changing body triggers a reset if an error was caught and then the user goes back a level or to another command list
    // Without this, the body would not rerender, and the fallback would remain present
    (0, $eUqFw.useEffect)(()=>{
        if (capturedError && !hasReset && prevExpandedCommand !== expandedCommand) onRetry();
        setPrevExpandedCommand(expandedCommand);
    }, [
        capturedError,
        expandedCommand,
        hasReset,
        onRetry,
        prevExpandedCommand
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "command.body",
        packageName: "jiraCommandPalette",
        teamName: teamName || 'deliveroo',
        attributes: attributes,
        onError: (_location, error)=>{
            setCapturedError(error);
        },
        fallback: fallback || 'unmount',
        resetCaughtError: hasReset ? capturedError : undefined
    }, children);
};

});

const $062cbd8a7bbd6c69$export$3545956e927a0d0a = 'command-palette.ui.modal.modal-content.no-results-container';

parcelRegister("fdlvn", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $2cb872d151bce948$export$a06f1c675e846f6f);

var $eUqFw = parcelRequire("eUqFw");

var $LddR2 = parcelRequire("LddR2");
const $2cb872d151bce948$export$a06f1c675e846f6f = (props)=>{
    const { activeCommand: activeCommand, ...rest } = props;
    const FooterComponent = activeCommand?.components?.Footer || (0, $LddR2.components).Footer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FooterComponent, rest);
};

});

parcelRegister("01XIV", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc1b29e28aa5bfdc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dxIU5 = parcelRequire("dxIU5");

var $bFzGY = parcelRequire("bFzGY");

var $7u4fN = parcelRequire("7u4fN");

var $dXKde = parcelRequire("dXKde");

var $dsroq = parcelRequire("dsroq");

var $4Bees = parcelRequire("4Bees");


var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ftpwV = parcelRequire("ftpwV");

var $itv82 = parcelRequire("itv82");

var $LddR2 = parcelRequire("LddR2");

var $5t8Df = parcelRequire("5t8Df");

var $8FbYY = parcelRequire("8FbYY");

var $gklnd = parcelRequire("gklnd");

var $gCtL7 = parcelRequire("gCtL7");


var $8FyMy = parcelRequire("8FyMy");
const $dc1b29e28aa5bfdc$export$8b251419efc915eb = ({ defaultPlaceholder: defaultPlaceholder, results: results, activeCommand: activeCommand })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ search: search, forceSearchFocus: forceSearchFocus, isOpen: isOpen, expandedCommand: expandedCommand, activeIndex: activeIndex, loadingList: loadingList, onAnalytics: onAnalytics, registry: registry, activeRegistry: activeRegistry }, { handleSearch: handleSearch, goBackLevel: goBackLevel, forceFocusSearch: forceFocusSearch, executeCommand: executeCommand, setFocusInput: setFocusInput }] = (0, $gCtL7.useCommandPalette)();
    const textFieldRef = (0, $eUqFw.useRef)();
    const onFocusInput = (isFocused)=>()=>{
            setFocusInput(isFocused);
        };
    const onInputKeyPress = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Backspace' && search === '') goBackLevel(false, {
            createAnalyticsEvent: createAnalyticsEvent,
            method: 'keyboard'
        });
        if (event.key === 'Enter') {
            event.preventDefault();
            const listed = results.find((result)=>!result.isGroup && result.index === activeIndex);
            if (listed) executeCommand(listed.command, {
                method: 'keyboard',
                createAnalyticsEvent: createAnalyticsEvent,
                attributes: {
                    ...(0, $8FbYY.getAnalyticsAttributesFromResult)(listed),
                    ...(0, $8FbYY.getRegistryData)(registry, activeRegistry, listed.command.id)
                }
            }, (0, $8FbYY.isSecondaryTrigger)(event));
        }
    }, [
        search,
        goBackLevel,
        createAnalyticsEvent,
        results,
        activeIndex,
        executeCommand,
        registry,
        activeRegistry
    ]);
    const onTypeAnalytics = (0, $eUqFw.useCallback)((query)=>{
        if (onAnalytics && createAnalyticsEvent) {
            const event = createAnalyticsEvent({});
            onAnalytics(event, (0, $ftpwV.TRACK_EVENT_TYPE), {
                action: 'entered',
                actionSubject: 'text',
                actionSubjectId: 'commandPaletteSearch',
                attributes: {
                    wordCount: (0, $8FbYY.getWordCount)(query),
                    queryLength: query.length,
                    queryHash: (0, $8FbYY.getQueryHash)(query),
                    queryVersion: -1 // This is done to prevent the quickSearch queryVersion being sent which may be confusing, something to reimplement later
                }
            });
        }
    }, [
        createAnalyticsEvent,
        onAnalytics
    ]);
    const onTypeAnalyticsDebounced = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(onTypeAnalytics, 400), [
        onTypeAnalytics
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            onTypeAnalyticsDebounced?.cancel?.();
        }, [
        onTypeAnalyticsDebounced
    ]);
    const onTypeSearch = (0, $eUqFw.useCallback)((ev)=>{
        const searchValue = ev.target.value;
        handleSearch(searchValue);
        onTypeAnalyticsDebounced(searchValue);
    }, [
        handleSearch,
        onTypeAnalyticsDebounced
    ]);
    const handleBackButton = (0, $eUqFw.useCallback)(()=>{
        goBackLevel(false, {
            createAnalyticsEvent: createAnalyticsEvent,
            method: 'mouse'
        });
    }, [
        createAnalyticsEvent,
        goBackLevel
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (textFieldRef.current && textFieldRef.current.value !== search) textFieldRef.current.value = search;
    }, [
        search
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (textFieldRef.current && forceSearchFocus) {
            textFieldRef.current.focus();
            forceFocusSearch(false);
        }
    }, [
        forceSearchFocus,
        forceFocusSearch
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isOpen && textFieldRef.current) textFieldRef.current.focus();
    }, [
        isOpen
    ]);
    const renderLozenge = (0, $eUqFw.useCallback)((command)=>{
        if (command.mode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5t8Df.OutlinedLozenge), {
            key: command.id,
            "data-testid": (0, $f0a93fae474b0982$export$a670752bd2308067)
        }, "\xa0", command.mode, "\xa0");
        const searchLozengeName = command.searchLozengeName || command.name;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5t8Df.SearchLozenge), {
            key: command.id,
            "data-testid": (0, $f0a93fae474b0982$export$1bc358df5aba61fd)
        }, searchLozengeName);
    }, []);
    const elemBeforeInput = (0, $eUqFw.useMemo)(()=>{
        if (!expandedCommand) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
            label: "",
            primaryColor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N700})`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dc1b29e28aa5bfdc$var$ElemBeforeInputWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $8FyMy.default).goBack)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dc1b29e28aa5bfdc$var$BackButton, {
            testId: (0, $f0a93fae474b0982$export$69f261bc56a05f72),
            appearance: "subtle",
            onClick: handleBackButton
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dXKde))), {
            size: "medium",
            label: formatMessage((0, $8FyMy.default).goBack),
            primaryColor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N700})`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dc1b29e28aa5bfdc$var$LozengeContainer, null, renderLozenge(expandedCommand)));
    }, [
        expandedCommand,
        formatMessage,
        handleBackButton,
        renderLozenge
    ]);
    const elemAfterInput = (0, $eUqFw.useMemo)(()=>{
        if (expandedCommand && loadingList) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dc1b29e28aa5bfdc$var$SpinnerContainer, {
            "data-testid": (0, $f0a93fae474b0982$export$b2afd57a1d4bc9e4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "small"
        }));
        return null;
    }, [
        expandedCommand,
        loadingList
    ]);
    const placeholder = (0, $eUqFw.useMemo)(()=>{
        if (expandedCommand) return expandedCommand.placeholder || expandedCommand.name;
        return defaultPlaceholder;
    }, [
        expandedCommand,
        defaultPlaceholder
    ]);
    const ModalHeader = (0, $eUqFw.useMemo)(()=>(0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r') ? (0, $gklnd.getActiveCommandList)(expandedCommand)?.components?.Header || (0, $LddR2.components).Header : (0, $LddR2.components).Header, [
        expandedCommand
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ModalHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $itv82.CommandPaletteSearchInput), {
        "aria-label": placeholder,
        placeholder: placeholder,
        onKeyDown: onInputKeyPress,
        elemBeforeInput: elemBeforeInput,
        elemAfterInput: elemAfterInput,
        onChange: onTypeSearch,
        ref: textFieldRef,
        onFocus: onFocusInput(true),
        onBlur: onFocusInput(false),
        activeId: activeCommand?.id
    }));
};
var $dc1b29e28aa5bfdc$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $dc1b29e28aa5bfdc$export$8b251419efc915eb;
const $dc1b29e28aa5bfdc$var$BackButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsba982 _4t3ia982 _vwz4a982 _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _t7bl1lpd _4hh6hwed _1fyqhwed",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dc1b29e28aa5bfdc$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dc1b29e28aa5bfdc$var$ElemBeforeInputWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulp1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dc1b29e28aa5bfdc$var$LozengeContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _zulp1b66 _2hwxv77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dXKde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a4a1e4b9148f86$var$_react = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a2a4a1e4b9148f86$var$_chevronLeft = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("a4cVy")));
function $a2a4a1e4b9148f86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a2a4a1e4b9148f86$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $a2a4a1e4b9148f86$var$_chevronLeft.default,
        iconType: "utility"
    }));
$a2a4a1e4b9148f86$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a2a4a1e4b9148f86$var$_default = module.exports.default = $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon;

});
parcelRegister("a4cVy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db781ab5297a2cc1540c99d75921a718>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75444e382f2d4220$var$_react = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75444e382f2d4220$var$_UNSAFE_baseNew = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75444e382f2d4220$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75444e382f2d4220$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $75444e382f2d4220$var$_react.default.createElement($75444e382f2d4220$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$75444e382f2d4220$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $75444e382f2d4220$var$_default = module.exports.default = $75444e382f2d4220$var$ChevronLeftIcon;

});


parcelRegister("itv82", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchInput", () => $510c1696d3210fe9$export$1f98f66b42e34226);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $cf2Y4 = parcelRequire("cf2Y4");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");


var $8gdK7 = parcelRequire("8gdK7");
const $510c1696d3210fe9$export$1f98f66b42e34226 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ activeId: activeId, ...rest }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const ariaProps = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(activeId) ? {
        'aria-expanded': true,
        'aria-controls': (0, $d08d4eae9e022dcf$export$5758a25d98c7bb27),
        role: 'combobox',
        'aria-activedescendant': `${0, $d08d4eae9e022dcf$export$f61172db5aff4b22}-${activeId}`
    } : {
        role: 'searchbox'
    };
    if ((0, $eI5EY.fg)('a11y_violations_fixes')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($510c1696d3210fe9$var$TextFieldStyle, {
        "aria-label": formatMessage((0, $8gdK7.default).searchInputAriaLabelNonFinal),
        appearance: "none",
        testId: (0, $d08d4eae9e022dcf$export$d3cd230e107fbce),
        ref: ref,
        ...ariaProps,
        ...rest
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($510c1696d3210fe9$var$TextFieldStyle, {
        "aria-label": formatMessage((0, $8gdK7.default).searchInputAriaLabelNonFinal),
        appearance: "none",
        testId: (0, $d08d4eae9e022dcf$export$d3cd230e107fbce),
        ref: ref,
        "aria-expanded": true,
        "aria-controls": (0, $d08d4eae9e022dcf$export$5758a25d98c7bb27),
        "aria-activedescendant": activeId !== undefined ? `${0, $d08d4eae9e022dcf$export$f61172db5aff4b22}-${activeId}` : undefined,
        role: "combobox",
        ...rest
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $510c1696d3210fe9$var$TextFieldStyle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $cf2Y4.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1fxt _19itglyw _1yt4mqyj _swxz1doa _10wj1doa _v69yidpf _h61aidpf _1qtqidpf _1bayidpf _n9z41b66 _lmlq1b66 _pytkgktf _k2u0gktf _5ce61wmz _irr31r81",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("8gdK7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c82fe1ec3a07b11e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c82fe1ec3a07b11e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    searchInputAriaLabelNonFinal: {
        "id": "command-palette.common.command-palette-search-dropdown.command-palette-search-input.search-input-aria-label-non-final",
        "defaultMessage": "Search input"
    }
});

});


const $f0a93fae474b0982$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $f0a93fae474b0982$export$a670752bd2308067 = 'command-palette.ui.modal.header.command-mode';
const $f0a93fae474b0982$export$69f261bc56a05f72 = 'command-palette.ui.modal.header.left-arrow';
const $f0a93fae474b0982$export$b2afd57a1d4bc9e4 = 'command-palette.ui.modal.header.spinner-container';
const $f0a93fae474b0982$export$1bc358df5aba61fd = 'command-palette.ui.modal.modal-content.header.search-lozenge';

parcelRegister("8FyMy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2efaf8ea233c79a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c2efaf8ea233c79a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    goBack: {
        "id": "command-palette.modal.modal-content.header.go-back",
        "defaultMessage": "Go back"
    }
});

});


parcelRegister("9Z5tL", function(module, exports) {

$parcel$export(module.exports, "ScreenReaderContent", () => $dba08790cc5aa798$export$d133a8e1226db0f3);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hzcvF = parcelRequire("hzcvF");

var $jqPMh = parcelRequire("jqPMh");

var $gCtL7 = parcelRequire("gCtL7");

var $j0TQV = parcelRequire("j0TQV");
const $dba08790cc5aa798$export$d133a8e1226db0f3 = ({ activeCommand: activeCommand, results: results })=>{
    const [{ search: search, activeIndex: activeIndex }, { forceFocusSearch: forceFocusSearch }] = (0, $gCtL7.useCommandPalette)();
    const previousSearch = (0, $hzcvF.usePrevious)(search);
    const { getScreenReaderText: getScreenReaderText } = $dba08790cc5aa798$export$a59db8e7afab3919();
    const [screenReaderText, setScreenReaderText] = (0, $eUqFw.useState)(null);
    const debouncedSetScreenReaderText = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(setScreenReaderText, 400), []);
    (0, $eUqFw.useEffect)(()=>()=>{
            debouncedSetScreenReaderText?.cancel?.();
        }, [
        debouncedSetScreenReaderText
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (previousSearch !== search) debouncedSetScreenReaderText(getScreenReaderText({
            activeCommand: activeCommand,
            results: results,
            activeIndex: activeIndex
        }));
    }, [
        activeCommand,
        getScreenReaderText,
        previousSearch,
        results,
        search,
        activeIndex,
        debouncedSetScreenReaderText
    ]);
    const onFocus = (0, $eUqFw.useCallback)(()=>{
        forceFocusSearch(true);
    }, [
        forceFocusSearch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jqPMh.CommandPaletteScreenReaderContent), {
        "data-testid": "command-palette.ui.modal.modal-content.screen-reader-content.command-palette-screen-reader-content",
        onFocus: onFocus
    }, screenReaderText);
};
const $dba08790cc5aa798$export$a59db8e7afab3919 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getScreenReaderText = ({ activeCommand: activeCommand, results: results, activeIndex: activeIndex })=>{
        if (!activeCommand) return null;
        const selectedOptionLabel = activeCommand?.name;
        const selectedIndex = activeIndex + 1;
        const totalSuggestions = results.filter((result)=>!result.isGroup).length;
        return formatMessage((0, $j0TQV.default).selectedOption, {
            selectedOptionLabel: selectedOptionLabel,
            selectedIndex: selectedIndex,
            totalSuggestions: totalSuggestions
        });
    };
    return {
        getScreenReaderText: getScreenReaderText
    };
};

});
parcelRegister("jqPMh", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteScreenReaderContent", () => $1b0395daacce9712$export$ec21ebd320897134);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

const $1b0395daacce9712$export$ec21ebd320897134 = ({ ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b0395daacce9712$var$ScreenReaderOnly, {
        "aria-live": "polite",
        "aria-atomic": "false",
        tabIndex: -1,
        ...props,
        id: (0, $d08d4eae9e022dcf$export$65eac2e53f304ab6)
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b0395daacce9712$var$ScreenReaderOnly = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1bsbt94y _4t3it94y _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq _ogtocqaw _slp34jg8 _19itidpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("j0TQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f080fd629ceabb7d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f080fd629ceabb7d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    selectedOption: {
        "id": "command-palette.modal.modal-content.screen-reader-content.selected-option",
        "defaultMessage": "{selectedOptionLabel}, selected, ({selectedIndex} of {totalSuggestions})"
    },
    selectedOptionWithSearch: {
        "id": "command-palette.modal.modal-content.screen-reader-content.selected-option-with-search",
        "defaultMessage": "{selectedOptionLabel}, selected, ({selectedIndex} of {totalSuggestions}) for {search}"
    }
});

});



parcelRegister("2eeKm", function(module, exports) {

$parcel$export(module.exports, "ModalWrapper", () => $79baba91711d0318$export$858bfd02c3f2fba5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1ybV0 = parcelRequire("1ybV0");

var $gklnd = parcelRequire("gklnd");

var $gCtL7 = parcelRequire("gCtL7");
const $79baba91711d0318$export$858bfd02c3f2fba5 = ({ children: children })=>{
    const [{ expandedCommand: expandedCommand }] = (0, $gCtL7.useCommandPaletteExpandedCommand)();
    const Wrapper = (0, $1ybV0.ff)('compal-issue-actions-follow-up-improvements_y49xu') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eUqFw.useMemo)(()=>(0, $gklnd.getActiveCommandList)(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.components?.Wrapper || (0, $eUqFw.Fragment), [
        expandedCommand
    ]) : (0, $gklnd.getActiveCommandList)(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.components?.Wrapper || (0, $eUqFw.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($79baba91711d0318$var$ModalDialogWrapper, null, children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $79baba91711d0318$var$ModalDialogWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8r5cr _2rko7vkz _bfhk1bhr _16qs1e6u",
            __cmplp.className
        ])
    });
});

});


parcelRegister("gITaz", function(module, exports) {

$parcel$export(module.exports, "handleAnalytics", () => $231a66f1118a32a5$export$51232d58b72ca41a);

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
const $231a66f1118a32a5$var$packageName = 'jiraCommandPaletteIntegration';
const $231a66f1118a32a5$export$51232d58b72ca41a = (event, eventType, args)=>{
    const eventFunctions = {
        [(0, $41ea3621645e2acc$export$a1562d08625f5d7e)]: (0, $jMP2a.fireUIAnalytics),
        [(0, $41ea3621645e2acc$export$947dac6c72b26f81)]: (0, $jMP2a.fireTrackAnalytics),
        [(0, $41ea3621645e2acc$export$12346a674644c156)]: (0, $jMP2a.fireOperationalAnalytics)
    };
    if (args?.actionSubject && args?.action || event.payload.actionSubject && event.payload.action) {
        const eventActionAndSubject = args?.actionSubject && args?.action ? `${args?.actionSubject} ${args?.action}` : `${event.payload.actionSubject} ${event.payload.action}`;
        if (args?.actionSubjectId) {
            eventFunctions[eventType]?.(event, eventActionAndSubject, args?.actionSubjectId, args?.attributes ? args?.attributes : {});
            return;
        }
        if (!args?.actionSubjectId) eventFunctions[eventType]?.(event, eventActionAndSubject, args?.attributes ? args?.attributes : {});
    } else (0, $guiFP.default)({
        error: new Error('Action or ActionSubject not provided'),
        meta: {
            id: 'jira.commandPalette.analytics',
            packageName: $231a66f1118a32a5$var$packageName,
            teamName: 'deliveroo'
        }
    });
};

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("52i70", function(module, exports) {

$parcel$export(module.exports, "useQuickSearchCommand", () => $d244b383b94a7e0e$export$e5359a76eb8e8480);

var $eUqFw = parcelRequire("eUqFw");

var $dsroq = parcelRequire("dsroq");

var $6jiFZ = parcelRequire("6jiFZ");

var $9zALC = parcelRequire("9zALC");

var $5JgJ2 = parcelRequire("5JgJ2");


var $hFCH5 = parcelRequire("hFCH5");

var $jL7R8 = parcelRequire("jL7R8");

var $3fAKi = parcelRequire("3fAKi");
var $3piX0 = parcelRequire("3piX0");
const $d244b383b94a7e0e$export$e5359a76eb8e8480 = (props)=>{
    const keepSearch = props?.keepSearch;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $jL7R8.useFireQuickSearchAnalyticsOnClose)();
    const quickSearchCommand = (0, $eUqFw.useMemo)(()=>({
            id: (0, $94cc2b63776eab35$export$2c1eb650fb9787f),
            name: formatMessage((0, $hFCH5.messages).searchCommandName),
            placeholder: formatMessage((0, $hFCH5.messages).searchInputPlaceHolder),
            keywords: formatMessage((0, $hFCH5.messages).searchYourIssuesSynonyms),
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
                        label: ""
                    })
            },
            mode: '/',
            section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).quickSearch,
            priority: 1,
            analytics: {
                action: 'quickSearchMode',
                actionCategory: 'quick-search'
            },
            primaryAction: {
                type: (0, $6jiFZ.CommandActionType).COMMAND_LIST,
                components: {
                    Body: (0, $3fAKi.QuickSearchChildren),
                    Wrapper: (0, $3piX0.QuickSearchChildWrapper)
                },
                keepSearch: keepSearch
            }
        }), [
        formatMessage,
        keepSearch
    ]);
    return {
        quickSearchCommand: quickSearchCommand
    };
};

});
const $94cc2b63776eab35$export$2c1eb650fb9787f = 'quick-search';

parcelRegister("hFCH5", function(module, exports) {

$parcel$export(module.exports, "messages", () => $868f03805919ec87$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $868f03805919ec87$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    searchCommandName: {
        "id": "command-palette-quick-search.use-quick-search-command.search-command-name",
        "defaultMessage": "Search issues, projects, and more"
    },
    searchInputPlaceHolder: {
        "id": "command-palette-quick-search.use-quick-search-command.search-input-place-holder",
        "defaultMessage": "Search for issues, projects, boards, filters and plans"
    },
    searchYourIssuesSynonyms: {
        "id": "command-palette-quick-search.use-quick-search-command.search-your-issues-synonyms",
        "defaultMessage": "Find my ideas tickets requests tasks work"
    }
});

});

parcelRegister("jL7R8", function(module, exports) {

$parcel$export(module.exports, "useFireQuickSearchAnalyticsOnClose", () => $a266a7bc9950a06d$export$5bb3a88a6bd57afb);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8CN3d = parcelRequire("8CN3d");
const $a266a7bc9950a06d$export$5bb3a88a6bd57afb = ()=>{
    const [{ isOpen: isOpen }] = (0, $gCtL7.useCommandPaletteIsOpen)();
    const previousIsOpen = (0, $hzcvF.usePrevious)(isOpen);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ hasModalWrapperMounted: hasModalWrapperMounted }] = (0, $8CN3d.useQuickSearchAnalytics)();
    // Need to get the previousAttributes since they will change after closing compal
    const [attributes] = (0, $gCtL7.useCommandPaletteAnalyticsAttributes)();
    const previousAttributes = (0, $hzcvF.usePrevious)(attributes);
    const [compalAttributes] = (0, $8CN3d.useQuickSearchAnalyticsAttributes)();
    const previousCompalAttributes = (0, $hzcvF.usePrevious)(compalAttributes);
    (0, $eUqFw.useEffect)(()=>{
        if (hasModalWrapperMounted && previousIsOpen && !isOpen) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'close commandPaletteSearch', {
            ...previousCompalAttributes,
            ...previousAttributes
        });
    }, [
        createAnalyticsEvent,
        isOpen,
        previousIsOpen,
        hasModalWrapperMounted,
        previousCompalAttributes,
        previousAttributes
    ]);
};

});
parcelRegister("8CN3d", function(module, exports) {

$parcel$export(module.exports, "useQuickSearchAnalytics", () => $01f5f05c8d8be152$export$4717a2168cba99f2);
$parcel$export(module.exports, "useQuickSearchAnalyticsAttributes", () => $01f5f05c8d8be152$export$c5622799de43dc3a);

var $dFBS3 = parcelRequire("dFBS3");

var $WBLbN = parcelRequire("WBLbN");

var $6Vuvq = parcelRequire("6Vuvq");
const $01f5f05c8d8be152$var$initialState = {
    queryVersion: -1,
    query: '',
    searchSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))(),
    hasModalWrapperMounted: false,
    screenName: undefined,
    isCachedResult: false
};
const $01f5f05c8d8be152$var$actions = {
    setQuery: (query)=>({ setState: setState, getState: getState })=>{
            setState({
                queryVersion: getState().queryVersion + 1,
                query: query
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                ...$01f5f05c8d8be152$var$initialState,
                searchSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))()
            });
        },
    setHasModalWrapperMounted: (hasModalWrapperMounted)=>({ setState: setState })=>{
            setState({
                hasModalWrapperMounted: hasModalWrapperMounted
            });
        },
    setScreenName: (screenName)=>({ setState: setState })=>{
            setState({
                screenName: screenName
            });
        },
    setIsCachedResult: (isCachedResult)=>({ setState: setState })=>{
            setState({
                isCachedResult: isCachedResult
            });
        }
};
const $01f5f05c8d8be152$var$store = (0, $WBLbN.createStore)({
    initialState: $01f5f05c8d8be152$var$initialState,
    actions: $01f5f05c8d8be152$var$actions,
    name: 'quickSearchAnalytics'
});
const $01f5f05c8d8be152$export$4717a2168cba99f2 = (0, $WBLbN.createHook)($01f5f05c8d8be152$var$store);
const $01f5f05c8d8be152$export$770c0b647b46c688 = (0, $WBLbN.createActionsHook)($01f5f05c8d8be152$var$store);
const $01f5f05c8d8be152$export$c5622799de43dc3a = (0, $WBLbN.createHook)($01f5f05c8d8be152$var$store, {
    selector: ({ query: query, queryVersion: queryVersion, searchSessionId: searchSessionId, screenName: screenName, isCachedResult: isCachedResult })=>({
            wordCount: (0, $6Vuvq.getWordCount)(query),
            queryLength: query.length,
            queryHash: (0, $6Vuvq.getQueryHash)(query),
            queryVersion: queryVersion,
            searchSessionId: searchSessionId,
            activeProduct: 'jira',
            isMultiProduct: false,
            screenName: screenName,
            isCachedResult: isCachedResult
        })
});

});
parcelRegister("6Vuvq", function(module, exports) {

$parcel$export(module.exports, "getQueryHash", () => $c1fc53def8d416d1$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $c1fc53def8d416d1$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "transformResultsForAnalytics", () => $c1fc53def8d416d1$export$902530edac79328);

var $3IRl5 = parcelRequire("3IRl5");
const $c1fc53def8d416d1$export$fa1c95a5ffa92036 = (str)=>(0, $3IRl5.createHash)().update(str).digest('hex');
const $c1fc53def8d416d1$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $c1fc53def8d416d1$export$902530edac79328 = (data, isRecentResult)=>{
    const results = data?.scopes?.map((scope)=>({
            sectionId: scope.id,
            results: scope.results.map((result)=>({
                    containerId: result?.attributes && 'containerId' in result?.attributes ? result?.attributes?.containerId || 'UNAVAILABLE' : 'UNAVAILABLE',
                    isRecentResult: isRecentResult,
                    resultContentId: result.id,
                    resultType: scope.id
                }))
        }));
    const resultCount = data?.scopes?.reduce((acc, scope)=>acc + scope.size, 0);
    return {
        results: results,
        sectionCount: data?.scopes?.length || 0,
        resultCount: resultCount,
        noResultsFetched: !results?.find((scope)=>scope.results.length > 0)
    };
};

});



parcelRegister("3fAKi", function(module, exports) {

$parcel$export(module.exports, "QuickSearchChildren", () => $40c6a82f2f37eb9f$export$a68383740408995a);

var $eUqFw = parcelRequire("eUqFw");

var $LddR2 = parcelRequire("LddR2");
var $hH3bZ = parcelRequire("hH3bZ");

var $8CN3d = parcelRequire("8CN3d");

var $6bWAB = parcelRequire("6bWAB");

var $30UcR = parcelRequire("30UcR");

var $l42Fv = parcelRequire("l42Fv");

var $3piX0 = parcelRequire("3piX0");
const $40c6a82f2f37eb9f$export$4630ed09821f1a78 = ()=>{
    const { fetch: fetch } = (0, $6bWAB.useQuickSearchWithRecentCache)();
    const getRecentResults = (0, $30UcR.useGetRecentResults)();
    const getSearchResults = (0, $l42Fv.useGetSearchResults)();
    const [{ searchSessionId: searchSessionId }, { setQuery: setQuery, setIsCachedResult: setIsCachedResult, setScreenName: setScreenName }] = (0, $8CN3d.useQuickSearchAnalytics)();
    const controllerRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>()=>controllerRef.current?.abort(), []);
    const isMountedRef = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    const loadChildren = (0, $eUqFw.useCallback)(async ({ search: search })=>{
        controllerRef.current?.abort();
        controllerRef.current = new AbortController();
        let response;
        let error;
        try {
            setQuery(search);
            response = await fetch(search, searchSessionId, controllerRef.current?.signal);
        } catch (e) {
            error = e instanceof Error ? e : new Error('Error not identified');
        }
        setIsCachedResult(response?.isCache || false);
        if (search && search.length > 0) {
            setScreenName('postQuerySearchResults');
            return {
                ...getSearchResults({
                    search: search,
                    quickSearchResponseData: response?.result,
                    error: error
                })
            };
        }
        setScreenName('preQuerySearchResults');
        return {
            ...getRecentResults({
                search: search,
                quickSearchResponseData: response?.result,
                error: error
            })
        };
    }, [
        setIsCachedResult,
        setScreenName,
        getRecentResults,
        setQuery,
        fetch,
        searchSessionId,
        getSearchResults
    ]);
    return {
        loadChildren: loadChildren
    };
};
const $40c6a82f2f37eb9f$export$a68383740408995a = ({ setChildResult: setChildResult, setLoading: setLoading, ...rest })=>{
    const { loadChildren: loadChildren } = $40c6a82f2f37eb9f$export$4630ed09821f1a78();
    const loadChildCommands = (0, $eUqFw.useCallback)((searchTerm, obj)=>loadChildren({
            search: searchTerm
        }).then((result)=>{
            if (!obj.isMounted) return;
            setChildResult?.(result);
        }), [
        loadChildren,
        setChildResult
    ]);
    (0, $hH3bZ.useDebouncedLoadChildren)(loadChildCommands);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LddR2.components).Body, {
        setChildResult: setChildResult,
        setLoading: setLoading,
        ...rest
    });
};

});
parcelRegister("hH3bZ", function(module, exports) {

$parcel$export(module.exports, "useDebouncedLoadChildren", () => $2d65e740d1f04fbc$export$d38ddfbd8b9028f);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $1ybV0 = parcelRequire("1ybV0");

var $gCtL7 = parcelRequire("gCtL7");
const $2d65e740d1f04fbc$export$d38ddfbd8b9028f = (callback)=>{
    const [{ search: search }, { setLoadingList: setLoadingList }] = (0, $gCtL7.useCommandPaletteSearch)();
    const loadChildCommands = (0, $eUqFw.useCallback)(async (searchTerm, obj)=>{
        await callback(searchTerm, obj);
        if (!obj.isMounted) return;
        setLoadingList(false);
    }, [
        callback,
        setLoadingList
    ]);
    const executeDebouncer = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(loadChildCommands, (0, $1ybV0.ff)('compal-issue-actions-follow-up-improvements_y49xu') ? 250 : 400), [
        loadChildCommands
    ]);
    (0, $eUqFw.useEffect)(()=>()=>executeDebouncer?.cancel?.(), [
        executeDebouncer
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const obj = {
            isMounted: true
        };
        setLoadingList(true);
        executeDebouncer(search, obj);
        return ()=>{
            obj.isMounted = false;
        };
    }, [
        search,
        executeDebouncer,
        setLoadingList
    ]);
};

});

parcelRegister("6bWAB", function(module, exports) {

$parcel$export(module.exports, "useQuickSearchWithRecentCache", () => $23ab6ce20fd85577$export$7eb3d4d963c0f46c);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $9ski6 = parcelRequire("9ski6");
const $23ab6ce20fd85577$export$ca7c3b177540050a = ()=>{
    const recentCacheRef = (0, $eUqFw.useRef)();
    const setRecentCache = (0, $eUqFw.useCallback)((cache)=>{
        recentCacheRef.current = cache;
    }, [
        recentCacheRef
    ]);
    return [
        recentCacheRef,
        setRecentCache
    ];
};
const $23ab6ce20fd85577$export$7eb3d4d963c0f46c = ()=>{
    const [{ isOpen: isOpen }] = (0, $gCtL7.useCommandPaletteIsOpen)();
    const [recentCache, setRecentCache] = $23ab6ce20fd85577$export$ca7c3b177540050a();
    const { fetch: fetch } = (0, $9ski6.useQuickSearch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // Reset cache when compal closes
    (0, $eUqFw.useEffect)(()=>{
        if (Boolean(recentCache.current) && !isOpen) setRecentCache(undefined);
    }, [
        isOpen,
        recentCache,
        setRecentCache
    ]);
    const fetchData = (0, $eUqFw.useCallback)(async (searchString, sessionId, signal)=>{
        const start = new Date();
        const apiCall = fetch(searchString, sessionId, signal);
        const result = await apiCall;
        const end = new Date();
        const duration = end.getTime() - start.getTime();
        if (searchString?.length) (0, $jMP2a.fireTrackAnalyticsDeferred)(createAnalyticsEvent({}), 'searchRequest completed', {
            postQueryRequestDurationMs: duration
        });
        else {
            (0, $jMP2a.fireTrackAnalyticsDeferred)(createAnalyticsEvent({}), 'recentRequest completed', {
                preQueryRequestDurationMs: duration
            });
            setRecentCache(apiCall);
        }
        return result;
    }, [
        createAnalyticsEvent,
        fetch,
        setRecentCache
    ]);
    const getResponse = (0, $eUqFw.useCallback)(async (searchString, sessionId, signal)=>{
        if (searchString && searchString.length > 0) {
            const result = await fetchData(searchString, sessionId, signal);
            return {
                result: result,
                isCache: false
            };
        }
        if (recentCache.current) // refetch if existing cache is in error state
        try {
            await recentCache.current;
        } catch (err) {
            const apiCall = fetchData(searchString, sessionId, signal);
            return {
                result: await apiCall,
                isCache: false
            };
        }
        else {
            const apiCall = fetchData(searchString, sessionId, signal);
            return {
                result: await apiCall,
                isCache: false
            };
        }
        return {
            result: await recentCache.current,
            isCache: true
        };
    }, [
        recentCache,
        fetchData
    ]);
    return {
        fetch: getResponse
    };
};

});
parcelRegister("9ski6", function(module, exports) {

$parcel$export(module.exports, "useQuickSearch", () => $05d922215cef879e$export$8ad8ebb2d2ffa47);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $gd0Sp = parcelRequire("gd0Sp");

var $dBMIc = parcelRequire("dBMIc");
const $05d922215cef879e$var$EXPERIENCE = 'command-palette-jira-integration';
// limit of results per scope (can only choose 1 limit, so we are using the max limit)
// we are also adding 1 to this so we know if there are more items than the limit (vs there is exactly the limit)
const $05d922215cef879e$var$LIMIT = Math.max((0, $dBMIc.ISSUE_LIMIT), (0, $dBMIc.PROJECT_LIMIT), (0, $dBMIc.BOARD_LIMIT), (0, $dBMIc.FILTER_LIMIT), (0, $dBMIc.PLAN_LIMIT)) + 1;
const $05d922215cef879e$export$8ad8ebb2d2ffa47 = ()=>{
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const fetch = (0, $eUqFw.useCallback)(async (query, sessionId, signal)=>{
        try {
            const data = await (0, $lRmyA.performPostRequest)('/gateway/api/xpsearch-aggregator/quicksearch/v1', {
                body: JSON.stringify({
                    cloudId: cloudId,
                    scopes: [
                        'jira.issue',
                        'jira.board',
                        'jira.project',
                        'jira.filter',
                        'jira.plan'
                    ],
                    query: query,
                    experience: $05d922215cef879e$var$EXPERIENCE,
                    searchSession: {
                        sessionId: sessionId,
                        referrerId: null
                    },
                    limit: $05d922215cef879e$var$LIMIT
                }),
                signal: signal
            });
            return data;
        } catch (error) {
            (0, $guiFP.default)({
                error: error instanceof Error ? error : new Error('Error not identified'),
                meta: {
                    id: 'fetchRecentlyViewedIssuesService',
                    packageName: 'jiraCommandPaletteQuickSearch',
                    teamName: 'deliveroo'
                }
            });
            throw error;
        }
    }, [
        cloudId
    ]);
    return {
        fetch: fetch
    };
};

});
parcelRegister("dBMIc", function(module, exports) {

$parcel$export(module.exports, "QUICK_SEARCH_PRIORITY", () => $b9556a53a77f558b$export$ce7c8c2e20fb73ca);
$parcel$export(module.exports, "ISSUE_LIMIT", () => $b9556a53a77f558b$export$dcc4c3a6f9b2e0aa);
$parcel$export(module.exports, "PROJECT_LIMIT", () => $b9556a53a77f558b$export$8000560255015036);
$parcel$export(module.exports, "BOARD_LIMIT", () => $b9556a53a77f558b$export$2987f3ac7bc1c1c3);
$parcel$export(module.exports, "FILTER_LIMIT", () => $b9556a53a77f558b$export$14ceffb568197d5a);
$parcel$export(module.exports, "PLAN_LIMIT", () => $b9556a53a77f558b$export$654fbdaf884d026c);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $b9556a53a77f558b$export$ce7c8c2e20fb73ca;
(function(QUICK_SEARCH_PRIORITY) {
    QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["ISSUES"] = 0] = "ISSUES";
    QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["PROJECTS"] = 1] = "PROJECTS";
    QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["BOARDS"] = 2] = "BOARDS";
    QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["FILTERS"] = 3] = "FILTERS";
    QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["PLANS"] = 4] = "PLANS";
    QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["RECOMMENDED"] = 5] = "RECOMMENDED";
})($b9556a53a77f558b$export$ce7c8c2e20fb73ca || ($b9556a53a77f558b$export$ce7c8c2e20fb73ca = {}));
const $b9556a53a77f558b$export$dcc4c3a6f9b2e0aa = 5;
const $b9556a53a77f558b$export$8000560255015036 = 3;
const $b9556a53a77f558b$export$2987f3ac7bc1c1c3 = 3;
const $b9556a53a77f558b$export$14ceffb568197d5a = 3;
const $b9556a53a77f558b$export$654fbdaf884d026c = 3;

});



parcelRegister("30UcR", function(module, exports) {

$parcel$export(module.exports, "useGetRecentResults", () => $8e96640c04b6745b$export$232194057b4317a2);

var $eUqFw = parcelRequire("eUqFw");

var $8FbYY = parcelRequire("8FbYY");

var $hawmT = parcelRequire("hawmT");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $1dpq6 = parcelRequire("1dpq6");

var $je4V0 = parcelRequire("je4V0");

var $472AY = parcelRequire("472AY");

var $6Vuvq = parcelRequire("6Vuvq");

var $drDlG = parcelRequire("drDlG");

var $3HVZG = parcelRequire("3HVZG");

var $gfVMl = parcelRequire("gfVMl");

var $55qsA = parcelRequire("55qsA");

var $l9NuM = parcelRequire("l9NuM");
const $8e96640c04b6745b$export$232194057b4317a2 = ()=>{
    const { getChildResult: getRecentBoardsChildResult } = (0, $drDlG.useGetRecentBoardsChildResult)();
    const { getChildResult: getRecentIssuesChildResult } = (0, $gfVMl.useGetRecentIssuesChildResult)();
    const { getChildResult: getRecentProjectsChildResult } = (0, $l9NuM.useGetRecentProjectsChildResult)();
    const { getChildResult: getRecentFiltersChildResult } = (0, $3HVZG.useGetRecentFiltersChildResult)();
    const { getChildResult: getRecentPlansChildResult } = (0, $55qsA.useGetRecentPlansChildResult)();
    const { getChildResult: getErrorChildResult } = (0, $1dpq6.useGetErrorChildResult)();
    const { getChildResult: getRecommendedChildResult } = (0, $je4V0.useGetRecommendedChildResult)();
    const [hasEditOrViewPermissions] = (0, $hawmT.useNavigationViewPlansPermission)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, $472AY.useSetTimeoutAutoClear)();
    const setTimeoutFunc = setTimeoutAutoClear;
    const getRecentResults = (0, $eUqFw.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        setTimeoutFunc(()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'searchResults shown', 'preQuerySearchResults', {
                ...(0, $6Vuvq.transformResultsForAnalytics)(quickSearchResponseData, true)
            });
        }, 0);
        return (0, $8FbYY.mergeChildResults)([
            getErrorChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getRecommendedChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getRecentIssuesChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getRecentProjectsChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getRecentBoardsChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getRecentFiltersChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            ...hasEditOrViewPermissions ? [
                getRecentPlansChildResult({
                    search: search,
                    quickSearchResponseData: quickSearchResponseData,
                    error: error
                })
            ] : []
        ]);
    }, [
        createAnalyticsEvent,
        getErrorChildResult,
        getRecommendedChildResult,
        getRecentIssuesChildResult,
        getRecentProjectsChildResult,
        getRecentBoardsChildResult,
        getRecentFiltersChildResult,
        hasEditOrViewPermissions,
        getRecentPlansChildResult,
        setTimeoutFunc
    ]);
    return getRecentResults;
};

});
parcelRegister("hawmT", function(module, exports) {

$parcel$export(module.exports, "navigationPlansVisibilityResource", () => $a93019de4376d1a2$export$fa475a9581133779);
$parcel$export(module.exports, "useNavigationPlansVisibility", () => $a93019de4376d1a2$export$4524245d4e74edb2);
$parcel$export(module.exports, "useNavigationViewPlansPermission", () => $a93019de4376d1a2$export$98eef08fd4586a4);
$parcel$export(module.exports, "useNavigationEditPlansPermission", () => $a93019de4376d1a2$export$525db876ed776e0d);
$parcel$export(module.exports, "useIsAdvancedRoadmapsTrial", () => $a93019de4376d1a2$export$54805a2120a31ad0);

var $gUUjF = parcelRequire("gUUjF");

var $79xbN = parcelRequire("79xbN");

var $2OdyW = parcelRequire("2OdyW");

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

var $6WXNs = parcelRequire("6WXNs");
var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");

const $a93019de4376d1a2$export$fa475a9581133779 = (0, $6xFTe.createResource)({
    type: (0, $b5f6b10e2be29709$export$9260ddb6dfeafd7b),
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return false;
            const response = await (0, $2OdyW.default)(`${tenantContext.baseUrl}/rest/jpo/1.0/navigation/simple`);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $b5f6b10e2be29709$export$87d0ca22edb7493a), 'Error while fetching plans visibility', error);
        }
        return false;
    },
    maxAge: Infinity
});
const $a93019de4376d1a2$export$4524245d4e74edb2 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $h5RgW.useResource)($a93019de4376d1a2$export$fa475a9581133779);
    const appEditions = (0, $ab6rA.useAppEditions)();
    const jswEdition = (0, $6WXNs.getEdition)((0, $eIp1n.JIRA_SOFTWARE), appEditions);
    let isVisible = false;
    if (!error && !loading && data !== null && typeof data === 'object') isVisible = data.isVisible;
    if (isVisible && jswEdition === (0, $6WXNs.FREE_EDITION)) {
        const shouldHidePlans = (0, $79xbN.expVal)('hide_plans_tab_for_jira_free', 'shouldHidePlansTab', false);
        return [
            !shouldHidePlans
        ];
    }
    return [
        isVisible
    ];
};
const $a93019de4376d1a2$export$98eef08fd4586a4 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $h5RgW.useResource)($a93019de4376d1a2$export$fa475a9581133779);
    let hasEditOrViewPermissions = false;
    if (!error && !loading && data !== null && typeof data === 'object') hasEditOrViewPermissions = data.hasEditOrViewPermissions;
    return [
        hasEditOrViewPermissions
    ];
};
const $a93019de4376d1a2$export$525db876ed776e0d = ()=>{
    const { data: data, loading: loading, error: error } = (0, $h5RgW.useResource)($a93019de4376d1a2$export$fa475a9581133779);
    let canEditPlans = false;
    if (!error && !loading && data !== null && typeof data === 'object') canEditPlans = data.hasEditPermissions || false;
    return canEditPlans;
};
const $a93019de4376d1a2$export$54805a2120a31ad0 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $h5RgW.useResource)($a93019de4376d1a2$export$fa475a9581133779);
    let isAdvancedRoadmapsTrial = false;
    if (!error && !loading && data !== null && typeof data === 'object') isAdvancedRoadmapsTrial = data.isAdvancedRoadmapsTrial || false;
    return isAdvancedRoadmapsTrial;
};

});
const $b5f6b10e2be29709$export$9260ddb6dfeafd7b = 'NAVIGATION_PLANS_VISIBILITY';
const $b5f6b10e2be29709$export$87d0ca22edb7493a = 'portfolio.services.plan-item-visibility';


parcelRegister("1dpq6", function(module, exports) {

$parcel$export(module.exports, "useGetErrorChildResult", () => $71c149305d967e91$export$3aefd3a8866c4c01);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fFLcE = parcelRequire("fFLcE");

var $gFgHR = parcelRequire("gFgHR");


var $4YCqV = parcelRequire("4YCqV");

var $jsJwX = parcelRequire("jsJwX");
const $71c149305d967e91$export$3aefd3a8866c4c01 = ()=>{
    const { formatMessage: formatMessage, formatList: formatList } = (0, $5JgJ2.default)();
    const getChildResult = (0, $eUqFw.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        const commands = [];
        const sections = {};
        const isSearching = Boolean(search);
        const issueScope = (0, $gFgHR.getQuickSearchIssueScope)(quickSearchResponseData);
        const projectScope = (0, $gFgHR.getQuickSearchProjectScope)(quickSearchResponseData);
        const boardScope = (0, $gFgHR.getQuickSearchBoardScope)(quickSearchResponseData);
        const filterScope = (0, $gFgHR.getQuickSearchFilterScope)(quickSearchResponseData);
        const planScope = (0, $gFgHR.getQuickSearchPlanScope)(quickSearchResponseData);
        const errorScopes = [
            issueScope?.error ? formatMessage((0, $4YCqV.messages).issues) : undefined,
            projectScope?.error ? formatMessage((0, $4YCqV.messages).projects) : undefined,
            boardScope?.error ? formatMessage((0, $4YCqV.messages).boards) : undefined,
            filterScope?.error ? formatMessage((0, $4YCqV.messages).filters) : undefined,
            planScope?.error ? formatMessage((0, $4YCqV.messages).plans) : undefined
        ];
        const errors = errorScopes.filter(Boolean); // If there is an api error or the api scopes are all errors
        if (error || errorScopes.length === errors.length) {
            const message = formatMessage(isSearching ? (0, $4YCqV.messages).searchFullError : (0, $4YCqV.messages).recentFullError);
            commands.push({
                id: 'full-error',
                name: message,
                components: {
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($71c149305d967e91$var$CommandErrorWrapper, {
                            "data-testid": (0, $6ef7030f2ad50edc$export$1a00547d03f724bf)
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fFLcE.FullWidthText), null, message))
                },
                keywords: search
            });
            return {
                sections: sections,
                commands: commands
            };
        }
        // If the api scopes are partially errored
        if (errors.length) {
            const formattedErrors = formatList(errors, {
                style: 'long',
                type: 'conjunction'
            });
            const message = isSearching ? formatMessage((0, $4YCqV.messages).searchPartialError, {
                errorList: formattedErrors
            }) : formatMessage((0, $4YCqV.messages).recentPartialError, {
                errorList: formattedErrors
            });
            commands.push({
                id: 'partial-error',
                name: formatMessage((0, $4YCqV.messages).searchFullError),
                // todo fix this
                components: {
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($71c149305d967e91$var$CommandErrorWrapper, {
                            "data-testid": (0, $6ef7030f2ad50edc$export$18ff005171e98b96)
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fFLcE.FullWidthText), null, message))
                },
                keywords: search
            });
            return {
                sections: sections,
                commands: commands
            };
        }
        const noSearchResults = !issueScope?.results?.length && !projectScope?.results?.length && !boardScope?.results?.length && !filterScope?.results?.length && !planScope?.results?.length;
        if (noSearchResults) {
            if (isSearching) commands.push({
                id: 'no-search-results',
                name: formatMessage((0, $4YCqV.messages).searchFullError),
                keywords: search,
                components: {
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($71c149305d967e91$var$CommandErrorWrapper, {
                            "data-testid": (0, $6ef7030f2ad50edc$export$92b3b15780115417)
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fFLcE.FullWidthText), null, formatMessage((0, $4YCqV.messages).searchNoResults)))
                }
            });
            else {
                const message = formatMessage((0, $4YCqV.messages).noRecentResults);
                commands.push({
                    id: 'no-recent-results',
                    name: message,
                    keywords: search,
                    components: {
                        Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($71c149305d967e91$var$CommandErrorWrapper, {
                                "data-testid": (0, $6ef7030f2ad50edc$export$b42da4a04bacaf8c)
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jsJwX.NoRecentResults), {
                                message: message
                            }))
                    }
                });
            }
            return {
                sections: sections,
                commands: commands
            };
        }
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatList,
        formatMessage
    ]);
    return {
        getChildResult: getChildResult
    };
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $71c149305d967e91$var$CommandErrorWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qpxbi _n3tdu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fFLcE", function(module, exports) {

$parcel$export(module.exports, "FullWidthText", () => $6389c69e6da1c39e$export$379b1877ecebef1d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $6389c69e6da1c39e$export$379b1877ecebef1d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gFgHR", function(module, exports) {

$parcel$export(module.exports, "transformQuickSearchIssueResultToIssue", () => $2259c3984412ea6a$export$58562759d0785ec6);
$parcel$export(module.exports, "getQuickSearchIssueScope", () => $2259c3984412ea6a$export$d7d3d79bf2e09f24);
$parcel$export(module.exports, "transformQuickSearchBoardResultToBoard", () => $2259c3984412ea6a$export$b8b15ec40fa1a48c);
$parcel$export(module.exports, "getQuickSearchBoardScope", () => $2259c3984412ea6a$export$53119668e12df12a);
$parcel$export(module.exports, "getQuickSearchProjectScope", () => $2259c3984412ea6a$export$a63a1be38234a3e5);
$parcel$export(module.exports, "transformQuickSearchProjectResultToProject", () => $2259c3984412ea6a$export$f2d81fcd7b29a3fa);
$parcel$export(module.exports, "getQuickSearchFilterScope", () => $2259c3984412ea6a$export$9fa79248b92c9eb7);
$parcel$export(module.exports, "transformQuickSearchFilterResultToFilter", () => $2259c3984412ea6a$export$ff1365615bf8816a);
$parcel$export(module.exports, "getQuickSearchPlanScope", () => $2259c3984412ea6a$export$ee6c69e884c0330);
$parcel$export(module.exports, "transformQuickSearchPlanResultToPlan", () => $2259c3984412ea6a$export$8033b8f463ee000a);
const $2259c3984412ea6a$export$58562759d0785ec6 = (issue)=>({
        issueId: issue.id,
        summary: issue.name,
        url: issue.url,
        issueKey: issue.attributes.key,
        avatar: issue.attributes.avatar,
        projectName: issue.attributes.container.title,
        projectId: issue.attributes.containerId,
        issueTypeName: issue.attributes.issueTypeName
    });
const $2259c3984412ea6a$export$d7d3d79bf2e09f24 = (results)=>{
    const issueResults = results?.scopes?.find((scope)=>scope.id === 'jira.issue');
    if (issueResults) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return issueResults;
    return undefined;
};
const $2259c3984412ea6a$export$b8b15ec40fa1a48c = (board)=>({
        id: board.id,
        url: board.url,
        name: board.name,
        containerId: board.attributes.containerId,
        containerName: board.attributes.containerName,
        isFavourite: board.attributes.isFavourite
    });
const $2259c3984412ea6a$export$53119668e12df12a = (results)=>{
    const boardResults = results?.scopes?.find((scope)=>scope.id === 'jira.board');
    if (boardResults) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return boardResults;
    return undefined;
};
const $2259c3984412ea6a$export$a63a1be38234a3e5 = (results)=>{
    const issueResults = results?.scopes?.find((scope)=>scope.id === 'jira.project');
    if (issueResults) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return issueResults;
    return undefined;
};
const $2259c3984412ea6a$export$f2d81fcd7b29a3fa = (project)=>({
        projectId: project.id,
        name: project.name,
        url: project.url,
        avatar: project.attributes.avatar,
        canView: project.attributes.canView,
        isFavourite: project.attributes.isFavourite,
        projectKey: project.attributes.projectKey,
        projectType: project.attributes.projectType,
        simplified: project.attributes.simplified
    });
const $2259c3984412ea6a$export$9fa79248b92c9eb7 = (results)=>{
    const filterResults = results?.scopes?.find((scope)=>scope.id === 'jira.filter');
    if (filterResults) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return filterResults;
    return undefined;
};
const $2259c3984412ea6a$export$ff1365615bf8816a = (filter)=>({
        id: filter.id,
        name: filter.name,
        url: filter.url
    });
const $2259c3984412ea6a$export$ee6c69e884c0330 = (results)=>{
    const planResults = results?.scopes?.find((scope)=>scope.id === 'jira.plan');
    if (planResults) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return planResults;
    return undefined;
};
const $2259c3984412ea6a$export$8033b8f463ee000a = (plan)=>({
        id: plan.id,
        name: plan.name,
        url: plan.url
    });

});

const $6ef7030f2ad50edc$export$1a00547d03f724bf = 'command-palette.ui.modal.modal-dialog';
const $6ef7030f2ad50edc$export$18ff005171e98b96 = 'command-palette.ui.modal.modal-dialog';
const $6ef7030f2ad50edc$export$92b3b15780115417 = 'command-palette.ui.modal.modal-dialog';
const $6ef7030f2ad50edc$export$b42da4a04bacaf8c = 'no-recent-results';

parcelRegister("4YCqV", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ad2087a530a9c207$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ad2087a530a9c207$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    noRecentResults: {
        "id": "command-palette-quick-search.common.error.no-recent-results",
        "defaultMessage": "Things in Jira that you\u2019ve recently viewed will appear here."
    },
    recentFullError: {
        "id": "command-palette-quick-search.common.error.recent-full-error",
        "defaultMessage": "We\u2019re having trouble loading recently viewed issues. Try again in a few moments."
    },
    searchFullError: {
        "id": "command-palette-quick-search.common.error.search-full-error",
        "defaultMessage": "We\u2019re not sure what went wrong. Try again in a few moments."
    },
    searchNoResults: {
        "id": "command-palette-quick-search.common.error.search-no-results",
        "defaultMessage": "No issue, project, board, plan, or filter matches your search"
    },
    searchIssueError: {
        "id": "command-palette-quick-search.common.error.search-issue-error",
        "defaultMessage": "We\u2019re having trouble searching issues. You can try again in a few moments."
    },
    recentPartialError: {
        "id": "command-palette-quick-search.common.error.recent-partial-error",
        "defaultMessage": "We are having trouble loading {errorList} from your recently viewed items. Try again in a few moments."
    },
    searchPartialError: {
        "id": "command-palette-quick-search.common.error.search-partial-error",
        "defaultMessage": "We are having trouble searching {errorList}. Try again in a few moments."
    },
    issues: {
        "id": "command-palette-quick-search.common.error.issues",
        "defaultMessage": "issues"
    },
    projects: {
        "id": "command-palette-quick-search.common.error.projects",
        "defaultMessage": "projects"
    },
    boards: {
        "id": "command-palette-quick-search.common.error.boards",
        "defaultMessage": "boards"
    },
    filters: {
        "id": "command-palette-quick-search.common.error.filters",
        "defaultMessage": "filters"
    },
    plans: {
        "id": "command-palette-quick-search.common.error.plans",
        "defaultMessage": "plans"
    }
});

});

parcelRegister("jsJwX", function(module, exports) {

$parcel$export(module.exports, "NoRecentResults", () => $257235d923fa6843$export$6a5306d6ad19b06d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");

var $17zNW = parcelRequire("17zNW");

var $fFLcE = parcelRequire("fFLcE");
const $257235d923fa6843$export$6a5306d6ad19b06d = ({ message: message })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fFLcE.FullWidthText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($257235d923fa6843$var$ImageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $17zNW.default), {
        alt: "",
        fill: true
    })), message)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $257235d923fa6843$var$ImageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ioahv _kqswh2mm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("17zNW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5db74c20798b6f43$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6tSzp")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6tSzp")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = nj3nrg7zrmxwrhh9fn9ftw5m
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/nj3nrg7zrmxwrhh9fn9ftw5m

var $9TZf5 = parcelRequire("9TZf5");

var $6tSzp = parcelRequire("6tSzp");
const $5db74c20798b6f43$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6tSzp)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6tSzp))
});
var $5db74c20798b6f43$export$2e2bcd8739ae039 = $5db74c20798b6f43$var$Illustration;
// for advanced use only
const $5db74c20798b6f43$export$a179c88182cb9d56 = [
    0,
    0,
    95,
    89
];

});
parcelRegister("6tSzp", function(module, exports) {
module.exports = new URL("magic-search.dbdce574.svg", import.meta.url).toString();

});




parcelRegister("je4V0", function(module, exports) {

$parcel$export(module.exports, "useGetRecommendedChildResult", () => $6d9ba257d04aaf15$export$d7d3564e5e2691ad);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dBMIc = parcelRequire("dBMIc");

var $gFgHR = parcelRequire("gFgHR");

var $j0X9A = parcelRequire("j0X9A");

var $a0nPo = parcelRequire("a0nPo");

var $8rJyn = parcelRequire("8rJyn");
const $6d9ba257d04aaf15$var$SECTION_ID = 'recommended';
const $6d9ba257d04aaf15$export$d7d3564e5e2691ad = ()=>{
    const { getViewAllCommand: getViewAllCommand } = (0, $j0X9A.useGetViewAllCommand)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getChildResult = (0, $eUqFw.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        const isSearching = Boolean(search);
        const sections = {
            [$6d9ba257d04aaf15$var$SECTION_ID]: {
                name: formatMessage((0, $8rJyn.messages).recommendedSection),
                priority: (0, $dBMIc.QUICK_SEARCH_PRIORITY).RECOMMENDED
            }
        };
        const commands = [];
        const issueScope = (0, $gFgHR.getQuickSearchIssueScope)(quickSearchResponseData);
        const projectScope = (0, $gFgHR.getQuickSearchProjectScope)(quickSearchResponseData);
        const boardScope = (0, $gFgHR.getQuickSearchBoardScope)(quickSearchResponseData);
        const filterScope = (0, $gFgHR.getQuickSearchFilterScope)(quickSearchResponseData);
        const planScope = (0, $gFgHR.getQuickSearchPlanScope)(quickSearchResponseData);
        const showRecommended = (scope)=>!scope || scope.error || error || isSearching && !scope?.results?.length;
        if (showRecommended(issueScope)) commands.push(getViewAllCommand({
            id: 'recommended-issues',
            section: $6d9ba257d04aaf15$var$SECTION_ID,
            name: formatMessage((0, $8rJyn.messages).viewAllIssues),
            keywords: search,
            isRecommended: true,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $a0nPo.getViewAllUrl)((0, $a0nPo.ViewAllType).ISSUE),
            priority: (0, $dBMIc.QUICK_SEARCH_PRIORITY).ISSUES,
            analyticsPayload: {
                action: 'viewAllIssues'
            }
        }));
        if (showRecommended(boardScope)) commands.push(getViewAllCommand({
            id: 'recommended-boards',
            section: $6d9ba257d04aaf15$var$SECTION_ID,
            name: formatMessage((0, $8rJyn.messages).viewAllBoards),
            keywords: search,
            isRecommended: true,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $a0nPo.getViewAllUrl)((0, $a0nPo.ViewAllType).BOARD),
            priority: (0, $dBMIc.QUICK_SEARCH_PRIORITY).BOARDS,
            analyticsPayload: {
                action: 'viewAllBoards'
            }
        }));
        if (showRecommended(projectScope)) commands.push(getViewAllCommand({
            id: 'recommended-projects',
            section: $6d9ba257d04aaf15$var$SECTION_ID,
            name: formatMessage((0, $8rJyn.messages).viewAllProjects),
            keywords: search,
            isRecommended: true,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $a0nPo.getViewAllUrl)((0, $a0nPo.ViewAllType).PROJECT),
            priority: (0, $dBMIc.QUICK_SEARCH_PRIORITY).PROJECTS,
            analyticsPayload: {
                action: 'viewAllProjects'
            }
        }));
        if (showRecommended(filterScope)) commands.push(getViewAllCommand({
            id: 'recommended-filters',
            section: $6d9ba257d04aaf15$var$SECTION_ID,
            name: formatMessage((0, $8rJyn.messages).viewAllFilters),
            keywords: search,
            isRecommended: true,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $a0nPo.getViewAllUrl)((0, $a0nPo.ViewAllType).FILTER),
            priority: (0, $dBMIc.QUICK_SEARCH_PRIORITY).FILTERS,
            analyticsPayload: {
                action: 'viewAllFilters'
            }
        }));
        if (showRecommended(planScope)) commands.push(getViewAllCommand({
            id: 'recommended-plans',
            section: $6d9ba257d04aaf15$var$SECTION_ID,
            name: formatMessage((0, $8rJyn.messages).viewAllPlans),
            keywords: search,
            isRecommended: true,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $a0nPo.getViewAllUrl)((0, $a0nPo.ViewAllType).PLAN),
            priority: (0, $dBMIc.QUICK_SEARCH_PRIORITY).PLANS,
            analyticsPayload: {
                action: 'viewAllPlans'
            }
        }));
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getViewAllCommand
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("j0X9A", function(module, exports) {

$parcel$export(module.exports, "useGetViewAllCommand", () => $a26b24cac0f3ade3$export$fc2d112e790e7f2a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cSu9v = parcelRequire("cSu9v");

var $gIIkx = parcelRequire("gIIkx");
const $a26b24cac0f3ade3$export$fc2d112e790e7f2a = ()=>{
    const { transformNavigationCommand: transformNavigationCommand } = (0, $gIIkx.useTransformNavigationCommands)();
    const getViewAllCommand = (0, $eUqFw.useCallback)(({ name: name, url: url, isRecommended: isRecommended = false, analyticsPayload: analyticsPayload = {}, ...rest })=>transformNavigationCommand({
            name: name,
            components: {
                Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a26b24cac0f3ade3$var$RenderNameWrapper, {
                        "data-testid": "command-palette-quick-search.common.ui.view-all.render-name-wrapper",
                        isRecommended: isRecommended
                    }, name),
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
                        label: ""
                    })
            },
            analytics: {
                action: 'quickSearchViewAll',
                ...analyticsPayload
            },
            ...rest
        }, {
            path: url
        }), [
        transformNavigationCommand
    ]);
    return {
        getViewAllCommand: getViewAllCommand
    };
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a26b24cac0f3ade3$var$RenderNameWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isRecommended: isRecommended, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            !__cmplp.isRecommended && "_syaz1e6v",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cSu9v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9601eacac1d33448$var$_react = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9601eacac1d33448$var$_arrowRight = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("gTPnA")));
function $9601eacac1d33448$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9601eacac1d33448$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $9601eacac1d33448$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $9601eacac1d33448$var$_arrowRight.default
    }));
$9601eacac1d33448$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $9601eacac1d33448$var$_default = module.exports.default = $9601eacac1d33448$var$ArrowRightIcon;

});
parcelRegister("gTPnA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::81f09b6725db6a703aeff6cd91bee5a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4d9a34bffd519bc$var$_react = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c4d9a34bffd519bc$var$_UNSAFE_baseNew = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c4d9a34bffd519bc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4d9a34bffd519bc$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c4d9a34bffd519bc$var$_react.default.createElement($c4d9a34bffd519bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M14.25 8H1m8.25-5 5 5-5 5"/>`
    }, props));
$c4d9a34bffd519bc$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c4d9a34bffd519bc$var$_default = module.exports.default = $c4d9a34bffd519bc$var$ArrowRightIcon;

});


parcelRegister("gIIkx", function(module, exports) {

$parcel$export(module.exports, "useTransformNavigationCommands", () => $2a846d5538aecfbb$export$5b108cd54c923a60);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $23NQ5 = parcelRequire("23NQ5");

var $6jiFZ = parcelRequire("6jiFZ");
var $LddR2 = parcelRequire("LddR2");
var $8FbYY = parcelRequire("8FbYY");
var $gCtL7 = parcelRequire("gCtL7");

var $igOBb = parcelRequire("igOBb");

var $jMP2a = parcelRequire("jMP2a");

var $lB25E = parcelRequire("lB25E");

var $8A5Pc = parcelRequire("8A5Pc");

var $4HIA6 = parcelRequire("4HIA6");

var $1Uuz9 = parcelRequire("1Uuz9");

var $duyJV = parcelRequire("duyJV");

const $2a846d5538aecfbb$export$5b108cd54c923a60 = ()=>{
    const [{ location: { pathname: pathname } }, { push: push, pushTo: pushTo }] = (0, $lB25E.useRouter)();
    const { getAnalyticsAttributes: getAnalyticsAttributes } = (0, $gCtL7.useActionsCommandPalette)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const openNewTab = (0, $eUqFw.useCallback)((link, openBackground)=>{
        const url = typeof link === 'string' ? link : link.path;
        const newTab = window.open(url, '_blank');
        if (openBackground) {
            newTab?.blur();
            window.focus();
        }
        return newTab;
    }, []);
    const openSameTab = (0, $eUqFw.useCallback)((link)=>{
        if (typeof link === 'string') return push(link);
        return pushTo(link);
    }, [
        push,
        pushTo
    ]);
    const renderCommand = (0, $eUqFw.useCallback)((props, path, shouldAlwaysOpenNewTab)=>{
        const { onClick: onClick, ...rest } = props;
        const { command: command } = rest;
        const handleClick = (event)=>{
            const wasSecondaryTriggered = (0, $8FbYY.isSecondaryTrigger)(event);
            if (!wasSecondaryTriggered) {
                onClick?.(event); // Run main action as it will close the modal too
                event.preventDefault();
                return;
            }
            const analytics = getAnalyticsAttributes(command, 'mouse', wasSecondaryTriggered, props?.analyticsAttributes);
            const eventAnalytics = createAnalyticsEvent({});
            (0, $jMP2a.fireTrackAnalytics)(eventAnalytics, 'commandPalette navigation', analytics);
            (0, $jMP2a.fireTrackAnalytics)(eventAnalytics, 'commandPalette secondaryAction', {
                ...analytics,
                keyPressed: (0, $igOBb.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                secondaryAction: 'openNewTab'
            });
            (0, $jMP2a.fireTrackAnalytics)(eventAnalytics, 'commandPalette taskSucceeded', analytics);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4HIA6.NavigationLink), {
            to: path,
            onClick: handleClick,
            ...shouldAlwaysOpenNewTab && {
                target: '_blank'
            },
            "data-testid": (0, $f3c17e0f83ec4de3$export$8db96ea7b6a4cbab),
            tabIndex: -1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LddR2.components).CommandRow, rest));
    }, [
        createAnalyticsEvent,
        getAnalyticsAttributes
    ]);
    const transformNavigationCommand = (0, $eUqFw.useCallback)((command, { path: path, shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab })=>({
            ...command,
            components: {
                ...command.components,
                Name: (base)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8A5Pc.NameContainer), null, command.components?.Name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.Name, base) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, command.name), !!shouldAlwaysOpenNewTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8A5Pc.IconContainer), {
                        "data-testid": (0, $f3c17e0f83ec4de3$export$99957d8f5f113509)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                        label: ""
                    }))),
                CommandRow: (base)=>renderCommand(base, path, shouldAlwaysOpenNewTab),
                Footer: (0, $1Uuz9.NewTabHintMessage)
            },
            primaryAction: {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: ()=>shouldAlwaysOpenNewTab ? openNewTab(path) : openSameTab(path)
            },
            secondaryAction: {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: ()=>openNewTab(path, true),
                preventModalClose: true,
                analyticsArgs: {
                    secondaryAction: 'openNewTab'
                }
            }
        }), [
        openNewTab,
        openSameTab,
        renderCommand
    ]);
    const shouldShowCommand = (0, $eUqFw.useCallback)((hideCommandPath)=>!(0, $duyJV.isCurrentPage)(hideCommandPath, pathname), [
        pathname
    ]);
    const hideAndTransformNavigationCommand = (0, $eUqFw.useCallback)((commandToTransform)=>{
        const { path: path, hideCommandPath: hideCommandPath, shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab, command: command } = commandToTransform;
        let hidePath = typeof path === 'string' ? path : path.path;
        if (hideCommandPath) hidePath = hideCommandPath;
        if (!shouldShowCommand(hidePath)) return undefined;
        return transformNavigationCommand(command, {
            path: path,
            shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab
        });
    }, [
        shouldShowCommand,
        transformNavigationCommand
    ]);
    const hideAndTransformNavigationCommands = (0, $eUqFw.useCallback)((commands)=>{
        const filteredCommands = [];
        commands.forEach((commandToTransform)=>{
            const transformedCommand = hideAndTransformNavigationCommand(commandToTransform);
            if (transformedCommand) filteredCommands.push(transformedCommand);
        });
        return filteredCommands;
    }, [
        hideAndTransformNavigationCommand
    ]);
    return {
        shouldShowCommand: shouldShowCommand,
        hideAndTransformNavigationCommand: hideAndTransformNavigationCommand,
        hideAndTransformNavigationCommands: hideAndTransformNavigationCommands,
        transformNavigationCommand: transformNavigationCommand
    };
};

});
parcelRegister("8A5Pc", function(module, exports) {

$parcel$export(module.exports, "NameContainer", () => $1a80cd2471468c76$export$817b6bdd5f45c94b);
$parcel$export(module.exports, "IconContainer", () => $1a80cd2471468c76$export$8f314e512d92575f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $1a80cd2471468c76$export$817b6bdd5f45c94b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _2lx2vrvc _1nmz1hna _slp31hna",
            __cmplp.className
        ])
    });
});
const $1a80cd2471468c76$export$8f314e512d92575f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _18u012x7 _1bsb1tcg _4t3i1tcg _vwz41tcg _1f027vkz _nbgx7vkz",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4HIA6", function(module, exports) {

$parcel$export(module.exports, "NavigationLink", () => $0497a7ba6bc39231$export$721ee963a67379f1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lB25E = parcelRequire("lB25E");
const $0497a7ba6bc39231$export$721ee963a67379f1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lB25E.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1Uuz9", function(module, exports) {

$parcel$export(module.exports, "NewTabHintMessage", () => $16f6fd73a925a670$export$54561b2030abf061);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $LddR2 = parcelRequire("LddR2");
var $5t8Df = parcelRequire("5t8Df");

var $igOBb = parcelRequire("igOBb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1TF2x = parcelRequire("1TF2x");
const $16f6fd73a925a670$export$54561b2030abf061 = ({ defaultFooterContent: defaultFooterContent })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LddR2.components).Footer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$FooterContentContainer, {
        "data-testid": "command-palette-common.common.ui.new-tab-hint-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, defaultFooterContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$HintMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$MessageWrapper, null, formatMessage((0, $1TF2x.messages).openInANewTab)), (0, $igOBb.isMacOs)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$MacLozenge, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$MacTextOffset, null, "\u2318")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$WindowsLozenge, null, "Ctrl"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$EnterLozenge, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16f6fd73a925a670$var$EnterIconSVG, null)))));
};
const $16f6fd73a925a670$var$EnterIconSVG = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "13",
        height: "8",
        viewBox: "0 0 13 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11.055 1.055V3.055H2.275L4.195 1.135C4.455 0.875 4.455 0.455 4.195 0.195C3.935 -0.065 3.515 -0.065 3.255 0.195L0.195 3.255C-0.065 3.515 -0.065 3.935 0.195 4.195L3.255 7.255C3.515 7.515 3.935 7.515 4.195 7.255C4.455 6.995 4.455 6.575 4.195 6.315L2.275 4.38833H11.7217C12.0883 4.38833 12.3883 4.08833 12.3883 3.72167V1.055C12.3883 0.688333 12.0883 0.388333 11.7217 0.388333C11.355 0.388333 11.055 0.688333 11.055 1.055Z",
        fill: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$exports).N600})`
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16f6fd73a925a670$var$FooterContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16f6fd73a925a670$var$HintMessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1y6m _syazc8hx _u5f312x7",
            __cmplp.className
        ])
    });
});
const $16f6fd73a925a670$var$MacLozenge = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $5t8Df.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0v77o _k48p1nn1 _1wybf6fq _vwz47vkz _syazc8hx",
            __cmplp.className
        ])
    });
});
const $16f6fd73a925a670$var$MacTextOffset = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_t9ec170z",
            __cmplp.className
        ])
    });
});
const $16f6fd73a925a670$var$WindowsLozenge = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $5t8Df.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1qjk _k48p1nn1 _1p1d1dk0 _syazc8hx",
            __cmplp.className
        ])
    });
});
const $16f6fd73a925a670$var$EnterLozenge = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $5t8Df.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0v77o",
            __cmplp.className
        ])
    });
});
const $16f6fd73a925a670$var$MessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c8qk37 _2hwxv77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1TF2x", function(module, exports) {

$parcel$export(module.exports, "messages", () => $62b2c63e3a44a01a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $62b2c63e3a44a01a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    openInANewTab: {
        "id": "command-palette-common.common.new-tab-hint-message.open-in-a-new-tab",
        "defaultMessage": "Open in a new tab"
    }
});

});


parcelRegister("duyJV", function(module, exports) {

$parcel$export(module.exports, "isCurrentPage", () => $fc96c12861a877b0$export$d4781f4a7d66b55c);
const $fc96c12861a877b0$export$d4781f4a7d66b55c = (hideCommandPath, pathname)=>{
    const currentPathnameWithoutTrailingSlash = pathname.replace(/\/$/, '');
    const hideCommandPathWithoutTrailingSlash = hideCommandPath?.replace(/\/$/, '');
    return hideCommandPathWithoutTrailingSlash === currentPathnameWithoutTrailingSlash;
};

});

const $f3c17e0f83ec4de3$export$99957d8f5f113509 = 'command-palette-common.controllers.transform-navigation-commands.icon-container';
const $f3c17e0f83ec4de3$export$8db96ea7b6a4cbab = 'command-palette-common.controllers.transform-navigation-commands.navigation-link';



parcelRegister("a0nPo", function(module, exports) {

$parcel$export(module.exports, "ViewAllType", () => $0be40a353c7be436$export$701f40362530db8b);
$parcel$export(module.exports, "getViewAllUrl", () => $0be40a353c7be436$export$96e8b39eed587a1e);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $0be40a353c7be436$export$701f40362530db8b;
(function(ViewAllType) {
    ViewAllType["PROJECT"] = "project";
    ViewAllType["ISSUE"] = "issue";
    ViewAllType["BOARD"] = "board";
    ViewAllType["FILTER"] = "filter";
    ViewAllType["PLAN"] = "plan";
})($0be40a353c7be436$export$701f40362530db8b || ($0be40a353c7be436$export$701f40362530db8b = {}));
const $0be40a353c7be436$export$96e8b39eed587a1e = (type, search)=>{
    switch(type){
        case "issue":
            return `/jira/search${search ? `?searchString=${search}` : ''}`;
        case "board":
            return `/jira/boards${search ? `?contains=${search}` : ''}`;
        case "project":
            return `/jira/projects${search ? `?keyword=${search}` : ''}`;
        case "filter":
            return `/jira/filters${search ? `?name=${search}` : ''}`;
        case "plan":
            return `/jira/plans${search ? `?name=${search}` : ''}`;
        default:
            return undefined;
    }
};

});

parcelRegister("8rJyn", function(module, exports) {

$parcel$export(module.exports, "messages", () => $cbff678eb95cceb1$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $cbff678eb95cceb1$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    recommendedSection: {
        "id": "command-palette-quick-search.common.recommended.recommended-section",
        "defaultMessage": "Recommended"
    },
    viewAllIssues: {
        "id": "command-palette-quick-search.common.recommended.view-all-issues",
        "defaultMessage": "View all issues"
    },
    viewAllProjects: {
        "id": "command-palette-quick-search.common.recommended.view-all-projects",
        "defaultMessage": "View all projects"
    },
    viewAllBoards: {
        "id": "command-palette-quick-search.common.recommended.view-all-boards",
        "defaultMessage": "View all boards"
    },
    viewAllFilters: {
        "id": "command-palette-quick-search.common.recommended.view-all-filters",
        "defaultMessage": "View all filters"
    },
    viewAllPlans: {
        "id": "command-palette-quick-search.common.recommended.view-all-plans",
        "defaultMessage": "View all plans"
    }
});

});


parcelRegister("472AY", function(module, exports) {

$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $f4b8b4ccf0b9f7fc$export$c3d20e8c1e93a572);

var $eUqFw = parcelRequire("eUqFw");
const $f4b8b4ccf0b9f7fc$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (0, $eUqFw.useCallback)((...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    }, []);
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});

parcelRegister("drDlG", function(module, exports) {

$parcel$export(module.exports, "useGetRecentBoardsChildResult", () => $3520ebe9d46abb21$export$67be4cf74634869c);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fOslh = parcelRequire("fOslh");

var $dBMIc = parcelRequire("dBMIc");


var $jmFu7 = parcelRequire("jmFu7");
const $3520ebe9d46abb21$export$67be4cf74634869c = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getQuickSearchBoardCommands: getQuickSearchBoardCommands } = (0, $fOslh.useGetQuickSearchBoardCommands)({
        section: (0, $2a160addefe41bfa$export$501955bd67991a25),
        showViewAll: false
    });
    const getChildResult = (0, $eUqFw.useCallback)((props)=>{
        const sections = {
            [(0, $2a160addefe41bfa$export$501955bd67991a25)]: {
                id: (0, $2a160addefe41bfa$export$501955bd67991a25),
                name: formatMessage((0, $jmFu7.messages).recentlyViewedBoards),
                priority: (0, $dBMIc.QUICK_SEARCH_PRIORITY).BOARDS
            }
        };
        const commands = getQuickSearchBoardCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchBoardCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("fOslh", function(module, exports) {

$parcel$export(module.exports, "useGetQuickSearchBoardCommands", () => $f495008d36a81443$export$3036f58f7b6b3d11);

var $eUqFw = parcelRequire("eUqFw");

var $dZFUQ = parcelRequire("dZFUQ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dBMIc = parcelRequire("dBMIc");

var $lgBXW = parcelRequire("lgBXW");

var $gFgHR = parcelRequire("gFgHR");

var $j0X9A = parcelRequire("j0X9A");

var $a0nPo = parcelRequire("a0nPo");
const $f495008d36a81443$export$3036f58f7b6b3d11 = ({ section: section, showViewAll: showViewAll })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getBoardCommand: getBoardCommand } = (0, $dZFUQ.useGetBoardCommand)();
    const { getViewAllCommand: getViewAllCommand } = (0, $j0X9A.useGetViewAllCommand)();
    const getQuickSearchBoardCommands = (0, $eUqFw.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        const boardScope = (0, $gFgHR.getQuickSearchBoardScope)(quickSearchResponseData);
        // No results
        if (!boardScope || error || boardScope?.error || boardScope?.results?.length === 0) return [];
        const commands = boardScope.results.slice(0, (0, $dBMIc.BOARD_LIMIT)).map((board)=>getBoardCommand({
                board: (0, $gFgHR.transformQuickSearchBoardResultToBoard)(board),
                keywords: search,
                section: section,
                analytics: {
                    isSearchResult: true
                }
            }));
        if (!showViewAll || boardScope.results.length <= (0, $dBMIc.BOARD_LIMIT)) return commands;
        const viewAllCommand = getViewAllCommand({
            id: 'view-all-boards',
            keywords: search,
            section: section,
            name: formatMessage((0, $lgBXW.messages).viewAllResults),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $a0nPo.getViewAllUrl)((0, $a0nPo.ViewAllType).BOARD, search),
            analyticsPayload: {
                action: 'viewAllBoards',
                size: boardScope.size
            }
        });
        return commands.concat([
            viewAllCommand
        ]);
    }, [
        formatMessage,
        getBoardCommand,
        getViewAllCommand,
        section,
        showViewAll
    ]);
    return {
        getQuickSearchBoardCommands: getQuickSearchBoardCommands
    };
};

});
parcelRegister("dZFUQ", function(module, exports) {

$parcel$export(module.exports, "useGetBoardCommand", () => $bdb99a41e67d9b22$export$a607cbe1c4fa60ee);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $28ybo = parcelRequire("28ybo");

var $gIIkx = parcelRequire("gIIkx");
const $bdb99a41e67d9b22$export$a607cbe1c4fa60ee = ()=>{
    const { transformNavigationCommand: transformNavigationCommand } = (0, $gIIkx.useTransformNavigationCommands)();
    const renderBoardName = (0, $eUqFw.useCallback)((name, containerName, isActive)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdb99a41e67d9b22$var$BoardNameContainer, {
            "data-testid": "command-palette-common.common.ui.command.board.board-name-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdb99a41e67d9b22$var$BoardNameText, null, name), containerName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdb99a41e67d9b22$export$17e73069b4d98f65, {
            active: isActive
        }, containerName)), []);
    const getBoardCommand = (0, $eUqFw.useCallback)(({ board: board, keywords: keywords, section: section, analytics: analytics, ...rest })=>{
        const { id: id, url: url, name: name, containerId: containerId = 'UNAVAILABLE', containerName: containerName } = board;
        return transformNavigationCommand({
            id: `board-${id}`,
            section: section,
            name: name,
            keywords: keywords,
            components: {
                Name: ({ isActive: isActive })=>renderBoardName(name, containerName, isActive),
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($28ybo))), {
                        label: ""
                    })
            },
            analytics: {
                action: 'boardViewed',
                boardId: id,
                boardContainerId: containerId || '',
                metadata: {
                    contentId: id,
                    containerId: containerId,
                    contentType: 'board'
                },
                ...analytics
            },
            ...rest
        }, {
            path: url
        });
    }, [
        renderBoardName,
        transformNavigationCommand
    ]);
    return {
        getBoardCommand: getBoardCommand
    };
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bdb99a41e67d9b22$var$BoardNameContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulp12x7",
            __cmplp.className
        ])
    });
});
const $bdb99a41e67d9b22$var$BoardNameText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81oud _vwz41kw7",
            __cmplp.className
        ])
    });
});
const $bdb99a41e67d9b22$export$17e73069b4d98f65 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81vlj _vwz41kw7",
            __cmplp.active ? "_syaz1a45" : "_syaz1wmz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("28ybo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $18e6d81a18ae6069$var$_react = $18e6d81a18ae6069$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $18e6d81a18ae6069$var$_board = $18e6d81a18ae6069$var$_interopRequireDefault((parcelRequire("1GihF")));
function $18e6d81a18ae6069$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $18e6d81a18ae6069$var$BoardIcon = (props)=>/*#__PURE__*/ $18e6d81a18ae6069$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M8 6v12h2V6zm6 0v12h2V6z"/></g></svg>`
    }, props, {
        newIcon: $18e6d81a18ae6069$var$_board.default
    }));
$18e6d81a18ae6069$var$BoardIcon.displayName = 'BoardIcon';
var $18e6d81a18ae6069$var$_default = module.exports.default = $18e6d81a18ae6069$var$BoardIcon;

});
parcelRegister("1GihF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8be58094d2c3db585c5ad72e0a89c62d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1397e58017ba0490$var$_react = $1397e58017ba0490$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $1397e58017ba0490$var$_UNSAFE_baseNew = $1397e58017ba0490$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $1397e58017ba0490$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1397e58017ba0490$var$BoardIcon = (props)=>/*#__PURE__*/ $1397e58017ba0490$var$_react.default.createElement($1397e58017ba0490$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M5.583 2.75H2C1.31 2.75.75 3.31.75 4v8c0 .69.56 1.25 1.25 1.25h3.583m0-10.5v10.5m0-10.5h4.834m-4.834 10.5h4.834m0-10.5H14c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25h-3.583m0-10.5v10.5"/>`
    }, props));
$1397e58017ba0490$var$BoardIcon.displayName = 'BoardIcon';
var $1397e58017ba0490$var$_default = module.exports.default = $1397e58017ba0490$var$BoardIcon;

});



parcelRegister("lgBXW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8904798379c5d6b9$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $8904798379c5d6b9$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    viewAllResults: {
        "id": "command-palette-quick-search.common.view-all-results",
        "defaultMessage": "View all results"
    }
});

});


const $2a160addefe41bfa$export$501955bd67991a25 = 'jira.board';

parcelRegister("jmFu7", function(module, exports) {

$parcel$export(module.exports, "messages", () => $baff5e50ae4dc59b$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $baff5e50ae4dc59b$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    recentlyViewedBoards: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.boards.recently-viewed-boards",
        "defaultMessage": "Recently Viewed Boards"
    }
});

});


parcelRegister("3HVZG", function(module, exports) {

$parcel$export(module.exports, "useGetRecentFiltersChildResult", () => $558ddd00c9fb6490$export$abc1122ece543f47);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dBMIc = parcelRequire("dBMIc");

var $lW8hb = parcelRequire("lW8hb");


var $8CNGl = parcelRequire("8CNGl");
const $558ddd00c9fb6490$export$abc1122ece543f47 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getQuickSearchFilterCommands: getQuickSearchFilterCommands } = (0, $lW8hb.useGetQuickSearchFilterCommands)({
        section: (0, $f6dbe079bcc5e85c$export$501955bd67991a25),
        showViewAll: false
    });
    const getChildResult = (0, $eUqFw.useCallback)((props)=>{
        const sections = {
            [(0, $f6dbe079bcc5e85c$export$501955bd67991a25)]: {
                id: (0, $f6dbe079bcc5e85c$export$501955bd67991a25),
                name: formatMessage((0, $8CNGl.messages).recentlyViewedFilters),
                priority: (0, $dBMIc.QUICK_SEARCH_PRIORITY).FILTERS
            }
        };
        const commands = getQuickSearchFilterCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchFilterCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("lW8hb", function(module, exports) {

$parcel$export(module.exports, "useGetQuickSearchFilterCommands", () => $462065ce37f5da74$export$b31b2989a89c872e);

var $eUqFw = parcelRequire("eUqFw");

var $90vo8 = parcelRequire("90vo8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dBMIc = parcelRequire("dBMIc");

var $lgBXW = parcelRequire("lgBXW");

var $gFgHR = parcelRequire("gFgHR");

var $j0X9A = parcelRequire("j0X9A");

var $a0nPo = parcelRequire("a0nPo");
const $462065ce37f5da74$export$b31b2989a89c872e = ({ section: section, showViewAll: showViewAll })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getFilterCommand: getFilterCommand } = (0, $90vo8.useGetFilterCommand)();
    const { getViewAllCommand: getViewAllCommand } = (0, $j0X9A.useGetViewAllCommand)();
    const getQuickSearchFilterCommands = (0, $eUqFw.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        const filterScope = (0, $gFgHR.getQuickSearchFilterScope)(quickSearchResponseData);
        // No results
        if (!filterScope || error || filterScope?.error || filterScope?.results?.length === 0) return [];
        const commands = filterScope.results.slice(0, (0, $dBMIc.FILTER_LIMIT)).map((filter)=>getFilterCommand({
                filter: (0, $gFgHR.transformQuickSearchFilterResultToFilter)(filter),
                keywords: search,
                section: section,
                analytics: {
                    isSearchResult: true
                }
            }));
        if (!showViewAll || filterScope.results.length <= (0, $dBMIc.FILTER_LIMIT)) return commands;
        const viewAllCommand = getViewAllCommand({
            id: 'view-all-filters',
            keywords: search,
            section: section,
            name: formatMessage((0, $lgBXW.messages).viewAllResults),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $a0nPo.getViewAllUrl)((0, $a0nPo.ViewAllType).FILTER, search),
            analyticsPayload: {
                action: 'viewAllFilters',
                size: filterScope.size
            }
        });
        return commands.concat([
            viewAllCommand
        ]);
    }, [
        formatMessage,
        getFilterCommand,
        getViewAllCommand,
        section,
        showViewAll
    ]);
    return {
        getQuickSearchFilterCommands: getQuickSearchFilterCommands
    };
};

});
parcelRegister("90vo8", function(module, exports) {

$parcel$export(module.exports, "useGetFilterCommand", () => $9b54631b58ada858$export$c074d91a3a335ecb);

var $eUqFw = parcelRequire("eUqFw");

var $4ki2H = parcelRequire("4ki2H");

var $gIIkx = parcelRequire("gIIkx");
const $9b54631b58ada858$export$c074d91a3a335ecb = ()=>{
    const { transformNavigationCommand: transformNavigationCommand } = (0, $gIIkx.useTransformNavigationCommands)();
    const getFilterCommand = (0, $eUqFw.useCallback)(({ filter: filter, section: section, analytics: analytics, ...rest })=>{
        const { id: id, url: url, name: name } = filter;
        return transformNavigationCommand({
            id: `filter-${id}`,
            section: section,
            name: name,
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ki2H))), {
                        label: ""
                    })
            },
            analytics: {
                action: 'filterViewed',
                filterId: id,
                metadata: {
                    contentId: id,
                    containerId: 'UNAVAILABLE',
                    contentType: 'filter'
                },
                ...analytics
            },
            ...rest
        }, {
            path: url
        });
    }, [
        transformNavigationCommand
    ]);
    return {
        getFilterCommand: getFilterCommand
    };
};

});


const $f6dbe079bcc5e85c$export$501955bd67991a25 = 'jira.filter';

parcelRegister("8CNGl", function(module, exports) {

$parcel$export(module.exports, "messages", () => $db2c17ff9f1c0340$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $db2c17ff9f1c0340$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    recentlyViewedFilters: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.filters.recently-viewed-filters",
        "defaultMessage": "Recently Viewed Filters"
    }
});

});


parcelRegister("gfVMl", function(module, exports) {

$parcel$export(module.exports, "useGetRecentIssuesChildResult", () => $eaa48e7c0c1978bc$export$e5366d4438f3f848);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dBMIc = parcelRequire("dBMIc");

var $bwtxV = parcelRequire("bwtxV");

var $E0PCa = parcelRequire("E0PCa");
const $eaa48e7c0c1978bc$var$SECTION_ID = 'jira.issue';
const $eaa48e7c0c1978bc$export$e5366d4438f3f848 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getQuickSearchIssueCommands: getQuickSearchIssueCommands } = (0, $bwtxV.useGetQuickSearchIssueCommands)({
        section: $eaa48e7c0c1978bc$var$SECTION_ID,
        errorMessage: formatMessage((0, $E0PCa.messages).issueError),
        showViewAll: false
    });
    const getChildResult = (0, $eUqFw.useCallback)((props)=>{
        const sections = {
            [$eaa48e7c0c1978bc$var$SECTION_ID]: {
                id: $eaa48e7c0c1978bc$var$SECTION_ID,
                name: formatMessage((0, $E0PCa.messages).recentlyViewedIssues),
                priority: (0, $dBMIc.QUICK_SEARCH_PRIORITY).ISSUES
            }
        };
        const commands = getQuickSearchIssueCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchIssueCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("bwtxV", function(module, exports) {

$parcel$export(module.exports, "useGetQuickSearchIssueCommands", () => $2d53875db69e1e67$export$e3611b615ec843dc);

var $eUqFw = parcelRequire("eUqFw");

var $33lXT = parcelRequire("33lXT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dBMIc = parcelRequire("dBMIc");

var $lgBXW = parcelRequire("lgBXW");

var $gFgHR = parcelRequire("gFgHR");

var $j0X9A = parcelRequire("j0X9A");

var $a0nPo = parcelRequire("a0nPo");
const $2d53875db69e1e67$export$e3611b615ec843dc = ({ section: section, showViewAll: showViewAll })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getIssueCommand: getIssueCommand } = (0, $33lXT.useGetIssueCommand)();
    const { getViewAllCommand: getViewAllCommand } = (0, $j0X9A.useGetViewAllCommand)();
    const getQuickSearchIssueCommands = (0, $eUqFw.useCallback)(({ error: error, search: search, quickSearchResponseData: quickSearchResponseData })=>{
        const issueScope = (0, $gFgHR.getQuickSearchIssueScope)(quickSearchResponseData);
        // No results
        if (!issueScope || error || issueScope?.error || issueScope?.results?.length === 0) return [];
        // There are results!
        const commands = issueScope.results.slice(0, (0, $dBMIc.ISSUE_LIMIT)).map((issue)=>{
            const command = getIssueCommand({
                issue: (0, $gFgHR.transformQuickSearchIssueResultToIssue)(issue),
                keywords: search,
                section: section,
                analytics: {
                    isSearchResult: true
                }
            });
            return command;
        });
        if (!showViewAll || issueScope.results.length <= (0, $dBMIc.ISSUE_LIMIT)) return commands;
        const viewAllCommand = getViewAllCommand({
            id: 'view-all-issues',
            keywords: search,
            section: section,
            name: formatMessage((0, $lgBXW.messages).viewAllResults),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $a0nPo.getViewAllUrl)((0, $a0nPo.ViewAllType).ISSUE, search),
            analyticsPayload: {
                action: 'viewAllIssues',
                size: issueScope.size
            }
        });
        return commands.concat([
            viewAllCommand
        ]);
    }, [
        formatMessage,
        getIssueCommand,
        getViewAllCommand,
        section,
        showViewAll
    ]);
    return {
        getQuickSearchIssueCommands: getQuickSearchIssueCommands
    };
};

});
parcelRegister("33lXT", function(module, exports) {

$parcel$export(module.exports, "useGetIssueCommand", () => $ff3e62beef364f34$export$98868e4240dcd14d);

var $eUqFw = parcelRequire("eUqFw");

var $gIIkx = parcelRequire("gIIkx");

var $b5tfU = parcelRequire("b5tfU");

var $1XCJk = parcelRequire("1XCJk");
const $ff3e62beef364f34$export$98868e4240dcd14d = ()=>{
    const { transformNavigationCommand: transformNavigationCommand } = (0, $gIIkx.useTransformNavigationCommands)();
    const getIssueCommand = (0, $eUqFw.useCallback)(({ issue: issue, keywords: keywords, section: section, analytics: analytics, ...rest })=>{
        const { issueId: issueId, summary: summary, issueKey: issueKey, projectId: projectId = 'UNAVAILABLE' } = issue;
        return transformNavigationCommand({
            id: `issue-${issueId}`,
            section: section,
            keywords: keywords,
            name: `${issueKey} ${summary}`,
            components: {
                Name: ({ isActive: isActive })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1XCJk.IssueView), {
                        issue: issue,
                        isActive: isActive
                    }),
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5tfU.IssueLeftIcon), {
                        iconUrl: issue.avatar?.url,
                        issueTypeName: issue.issueTypeName
                    })
            },
            analytics: {
                action: 'issueViewed',
                issueId: issueId,
                metadata: {
                    contentId: issueId,
                    containerId: projectId,
                    contentType: 'issue'
                },
                ...analytics
            },
            ...rest
        }, {
            path: `/browse/${issueKey}`
        });
    }, [
        transformNavigationCommand
    ]);
    return {
        getIssueCommand: getIssueCommand
    };
};

});
parcelRegister("b5tfU", function(module, exports) {

$parcel$export(module.exports, "IssueLeftIcon", () => $1622fc3f30429d58$export$b1b562672a76ad84);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4SlOI = parcelRequire("4SlOI");
const $1622fc3f30429d58$export$b1b562672a76ad84 = ({ iconUrl: iconUrl, issueTypeName: issueTypeName })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: iconUrl,
        alt: formatMessage((0, $4SlOI.messages).issueIconAltText, {
            issueTypeName: issueTypeName
        }),
        height: "16"
    });
};

});
parcelRegister("4SlOI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9a3b0db79e5e3d34$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9a3b0db79e5e3d34$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issueIconAltText: {
        "id": "command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text",
        "defaultMessage": "Icon for the issue type {issueTypeName}"
    }
});

});


parcelRegister("1XCJk", function(module, exports) {

$parcel$export(module.exports, "IssueView", () => $885de411a2deb395$export$5aebed4b5cba826a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jCRsd = parcelRequire("jCRsd");
const $885de411a2deb395$export$995d7ae0c0293bac = {
    1: 'default',
    2: 'default',
    3: 'success',
    4: 'inprogress'
};
const $885de411a2deb395$export$5aebed4b5cba826a = ({ issue: { issueKey: issueKey, summary: summary, projectName: projectName, status: status }, isActive: isActive })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $885de411a2deb395$var$searchResultContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($885de411a2deb395$var$TopContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jCRsd.TruncateWithTooltipOnActive), {
        isActive: !!isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($885de411a2deb395$var$IssueKey, null, issueKey), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($885de411a2deb395$var$IssueSummary, {
        active: isActive
    }, summary))), (status || projectName) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($885de411a2deb395$var$BottomContainer, null, status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $885de411a2deb395$var$statusStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: $885de411a2deb395$export$995d7ae0c0293bac[status.statusCategoryId],
        maxWidth: 236
    }, status.statusName)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($885de411a2deb395$var$ProjectName, {
        active: isActive
    }, projectName)));
const $885de411a2deb395$var$searchResultContainerStyles = (0, $1ZAYh.xcss)({
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $885de411a2deb395$var$TopContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz41tcg _slp31hna _1nmz1hna",
            __cmplp.className
        ])
    });
});
const $885de411a2deb395$var$IssueKey = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1a45 _2hwx12x7 _1e0c1nu9",
            __cmplp.className
        ])
    });
});
const $885de411a2deb395$var$IssueSummary = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1nu9",
            __cmplp.active ? "_syazaj1x" : "_syaz1a45",
            __cmplp.className
        ])
    });
});
const $885de411a2deb395$var$BottomContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _19pkv77o _syaz1a45 _11c8qk37 _vwz41kw7",
            __cmplp.className
        ])
    });
});
const $885de411a2deb395$var$statusStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.150'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $885de411a2deb395$var$ProjectName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s _p12fuuw1 _vwz4gktf",
            __cmplp.active ? "_syaz1a45" : "_syaz1wmz",
            __cmplp.className
        ])
    });
});

});



parcelRegister("E0PCa", function(module, exports) {

$parcel$export(module.exports, "messages", () => $efdf85da76e7ce16$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $efdf85da76e7ce16$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    recentlyViewedIssues: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.issues.recently-viewed-issues",
        "defaultMessage": "Recently Viewed Issues"
    },
    issueError: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.issues.issue-error",
        "defaultMessage": "We're having trouble loading recently viewed issues. Try again in a few moments."
    }
});

});


parcelRegister("55qsA", function(module, exports) {

$parcel$export(module.exports, "useGetRecentPlansChildResult", () => $b85556c6a5495346$export$ec02659dcd249bd6);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dBMIc = parcelRequire("dBMIc");

var $itkCl = parcelRequire("itkCl");


var $9NeqD = parcelRequire("9NeqD");
const $b85556c6a5495346$export$ec02659dcd249bd6 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getQuickSearchPlanCommands: getQuickSearchPlanCommands } = (0, $itkCl.useGetQuickSearchPlanCommands)({
        section: (0, $bf48e857a6ced0ff$export$501955bd67991a25),
        showViewAll: false
    });
    const getChildResult = (0, $eUqFw.useCallback)((props)=>{
        const sections = {
            [(0, $bf48e857a6ced0ff$export$501955bd67991a25)]: {
                id: (0, $bf48e857a6ced0ff$export$501955bd67991a25),
                name: formatMessage((0, $9NeqD.messages).recentlyViewedPlans),
                priority: (0, $dBMIc.QUICK_SEARCH_PRIORITY).PLANS
            }
        };
        const commands = getQuickSearchPlanCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchPlanCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("itkCl", function(module, exports) {

$parcel$export(module.exports, "useGetQuickSearchPlanCommands", () => $bb84d2bfae77ef28$export$668213efda00d797);

var $eUqFw = parcelRequire("eUqFw");

var $jYd4U = parcelRequire("jYd4U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dBMIc = parcelRequire("dBMIc");

var $lgBXW = parcelRequire("lgBXW");

var $gFgHR = parcelRequire("gFgHR");

var $j0X9A = parcelRequire("j0X9A");

var $a0nPo = parcelRequire("a0nPo");
const $bb84d2bfae77ef28$export$668213efda00d797 = ({ section: section, showViewAll: showViewAll })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getPlanCommand: getPlanCommand } = (0, $jYd4U.useGetPlanCommand)();
    const { getViewAllCommand: getViewAllCommand } = (0, $j0X9A.useGetViewAllCommand)();
    const getQuickSearchPlanCommands = (0, $eUqFw.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        const planScope = (0, $gFgHR.getQuickSearchPlanScope)(quickSearchResponseData);
        // No results
        if (!planScope || error || planScope?.error || planScope?.results?.length === 0) return [];
        const commands = planScope.results.slice(0, (0, $dBMIc.PLAN_LIMIT)).map((plan)=>getPlanCommand({
                plan: (0, $gFgHR.transformQuickSearchPlanResultToPlan)(plan),
                keywords: search,
                section: section,
                analytics: {
                    isSearchResult: true
                }
            }));
        if (!showViewAll || planScope.results.length <= (0, $dBMIc.PLAN_LIMIT)) return commands;
        const viewAllCommand = getViewAllCommand({
            id: 'view-all-plans',
            keywords: search,
            section: section,
            name: formatMessage((0, $lgBXW.messages).viewAllResults),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $a0nPo.getViewAllUrl)((0, $a0nPo.ViewAllType).PLAN, search),
            analyticsPayload: {
                action: 'viewAllPlans',
                size: planScope.size
            }
        });
        return commands.concat([
            viewAllCommand
        ]);
    }, [
        formatMessage,
        getPlanCommand,
        getViewAllCommand,
        section,
        showViewAll
    ]);
    return {
        getQuickSearchPlanCommands: getQuickSearchPlanCommands
    };
};

});
parcelRegister("jYd4U", function(module, exports) {

$parcel$export(module.exports, "useGetPlanCommand", () => $1607080d814a947b$export$69408f6c87099775);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gIIkx = parcelRequire("gIIkx");
const $1607080d814a947b$export$69408f6c87099775 = ()=>{
    const { transformNavigationCommand: transformNavigationCommand } = (0, $gIIkx.useTransformNavigationCommands)();
    const getPlanCommand = (0, $eUqFw.useCallback)(({ plan: plan, section: section, analytics: analytics, ...rest })=>{
        const { id: id, url: url, name: name } = plan;
        return transformNavigationCommand({
            id: `plan-${id}`,
            section: section,
            name: name,
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1607080d814a947b$export$3eeaa2f0a53409a2, null)
            },
            analytics: {
                action: 'planViewed',
                planId: id,
                metadata: {
                    contentId: id,
                    containerId: 'UNAVAILABLE',
                    contentType: 'plan'
                },
                ...analytics
            },
            ...rest
        }, {
            path: url
        });
    }, [
        transformNavigationCommand
    ]);
    return {
        getPlanCommand: getPlanCommand
    };
};
const $1607080d814a947b$export$3eeaa2f0a53409a2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1607080d814a947b$var$PlanLeftIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6.44455 5.66667C6.015 5.66667 5.66677 6.01489 5.66677 6.44444C5.66677 6.874 6.015 7.22222 6.44455 7.22222H9.55566C9.98522 7.22222 10.3334 6.874 10.3334 6.44444C10.3334 6.01489 9.98522 5.66667 9.55566 5.66667H6.44455Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6.44455 8.77778C6.44455 8.34822 6.79278 8 7.22233 8H10.3334C10.763 8 11.1112 8.34822 11.1112 8.77778C11.1112 9.20733 10.763 9.55556 10.3334 9.55556H7.22233C6.79278 9.55556 6.44455 9.20733 6.44455 8.77778Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6.44455 10.3333C6.015 10.3333 5.66677 10.6816 5.66677 11.1111C5.66677 11.5407 6.015 11.8889 6.44455 11.8889H8.00011C8.42966 11.8889 8.77789 11.5407 8.77789 11.1111C8.77789 10.6816 8.42966 10.3333 8.00011 10.3333H6.44455Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.889 2.55556C4.889 1.69645 5.58544 1 6.44455 1H9.55566C10.4148 1 11.1112 1.69645 11.1112 2.55556H11.889C12.7481 2.55556 13.4446 3.252 13.4446 4.11111V13.4444C13.4446 14.3036 12.7481 15 11.889 15H4.11122C3.25211 15 2.55566 14.3036 2.55566 13.4444V4.11111C2.55566 3.252 3.25211 2.55556 4.11122 2.55556H4.889ZM9.55566 4.88889C10.1314 4.88889 10.6342 4.57607 10.9031 4.11111H11.889V13.4444H4.11122L4.11122 4.11111H5.0971C5.36607 4.57607 5.86878 4.88889 6.44455 4.88889H9.55566ZM9.55566 2.55556H6.44455V3.33333H9.55566V2.55556Z"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1607080d814a947b$var$PlanLeftIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4kb7n _13ti15vq _15jv15vq _n0baglyw _1m8i1osq _1azq1osq _11d61r31 _11ssyfq0",
            __cmplp.className
        ])
    });
});

});


const $bf48e857a6ced0ff$export$501955bd67991a25 = 'jira.plan';

parcelRegister("9NeqD", function(module, exports) {

$parcel$export(module.exports, "messages", () => $368d5e19fc84b47d$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $368d5e19fc84b47d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    recentlyViewedPlans: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.plans.recently-viewed-plans",
        "defaultMessage": "Recently Viewed Plans"
    }
});

});


parcelRegister("l9NuM", function(module, exports) {

$parcel$export(module.exports, "useGetRecentProjectsChildResult", () => $62debaec54022f25$export$1f6a5212707c0c74);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dBMIc = parcelRequire("dBMIc");

var $4UBKl = parcelRequire("4UBKl");

var $kl0II = parcelRequire("kl0II");
const $62debaec54022f25$var$SECTION_ID = 'jira.project';
const $62debaec54022f25$export$1f6a5212707c0c74 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getQuickSearchProjectCommands: getQuickSearchProjectCommands } = (0, $4UBKl.useGetQuickSearchProjectCommands)({
        section: $62debaec54022f25$var$SECTION_ID,
        showViewAll: false
    });
    const getChildResult = (0, $eUqFw.useCallback)((props)=>{
        const sections = {
            [$62debaec54022f25$var$SECTION_ID]: {
                id: $62debaec54022f25$var$SECTION_ID,
                name: formatMessage((0, $kl0II.messages).recentlyViewedProjects),
                priority: (0, $dBMIc.QUICK_SEARCH_PRIORITY).PROJECTS
            }
        };
        const commands = getQuickSearchProjectCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchProjectCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("4UBKl", function(module, exports) {

$parcel$export(module.exports, "useGetQuickSearchProjectCommands", () => $ad32e6cb7c9a5b9c$export$d434736854ef42ec);

var $eUqFw = parcelRequire("eUqFw");

var $72o8f = parcelRequire("72o8f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dBMIc = parcelRequire("dBMIc");

var $lgBXW = parcelRequire("lgBXW");

var $gFgHR = parcelRequire("gFgHR");

var $j0X9A = parcelRequire("j0X9A");

var $a0nPo = parcelRequire("a0nPo");
const $ad32e6cb7c9a5b9c$export$d434736854ef42ec = ({ section: section, showViewAll: showViewAll })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getProjectCommand: getProjectCommand } = (0, $72o8f.useGetProjectCommand)();
    const { getViewAllCommand: getViewAllCommand } = (0, $j0X9A.useGetViewAllCommand)();
    const getQuickSearchProjectCommands = (0, $eUqFw.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        const projectScope = (0, $gFgHR.getQuickSearchProjectScope)(quickSearchResponseData);
        // No results
        if (!projectScope || error || projectScope?.error || projectScope?.results?.length === 0) return [];
        // There are results!
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const commands = projectScope.results.slice(0, (0, $dBMIc.PROJECT_LIMIT)).map((project)=>getProjectCommand({
                project: (0, $gFgHR.transformQuickSearchProjectResultToProject)(project),
                keywords: search,
                section: section,
                analytics: {
                    isSearchResult: true
                }
            })).filter((project)=>project);
        if (!showViewAll || projectScope.results.length <= (0, $dBMIc.PROJECT_LIMIT)) return commands;
        const viewAllCommand = getViewAllCommand({
            id: 'view-all-projects',
            keywords: search,
            section: section,
            name: formatMessage((0, $lgBXW.messages).viewAllResults),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $a0nPo.getViewAllUrl)((0, $a0nPo.ViewAllType).PROJECT, search),
            analyticsPayload: {
                action: 'viewAllProjects',
                size: projectScope.size
            }
        });
        return commands.concat([
            viewAllCommand
        ]);
    }, [
        formatMessage,
        getProjectCommand,
        getViewAllCommand,
        section,
        showViewAll
    ]);
    return {
        getQuickSearchProjectCommands: getQuickSearchProjectCommands
    };
};

});
parcelRegister("72o8f", function(module, exports) {

$parcel$export(module.exports, "useGetProjectCommand", () => $43fcc51b239799ab$export$ea003d923e77b495);

var $eUqFw = parcelRequire("eUqFw");

var $gIIkx = parcelRequire("gIIkx");

var $iPaa3 = parcelRequire("iPaa3");
const $43fcc51b239799ab$export$ea003d923e77b495 = ()=>{
    const { transformNavigationCommand: transformNavigationCommand } = (0, $gIIkx.useTransformNavigationCommands)();
    const getProjectCommand = (0, $eUqFw.useCallback)(({ project: project, keywords: keywords, section: section, analytics: analytics, ...rest })=>{
        const { projectId: projectId, name: name, url: url, avatar: avatar, canView: canView } = project;
        if (!canView) return null;
        return transformNavigationCommand({
            id: `project-${projectId}`,
            section: section,
            keywords: keywords,
            name: name,
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iPaa3.ProjectLeftIcon), {
                        url: avatar.url,
                        name: name
                    })
            },
            analytics: {
                action: 'projectViewed',
                projectId: projectId,
                metadata: {
                    contentId: projectId,
                    containerId: 'UNAVAILABLE',
                    contentType: 'project'
                },
                ...analytics
            },
            ...rest
        }, {
            path: url
        });
    }, [
        transformNavigationCommand
    ]);
    return {
        getProjectCommand: getProjectCommand
    };
};

});
parcelRegister("iPaa3", function(module, exports) {

$parcel$export(module.exports, "ProjectLeftIcon", () => $5db8652484dd86cf$export$423e89389ac007b0);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8txNy = parcelRequire("8txNy");
const $5db8652484dd86cf$export$423e89389ac007b0 = ({ url: url, name: name })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: url,
        alt: formatMessage((0, $8txNy.messages).issueIconAltText, {
            name: name
        }),
        height: "16"
    });
};

});
parcelRegister("8txNy", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6b8c3b25c7775077$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $6b8c3b25c7775077$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issueIconAltText: {
        "id": "command-palette-common.common.command.project.project-left-icon.issue-icon-alt-text",
        "defaultMessage": "Icon for the project {name}"
    }
});

});




parcelRegister("kl0II", function(module, exports) {

$parcel$export(module.exports, "messages", () => $60ae58525f118d08$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $60ae58525f118d08$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    recentlyViewedProjects: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.projects.recently-viewed-projects",
        "defaultMessage": "Recently Viewed Projects"
    }
});

});



parcelRegister("l42Fv", function(module, exports) {

$parcel$export(module.exports, "useGetSearchResults", () => $ad53aad6a7caf550$export$bca2834c2ecfc5f9);

var $eUqFw = parcelRequire("eUqFw");

var $8FbYY = parcelRequire("8FbYY");

var $hawmT = parcelRequire("hawmT");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $1dpq6 = parcelRequire("1dpq6");

var $je4V0 = parcelRequire("je4V0");

var $472AY = parcelRequire("472AY");

var $6Vuvq = parcelRequire("6Vuvq");

var $jXO7O = parcelRequire("jXO7O");

var $fWkcL = parcelRequire("fWkcL");

var $4g1QA = parcelRequire("4g1QA");

var $9lUuW = parcelRequire("9lUuW");

var $ezWCE = parcelRequire("ezWCE");
const $ad53aad6a7caf550$export$bca2834c2ecfc5f9 = ()=>{
    const { getChildResult: getErrorChildResult } = (0, $1dpq6.useGetErrorChildResult)();
    const { getChildResult: getRecommendedChildResult } = (0, $je4V0.useGetRecommendedChildResult)();
    const { getChildResult: getSearchIssuesChildResult } = (0, $4g1QA.useGetSearchIssuesChildResult)();
    const { getChildResult: getSearchProjectsChildResult } = (0, $ezWCE.useGetSearchProjectsChildResult)();
    const { getChildResult: getSearchBoardsChildResult } = (0, $jXO7O.useGetSearchBoardsChildResult)();
    const { getChildResult: getSearchFiltersChildResult } = (0, $fWkcL.useGetSearchFiltersChildResult)();
    const { getChildResult: getSearchPlansChildResult } = (0, $9lUuW.useGetSearchPlansChildResult)();
    const [hasEditOrViewPermissions] = (0, $hawmT.useNavigationViewPlansPermission)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, $472AY.useSetTimeoutAutoClear)();
    const setTimeoutFunc = setTimeoutAutoClear;
    const getSearchResults = (0, $eUqFw.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        setTimeoutFunc(()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'searchResults shown', 'postQuerySearchResults', {
                ...(0, $6Vuvq.transformResultsForAnalytics)(quickSearchResponseData, false)
            });
        }, 0);
        return (0, $8FbYY.mergeChildResults)([
            getErrorChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getRecommendedChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getSearchIssuesChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getSearchProjectsChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getSearchBoardsChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getSearchFiltersChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            ...hasEditOrViewPermissions ? [
                getSearchPlansChildResult({
                    search: search,
                    quickSearchResponseData: quickSearchResponseData,
                    error: error
                })
            ] : []
        ]);
    }, [
        createAnalyticsEvent,
        getErrorChildResult,
        getRecommendedChildResult,
        getSearchBoardsChildResult,
        getSearchFiltersChildResult,
        getSearchIssuesChildResult,
        getSearchPlansChildResult,
        getSearchProjectsChildResult,
        hasEditOrViewPermissions,
        setTimeoutFunc
    ]);
    return getSearchResults;
};

});
parcelRegister("jXO7O", function(module, exports) {

$parcel$export(module.exports, "useGetSearchBoardsChildResult", () => $f84614c4479e6842$export$894d6ed9a271a485);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fOslh = parcelRequire("fOslh");

var $dBMIc = parcelRequire("dBMIc");


var $48yD2 = parcelRequire("48yD2");
const $f84614c4479e6842$export$894d6ed9a271a485 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getQuickSearchBoardCommands: getQuickSearchBoardCommands } = (0, $fOslh.useGetQuickSearchBoardCommands)({
        section: (0, $f13643a9b02be974$export$501955bd67991a25),
        showViewAll: true
    });
    const getChildResult = (0, $eUqFw.useCallback)((props)=>{
        const sections = {
            [(0, $f13643a9b02be974$export$501955bd67991a25)]: {
                id: (0, $f13643a9b02be974$export$501955bd67991a25),
                name: formatMessage((0, $48yD2.messages).boards),
                priority: (0, $dBMIc.QUICK_SEARCH_PRIORITY).BOARDS
            }
        };
        const commands = getQuickSearchBoardCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchBoardCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
const $f13643a9b02be974$export$501955bd67991a25 = 'jira.board';

parcelRegister("48yD2", function(module, exports) {

$parcel$export(module.exports, "messages", () => $80cbd78ce5d9b9f2$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $80cbd78ce5d9b9f2$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    boards: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.boards.boards",
        "defaultMessage": "Boards"
    }
});

});


parcelRegister("fWkcL", function(module, exports) {

$parcel$export(module.exports, "useGetSearchFiltersChildResult", () => $0b6db2c121e7caa2$export$679a1b8aea427942);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dBMIc = parcelRequire("dBMIc");

var $lW8hb = parcelRequire("lW8hb");


var $jR0dY = parcelRequire("jR0dY");
const $0b6db2c121e7caa2$export$679a1b8aea427942 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getQuickSearchFilterCommands: getQuickSearchFilterCommands } = (0, $lW8hb.useGetQuickSearchFilterCommands)({
        section: (0, $cbe2f99c34184a21$export$501955bd67991a25),
        showViewAll: true
    });
    const getChildResult = (0, $eUqFw.useCallback)((props)=>{
        const sections = {
            [(0, $cbe2f99c34184a21$export$501955bd67991a25)]: {
                id: (0, $cbe2f99c34184a21$export$501955bd67991a25),
                name: formatMessage((0, $jR0dY.messages).filters),
                priority: (0, $dBMIc.QUICK_SEARCH_PRIORITY).FILTERS
            }
        };
        const commands = getQuickSearchFilterCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchFilterCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
const $cbe2f99c34184a21$export$501955bd67991a25 = 'jira.filter';

parcelRegister("jR0dY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f32c1475361f72a3$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $f32c1475361f72a3$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    filters: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.filters.filters",
        "defaultMessage": "Filters"
    }
});

});


parcelRegister("4g1QA", function(module, exports) {

$parcel$export(module.exports, "useGetSearchIssuesChildResult", () => $379be424f1a5a1c3$export$87713fad27eebcf1);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dBMIc = parcelRequire("dBMIc");

var $bwtxV = parcelRequire("bwtxV");

var $75jV7 = parcelRequire("75jV7");
const $379be424f1a5a1c3$var$SECTION_ID = 'jira.issue';
const $379be424f1a5a1c3$export$87713fad27eebcf1 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getQuickSearchIssueCommands: getQuickSearchIssueCommands } = (0, $bwtxV.useGetQuickSearchIssueCommands)({
        section: $379be424f1a5a1c3$var$SECTION_ID,
        errorMessage: formatMessage((0, $75jV7.messages).issueError),
        showViewAll: true
    });
    const getChildResult = (0, $eUqFw.useCallback)((props)=>{
        const sections = {
            [$379be424f1a5a1c3$var$SECTION_ID]: {
                id: $379be424f1a5a1c3$var$SECTION_ID,
                name: formatMessage((0, $75jV7.messages).issues),
                priority: (0, $dBMIc.QUICK_SEARCH_PRIORITY).ISSUES
            }
        };
        const commands = getQuickSearchIssueCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchIssueCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("75jV7", function(module, exports) {

$parcel$export(module.exports, "messages", () => $62b015f077eaf5f3$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $62b015f077eaf5f3$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issueError: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.issues.issue-error",
        "defaultMessage": "We\u2019re having trouble searching issues. You can try again in a few moments."
    },
    issues: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.issues.issues",
        "defaultMessage": "Issues"
    }
});

});


parcelRegister("9lUuW", function(module, exports) {

$parcel$export(module.exports, "useGetSearchPlansChildResult", () => $6cfd047d979205a9$export$fc9d0a774ff010f1);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dBMIc = parcelRequire("dBMIc");

var $itkCl = parcelRequire("itkCl");


var $62J9r = parcelRequire("62J9r");
const $6cfd047d979205a9$export$fc9d0a774ff010f1 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getQuickSearchPlanCommands: getQuickSearchPlanCommands } = (0, $itkCl.useGetQuickSearchPlanCommands)({
        section: (0, $1dc439985e4528e4$export$501955bd67991a25),
        showViewAll: true
    });
    const getChildResult = (0, $eUqFw.useCallback)((props)=>{
        const sections = {
            [(0, $1dc439985e4528e4$export$501955bd67991a25)]: {
                id: (0, $1dc439985e4528e4$export$501955bd67991a25),
                name: formatMessage((0, $62J9r.messages).plans),
                priority: (0, $dBMIc.QUICK_SEARCH_PRIORITY).PLANS
            }
        };
        const commands = getQuickSearchPlanCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchPlanCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
const $1dc439985e4528e4$export$501955bd67991a25 = 'jira.plan';

parcelRegister("62J9r", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a000f60a1c19f725$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a000f60a1c19f725$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    plans: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.plans.plans",
        "defaultMessage": "Plans"
    }
});

});


parcelRegister("ezWCE", function(module, exports) {

$parcel$export(module.exports, "useGetSearchProjectsChildResult", () => $3acd668a25d3ae7d$export$e18d773eb3827574);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dBMIc = parcelRequire("dBMIc");

var $4UBKl = parcelRequire("4UBKl");

var $fxSoO = parcelRequire("fxSoO");
const $3acd668a25d3ae7d$var$SECTION_ID = 'jira.project';
const $3acd668a25d3ae7d$export$e18d773eb3827574 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getQuickSearchProjectCommands: getQuickSearchProjectCommands } = (0, $4UBKl.useGetQuickSearchProjectCommands)({
        section: $3acd668a25d3ae7d$var$SECTION_ID,
        showViewAll: true
    });
    const getChildResult = (0, $eUqFw.useCallback)((props)=>{
        const sections = {
            [$3acd668a25d3ae7d$var$SECTION_ID]: {
                id: $3acd668a25d3ae7d$var$SECTION_ID,
                name: formatMessage((0, $fxSoO.messages).projects),
                priority: (0, $dBMIc.QUICK_SEARCH_PRIORITY).PROJECTS
            }
        };
        const commands = getQuickSearchProjectCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchProjectCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("fxSoO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0dd2e19d5cafaa7b$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $0dd2e19d5cafaa7b$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    projects: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.projects.projects",
        "defaultMessage": "Projects"
    }
});

});



parcelRegister("3piX0", function(module, exports) {

$parcel$export(module.exports, "QuickSearchChildWrapper", () => $6d9f8bc5c493197e$export$85ee85d7d315a747);

var $eUqFw = parcelRequire("eUqFw");

var $8CN3d = parcelRequire("8CN3d");

var $eyEYc = parcelRequire("eyEYc");

var $lSWhx = parcelRequire("lSWhx");
const $6d9f8bc5c493197e$export$85ee85d7d315a747 = ({ children: children })=>{
    const [attributes, { reset: reset }] = (0, $8CN3d.useQuickSearchAnalyticsAttributes)();
    (0, $eUqFw.useEffect)(()=>{
        reset();
        return ()=>{
            reset();
        };
    }, [
        reset
    ]);
    const shouldFireScreenAnalytics = attributes.queryVersion >= 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eyEYc.QuickSearchWrapper), null, shouldFireScreenAnalytics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSWhx.QuickSearchFireScreenAnalytics), null), children);
};

});
parcelRegister("eyEYc", function(module, exports) {

$parcel$export(module.exports, "QuickSearchWrapper", () => $2285ea4b0a29e01e$export$2398c0852f2402a1);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $8WuJm = parcelRequire("8WuJm");

var $8CN3d = parcelRequire("8CN3d");
const $2285ea4b0a29e01e$export$2398c0852f2402a1 = ({ children: children })=>{
    const [attributes] = (0, $8CN3d.useQuickSearchAnalyticsAttributes)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jiraCommandPaletteQuickSearch",
        id: "quick-search",
        teamName: "deliveroo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: attributes
    }, children));
};

});

parcelRegister("lSWhx", function(module, exports) {

$parcel$export(module.exports, "QuickSearchFireScreenAnalytics", () => $f88537cf92ce2510$export$7b8039e0ef5a7b1b);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $8CN3d = parcelRequire("8CN3d");
const $f88537cf92ce2510$export$7b8039e0ef5a7b1b = ()=>{
    const [{ query: query }] = (0, $8CN3d.useQuickSearchAnalytics)();
    const isSearch = (0, $eUqFw.useMemo)(()=>Boolean(query?.length), [
        query
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: isSearch ? 'searchCommandPalettePostQuery' : 'searchCommandPalettePreQuery',
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};

});




parcelRegister("azJRA", function(module, exports) {

$parcel$export(module.exports, "useCommandPaletteRegistry", () => $d28d59123f9ceddb$export$843ca10488699b0c);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");

var $fmmnJ = parcelRequire("fmmnJ");
const $d28d59123f9ceddb$export$843ca10488699b0c = ()=>{
    const { setRegistry: setRegistry } = (0, $gCtL7.useActionsCommandPalette)();
    (0, $eUqFw.useState)(()=>{
        setRegistry((0, $fmmnJ.COMMAND_PALETTE_REGISTRY));
    });
};

});
parcelRegister("fmmnJ", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $2688cae36ed8d4f6$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $2688cae36ed8d4f6$export$96f61eb1261e42c3);
// Documentation for contributing to command palette: go/compal
const $2688cae36ed8d4f6$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $2688cae36ed8d4f6$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $2688cae36ed8d4f6$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.COPY_URL,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.DESCRIPTION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.LOG_WORK,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.PARENT,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.QUICK_ADD,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.QUICK_SEARCH,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.SHORTCUTS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.STATUS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.STORY_POINTS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.THEME_MODE,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    }
};

});


const $a4122e01fb37b64d$export$70d2130cb02f61fa = 'command-palette-integration.ui.container';

parcelRegister("jnUZa", function(module, exports) {

$parcel$export(module.exports, "useCloseDotMenu", () => $334dc23740a420e3$export$64ace3e915332feb);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");

var $igOBb = parcelRequire("igOBb");

var $7uVYl = parcelRequire("7uVYl");
const $334dc23740a420e3$export$64ace3e915332feb = ()=>{
    const [{ isShortcutsDialogVisible: isShortcutsDialogVisible }, { setShortcutsDialogVisibility: setShortcutsDialogVisibility }] = (0, $7uVYl.useShortcuts)();
    const [{ isOpen: isOpen }, { open: open }] = (0, $gCtL7.useCommandPaletteIsOpen)();
    (0, $eUqFw.useEffect)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (isOpen) return ()=>{};
        const handler = (ev)=>{
            const modifier = (0, $igOBb.isMacOs)() ? ev.metaKey : ev.ctrlKey;
            if (modifier && ev.key === 'k') {
                const hasMonolithDotMenu = typeof JIRA !== 'undefined' && typeof JIRA?.Shifter?.dialog?.destroyed === 'function' && !JIRA?.Shifter?.dialog?.destroyed();
                const dotOpen = isShortcutsDialogVisible || hasMonolithDotMenu;
                if (!dotOpen) return;
                if (isShortcutsDialogVisible) setShortcutsDialogVisibility(false);
                if (hasMonolithDotMenu) JIRA.Shifter?.hide?.();
                open();
            }
        };
        window.addEventListener('keydown', handler);
        return ()=>{
            window.removeEventListener('keydown', handler);
        };
    }, [
        isOpen,
        isShortcutsDialogVisible,
        open,
        setShortcutsDialogVisibility
    ]);
};

});

parcelRegister("lq8s9", function(module, exports) {

$parcel$export(module.exports, "useCompalBridge", () => $bf90fcbfe97947e8$export$9e0258ef367c1984);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");
const $bf90fcbfe97947e8$export$9e0258ef367c1984 = ()=>{
    const { open: open } = (0, $gCtL7.useActionsCommandPalette)();
    (0, $eUqFw.useEffect)(()=>{
        if (typeof window !== 'undefined') window.JIRA_COMPAL = {
            open: open
        };
        return ()=>{
            if (typeof window !== 'undefined') window.JIRA_COMPAL = undefined;
        };
    }, [
        open
    ]);
};

});

parcelRegister("b4jyX", function(module, exports) {

$parcel$export(module.exports, "useDisableCompalIfEmbed", () => $8b67c8dfdc205b59$export$2b4e2f60c6063c36);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");

var $kqyVN = parcelRequire("kqyVN");
const $8b67c8dfdc205b59$export$2b4e2f60c6063c36 = ()=>{
    const { isEmbed: isEmbed } = (0, $kqyVN.useIsEmbed)();
    const { setIsDisabled: setIsDisabled } = (0, $gCtL7.useActionsCommandPalette)();
    (0, $eUqFw.useEffect)(()=>{
        setIsDisabled(isEmbed);
    }, [
        isEmbed,
        setIsDisabled
    ]);
};

});
parcelRegister("kqyVN", function(module, exports) {

$parcel$export(module.exports, "useIsEmbed", () => $c4013f04e73857db$export$ce94463dec1ccebd);

var $lB25E = parcelRequire("lB25E");
const $c4013f04e73857db$export$ce94463dec1ccebd = ()=>{
    const [{ location: { pathname: pathname } }] = (0, $lB25E.useRouter)();
    if (pathname.endsWith('/embed')) return {
        isEmbed: true
    };
    return {
        isEmbed: false
    };
};

});


parcelRegister("aVGC7", function(module, exports) {

$parcel$export(module.exports, "useRegisterDismissCommand", () => $f1fb751a490df321$export$ba1bbbf46b23917);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");

var $9zALC = parcelRequire("9zALC");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dxLfx = parcelRequire("dxLfx");
const $f1fb751a490df321$export$ba1bbbf46b23917 = ()=>{
    const [{ isOpen: isOpen }, { close: close }] = (0, $gCtL7.useCommandPaletteIsOpen)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!isOpen) return ()=>{};
        const dismissCommandPalette = (ev)=>{
            if (!(0, $dxLfx.isCommandPaletteTrigger)(ev)) return;
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent((0, $9zALC.COMMAND_PALETTE_PRESSED_ANALYTICS)), (0, $9zALC.COMMAND_PALETTE_ID), {
                key: 'k',
                isDismissing: true
            });
            ev.preventDefault();
            close();
        };
        document.addEventListener('keydown', dismissCommandPalette);
        return ()=>{
            document.removeEventListener('keydown', dismissCommandPalette);
        };
    }, [
        close,
        createAnalyticsEvent,
        isOpen
    ]);
    return null;
};

});
parcelRegister("dxLfx", function(module, exports) {

$parcel$export(module.exports, "isCommandPaletteTrigger", () => $212a48f4b7d4a8a6$export$fdcbda728f65a22a);

var $igOBb = parcelRequire("igOBb");
const $212a48f4b7d4a8a6$export$fdcbda728f65a22a = (ev)=>{
    if (ev.key !== 'k') return false;
    if ((0, $igOBb.isMacOs)()) {
        if (!ev.metaKey) return false;
    } else if (!ev.ctrlKey) return false;
    return true;
};

});


parcelRegister("gVlMC", function(module, exports) {

$parcel$export(module.exports, "useRegisterSections", () => $dabe6f2677b40ad7$export$322b8dfd66fee25d);

var $eUqFw = parcelRequire("eUqFw");

var $6Ao31 = parcelRequire("6Ao31");

var $9zALC = parcelRequire("9zALC");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7sqcu = parcelRequire("7sqcu");
const $dabe6f2677b40ad7$export$d67bb364b16506d = {
    [(0, $9zALC.COMMAND_PALETTE_SECTIONS).projectNavigation]: {
        message: (0, $7sqcu.messages).projectNavigationSection,
        priority: (0, $9zALC.COMMAND_PALETTE_SECTIONS_PRIORITY).projectNavigation,
        actionCategory: 'projectNavigation'
    },
    [(0, $9zALC.COMMAND_PALETTE_SECTIONS).siteNavigation]: {
        message: (0, $7sqcu.messages).siteNavigationSection,
        priority: (0, $9zALC.COMMAND_PALETTE_SECTIONS_PRIORITY).siteNavigation,
        actionCategory: 'siteNavigation'
    },
    [(0, $9zALC.COMMAND_PALETTE_SECTIONS).quickActions]: {
        message: (0, $7sqcu.messages).quickActionsSection,
        priority: (0, $9zALC.COMMAND_PALETTE_SECTIONS_PRIORITY).quickActions,
        actionCategory: 'quickActions'
    },
    [(0, $9zALC.COMMAND_PALETTE_SECTIONS).personalSettings]: {
        message: (0, $7sqcu.messages).personalSettingsSection,
        priority: (0, $9zALC.COMMAND_PALETTE_SECTIONS_PRIORITY).personalSettings,
        actionCategory: 'personalSettings'
    },
    [(0, $9zALC.COMMAND_PALETTE_SECTIONS).help]: {
        message: (0, $7sqcu.messages).helpSection,
        priority: (0, $9zALC.COMMAND_PALETTE_SECTIONS_PRIORITY).help,
        actionCategory: 'help'
    },
    [(0, $9zALC.COMMAND_PALETTE_SECTIONS).jiraSettings]: {
        message: (0, $7sqcu.messages).jiraSettingsSection,
        priority: (0, $9zALC.COMMAND_PALETTE_SECTIONS_PRIORITY).jiraSettings,
        actionCategory: 'jiraSettings'
    },
    [(0, $9zALC.COMMAND_PALETTE_SECTIONS).atlassianAdmin]: {
        message: (0, $7sqcu.messages).atlassianAdminSection,
        priority: (0, $9zALC.COMMAND_PALETTE_SECTIONS_PRIORITY).atlassianAdmin,
        actionCategory: 'atlassianAdmin'
    },
    [(0, $9zALC.COMMAND_PALETTE_SECTIONS).quickSearch]: {
        message: (0, $7sqcu.messages).quickSearchSection,
        priority: (0, $9zALC.COMMAND_PALETTE_SECTIONS_PRIORITY).quickSearch,
        actionCategory: 'quickSearch'
    }
};
const $dabe6f2677b40ad7$export$322b8dfd66fee25d = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const sections = (0, $eUqFw.useMemo)(()=>Object.entries($dabe6f2677b40ad7$export$d67bb364b16506d).reduce((acc, [key, entry])=>{
            acc[key] = {
                name: formatMessage(entry.message),
                priority: entry.priority,
                actionCategory: entry.actionCategory
            };
            return acc;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        }, {}), [
        formatMessage
    ]);
    (0, $6Ao31.useRegisterCommandSections)(sections);
};

});
parcelRegister("6Ao31", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommandSections", () => $0604517059fb0bc8$export$24e75e2bcad1489a);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");
const $0604517059fb0bc8$export$24e75e2bcad1489a = (sections, deps = [])=>{
    const { registerSections: registerSections, unregisterSections: unregisterSections } = (0, $gCtL7.useActionsCommandPalette)();
    const ids = Object.keys(sections);
    (0, $eUqFw.useEffect)(()=>{
        registerSections(sections);
        return ()=>{
            unregisterSections(sections);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ...deps,
        registerSections,
        unregisterSections,
        ids.toString()
    ]);
};

});

parcelRegister("7sqcu", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5ae007bb000ba2a4$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $5ae007bb000ba2a4$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    projectNavigationSection: {
        "id": "command-palette-integration.controllers.use-register-sections.project-navigation-section",
        "defaultMessage": "Project navigation"
    },
    siteNavigationSection: {
        "id": "command-palette-integration.controllers.use-register-sections.site-navigation-section",
        "defaultMessage": "Site navigation"
    },
    quickActionsSection: {
        "id": "command-palette-integration.controllers.use-register-sections.quick-actions-section",
        "defaultMessage": "Quick actions"
    },
    personalSettingsSection: {
        "id": "command-palette-integration.controllers.use-register-sections.personal-settings-section",
        "defaultMessage": "Personal settings"
    },
    helpSection: {
        "id": "command-palette-integration.controllers.use-register-sections.help-section",
        "defaultMessage": "Help"
    },
    jiraSettingsSection: {
        "id": "command-palette-integration.controllers.use-register-sections.jira-settings-section",
        "defaultMessage": "Jira Settings"
    },
    atlassianAdminSection: {
        "id": "command-palette-integration.controllers.use-register-sections.atlassian-admin-section",
        "defaultMessage": "Atlassian admin"
    },
    quickSearchSection: {
        "id": "command-palette-integration.controllers.use-register-sections.quick-search-section",
        "defaultMessage": "Search work"
    }
});

});


parcelRegister("5bGMz", function(module, exports) {

$parcel$export(module.exports, "FooterFeedbackContent", () => $b5ec4ed5f844b133$export$63ddf0170f2bf579);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $gCtL7 = parcelRequire("gCtL7");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $90RXu = parcelRequire("90RXu");

var $jaNWZ = parcelRequire("jaNWZ");
const $b5ec4ed5f844b133$export$63ddf0170f2bf579 = ()=>{
    const [openFeedbackCollectorDialog] = (0, $90RXu.useCommandPaletteFeedbackCollector)();
    const { close: close } = (0, $gCtL7.useActionsCommandPalette)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5ec4ed5f844b133$var$FeedbackContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5ec4ed5f844b133$var$TextWrapper, null, " ", formatMessage((0, $jaNWZ.messages).feedbackContentText), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5ec4ed5f844b133$var$FeedbackButton, {
        appearance: "subtle-link",
        testId: "command-palette-integration.ui.footer-feedback-content.feedback-button",
        onClick: (event, analyticsEvent)=>{
            close();
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'openCommandPaletteFeedbackForm');
            openFeedbackCollectorDialog();
        }
    }, formatMessage((0, $jaNWZ.messages).feedbackButtonText)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b5ec4ed5f844b133$var$FeedbackContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _11c8qk37 _1yt4h8dc _syaz1a45 _1bah1y6m _16ai1a45",
            __cmplp.className
        ])
    });
});
const $b5ec4ed5f844b133$var$TextWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c8qk37 _syaz1a45 _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b5ec4ed5f844b133$var$FeedbackButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c8qk37 _4cvr1h6o _k48p1wq8 _18u0v77o _1yt41nxw _syaz1504 _4t3i1wug _vwz44jg8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("90RXu", function(module, exports) {

$parcel$export(module.exports, "useCommandPaletteFeedbackCollector", () => $49b05e0b9acb256f$export$6db0caae08144d99);

var $eUqFw = parcelRequire("eUqFw");

var $1c02D = parcelRequire("1c02D");
var $irg9D = parcelRequire("irg9D");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jaNWZ = parcelRequire("jaNWZ");
const $49b05e0b9acb256f$export$6db0caae08144d99 = ()=>{
    const { openFeedbackCollector: openFeedbackCollector, resetFeedbackCollectorState: resetFeedbackCollectorState } = (0, $irg9D.useFeedbackCollectorActions)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const openCommandPaletteFeedbackCollector = (0, $eUqFw.useCallback)((props)=>{
        openFeedbackCollector({
            entrypointId: (0, $1c02D.ENTRYPOINT_ID_JIRA_COMMAND_PALETTE),
            feedbackTitle: formatMessage((0, $jaNWZ.messages).feedbackTitle),
            ...props
        });
    }, [
        formatMessage,
        openFeedbackCollector
    ]);
    return [
        openCommandPaletteFeedbackCollector,
        resetFeedbackCollectorState
    ];
};

});
parcelRegister("1c02D", function(module, exports) {

$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", () => $ccbba0a7f0f3304b$export$baea5c8192e79adc);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", () => $ccbba0a7f0f3304b$export$4eda1e3a4a311d13);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", () => $ccbba0a7f0f3304b$export$5fb38521eb7ad63c);
$parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", () => $ccbba0a7f0f3304b$export$345c45dd28f28a32);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", () => $ccbba0a7f0f3304b$export$8962f2e618411469);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", () => $ccbba0a7f0f3304b$export$7d7f2319141db3c5);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", () => $ccbba0a7f0f3304b$export$4725635e6fe1907a);
$parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", () => $ccbba0a7f0f3304b$export$3a50f2efd6cfd6f3);
$parcel$export(module.exports, "ENTRY_POINT_ID_AIOPS", () => $ccbba0a7f0f3304b$export$5bd148c13bb23f7a);
$parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", () => $ccbba0a7f0f3304b$export$b4de0744c1fd450d);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", () => $ccbba0a7f0f3304b$export$1a7c42187130faf9);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", () => $ccbba0a7f0f3304b$export$e84c34a7e1dbcf78);
$parcel$export(module.exports, "ENTRYPOINT_ID_NAVIGATION_REFRESH", () => $ccbba0a7f0f3304b$export$23f6d7b16d2210c1);
$parcel$export(module.exports, "EntryKeys", () => $ccbba0a7f0f3304b$export$12d01b6c311a909a);
// Jira platform project feedback JSD widget configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JGF/queues/custom/448
const $ccbba0a7f0f3304b$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
const $ccbba0a7f0f3304b$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
const $ccbba0a7f0f3304b$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
const $ccbba0a7f0f3304b$export$4a288e389131b3de = 'b6176efc-e703-426b-b4f8-3e43ce4aa0db';
const $ccbba0a7f0f3304b$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
const $ccbba0a7f0f3304b$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
const $ccbba0a7f0f3304b$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
const $ccbba0a7f0f3304b$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
const $ccbba0a7f0f3304b$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
const $ccbba0a7f0f3304b$export$5bd148c13bb23f7a = 'b6a8ea1d-9ec0-4bb6-9e22-01fd310c0591';
const $ccbba0a7f0f3304b$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
const $ccbba0a7f0f3304b$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
const $ccbba0a7f0f3304b$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
const $ccbba0a7f0f3304b$export$23f6d7b16d2210c1 = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
const $ccbba0a7f0f3304b$export$12d01b6c311a909a = Object.freeze({
    CLOUD_ID: 'cloud-id',
    OPT_OUT: 'Opt-out',
    REASON: 'reason',
    FEELING: 'feeling',
    IS_ADMIN: 'is-admin',
    IS_SITE_ADMIN: 'is-site-admin',
    IS_PROJECT_SETTINGS: 'is-project-settings',
    INLINE_FEEDBACK_ID: 'inlineFeedbackId',
    IS_JSD_EVALUATOR: 'is-jsd-evaluator',
    IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
    SUPPORTED_PROJECT_TYPES: 'supported-project-types',
    FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
    FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
    FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
    LOCATION: 'Location',
    PROJECT_TYPE: 'project-type',
    BOARD_TYPE: 'board-type',
    REFERER: 'Referer',
    ROUTE_GROUP: 'route-group',
    ROUTE_NAME: 'route-name',
    USER_AGENT: 'User-Agent',
    SCREEN_RESOLUTION: 'Screen Resolution',
    SOURCE: 'Source',
    SUB_PRODUCT: 'Sub-product',
    JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
    JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
    DEPLOYMENT_PROVIDERS: 'deployment-providers',
    JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
    VERSION_CONTROL_PROVIDERS: 'version-control-providers',
    DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
    CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
    SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
    INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
    IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
    FEEDBACK_GROUP_ID: 'feedback-group-id',
    EDITION: 'edition',
    ENV: 'environment'
});

});

parcelRegister("irg9D", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $8d3d8a971c5329dd$export$4be696be8a3bff13);
$parcel$export(module.exports, "useFeedbackCollectorActions", () => $8d3d8a971c5329dd$export$dfb2ee2d9e73fa48);
$parcel$export(module.exports, "FeedbackActionsSubscriber", () => $8d3d8a971c5329dd$export$c35dbf16ebe9df04);

var $WBLbN = parcelRequire("WBLbN");
const $8d3d8a971c5329dd$export$d4c72bab9d6cc13a = {
    isFeedbackCollectorOpen: false,
    entrypointId: undefined,
    email: undefined,
    additionalFields: undefined,
    feedbackTitle: undefined,
    feedbackContext: undefined,
    feedbackCollectorId: undefined,
    // default value of this prop is true so making sure inititally it is true
    showTypeField: true,
    submitButtonLabel: undefined,
    canBeContactedLabel: undefined,
    summaryPlaceholder: undefined,
    feedbackGroupLabels: undefined,
    onClose: undefined,
    feedbackTitleDetails: undefined,
    triggerRef: undefined,
    renderCustomContent: undefined,
    customFeedbackOptions: []
};
const $8d3d8a971c5329dd$export$e324594224ef24da = {
    openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
            // Reset to initial state to clear any leftover state
            dispatch($8d3d8a971c5329dd$export$e324594224ef24da.resetFeedbackCollectorState());
            setState({
                ...feedbackCollectorProps,
                isFeedbackCollectorOpen: true
            });
        },
    closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
            const { triggerRef: triggerRef } = getState();
            if (triggerRef) // Unfortunately we need a setTimeout here to delay the execution cycle because modal is yet to be closed
            setTimeout(()=>triggerRef.current?.focus(), 50);
            setState({
                isFeedbackCollectorOpen: false,
                triggerRef: undefined
            });
        },
    resetFeedbackCollectorState: ()=>({ setState: setState })=>{
            setState({
                ...$8d3d8a971c5329dd$export$d4c72bab9d6cc13a
            });
        },
    updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
            setState({
                renderCustomContent: updatedCustomRenderContent
            });
        },
    updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
            setState({
                additionalFields: updatedAdditionalFields
            });
        }
};
const $8d3d8a971c5329dd$var$Store = (0, $WBLbN.createStore)({
    name: 'feedback-collector',
    initialState: $8d3d8a971c5329dd$export$d4c72bab9d6cc13a,
    actions: $8d3d8a971c5329dd$export$e324594224ef24da
});
const $8d3d8a971c5329dd$export$4be696be8a3bff13 = (0, $WBLbN.createHook)($8d3d8a971c5329dd$var$Store);
const $8d3d8a971c5329dd$export$dfb2ee2d9e73fa48 = (0, $WBLbN.createActionsHook)($8d3d8a971c5329dd$var$Store);
const $8d3d8a971c5329dd$export$c35dbf16ebe9df04 = (0, $WBLbN.createSubscriber)($8d3d8a971c5329dd$var$Store, {
    selector: null
});

});

parcelRegister("jaNWZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0b0470c85c83a24d$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $0b0470c85c83a24d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    feedbackTitle: {
        "id": "command-palette-integration.controllers.use-feedback-collector.feedback-title",
        "defaultMessage": "Share your thoughts"
    },
    feedbackButtonText: {
        "id": "command-palette-integration.controllers.use-feedback-collector.feedback-button-text",
        "defaultMessage": "Let us know"
    },
    feedbackContentText: {
        "id": "command-palette-integration.controllers.use-feedback-collector.feedback-content-text",
        "defaultMessage": "Got feedback?"
    }
});

});



parcelRegister("aPuGw", function(module, exports) {

$parcel$export(module.exports, "useRegisterInitialCommands", () => $80d779156c70c4cc$export$c84e12da7f59adc);

var $fmmnJ = parcelRequire("fmmnJ");
var $gjNh9 = parcelRequire("gjNh9");

var $e0Hma = parcelRequire("e0Hma");

var $j3JBz = parcelRequire("j3JBz");

var $iDtnH = parcelRequire("iDtnH");
const $80d779156c70c4cc$export$c84e12da7f59adc = ()=>{
    const copyCommand = (0, $j3JBz.useCopyPageUrlCommand)();
    const navigationCommands = (0, $iDtnH.useNavigationCommands)();
    const { issueNavigatorLink: issueNavigatorLink } = (0, $e0Hma.useIssueNavigatorLink)();
    (0, $gjNh9.useRegisterCommands)((0, $fmmnJ.COMMAND_PALETTE_REGISTRY_IDS).COPY_URL, [
        copyCommand
    ]);
    (0, $gjNh9.useRegisterCommands)((0, $fmmnJ.COMMAND_PALETTE_REGISTRY_IDS).NAVIGATION_COMMANDS, navigationCommands, [
        issueNavigatorLink
    ]);
};

});
parcelRegister("gjNh9", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommands", () => $5aa93b9a91fcbcd2$export$3f626f8a5dbc29e4);

var $fqCN8 = parcelRequire("fqCN8");
const $5aa93b9a91fcbcd2$export$3f626f8a5dbc29e4 = (0, $fqCN8.useRegisterCommandsWithRegistry);

});
parcelRegister("fqCN8", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommandsWithRegistry", () => $f1b669646bbb8295$export$8a824ae164ff968d);

var $eUqFw = parcelRequire("eUqFw");

var $7Xm2s = parcelRequire("7Xm2s");
function $f1b669646bbb8295$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
    const subscribe = (0, $7Xm2s.useSubscribeCommandsWithRegistry)();
    const commandCache = (0, $eUqFw.useRef)(commands);
    (0, $eUqFw.useEffect)(()=>{
        commandCache.current = commands;
    }, [
        commands
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useEffect)(()=>subscribe(registrationId, commandCache.current), [
        ...dependencies,
        subscribe
    ]);
}

});
parcelRegister("7Xm2s", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $ed5a0599e1840fb5$export$880fc01e31710b27);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");
function $ed5a0599e1840fb5$export$880fc01e31710b27() {
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $gCtL7.useActionsCommandPalette)();
    const subscribe = (0, $eUqFw.useCallback)((registrationId, commands)=>{
        updateActiveRegistry(registrationId, commands);
        addCommands(commands);
        return ()=>{
            removeCommands(commands);
            removeFromActiveRegistry(registrationId, commands);
        };
    }, [
        addCommands,
        removeCommands,
        removeFromActiveRegistry,
        updateActiveRegistry
    ]);
    return subscribe;
}

});



parcelRegister("e0Hma", function(module, exports) {

$parcel$export(module.exports, "useIssueNavigatorLink", () => $b9bb9a654d2a53f1$export$3e785a826ba5bd41);

var $7ZZxN = parcelRequire("7ZZxN");

var $5bIU1 = parcelRequire("5bIU1");

var $bNe1g = parcelRequire("bNe1g");

var $dqxG2 = parcelRequire("dqxG2");
const $b9bb9a654d2a53f1$export$3e785a826ba5bd41 = ()=>{
    const { data: projectContextData } = (0, $bNe1g.useProjectContext)();
    const { data: features } = (0, $5bIU1.useFeatures)();
    if (!projectContextData?.projectType || !projectContextData?.projectKey || typeof projectContextData?.simplified !== 'boolean') return {
        issueNavigatorLink: null
    };
    const issueNavigatorLink = (0, $dqxG2.generateNinBasePath)(projectContextData.projectKey, projectContextData.projectType, projectContextData.simplified);
    // Service Desk and Business Projects have Issue Navigator feature permanently on
    let isIssueNavigatoraEnabled = true;
    // Only Jira Software projects have the ability to toggle the Issue Navigator feature
    if (projectContextData.projectType === (0, $7ZZxN.SOFTWARE_PROJECT)) isIssueNavigatoraEnabled = features?.hasSIN || false;
    return {
        issueNavigatorLink: isIssueNavigatoraEnabled ? issueNavigatorLink : null
    };
};

});
parcelRegister("5bIU1", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $29199b315decc1d0$export$4a39035bacc4ed76);

var $eUqFw = parcelRequire("eUqFw");

var $2futN = parcelRequire("2futN");

var $fx7mS = parcelRequire("fx7mS");
var $4tOq6 = parcelRequire("4tOq6");
var $gleuI = parcelRequire("gleuI");

var $6EvIB = parcelRequire("6EvIB");
const $29199b315decc1d0$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2futN.useJiraSoftwareProjectNavigation)();
    const isEligibleForFeatureToggle = (0, $4tOq6.useShouldApplyFeatureToggle)();
    const [sidebarFeatureToggled] = (0, $gleuI.useSidebarFeatureToggled)();
    const extractedData = (0, $eUqFw.useMemo)(()=>data && (0, $6EvIB.extractData)(data), [
        data
    ]);
    // merged feature status before navigation resource gets refreshed
    // if and only if there are features toggled and they are eligible for the feature
    const features = (0, $eUqFw.useMemo)(()=>{
        if (!extractedData || !isEligibleForFeatureToggle || !sidebarFeatureToggled) return extractedData;
        return {
            ...extractedData,
            ...sidebarFeatureToggled
        };
    }, [
        extractedData,
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    (0, $fx7mS.useClearSidebarToggled)();
    return {
        data: features,
        loading: loading,
        error: error
    };
};

});
parcelRegister("2futN", function(module, exports) {

$parcel$export(module.exports, "useProjectSidebarNavigation", () => $e6824b09c7b48982$export$5a85006c180fb373);
$parcel$export(module.exports, "useProjectSidebarConnectNavigation", () => $e6824b09c7b48982$export$2bed15cd7d167db5);
$parcel$export(module.exports, "useProjectReportsSidebarConnectNavigation", () => $e6824b09c7b48982$export$a9d05fc2c1d94895);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectNavigation", () => $e6824b09c7b48982$export$d48e3c3556894533);
$parcel$export(module.exports, "useJSMProjectConnectQueuesNavigation", () => $e6824b09c7b48982$export$24a781cd863077aa);
$parcel$export(module.exports, "useJiraWorkmanagementProjectNavigation", () => $e6824b09c7b48982$export$e16ecd2512eb0dc7);
$parcel$export(module.exports, "useJiraSoftwareProjectNavigation", () => $e6824b09c7b48982$export$68dc0ecbea8211d2);
$parcel$export(module.exports, "useJiraServiceManagementProjectNavigation", () => $e6824b09c7b48982$export$5cf90b625d0e1248);
$parcel$export(module.exports, "useJiraProductDiscoveryProjectNavigation", () => $e6824b09c7b48982$export$d63d92edebe543d9);

var $eUqFw = parcelRequire("eUqFw");

var $7wRIc = parcelRequire("7wRIc");
var $kKeF6 = parcelRequire("kKeF6");
var $iivTa = parcelRequire("iivTa");
var $cbmC6 = parcelRequire("cbmC6");
var $kXWpU = parcelRequire("kXWpU");

var $iZJHG = parcelRequire("iZJHG");

var $h5RgW = parcelRequire("h5RgW");

var $cLNfQ = parcelRequire("cLNfQ");
const $e6824b09c7b48982$export$5a85006c180fb373 = (customContext)=>{
    const { data: navResponse, loading: loading, error: error, refresh: refresh, clearAll: clearAll, ...rest } = (0, $iZJHG.useResourceWithCustomRouterContext)((0, $kXWpU.staticProjectSidebarNavigationResource), customContext);
    const memoizedResponse = (0, $eUqFw.useMemo)(()=>navResponse, [
        navResponse
    ]);
    (0, $cLNfQ.useJiraSoftwareCMPNavigationSynchronizer)(memoizedResponse);
    return {
        data: memoizedResponse,
        loading: memoizedResponse != null ? false : loading,
        refresh: refresh,
        clearAll: clearAll,
        error: error,
        ...rest
    };
};
const $e6824b09c7b48982$export$2bed15cd7d167db5 = ()=>(0, $h5RgW.useResource)((0, $cbmC6.staticProjectSidebarConnectAddonsNavigationResource));
const $e6824b09c7b48982$export$a9d05fc2c1d94895 = ()=>(0, $h5RgW.useResource)((0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource));
const $e6824b09c7b48982$export$d48e3c3556894533 = ()=>(0, $h5RgW.useResource)((0, $iivTa.staticProjectSettingsSidebarConnectAddonsNavigationResource));
const $e6824b09c7b48982$export$24a781cd863077aa = ()=>(0, $h5RgW.useResource)((0, $7wRIc.staticJSMProjectConnectAddonsNavigationResource));
const $e6824b09c7b48982$export$e16ecd2512eb0dc7 = ()=>{
    const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373();
    const response = data?.jiraWorkManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $e6824b09c7b48982$export$68dc0ecbea8211d2 = ()=>{
    const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373();
    const response = data?.jiraSoftwareNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $e6824b09c7b48982$export$5cf90b625d0e1248 = (customContext)=>{
    const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373(customContext);
    const response = data?.jiraServiceManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $e6824b09c7b48982$export$d63d92edebe543d9 = ()=>{
    const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373();
    const response = data?.jiraProductDiscoveryNavData || null;
    return {
        data: response,
        ...rest
    };
};

});
parcelRegister("7wRIc", function(module, exports) {

$parcel$export(module.exports, "staticJSMProjectConnectAddonsNavigationResource", () => $1da568058e8dfab8$export$fab84295e18e9246);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $6xFTe = parcelRequire("6xFTe");

var $9zYls = parcelRequire("9zYls");

var $76v64 = parcelRequire("76v64");
const $1da568058e8dfab8$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $1da568058e8dfab8$export$fab84295e18e9246 = (0, $6xFTe.createResource)({
    type: 'NAVIGATION_SIDEBAR_JSM_PROJECT_CONNECT_ADDONS_QUEUES_RESOURCE',
    getKey: ({ match: match, query: query })=>$1da568058e8dfab8$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $1da568058e8dfab8$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'jsm_queues');
        return navInfo;
    },
    maxAge: 300000
});

});
parcelRegister("76v64", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarConnectNavigationInfo", () => $c603d0485f5d33bd$export$b15f9f5cf6db359e);

var $lRmyA = parcelRequire("lRmyA");
const $c603d0485f5d33bd$export$b15f9f5cf6db359e = (projectKeyOrId, sidebarType)=>{
    if (projectKeyOrId == null) throw new Error('invalid identifier specified');
    return (0, $lRmyA.performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=${sidebarType}`);
};

});


parcelRegister("kKeF6", function(module, exports) {

$parcel$export(module.exports, "staticProjectReportsSidebarConnectAddonsNavigationResource", () => $5a0ad956b22e7be5$export$b662f3f877add30d);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $6xFTe = parcelRequire("6xFTe");

var $9zYls = parcelRequire("9zYls");

var $76v64 = parcelRequire("76v64");
const $5a0ad956b22e7be5$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $5a0ad956b22e7be5$export$b662f3f877add30d = (0, $6xFTe.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_REPORTS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$5a0ad956b22e7be5$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $5a0ad956b22e7be5$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'reports');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("iivTa", function(module, exports) {

$parcel$export(module.exports, "staticProjectSettingsSidebarConnectAddonsNavigationResource", () => $a5660a56dfe8a855$export$e4bf33528101348c);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectAddonsNavigationResource", () => $a5660a56dfe8a855$export$2d5a704ae6f6b050);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

var $9zYls = parcelRequire("9zYls");

var $76v64 = parcelRequire("76v64");
const $a5660a56dfe8a855$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $a5660a56dfe8a855$export$e4bf33528101348c = (0, $6xFTe.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SETTINGS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$a5660a56dfe8a855$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $a5660a56dfe8a855$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'settings');
        return navInfo;
    },
    maxAge: 300000
});
const $a5660a56dfe8a855$export$2d5a704ae6f6b050 = ()=>(0, $h5RgW.useResource)($a5660a56dfe8a855$export$e4bf33528101348c);

});

parcelRegister("cbmC6", function(module, exports) {

$parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResource", () => $9d72696b0f8eb1a8$export$b8c6e2666f12f4bb);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $6xFTe = parcelRequire("6xFTe");

var $9zYls = parcelRequire("9zYls");

var $76v64 = parcelRequire("76v64");
const $9d72696b0f8eb1a8$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $9d72696b0f8eb1a8$export$b8c6e2666f12f4bb = (0, $6xFTe.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$9d72696b0f8eb1a8$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $9d72696b0f8eb1a8$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const projectHomeAddonNavInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'home');
        return projectHomeAddonNavInfo;
    },
    maxAge: 300000
});

});

parcelRegister("cLNfQ", function(module, exports) {

$parcel$export(module.exports, "useJiraSoftwareCMPNavigationSynchronizer", () => $1154a45446083a64$export$780174995da89d60);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $kXWpU = parcelRequire("kXWpU");

var $kXWpU = parcelRequire("kXWpU");

var $lB25E = parcelRequire("lB25E");
var $h5RgW = parcelRequire("h5RgW");
const $1154a45446083a64$export$90dbde7e33e6e21 = ()=>null;
const $1154a45446083a64$export$d647718555c2fdd8 = (projectKey)=>projectKey ? (0, $lB25E.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/:projectKey/dummyroute',
        component: $1154a45446083a64$export$90dbde7e33e6e21
    }, {
        params: {
            projectKey: projectKey
        }
    }) : undefined;
const $1154a45446083a64$export$19001bab9e4b7f8f = (projectKey)=>{
    const { data: data, update: update } = (0, $h5RgW.useResource)((0, $kXWpU.staticProjectSidebarNavigationResource), {
        routerContext: $1154a45446083a64$export$d647718555c2fdd8(projectKey)
    });
    return {
        data: data,
        update: update
    };
};
const $1154a45446083a64$export$23dc6491016cabdc = (boardId)=>boardId != null ? (0, $lB25E.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/boards/:boardId/dummyroute',
        component: $1154a45446083a64$export$90dbde7e33e6e21
    }, {
        params: {
            boardId: `${boardId}`
        }
    }) : undefined;
const $1154a45446083a64$export$e2bb7877e6cec3eb = (boardId)=>{
    const { data: data, update: update } = (0, $h5RgW.useResource)((0, $kXWpU.staticProjectSidebarNavigationResource), {
        routerContext: $1154a45446083a64$export$23dc6491016cabdc(boardId)
    });
    return {
        data: data,
        update: update
    };
};
const $1154a45446083a64$export$780174995da89d60 = (latestNavInfo)=>{
    const [{ match: match, query: query, route: { name: name } }] = (0, $lB25E.useRouter)();
    const isOnBoardBasedRoute = (0, $kXWpU.getIdentifier)(name, match, query)?.identifierType === 'boardId';
    const isSoftwareCMP = latestNavInfo?.jiraSoftwareNavData?.project?.simplified === false;
    const pKey = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.project?.key || null;
    const boardId = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.boardInfo?.id || null;
    // explicitly get project data by forcing key to be project
    const { data: projectRouteNavInfo, update: updateProjectRoute } = $1154a45446083a64$export$19001bab9e4b7f8f(pKey);
    // explicitly get board data by forcing key to be board
    const { data: boardRouteNavInfo, update: updateBoardRoute } = $1154a45446083a64$export$e2bb7877e6cec3eb(boardId);
    // if software CMP project or board data is not in sync, then force update
    (0, $eUqFw.useEffect)(()=>{
        if (latestNavInfo != null && isSoftwareCMP) {
            if (isOnBoardBasedRoute && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(latestNavInfo, projectRouteNavInfo)) updateProjectRoute(()=>latestNavInfo);
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(latestNavInfo, boardRouteNavInfo)) updateBoardRoute(()=>latestNavInfo);
        }
    }, [
        isOnBoardBasedRoute,
        latestNavInfo,
        updateProjectRoute,
        updateBoardRoute,
        projectRouteNavInfo,
        boardRouteNavInfo,
        isSoftwareCMP
    ]);
};

});


parcelRegister("fx7mS", function(module, exports) {

$parcel$export(module.exports, "useClearSidebarToggled", () => $56a5d67cb570e6e5$export$2946f555c6f48127);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $2futN = parcelRequire("2futN");

var $hzcvF = parcelRequire("hzcvF");

var $gleuI = parcelRequire("gleuI");

var $4tOq6 = parcelRequire("4tOq6");
const $56a5d67cb570e6e5$export$2946f555c6f48127 = ()=>{
    const { data: data, refresh: refresh } = (0, $2futN.useJiraSoftwareProjectNavigation)();
    const [sidebarFeatureToggled, { clearSiderbarFeatureToggled: clearSiderbarFeatureToggled }] = (0, $gleuI.useSidebarFeatureToggled)();
    const isEligibleForFeatureToggle = (0, $4tOq6.useShouldApplyFeatureToggle)();
    const sidebarHasChanged = (0, $eUqFw.useRef)(false);
    const previousData = (0, $hzcvF.usePreviousWithInitial)(data);
    // if resource data has changed since the last refresh then remove the sidebar toggled data.
    // i.e. whatever that has been toggled is reflected on the latest resource
    const shouldClear = (0, $eUqFw.useMemo)(()=>isEligibleForFeatureToggle && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(previousData, data), [
        isEligibleForFeatureToggle,
        previousData,
        data
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (shouldClear) clearSiderbarFeatureToggled();
    }, [
        shouldClear,
        clearSiderbarFeatureToggled
    ]);
    (0, $eUqFw.useEffect)(()=>{
        sidebarHasChanged.current = isEligibleForFeatureToggle && !!sidebarFeatureToggled;
    }, [
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    // refresh the navigation resource if sidebar has changed
    (0, $eUqFw.useEffect)(()=>()=>{
            if (sidebarHasChanged.current) refresh();
        }, [
        refresh
    ]);
};

});
parcelRegister("gleuI", function(module, exports) {

$parcel$export(module.exports, "useFeature", () => $4a189912c2bfb976$export$fc97652867e5867e);
$parcel$export(module.exports, "useEnablingFeature", () => $4a189912c2bfb976$export$207b461610a7fca6);
$parcel$export(module.exports, "useSidebarFeatureToggled", () => $4a189912c2bfb976$export$9eef668f94562feb);

var $WBLbN = parcelRequire("WBLbN");

var $l7y1V = parcelRequire("l7y1V");
const $4a189912c2bfb976$var$initialState = {
    features: [],
    isLoading: false,
    enablingFeatures: [],
    isFetchError: false,
    sidebarFeatureToggled: null
};
const $4a189912c2bfb976$var$store = (0, $WBLbN.createStore)({
    name: 'feature-toggle',
    initialState: $4a189912c2bfb976$var$initialState,
    actions: $l7y1V.actions
});
const $4a189912c2bfb976$export$fc97652867e5867e = (0, $WBLbN.createHook)($4a189912c2bfb976$var$store);
const $4a189912c2bfb976$export$207b461610a7fca6 = (0, $WBLbN.createHook)($4a189912c2bfb976$var$store, {
    selector: (state, { feature: feature })=>state.enablingFeatures.some((f)=>f === feature)
});
const $4a189912c2bfb976$export$e7699ed698eeb9ec = (0, $WBLbN.createHook)($4a189912c2bfb976$var$store, {
    selector: (state, { feature: feature })=>state.features.find((f)=>f.feature === feature)?.state
});
const $4a189912c2bfb976$export$9eef668f94562feb = (0, $WBLbN.createHook)($4a189912c2bfb976$var$store, {
    selector: (state)=>state.sidebarFeatureToggled
});

});
parcelRegister("l7y1V", function(module, exports) {

$parcel$export(module.exports, "actions", () => $be4dec2964c48764$export$e324594224ef24da);

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");

var $hgS1t = parcelRequire("hgS1t");

var $lav2w = parcelRequire("lav2w");

var $acaKg = parcelRequire("acaKg");

var $7pTBU = parcelRequire("7pTBU");
const $be4dec2964c48764$var$clearSiderbarFeatureToggled = ()=>({ setState: setState })=>{
        setState({
            sidebarFeatureToggled: null
        });
    };
const $be4dec2964c48764$var$fetchFeatures = (boardId)=>async ({ getState: getState, setState: setState })=>{
        const { features: features, isLoading: isLoading } = getState();
        if (isLoading) return;
        setState({
            isFetchError: false
        });
        try {
            if (features.length === 0) {
                setState({
                    isLoading: true
                });
                const data = await (0, $acaKg.getBoardFeatures)(boardId);
                const filteredFeatures = (0, $lav2w.filterAndSort)(data);
                (0, $lav2w.fireErrorAnalyticsOnUnmatchFeatureKey)(filteredFeatures);
                setState({
                    isLoading: false,
                    features: filteredFeatures
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isFetchError: true,
                isLoading: false
            });
            (0, $guiFP.default)({
                meta: {
                    ...(0, $hgS1t.commonErrorAnalyticsMeta),
                    id: 'fetchFeatures'
                },
                error: error
            });
        }
    };
const $be4dec2964c48764$var$syncFeaturesNew = (sidebarFeatureStatus)=>({ getState: getState, setState: setState })=>{
        const { features: features } = getState();
        const isListViewEnabled = (0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation');
        const featureMap = (0, $hgS1t.getFeatureMap)({
            isListViewEnabled: isListViewEnabled
        });
        const synced = features.map((f)=>{
            const id = f.feature;
            if (featureMap[id]) {
                const { statusKey: statusKey } = featureMap[id];
                return {
                    ...f,
                    state: sidebarFeatureStatus[statusKey] ? 'ENABLED' : 'DISABLED'
                };
            }
            return f;
        });
        setState({
            features: synced
        });
    };
const $be4dec2964c48764$var$syncFeaturesOld = (sidebarFeatureStatus)=>({ getState: getState, setState: setState })=>{
        const { features: features } = getState();
        let featureMap = (0, $hgS1t.featureMap);
        if ((0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation')) featureMap = {
            ...featureMap,
            ...(0, $hgS1t.listFeature)
        };
        const keys = new Set(Object.keys(featureMap));
        const synced = features.map((f)=>{
            const id = f.feature;
            if (keys.has(id)) {
                const { statusKey: statusKey } = featureMap[id];
                return {
                    ...f,
                    state: sidebarFeatureStatus[statusKey] ? 'ENABLED' : 'DISABLED'
                };
            }
            return f;
        });
        setState({
            features: synced
        });
    };
const $be4dec2964c48764$var$syncFeatures = (sidebarFeatureStatus)=>(0, $eI5EY.fg)('jsw_feature_toggle_project_pages') ? $be4dec2964c48764$var$syncFeaturesNew(sidebarFeatureStatus) : $be4dec2964c48764$var$syncFeaturesOld(sidebarFeatureStatus);
const $be4dec2964c48764$var$updateFeatureNew = ({ boardId: boardId, feature: feature, dependentFeature: dependentFeature, analyticsEvent: analyticsEvent, onError: onError, onAfterUpdate: onAfterUpdate })=>async ({ getState: getState, setState: setState })=>{
        const { features: features, enablingFeatures: enablingFeatures, sidebarFeatureToggled: sidebarFeatureToggled } = getState();
        let featureMap = (0, $hgS1t.getFeatureMap)();
        if ((0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation')) featureMap = {
            ...featureMap,
            ...(0, $hgS1t.listFeature)
        };
        const currentStatus = features.find((f)=>f.feature === feature)?.state;
        const isEnabling = currentStatus === 'DISABLED';
        if (!boardId || feature.length === 0 || !currentStatus) return;
        try {
            // Optimistically update the toggle status before the API call finishes
            // and add feature to the enabling states
            setState({
                features: features.map((0, $lav2w.updateFeatureState)(feature, dependentFeature)),
                sidebarFeatureToggled: {
                    ...sidebarFeatureToggled ?? {},
                    [featureMap[feature].statusKey]: isEnabling,
                    ...dependentFeature && {
                        [featureMap[dependentFeature].statusKey]: isEnabling
                    }
                },
                ...isEnabling && {
                    enablingFeatures: [
                        ...enablingFeatures,
                        feature
                    ]
                }
            });
            await (0, $7pTBU.updateBoardFeature)({
                boardId: boardId,
                feature: feature,
                enabling: isEnabling
            });
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'featureStatus updated', {
                featureId: feature,
                newStatus: currentStatus
            });
            onAfterUpdate?.(feature, isEnabling);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onError?.();
            setState({
                features: features,
                sidebarFeatureToggled: sidebarFeatureToggled
            });
            (0, $guiFP.default)({
                meta: {
                    ...(0, $hgS1t.commonErrorAnalyticsMeta),
                    id: 'updateFeature'
                },
                error: error
            });
        }
        if (isEnabling) setState({
            // feature has been enabled, remove from enabling state
            enablingFeatures: getState().enablingFeatures.filter((f)=>f !== feature)
        });
    };
const $be4dec2964c48764$var$updateFeatureOld = ({ boardId: boardId, feature: feature, dependentFeature: dependentFeature, analyticsEvent: analyticsEvent, onError: onError, onAfterUpdate: onAfterUpdate })=>async ({ getState: getState, setState: setState })=>{
        const { features: features, enablingFeatures: enablingFeatures, sidebarFeatureToggled: sidebarFeatureToggled } = getState();
        let featureMap = (0, $hgS1t.featureMap);
        if ((0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation')) featureMap = {
            ...featureMap,
            ...(0, $hgS1t.listFeature)
        };
        const currentStatus = features.find((f)=>f.feature === feature)?.state;
        const isEnabling = currentStatus === 'DISABLED';
        if (!boardId || feature.length === 0 || !currentStatus) return;
        try {
            // Optimistically update the toggle status before the API call finishes
            // and add feature to the enabling states
            setState({
                features: features.map((0, $lav2w.updateFeatureState)(feature, dependentFeature)),
                sidebarFeatureToggled: {
                    ...sidebarFeatureToggled ?? {},
                    [featureMap[feature].statusKey]: isEnabling,
                    ...dependentFeature && {
                        [featureMap[dependentFeature].statusKey]: isEnabling
                    }
                },
                ...isEnabling && {
                    enablingFeatures: [
                        ...enablingFeatures,
                        feature
                    ]
                }
            });
            await (0, $7pTBU.updateBoardFeature)({
                boardId: boardId,
                feature: feature,
                enabling: isEnabling
            });
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'featureStatus updated', {
                featureId: feature,
                newStatus: currentStatus
            });
            onAfterUpdate?.(feature, isEnabling);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onError?.();
            setState({
                features: features,
                sidebarFeatureToggled: sidebarFeatureToggled
            });
            (0, $guiFP.default)({
                meta: {
                    ...(0, $hgS1t.commonErrorAnalyticsMeta),
                    id: 'updateFeature'
                },
                error: error
            });
        }
        if (isEnabling) setState({
            // feature has been enabled, remove from enabling state
            enablingFeatures: getState().enablingFeatures.filter((f)=>f !== feature)
        });
    };
const $be4dec2964c48764$var$updateFeature = ({ boardId: boardId, feature: feature, dependentFeature: dependentFeature, analyticsEvent: analyticsEvent, onError: onError, onAfterUpdate: onAfterUpdate })=>(0, $eI5EY.fg)('jsw_feature_toggle_project_pages') ? $be4dec2964c48764$var$updateFeatureNew({
        boardId: boardId,
        feature: feature,
        dependentFeature: dependentFeature,
        analyticsEvent: analyticsEvent,
        onError: onError,
        onAfterUpdate: onAfterUpdate
    }) : $be4dec2964c48764$var$updateFeatureOld({
        boardId: boardId,
        feature: feature,
        dependentFeature: dependentFeature,
        analyticsEvent: analyticsEvent,
        onError: onError,
        onAfterUpdate: onAfterUpdate
    });
const $be4dec2964c48764$export$e324594224ef24da = {
    fetchFeatures: $be4dec2964c48764$var$fetchFeatures,
    updateFeature: $be4dec2964c48764$var$updateFeature,
    syncFeatures: $be4dec2964c48764$var$syncFeatures,
    clearSiderbarFeatureToggled: $be4dec2964c48764$var$clearSiderbarFeatureToggled
};

});
parcelRegister("hgS1t", function(module, exports) {

$parcel$export(module.exports, "commonErrorAnalyticsMeta", () => $e55474b5442b6fa2$export$47825241dc3c472c);
$parcel$export(module.exports, "MANAGE_FEATURE_MENU_ITEM_TEST_ID", () => $e55474b5442b6fa2$export$143e1d685830adbe);
$parcel$export(module.exports, "listFeature", () => $e55474b5442b6fa2$export$4ddfd7a9f5527982);
$parcel$export(module.exports, "featureMap", () => $e55474b5442b6fa2$export$a712b1e96d47b856);
$parcel$export(module.exports, "getFeatureMap", () => $e55474b5442b6fa2$export$6ac50cf33852adb5);
$parcel$export(module.exports, "ERROR_FLAG_ID", () => $e55474b5442b6fa2$export$f5e4c120ac01b615);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $5iWql = parcelRequire("5iWql");

var $5pv0k = parcelRequire("5pv0k");

var $28ybo = parcelRequire("28ybo");

var $fD5Ev = parcelRequire("fD5Ev");

var $6nIG2 = parcelRequire("6nIG2");

var $8CfG4 = parcelRequire("8CfG4");

var $1vuAp = parcelRequire("1vuAp");

var $exb0h = parcelRequire("exb0h");
const $e55474b5442b6fa2$export$47825241dc3c472c = {
    packageName: 'jiraTmpFeatureToggle',
    teamName: 'jlove-makkuro'
};
const $e55474b5442b6fa2$export$143e1d685830adbe = 'manage-feature-menu-item';
const $e55474b5442b6fa2$export$4ddfd7a9f5527982 = {
    'jsw.agility.list_view': {
        descriptionKey: 'listDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fD5Ev))), {
            label: ""
        }),
        statusKey: 'hasList',
        order: 35,
        redirectOn: [
            (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST)
        ]
    }
};
const $e55474b5442b6fa2$export$a712b1e96d47b856 = {
    'jsw.agility.simple-roadmap': {
        descriptionKey: 'timelineDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1vuAp))), {
            label: ""
        }),
        statusKey: 'hasRoadmap',
        order: 10,
        redirectOn: [
            (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE),
            (0, $exb0h.ROUTE_NAMES_SOFTWARE_ROADMAP)
        ]
    },
    'jsw.agility.backlog': {
        descriptionKey: 'backlogDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5pv0k))), {
            label: ""
        }),
        statusKey: 'hasBacklog',
        order: 20,
        redirectOn: [
            (0, $exb0h.ROUTE_NAMES_SOFTWARE_BACKLOG)
        ]
    },
    'jsw.agility.board': {
        descriptionKey: 'boardDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($28ybo))), {
            label: ""
        }),
        statusKey: 'hasBoard',
        order: 30
    },
    'jsw.agility.issue_navigator': {
        descriptionKey: 'issueNavigatorDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6nIG2))), {
            label: ""
        }),
        statusKey: 'hasSIN',
        order: 40,
        redirectOn: [
            (0, $exb0h.ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
            (0, $exb0h.ROUTE_NAMES_ISSUE)
        ]
    },
    'jsw.agility.sprints': {
        descriptionKey: 'releasesDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        statusKey: 'hasSprint',
        order: 50,
        isHidden: true
    }
}; // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>
const $e55474b5442b6fa2$export$6ac50cf33852adb5 = (0, $5iWql.default)(({ isSimplifyNavExperimentEnabled: isSimplifyNavExperimentEnabled, isListViewEnabled: isListViewEnabled } = {})=>({
        'jsw.agility.simple-roadmap': {
            descriptionKey: 'timelineDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1vuAp))), {
                label: ""
            }),
            statusKey: 'hasRoadmap',
            order: 10,
            redirectOn: [
                (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE),
                (0, $exb0h.ROUTE_NAMES_SOFTWARE_ROADMAP)
            ]
        },
        'jsw.agility.backlog': {
            descriptionKey: 'backlogDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5pv0k))), {
                label: ""
            }),
            statusKey: 'hasBacklog',
            order: 20,
            redirectOn: [
                (0, $exb0h.ROUTE_NAMES_SOFTWARE_BACKLOG)
            ]
        },
        'jsw.agility.board': {
            descriptionKey: 'boardDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($28ybo))), {
                label: ""
            }),
            statusKey: 'hasBoard',
            order: 30
        },
        ...!isSimplifyNavExperimentEnabled && {
            'jsw.agility.issue_navigator': {
                descriptionKey: 'issueNavigatorDescription',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6nIG2))), {
                    label: ""
                }),
                statusKey: 'hasSIN',
                order: 40,
                redirectOn: [
                    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
                    (0, $exb0h.ROUTE_NAMES_ISSUE)
                ]
            }
        },
        'jsw.agility.sprints': {
            descriptionKey: 'releasesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
            statusKey: 'hasSprint',
            order: 50,
            isHidden: true
        },
        'jsw.agility.pages': {
            descriptionKey: 'projectPagesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
                label: ""
            }),
            statusKey: 'hasPages',
            order: 60,
            redirectOn: [
                (0, $exb0h.ROUTE_NAMES_PROJECT_PAGES)
            ]
        },
        ...isListViewEnabled && $e55474b5442b6fa2$export$4ddfd7a9f5527982
    }), (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))); // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>;
const $e55474b5442b6fa2$export$f5e4c120ac01b615 = 'feature-toggle-error-flag';

});
parcelRegister("5pv0k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3f07565d43ea9ca6$var$_react = $3f07565d43ea9ca6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $3f07565d43ea9ca6$var$_backlog = $3f07565d43ea9ca6$var$_interopRequireDefault((parcelRequire("c3Enf")));
function $3f07565d43ea9ca6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3f07565d43ea9ca6$var$BacklogIcon = (props)=>/*#__PURE__*/ $3f07565d43ea9ca6$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.002C5 19 17 19 17 19v-2.002C17 17 5 17 5 17zm-2-2.004C3 15.894 3.895 15 4.994 15h12.012c1.101 0 1.994.898 1.994 1.998v2.004A1.997 1.997 0 0 1 17.006 21H4.994A2 2 0 0 1 3 19.002z"/><path d="M5 15h12v-2H5zm-2-4h16v6H3z"/><path d="M7 11.002C7 11 19 11 19 11V8.998C19 9 7 9 7 9zM5 8.998C5 7.894 5.895 7 6.994 7h12.012C20.107 7 21 7.898 21 8.998v2.004A1.997 1.997 0 0 1 19.006 13H6.994A2 2 0 0 1 5 11.002z"/><path d="M5 5v2h12V5zm-2-.002C3 3.894 3.895 3 4.994 3h12.012C18.107 3 19 3.898 19 4.998V9H3z"/></g></svg>`
    }, props, {
        newIcon: $3f07565d43ea9ca6$var$_backlog.default
    }));
$3f07565d43ea9ca6$var$BacklogIcon.displayName = 'BacklogIcon';
var $3f07565d43ea9ca6$var$_default = module.exports.default = $3f07565d43ea9ca6$var$BacklogIcon;

});
parcelRegister("c3Enf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ddd0d36f6409a9fcba622c91220b0b67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c75154d70bb8152$var$_react = $8c75154d70bb8152$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $8c75154d70bb8152$var$_UNSAFE_baseNew = $8c75154d70bb8152$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $8c75154d70bb8152$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8c75154d70bb8152$var$BacklogIcon = (props)=>/*#__PURE__*/ $8c75154d70bb8152$var$_react.default.createElement($8c75154d70bb8152$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 5.917V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v2.917m-12.5 0v4.166m0-4.166h12.5m-12.5 4.166V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-2.917m-12.5 0h12.5m0-4.166v4.166"/>`
    }, props));
$8c75154d70bb8152$var$BacklogIcon.displayName = 'BacklogIcon';
var $8c75154d70bb8152$var$_default = module.exports.default = $8c75154d70bb8152$var$BacklogIcon;

});


parcelRegister("fD5Ev", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b60ee1f4d4329714$var$_react = $b60ee1f4d4329714$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $b60ee1f4d4329714$var$_listBulleted = $b60ee1f4d4329714$var$_interopRequireDefault((parcelRequire("bH5AZ")));
function $b60ee1f4d4329714$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b60ee1f4d4329714$var$BulletListIcon = (props)=>/*#__PURE__*/ $b60ee1f4d4329714$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="10" y="15" rx="1"/><rect width="2" height="2" x="6" y="15" rx="1"/><rect width="8" height="2" x="10" y="11" rx="1"/><rect width="2" height="2" x="6" y="11" rx="1"/><rect width="8" height="2" x="10" y="7" rx="1"/><rect width="2" height="2" x="6" y="7" rx="1"/></g></svg>`
    }, props, {
        newIcon: $b60ee1f4d4329714$var$_listBulleted.default
    }));
$b60ee1f4d4329714$var$BulletListIcon.displayName = 'BulletListIcon';
var $b60ee1f4d4329714$var$_default = module.exports.default = $b60ee1f4d4329714$var$BulletListIcon;

});
parcelRegister("bH5AZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::38bd678c7566e24589e760902a3381f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88380d0c63fc4ead$var$_react = $88380d0c63fc4ead$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $88380d0c63fc4ead$var$_UNSAFE_baseNew = $88380d0c63fc4ead$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $88380d0c63fc4ead$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $88380d0c63fc4ead$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $88380d0c63fc4ead$var$_react.default.createElement($88380d0c63fc4ead$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.75 2.75a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M5 2.75h10M5 8h10M5 13.25h10M2.75 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0-10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`
    }, props));
$88380d0c63fc4ead$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $88380d0c63fc4ead$var$_default = module.exports.default = $88380d0c63fc4ead$var$ListBulletedIcon;

});


parcelRegister("8CfG4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $645e088e86b3f594$var$_react = $645e088e86b3f594$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $645e088e86b3f594$var$_page = $645e088e86b3f594$var$_interopRequireDefault((parcelRequire("20Mcc")));
function $645e088e86b3f594$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $645e088e86b3f594$var$PageIcon = (props)=>/*#__PURE__*/ $645e088e86b3f594$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
    }, props, {
        newIcon: $645e088e86b3f594$var$_page.default
    }));
$645e088e86b3f594$var$PageIcon.displayName = 'PageIcon';
var $645e088e86b3f594$var$_default = module.exports.default = $645e088e86b3f594$var$PageIcon;

});
parcelRegister("20Mcc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cab2bd3bf7f5b1e2b2df4de8af9192f9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1770f78818431634$var$_react = $1770f78818431634$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $1770f78818431634$var$_UNSAFE_baseNew = $1770f78818431634$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $1770f78818431634$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1770f78818431634$var$PageIcon = (props)=>/*#__PURE__*/ $1770f78818431634$var$_react.default.createElement($1770f78818431634$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 5.25h8m-8 3.5h6m-7 5.5h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$1770f78818431634$var$PageIcon.displayName = 'PageIcon';
var $1770f78818431634$var$_default = module.exports.default = $1770f78818431634$var$PageIcon;

});


parcelRegister("1vuAp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1190697f0a3052c9$var$_react = $1190697f0a3052c9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $1190697f0a3052c9$var$_roadmap = $1190697f0a3052c9$var$_interopRequireDefault((parcelRequire("i2kUf")));
function $1190697f0a3052c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1190697f0a3052c9$var$RoadmapIcon = (props)=>/*#__PURE__*/ $1190697f0a3052c9$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 2h10a3 3 0 0 1 0 6H6a3 3 0 1 1 0-6m0 2a1 1 0 1 0 0 2h10a1 1 0 0 0 0-2zm4 5h8a3 3 0 0 1 0 6h-8a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zm-4 5h6a3 3 0 0 1 0 6H6a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        newIcon: $1190697f0a3052c9$var$_roadmap.default
    }));
$1190697f0a3052c9$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $1190697f0a3052c9$var$_default = module.exports.default = $1190697f0a3052c9$var$RoadmapIcon;

});
parcelRegister("i2kUf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b399ad3f0d3690e46558e99d7cc79bda>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d218a16aa9c2bf5b$var$_react = $d218a16aa9c2bf5b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $d218a16aa9c2bf5b$var$_UNSAFE_baseNew = $d218a16aa9c2bf5b$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $d218a16aa9c2bf5b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d218a16aa9c2bf5b$var$RoadmapIcon = (props)=>/*#__PURE__*/ $d218a16aa9c2bf5b$var$_react.default.createElement($d218a16aa9c2bf5b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M.75 4c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v1c0 .69-.56 1.25-1.25 1.25H2C1.31 6.25.75 5.69.75 5zm3 7c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v1c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25z"/>`
    }, props));
$d218a16aa9c2bf5b$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $d218a16aa9c2bf5b$var$_default = module.exports.default = $d218a16aa9c2bf5b$var$RoadmapIcon;

});



parcelRegister("lav2w", function(module, exports) {

$parcel$export(module.exports, "filterAndSort", () => $90bd3e7820b384a6$export$d0e0de50c701304c);
$parcel$export(module.exports, "findDependentFeature", () => $90bd3e7820b384a6$export$4c8205136225a4e2);
$parcel$export(module.exports, "updateFeatureState", () => $90bd3e7820b384a6$export$2bdeae30201d513c);
$parcel$export(module.exports, "fireErrorAnalyticsOnUnmatchFeatureKey", () => $90bd3e7820b384a6$export$5da1e8c5ba5c0dc2);

var $7GXrf = parcelRequire("7GXrf");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $hgS1t = parcelRequire("hgS1t");
const $90bd3e7820b384a6$export$b70265791d2079d4 = (hasFeature)=>hasFeature ? 'ENABLED' : 'DISABLED';
const $90bd3e7820b384a6$export$d0e0de50c701304c = (features)=>{
    const isListViewEnabled = (0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation');
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
    if ((0, $eI5EY.fg)('jsw_feature_toggle_project_pages')) {
        const featureMap = (0, $hgS1t.getFeatureMap)({
            isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
            isListViewEnabled: isListViewEnabled
        });
        return features.filter((f)=>Object.keys(featureMap).includes(f.feature)).sort((a, b)=>featureMap[a.feature].order - featureMap[b.feature].order);
    }
    let featureMap = (0, $hgS1t.featureMap);
    if (isListViewEnabled) featureMap = {
        ...featureMap,
        ...(0, $hgS1t.listFeature)
    };
    return features.filter((f)=>Object.keys(featureMap).includes(f.feature)).sort((a, b)=>featureMap[a.feature].order - featureMap[b.feature].order);
};
const $90bd3e7820b384a6$export$4c8205136225a4e2 = (features, featureId)=>{
    const featureToDisable = features.find((f)=>f.feature === featureId);
    // Will only show the modal when the current status is enabled for both the feature to disable and the dependent feature
    if (featureToDisable?.state !== 'ENABLED') return undefined;
    // For the scope of the feature toggle, we assume there is only one dependency for now
    return features.find((f)=>f.prerequisites.includes(featureId) && f.state === 'ENABLED');
};
const $90bd3e7820b384a6$export$2bdeae30201d513c = (featureId, dependentFeatureId)=>(feature)=>feature.feature === featureId || dependentFeatureId && feature.feature === dependentFeatureId ? {
            ...feature,
            state: feature.state === 'ENABLED' ? 'DISABLED' : 'ENABLED'
        } : feature;
const $90bd3e7820b384a6$export$5da1e8c5ba5c0dc2 = (filteredFeatures)=>{
    const isListViewEnabled = (0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation');
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
    if ((0, $eI5EY.fg)('jsw_feature_toggle_project_pages')) {
        const featureMap = (0, $hgS1t.getFeatureMap)({
            isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
            isListViewEnabled: isListViewEnabled
        });
        if (filteredFeatures.length < Object.keys(featureMap).length) {
            const unmatchedFeatureKeys = (0, (/*@__PURE__*/$parcel$interopDefault($7GXrf)))(Object.keys(featureMap), ...filteredFeatures.map((f)=>f.feature));
            (0, $guiFP.default)({
                error: new Error("Some feature keys don't match . Please check API response"),
                meta: {
                    ...(0, $hgS1t.commonErrorAnalyticsMeta),
                    id: 'unmatchFeatureKey'
                },
                attributes: {
                    unmatchedFeatureKeys: unmatchedFeatureKeys.toString()
                }
            });
        }
    } else {
        let featureMap = (0, $hgS1t.featureMap);
        if (isListViewEnabled) featureMap = {
            ...featureMap,
            ...(0, $hgS1t.listFeature)
        };
        if (filteredFeatures.length < Object.keys(featureMap).length) {
            const unmatchedFeatureKeys = (0, (/*@__PURE__*/$parcel$interopDefault($7GXrf)))(Object.keys(featureMap), ...filteredFeatures.map((f)=>f.feature));
            (0, $guiFP.default)({
                error: new Error("Some feature keys don't match . Please check API response"),
                meta: {
                    ...(0, $hgS1t.commonErrorAnalyticsMeta),
                    id: 'unmatchFeatureKey'
                },
                attributes: {
                    unmatchedFeatureKeys: unmatchedFeatureKeys.toString()
                }
            });
        }
    }
};

});
parcelRegister("7GXrf", function(module, exports) {

var $fa0Ox = parcelRequire("fa0Ox");

var $9eFtX = parcelRequire("9eFtX");

var $cRpul = parcelRequire("cRpul");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $599a8fe1eb632ef8$var$without = $9eFtX(function(array, values) {
    return $cRpul(array) ? $fa0Ox(array, values) : [];
});
module.exports = $599a8fe1eb632ef8$var$without;

});


parcelRegister("acaKg", function(module, exports) {

$parcel$export(module.exports, "getBoardFeatures", () => $56d9fdff2bf76afe$export$c20100b185d41ab0);

var $lRmyA = parcelRequire("lRmyA");

var $gEHAf = parcelRequire("gEHAf");
const $56d9fdff2bf76afe$export$c20100b185d41ab0 = async (boardId)=>{
    const data = await (0, $lRmyA.performGetRequest)((0, $gEHAf.getBoardFeaturesUrl)(boardId));
    return data.features;
};

});
parcelRegister("gEHAf", function(module, exports) {

$parcel$export(module.exports, "getBoardFeaturesUrl", () => $bba54409f593a7bc$export$3f9939d302766b52);
const $bba54409f593a7bc$export$3f9939d302766b52 = (boardId)=>`/rest/agile/latest/board/${boardId}/features`;

});


parcelRegister("7pTBU", function(module, exports) {

$parcel$export(module.exports, "updateBoardFeature", () => $744e8308bd8c4834$export$61f6bbb745b3a3);

var $lRmyA = parcelRequire("lRmyA");

var $gEHAf = parcelRequire("gEHAf");
const $744e8308bd8c4834$export$61f6bbb745b3a3 = async (request)=>{
    // it returns the board features array, but we don't use it for optimistic update
    // feature state is used instead to indicate if the updates successful or not
    const data = await (0, $lRmyA.performPutRequest)((0, $gEHAf.getBoardFeaturesUrl)(request.boardId), {
        body: JSON.stringify(request)
    });
    const newState = data.features.find((f)=>f.feature === request.feature)?.state;
    return newState ?? (request.enabling ? 'ENABLED' : 'DISABLED');
};

});



parcelRegister("4tOq6", function(module, exports) {

$parcel$export(module.exports, "useShouldApplyFeatureToggle", () => $c65009790646f0d4$export$7deca16ba2d9eb74);

var $7ZZxN = parcelRequire("7ZZxN");

var $eI5EY = parcelRequire("eI5EY");

var $bNe1g = parcelRequire("bNe1g");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");
var $21Sgb = parcelRequire("21Sgb");
const $c65009790646f0d4$export$7deca16ba2d9eb74 = ()=>{
    const { data: project } = (0, $bNe1g.useProjectContext)();
    const { software: software } = (0, $ab6rA.useAppEditions)();
    const firstActivationDateMs = (0, $21Sgb.useFirstActivationDateMs)() || 0;
    const isJSW = project?.projectType === (0, $7ZZxN.SOFTWARE_PROJECT);
    const isTMP = !!project?.simplified;
    const isProjectAdmin = !!project?.isProjectAdmin;
    const isFreeInstance = software === (0, $6WXNs.FREE_EDITION);
    const isNewInstance = new Date(firstActivationDateMs) >= new Date('2023-09-25T15:00:00');
    if ((0, $eI5EY.fg)('jsw_feature_toggle_project_pages')) return isJSW && isTMP && isProjectAdmin && isNewInstance;
    return isJSW && isFreeInstance && isTMP && isProjectAdmin && isNewInstance;
};

});
parcelRegister("21Sgb", function(module, exports) {

$parcel$export(module.exports, "useFirstActivationDateMs", () => $080756a4d87be123$export$9df3a539e50a284b);

var $gd0Sp = parcelRequire("gd0Sp");
const $080756a4d87be123$export$9df3a539e50a284b = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
};

});



parcelRegister("6EvIB", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $862aee856901356e$export$9df5fa0a366163d2);

var $79xbN = parcelRequire("79xbN");
const $862aee856901356e$export$9df5fa0a366163d2 = (navData)=>{
    const { permissionInfo: permissionInfo, hasBacklog: hasBacklog, hasBoard: hasBoard, hasCode: hasCode, hasGoals: hasGoals, hasSecurity: hasSecurity, hasDeployments: hasDeployments, hasList: hasList, hasOpsgenieSchedule: hasOpsgenieSchedule, hasPages: hasPages, hasReleases: hasReleases, hasRoadmap: hasRoadmap, hasReports: hasReports, hasRequests: hasRequests, hasIssues: hasIssues, hasSprint: hasSprint, hasIncidents: hasIncidents, hasCalendar: hasCalendar, aiInfo: aiInfo } = navData;
    const isProjectOrJiraAdmin = permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    return {
        hasBacklog: hasBacklog,
        hasBoard: hasBoard,
        hasRoadmap: hasRoadmap,
        hasCode: hasCode,
        hasGoals: hasGoals,
        hasSecurity: hasSecurity,
        hasDeployments: hasDeployments,
        hasList: (0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation') ? hasList : false,
        hasReleases: hasReleases,
        hasSIN: hasIssues,
        hasReports: hasReports,
        hasRequests: hasRequests,
        hasPages: hasPages,
        hasOpsgenie: hasOpsgenieSchedule,
        hasShortcutsAdd: isProjectOrJiraAdmin,
        hasSettings: isProjectOrJiraAdmin,
        hasSprint: hasSprint,
        hasIncidents: hasIncidents,
        hasCalendar: hasCalendar,
        hasAIInNIN: hasIssues && aiInfo?.isEnabledInIssueNavigator === true
    };
};

});


parcelRegister("dqxG2", function(module, exports) {

$parcel$export(module.exports, "generateNinBasePath", () => $d1968689379c0bf2$export$47d9a807c1277671);

var $7ZZxN = parcelRequire("7ZZxN");
const $d1968689379c0bf2$export$ddaf187654250a8d = '/issues/';
const $d1968689379c0bf2$export$47d9a807c1277671 = (projectKey, projectType, isSimplifiedProject)=>{
    const getMainPath = (projectPath, simplified = true)=>`/jira/${projectPath}${!simplified ? '/c' : ''}/projects/${projectKey}/issues`;
    switch(projectType){
        case 0, $7ZZxN.CORE_PROJECT:
            return getMainPath('core');
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return getMainPath('servicedesk');
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return getMainPath('software', isSimplifiedProject);
        default:
            return $d1968689379c0bf2$export$ddaf187654250a8d; // Fall back to GIN
    }
};

});


parcelRegister("j3JBz", function(module, exports) {

$parcel$export(module.exports, "useCopyPageUrlCommand", () => $5722c9018ee7913b$export$e4eb2b3d3a5a5045);

var $eUqFw = parcelRequire("eUqFw");

var $dmCPj = parcelRequire("dmCPj");

var $6jiFZ = parcelRequire("6jiFZ");

var $jmejm = parcelRequire("jmejm");
var $9zALC = parcelRequire("9zALC");
var $gfXKy = parcelRequire("gfXKy");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $j0PGh = parcelRequire("j0PGh");

var $7ZOAl = parcelRequire("7ZOAl");
const $5722c9018ee7913b$export$e4eb2b3d3a5a5045 = ()=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const copyToClipboard = async ()=>{
        try {
            await (0, $7ZOAl.getNavigator)().clipboard.writeText((0, $7ZOAl.getWindow)().location.href);
            showFlag({
                type: 'success',
                title: (0, $j0PGh.messages).successTitleCopiedUrl
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            showFlag({
                type: 'error',
                title: (0, $j0PGh.messages).errorTitleCopiedUrl,
                description: (0, $j0PGh.messages).errorDescriptionCopiedUrl
            });
            (0, $guiFP.default)({
                error: err,
                meta: {
                    id: 'commandPaletteCopyUrlToClipboard',
                    packageName: 'jiraCommandPaletteIntegration',
                    teamName: 'deliveroo'
                }
            });
        }
    };
    const { getKeywords: getKeywords } = (0, $gfXKy.useCommandKeywords)();
    return {
        id: 'copy-page-url',
        name: formatMessage((0, $j0PGh.messages).commandCommandLabel),
        keywords: getKeywords('copyCurrentPageUrlSynonyms'),
        primaryAction: {
            type: (0, $6jiFZ.CommandActionType).PERFORM,
            perform: copyToClipboard
        },
        section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).quickActions,
        priority: (0, $jmejm.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).copyUrl,
        components: {
            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))), {
                    label: formatMessage((0, $j0PGh.messages).commandCommandLabel)
                })
        },
        analytics: {
            action: 'copyPageURL'
        }
    };
};

});
parcelRegister("dmCPj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bab72963b78cefe$var$_react = $9bab72963b78cefe$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9bab72963b78cefe$var$_copy = $9bab72963b78cefe$var$_interopRequireDefault((parcelRequire("dBCpP")));
function $9bab72963b78cefe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9bab72963b78cefe$var$CopyIcon = (props)=>/*#__PURE__*/ $9bab72963b78cefe$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $9bab72963b78cefe$var$_copy.default
    }));
$9bab72963b78cefe$var$CopyIcon.displayName = 'CopyIcon';
var $9bab72963b78cefe$var$_default = module.exports.default = $9bab72963b78cefe$var$CopyIcon;

});
parcelRegister("dBCpP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb7c6c8cdb896d771e123a497630ca2d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e7c879c9eefdea2$var$_react = $9e7c879c9eefdea2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9e7c879c9eefdea2$var$_UNSAFE_baseNew = $9e7c879c9eefdea2$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $9e7c879c9eefdea2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e7c879c9eefdea2$var$CopyIcon = (props)=>/*#__PURE__*/ $9e7c879c9eefdea2$var$_react.default.createElement($9e7c879c9eefdea2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
    }, props));
$9e7c879c9eefdea2$var$CopyIcon.displayName = 'CopyIcon';
var $9e7c879c9eefdea2$var$_default = module.exports.default = $9e7c879c9eefdea2$var$CopyIcon;

});


parcelRegister("jmejm", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY", () => $008cf4f8cce3a652$export$5ea2dca0a260365d);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $008cf4f8cce3a652$export$5ea2dca0a260365d;
(function(COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY) {
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["createIssue"] = 0] = "createIssue";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["searchOnCurrentPage"] = 1] = "searchOnCurrentPage";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openQuickSearch"] = 2] = "openQuickSearch";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["copyUrl"] = 3] = "copyUrl";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["checkNotifications"] = 4] = "checkNotifications";
})($008cf4f8cce3a652$export$5ea2dca0a260365d || ($008cf4f8cce3a652$export$5ea2dca0a260365d = {}));

});

parcelRegister("gfXKy", function(module, exports) {

$parcel$export(module.exports, "useCommandKeywords", () => $59897234799b31c8$export$4d8fe3ef6385358);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3iBHM = parcelRequire("3iBHM");
const $59897234799b31c8$export$4d8fe3ef6385358 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getKeywords = (0, $eUqFw.useCallback)((keywordGroup)=>(0, $3iBHM.messages)[keywordGroup] ? formatMessage((0, $3iBHM.messages)[keywordGroup]) : undefined, [
        formatMessage
    ]);
    return {
        getKeywords: getKeywords
    };
};

});
parcelRegister("3iBHM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2f74b9c3b50ad31d$export$defe85febe8b728c);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $2f74b9c3b50ad31d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    searchYourIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
        "defaultMessage": "Find my ideas tickets requests tasks work"
    },
    changeStatusSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
        "defaultMessage": "Move through workflow  Progress Done Complete transition"
    },
    assignToMeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
        "defaultMessage": "self"
    },
    assignIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
        "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
    },
    startWatchingIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
        "defaultMessage": "Follow work Track Unwatch Unfollow"
    },
    backlogSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
        "defaultMessage": "Inventory Go"
    },
    boardSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
        "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
    },
    reportsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
        "defaultMessage": "Summary Insights Burndown Go"
    },
    timelineSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
        "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
    },
    // TODO cleanup isCommandPaletteQuickSearchEnabled
    quickSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
        "defaultMessage": "Search products across Atlassian Go to"
    },
    pageSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
        "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
    },
    createIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
        "defaultMessage": "work Start idea New ticket task"
    },
    switchDarkThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
        "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    matchSystemThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
        "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    copyCurrentPageUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
        "defaultMessage": "link website address"
    },
    getHelpSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
        "defaultMessage": "In-product Support Documentation Questions Answers"
    },
    viewKeyboardShortcutsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
        "defaultMessage": "Hotkeys Show See"
    },
    editDescriptionSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
        "defaultMessage": "Completion criteria Info Information Details Add Write"
    },
    addAttachmentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
        "defaultMessage": "Attach Upload Document Media"
    },
    addCommentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
        "defaultMessage": "Write Message"
    },
    logWorkSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
        "defaultMessage": "Track Record hours Time spent"
    },
    addRemoveFlagSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
        "defaultMessage": "Unflag Mark Unmark Star Unstar"
    },
    cloneIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
        "defaultMessage": "Copy Duplicate Task Idea Request"
    },
    linkConfluencePageSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
        "defaultMessage": "Relate Add Connect"
    },
    addAUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
        "defaultMessage": "Connect Weblink Link Website Domain"
    },
    goToIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
        "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
    },
    goToPersonalSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
        "defaultMessage": "Preferences Notifications Theme Jira labs"
    },
    goToAccountSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
        "defaultMessage": "Preferences Privacy Profile Your details Personal information"
    },
    viewAllIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
        "defaultMessage": "Site issues JQL View all"
    },
    viewAllProjectsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllPlansSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllBoardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllFiltersSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllDashboardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
        "defaultMessage": "List Go"
    },
    checkNotificationsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
        "defaultMessage": "window See Updates"
    },
    goToUserManagementSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
        "defaultMessage": "Permissions"
    }
});

});


parcelRegister("j0PGh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $74ff3663e25bba7b$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $74ff3663e25bba7b$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    successTitleCopiedUrl: {
        "id": "command-palette-integration.initial-commands.use-copy-page-url.success-title-copied-url",
        "defaultMessage": "Page URL copied to clipboard"
    },
    errorTitleCopiedUrl: {
        "id": "command-palette-integration.initial-commands.use-copy-page-url.error-title-copied-url",
        "defaultMessage": "We couldn't copy the page URL"
    },
    errorDescriptionCopiedUrl: {
        "id": "command-palette-integration.initial-commands.use-copy-page-url.error-description-copied-url",
        "defaultMessage": "Please check your browser settings."
    },
    commandCommandLabel: {
        "id": "command-palette-integration.initial-commands.use-copy-page-url.command-command-label",
        "defaultMessage": "Copy current page URL"
    }
});

});

parcelRegister("7ZOAl", function(module, exports) {

$parcel$export(module.exports, "getWindow", () => $d8913a03720918d6$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getNavigator", () => $d8913a03720918d6$export$a56241c767c1d89f);
/* istanbul ignore file */ const $d8913a03720918d6$export$38b2d434cce3ea22 = ()=>window;
const $d8913a03720918d6$export$a56241c767c1d89f = ()=>navigator;

});


parcelRegister("iDtnH", function(module, exports) {

$parcel$export(module.exports, "useNavigationCommands", () => $ecb5b68d58dadd19$export$997e3c408ba63e3b);

var $eUqFw = parcelRequire("eUqFw");

var $cSu9v = parcelRequire("cSu9v");

var $iw0Y6 = parcelRequire("iw0Y6");
parcelRequire("1tWuI");
var $hrxXt = parcelRequire("hrxXt");

var $9zALC = parcelRequire("9zALC");
var $gfXKy = parcelRequire("gfXKy");
var $gIIkx = parcelRequire("gIIkx");

var $9zALC = parcelRequire("9zALC");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3rqlh = parcelRequire("3rqlh");

var $iJPUk = parcelRequire("iJPUk");

var $hawmT = parcelRequire("hawmT");

var $cWiVr = parcelRequire("cWiVr");

var $6JBWS = parcelRequire("6JBWS");
var $bLGeo = parcelRequire("bLGeo");
var $1cmFR = parcelRequire("1cmFR");
var $jsQSa = parcelRequire("jsQSa");
var $1iihP = parcelRequire("1iihP");

var $7lcEz = parcelRequire("7lcEz");

var $gd0Sp = parcelRequire("gd0Sp");

var $e0Hma = parcelRequire("e0Hma");


var $5eTF6 = parcelRequire("5eTF6");
const $ecb5b68d58dadd19$export$997e3c408ba63e3b = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getKeywords: getKeywords } = (0, $gfXKy.useCommandKeywords)();
    const { issueNavigatorLink: issueNavigatorLink } = (0, $e0Hma.useIssueNavigatorLink)();
    const { hideAndTransformNavigationCommands: hideAndTransformNavigationCommands } = (0, $gIIkx.useTransformNavigationCommands)();
    const { data: data } = (0, $cWiVr.useCurrentUser)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const email = data.user?.emailAddress;
    const accountSettingsLink = (0, $3rqlh.useAtlassianPersonalSettingsLink)(email || undefined);
    const [isPlansVisible] = (0, $hawmT.useNavigationPlansVisibility)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const commands = hideAndTransformNavigationCommands([
        {
            command: {
                id: (0, $d407c1f9c5a1b304$export$2d4af8d3471f446),
                name: formatMessage((0, $5eTF6.default).viewAllProjects),
                keywords: getKeywords('viewAllProjectsSynonyms'),
                section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).siteNavigation,
                priority: (0, $9zALC.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).goToProjects,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
                            label: formatMessage((0, $5eTF6.default).viewAllProjects)
                        })
                },
                analytics: {
                    action: 'viewAllProjects'
                }
            },
            path: (0, $1iihP.projectsDirectoryRoute)
        },
        {
            command: {
                id: (0, $d407c1f9c5a1b304$export$bfa43d3c5bfbcf35),
                name: formatMessage((0, $5eTF6.default).viewAllFilters),
                keywords: getKeywords('viewAllFiltersSynonyms'),
                section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).siteNavigation,
                priority: (0, $9zALC.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).goToFilters,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
                            label: formatMessage((0, $5eTF6.default).viewAllFilters)
                        })
                },
                analytics: {
                    action: 'viewAllFilters'
                }
            },
            path: (0, $1cmFR.filtersDirectoryRoute)
        },
        {
            command: {
                id: (0, $d407c1f9c5a1b304$export$538e0daca84e7e29),
                name: formatMessage((0, $5eTF6.default).viewAllDashboards),
                keywords: getKeywords('viewAllDashboardsSynonyms'),
                section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).siteNavigation,
                priority: (0, $9zALC.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).goToDashboards,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
                            label: formatMessage((0, $5eTF6.default).viewAllDashboards)
                        })
                },
                analytics: {
                    action: 'viewAllDashboards'
                }
            },
            path: (0, $bLGeo.dashboardsDirectoryRoute)
        },
        {
            command: {
                id: (0, $d407c1f9c5a1b304$export$98cbb2f7230db2a1),
                name: formatMessage((0, $5eTF6.default).goToPersonalSettings),
                keywords: getKeywords('goToPersonalSettingsSynonyms'),
                section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).personalSettings,
                priority: (0, $9zALC.COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY).goToPersonalSettings,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iw0Y6))), {
                            label: formatMessage((0, $5eTF6.default).goToPersonalSettings)
                        })
                },
                analytics: {
                    action: 'goToPersonalSettings'
                }
            },
            path: (0, $7lcEz.getGeneralPersonalSettingsRouteForLink)(),
            hideCommandPath: (0, $iJPUk.getGeneralPersonalSettingsPath)()
        },
        {
            command: {
                id: (0, $d407c1f9c5a1b304$export$7e8556985118cd1e),
                name: formatMessage((0, $5eTF6.default).viewAllBoards),
                keywords: getKeywords('viewAllBoardsSynonyms'),
                section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).siteNavigation,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
                            label: formatMessage((0, $5eTF6.default).viewAllBoards)
                        })
                },
                priority: (0, $9zALC.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).goToBoards,
                analytics: {
                    action: 'viewAllBoards'
                }
            },
            path: (0, $6JBWS.boardsDirectoryRoute)
        },
        {
            command: {
                id: (0, $d407c1f9c5a1b304$export$7976f2daa1e8078a),
                name: formatMessage((0, $5eTF6.default).goToAccountSettings),
                keywords: getKeywords('goToAccountSettingsSynonyms'),
                section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).personalSettings,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iw0Y6))), {
                            label: formatMessage((0, $5eTF6.default).goToAccountSettings)
                        })
                },
                priority: (0, $9zALC.COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY).goToAccountSettings,
                analytics: {
                    action: 'goToAccountSettings'
                }
            },
            path: accountSettingsLink,
            shouldAlwaysOpenNewTab: true
        },
        ...issueNavigatorLink ? [
            {
                command: {
                    id: (0, $d407c1f9c5a1b304$export$f3211b812cd1a523),
                    name: formatMessage((0, $5eTF6.default).goToIssues),
                    keywords: getKeywords('goToIssuesSynonyms'),
                    section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).projectNavigation,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
                                label: formatMessage((0, $5eTF6.default).goToIssues)
                            })
                    },
                    priority: (0, $9zALC.COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY).goToIssues,
                    analytics: {
                        action: 'goToIssues'
                    }
                },
                path: issueNavigatorLink,
                hideCommandPath: (0, $1iihP.projectsDirectoryRoute).path
            }
        ] : [],
        ...isPlansVisible ? [
            {
                command: {
                    id: (0, $d407c1f9c5a1b304$export$653733b43ae1b993),
                    name: formatMessage((0, $5eTF6.default).viewAllPlans),
                    keywords: getKeywords('viewAllPlansSynonyms'),
                    section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).siteNavigation,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
                                label: formatMessage((0, $5eTF6.default).viewAllPlans)
                            })
                    },
                    priority: (0, $9zALC.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).goToPlans,
                    analytics: {
                        action: 'viewAllPlans'
                    }
                },
                path: (0, $jsQSa.plansDirectoryRoute)
            }
        ] : [],
        ...isSiteAdmin ? [
            {
                command: {
                    id: (0, $d407c1f9c5a1b304$export$9ede11404253696),
                    name: formatMessage((0, $5eTF6.default).goToUserManagement),
                    keywords: getKeywords('goToUserManagementSynonyms'),
                    section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).atlassianAdmin,
                    priority: (0, $9zALC.COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY).userManagement,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iw0Y6))), {
                                label: formatMessage((0, $5eTF6.default).goToUserManagement)
                            })
                    },
                    analytics: {
                        action: 'goToUserManagement'
                    }
                },
                path: (0, $hrxXt.SITE_ADMIN_SETTINGS_ITEM_HREFS).USER_MANAGEMENT,
                shouldAlwaysOpenNewTab: true
            },
            {
                command: {
                    id: (0, $d407c1f9c5a1b304$export$bf77ae178e5e5984),
                    name: formatMessage((0, $5eTF6.default).goToBilling),
                    section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).atlassianAdmin,
                    priority: (0, $9zALC.COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY).billing,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iw0Y6))), {
                                label: formatMessage((0, $5eTF6.default).goToBilling)
                            })
                    },
                    analytics: {
                        action: 'goToBilling'
                    }
                },
                path: (0, $hrxXt.SITE_ADMIN_SETTINGS_ITEM_HREFS).BILLING,
                shouldAlwaysOpenNewTab: true
            }
        ] : []
    ]);
    return commands;
};

});
parcelRegister("1tWuI", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $d6c6325a34d6a2b4$export$be58b4326e23250f);
$parcel$export(module.exports, "getGlobalSettingsAdminItems", () => $d6c6325a34d6a2b4$export$d637bf5a394b4534);
$parcel$export(module.exports, "messages", () => (parcelRequire("GQMch")).default);
$parcel$export(module.exports, "JIRA_SETTINGS_SECTION_IDS", () => (parcelRequire("hrxXt")).JIRA_SETTINGS_SECTION_IDS);
$parcel$export(module.exports, "SITE_ADMIN_SETTINGS_ITEM_HREFS", () => (parcelRequire("hrxXt")).SITE_ADMIN_SETTINGS_ITEM_HREFS);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5KEua = parcelRequire("5KEua");

var $jVbWM = parcelRequire("jVbWM");

var $3zPrX = parcelRequire("3zPrX");

var $3vmed = parcelRequire("3vmed");

var $1yh1n = parcelRequire("1yh1n");

var $jomRY = parcelRequire("jomRY");

var $gbbKH = parcelRequire("gbbKH");

var $gib2Q = parcelRequire("gib2Q");

var $oeORR = parcelRequire("oeORR");

var $iFXD5 = parcelRequire("iFXD5");

var $1j9EV = parcelRequire("1j9EV");

var $e5T2d = parcelRequire("e5T2d");

var $6nIG2 = parcelRequire("6nIG2");

var $iwsIy = parcelRequire("iwsIy");

var $5318D = parcelRequire("5318D");

var $23NQ5 = parcelRequire("23NQ5");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $5t8Df = parcelRequire("5t8Df");

var $igOBb = parcelRequire("igOBb");

var $jxzG5 = parcelRequire("jxzG5");

var $bKRo5 = parcelRequire("bKRo5");

var $hrxXt = parcelRequire("hrxXt");

var $GQMch = parcelRequire("GQMch");
const $d6c6325a34d6a2b4$var$getApplicationsMenuLink = (appPermissions)=>{
    if (appPermissions.hasSoftwareAccess) return '/jira/settings/products/jira-software-configuration';
    if (appPermissions.hasServiceDeskAccess) return '/jira/settings/products/jira-service-management-configuration';
    return '/plugins/servlet/applinks/listApplicationLinks';
};
const $d6c6325a34d6a2b4$export$f3a5db2467c22913 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5318D))), {
        label: "",
        size: "small",
        primaryColor: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $d6c6325a34d6a2b4$export$3055c15ea575d46c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($oeORR))), {
        label: "",
        size: "small",
        primaryColor: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $d6c6325a34d6a2b4$export$43db94b81c32328a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e5T2d))), {
        label: "",
        size: "small",
        primaryColor: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $d6c6325a34d6a2b4$export$583f26efcd800ae2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6nIG2))), {
        label: "",
        size: "small",
        primaryColor: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $d6c6325a34d6a2b4$export$627b4c7b9568cd5d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXD5))), {
        label: "",
        size: "small",
        primaryColor: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $d6c6325a34d6a2b4$export$4464648b9631e67f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$export$be58b4326e23250f, {
        dark: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iwsIy))), {
        label: "",
        size: "small",
        primaryColor: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $d6c6325a34d6a2b4$export$7b659dc9c22493b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$export$be58b4326e23250f, {
        dark: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1j9EV))), {
        label: "",
        size: "small",
        primaryColor: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $d6c6325a34d6a2b4$var$getAdminSectionOld = (formatMessage, appPermissions)=>({
        id: (0, $hrxXt.JIRA_SETTINGS_SECTION_IDS).SYSTEM_ADMIN,
        type: 'Group',
        hasSeparator: true,
        sideHeading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$export$b79014a8ad5d31bf, {
                "aria-label": formatMessage((0, $igOBb.isMacOs)() ? (0, $GQMch.default).jiraSettingsCommandPaletteMacScreenReader : (0, $GQMch.default).jiraSettingsCommandPaletteOtherScreenReader)
            }, formatMessage((0, $igOBb.isMacOs)() ? (0, $GQMch.default).jiraSettingsCommandPaletteMac : (0, $GQMch.default).jiraSettingsCommandPaletteOther, {
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "strong",
                        size: "small",
                        color: "inherit"
                    }, chunks),
                wrapper: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$var$CommandPaletteShortcutsContainer, null, chunks),
                key: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$var$KeyboardShortcut, null, chunks),
                command: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$var$KeyboardShortcut, {
                        isMeta: true
                    }, chunks)
            })),
        items: [
            {
                goTo: 'root/global-settings/system',
                // sets active navigation 2nd level menu and an active item in navigation menu, via `navApi.setView(goTo)`
                id: (0, $hrxXt.ADMIN_SETTINGS_ITEM_IDS).SYSTEM,
                legacyId: 'admin_system_menu',
                href: '/jira/settings/system/general-configuration',
                text: formatMessage((0, $GQMch.default).system),
                type: 'Item',
                before: $d6c6325a34d6a2b4$export$f3a5db2467c22913
            },
            {
                goTo: 'root/global-settings/applications',
                id: (0, $hrxXt.ADMIN_SETTINGS_ITEM_IDS).APPLICATIONS,
                legacyId: 'admin_applications_menu',
                href: $d6c6325a34d6a2b4$var$getApplicationsMenuLink(appPermissions),
                text: formatMessage((0, $GQMch.default).applications),
                type: 'Item',
                before: $d6c6325a34d6a2b4$export$3055c15ea575d46c
            },
            {
                goTo: 'root/global-settings/projects',
                id: (0, $hrxXt.ADMIN_SETTINGS_ITEM_IDS).MANAGE_PROJECTS,
                legacyId: 'admin_project_menu',
                href: '/jira/settings/projects/manage',
                text: formatMessage((0, $GQMch.default).projects),
                type: 'Item',
                before: $d6c6325a34d6a2b4$export$43db94b81c32328a
            },
            {
                goTo: 'root/global-settings/issues',
                id: (0, $hrxXt.ADMIN_SETTINGS_ITEM_IDS).ISSUES,
                legacyId: 'admin_issues_menu',
                href: '/jira/settings/issues/issue-types',
                text: formatMessage((0, $GQMch.default).issues),
                type: 'Item',
                before: $d6c6325a34d6a2b4$export$583f26efcd800ae2
            },
            {
                goTo: 'root/global-settings/addons',
                id: (0, $hrxXt.ADMIN_SETTINGS_ITEM_IDS).PLUGINS,
                legacyId: 'admin_plugins_menu',
                href: (0, $jxzG5.getEmceeDiscoverLink)({
                    source: 'side_nav_find_new_addons'
                }),
                text: formatMessage((0, $GQMch.default).addons),
                type: 'Item',
                before: $d6c6325a34d6a2b4$export$627b4c7b9568cd5d
            }
        ]
    });
const $d6c6325a34d6a2b4$var$getAdminSectionNew = (formatMessage, appPermissions)=>({
        id: (0, $hrxXt.JIRA_SETTINGS_SECTION_IDS).SYSTEM_ADMIN,
        type: 'Group',
        hasSeparator: true,
        heading: formatMessage((0, $GQMch.default).jiraAdminSettingsNonFinal),
        items: [
            {
                goTo: 'root/global-settings/system',
                // sets active navigation 2nd level menu and an active item in navigation menu, via `navApi.setView(goTo)`
                id: (0, $hrxXt.ADMIN_SETTINGS_ITEM_IDS).SYSTEM,
                legacyId: 'admin_system_menu',
                href: '/jira/settings/system/general-configuration',
                text: formatMessage((0, $GQMch.default).system),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gbbKH))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $GQMch.default).systemDescriptionNonFinal)
            },
            {
                goTo: 'root/global-settings/applications',
                id: (0, $hrxXt.ADMIN_SETTINGS_ITEM_IDS).APPLICATIONS,
                legacyId: 'admin_applications_menu',
                href: $d6c6325a34d6a2b4$var$getApplicationsMenuLink(appPermissions),
                text: formatMessage((0, $GQMch.default).applications),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5KEua))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $GQMch.default).productsDescriptionNonFinal)
            },
            {
                goTo: 'root/global-settings/projects',
                id: (0, $hrxXt.ADMIN_SETTINGS_ITEM_IDS).MANAGE_PROJECTS,
                legacyId: 'admin_project_menu',
                href: '/jira/settings/projects/manage',
                text: formatMessage((0, $GQMch.default).projects),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jomRY))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $GQMch.default).projectsDescriptionNonFinal)
            },
            {
                goTo: 'root/global-settings/issues',
                id: (0, $hrxXt.ADMIN_SETTINGS_ITEM_IDS).ISSUES,
                legacyId: 'admin_issues_menu',
                href: '/jira/settings/issues/issue-types',
                text: formatMessage((0, $GQMch.default).issues),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3vmed))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $GQMch.default).issuesDescriptionNonFinal)
            },
            {
                goTo: 'root/global-settings/addons',
                id: (0, $hrxXt.ADMIN_SETTINGS_ITEM_IDS).PLUGINS,
                legacyId: 'admin_plugins_menu',
                href: (0, $bKRo5.manageAppsRoute).path,
                text: formatMessage((0, $GQMch.default).addons),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jVbWM))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $GQMch.default).appsDescriptionNonFinal)
            },
            {
                id: 'keyboad-shortcut-tip',
                type: 'Content',
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        xcss: $d6c6325a34d6a2b4$var$jiraCommandPalletteTipContainerStyles,
                        "aria-label": formatMessage((0, $igOBb.isMacOs)() ? (0, $GQMch.default).jiraSettingsCommandPaletteMacScreenReader : (0, $GQMch.default).jiraSettingsCommandPaletteOtherScreenReader)
                    }, formatMessage((0, $igOBb.isMacOs)() ? (0, $GQMch.default).jiraSettingsCommandPaletteMac : (0, $GQMch.default).jiraSettingsCommandPaletteOther, {
                        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                                size: "small"
                            }, chunks),
                        wrapper: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                                xcss: $d6c6325a34d6a2b4$var$commandPalleteShortcutStyles
                            }, chunks),
                        key: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
                                alignItems: "center",
                                justifyContent: "center",
                                xcss: $d6c6325a34d6a2b4$var$keyboardShortcutStyles
                            }, chunks),
                        command: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
                                alignItems: "center",
                                justifyContent: "center",
                                xcss: $d6c6325a34d6a2b4$var$keyboardShortcutStyles
                            }, chunks)
                    }))
            }
        ]
    });
const $d6c6325a34d6a2b4$var$getSiteAdminSectionNew = (formatMessage, isSiteAdmin, canManageUsers)=>({
        id: (0, $hrxXt.JIRA_SETTINGS_SECTION_IDS).SITE_ADMIN,
        heading: formatMessage((0, $GQMch.default).atlassianAdminSettingsNonFinal),
        type: 'Group',
        hasSeparator: false,
        items: [
            ...canManageUsers || isSiteAdmin ? [
                {
                    id: (0, $hrxXt.SITE_ADMIN_SETTINGS_ITEM_IDS).USER_MANAGEMENT,
                    legacyId: 'user_management_section',
                    href: (0, $hrxXt.SITE_ADMIN_SETTINGS_ITEM_HREFS).USER_MANAGEMENT,
                    text: formatMessage((0, $GQMch.default).userManagement),
                    type: 'Item',
                    before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gib2Q))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yh1n))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    target: '_blank',
                    description: formatMessage((0, $GQMch.default).userManagementDescriptionNonFinal)
                }
            ] : [],
            ...isSiteAdmin ? [
                {
                    id: (0, $hrxXt.SITE_ADMIN_SETTINGS_ITEM_IDS).BILLING,
                    legacyId: 'admin_billing_section',
                    href: (0, $hrxXt.SITE_ADMIN_SETTINGS_ITEM_HREFS).BILLING,
                    text: formatMessage((0, $GQMch.default).billing),
                    type: 'Item',
                    before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3zPrX))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yh1n))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    target: '_blank',
                    description: formatMessage((0, $GQMch.default).billingDescriptionNonFinal)
                }
            ] : []
        ]
    });
const $d6c6325a34d6a2b4$var$getSiteAdminSectionOld = (formatMessage, isSiteAdmin, canManageUsers)=>({
        id: (0, $hrxXt.JIRA_SETTINGS_SECTION_IDS).SITE_ADMIN,
        type: 'Group',
        hasSeparator: false,
        items: [
            ...canManageUsers || isSiteAdmin ? [
                {
                    id: (0, $hrxXt.SITE_ADMIN_SETTINGS_ITEM_IDS).USER_MANAGEMENT,
                    legacyId: 'user_management_section',
                    href: (0, $hrxXt.SITE_ADMIN_SETTINGS_ITEM_HREFS).USER_MANAGEMENT,
                    text: formatMessage((0, $GQMch.default).userManagement),
                    type: 'Item',
                    before: $d6c6325a34d6a2b4$export$4464648b9631e67f,
                    // @ts-expect-error - TS2769 - No overload matches this call.
                    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
                    after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                            size: "small"
                        }),
                    target: '_blank'
                }
            ] : [],
            ...isSiteAdmin ? [
                {
                    id: (0, $hrxXt.SITE_ADMIN_SETTINGS_ITEM_IDS).BILLING,
                    legacyId: 'admin_billing_section',
                    href: (0, $hrxXt.SITE_ADMIN_SETTINGS_ITEM_HREFS).BILLING,
                    text: formatMessage((0, $GQMch.default).billing),
                    type: 'Item',
                    before: $d6c6325a34d6a2b4$export$7b659dc9c22493b,
                    // @ts-expect-error - TS2769 - No overload matches this call.
                    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
                    after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                            size: "small"
                        }),
                    target: '_blank'
                }
            ] : []
        ]
    });
const $d6c6325a34d6a2b4$export$d637bf5a394b4534 = (formatMessage, appPermissions, userRoles, willShowNav4)=>{
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin, manageUsersPermission: manageUsersPermission } = userRoles;
    const result = [];
    if (isAdmin) {
        const getAdminSection = willShowNav4 ? $d6c6325a34d6a2b4$var$getAdminSectionNew : $d6c6325a34d6a2b4$var$getAdminSectionOld;
        result.push(getAdminSection(formatMessage, appPermissions));
    }
    // Adding these items to the end because `manageUsersPermission` may change after the initial
    // render because it is determined by an async API call. It will need to be the responsibility
    // of the consumer to show a loading state if needed.
    if (isSiteAdmin || manageUsersPermission.loading === false && manageUsersPermission.canManageUsers) {
        const getSiteAdminSection = willShowNav4 ? $d6c6325a34d6a2b4$var$getSiteAdminSectionNew : $d6c6325a34d6a2b4$var$getSiteAdminSectionOld;
        result.push(getSiteAdminSection(formatMessage, userRoles.isSiteAdmin, manageUsersPermission.canManageUsers));
    }
    return result;
};
const $d6c6325a34d6a2b4$export$be58b4326e23250f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { dark: dark, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _1bah1h6o _4t3i1tcg _1bsb1tcg _2rko1l7b",
            __cmplp.dark ? "_11q7gkf6" : "_11q71pom",
            __cmplp.className
        ])
    });
});
const $d6c6325a34d6a2b4$var$CommandPaletteShortcutsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _zulpv77o",
            __cmplp.className
        ])
    });
});
const $d6c6325a34d6a2b4$var$KeyboardShortcut = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $5t8Df.FilledLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _1bsb1wug _1ul9dlk8 _4t3idlk8 _16jlidpf _vwz4wk7l _y3gn1h6o _1yt41nxw _vchhusvi _1p1dglyw",
            __cmplp.isMeta ? "_1wyb1bt6" : "_1wybc4v4",
            __cmplp.className
        ])
    });
});
const $d6c6325a34d6a2b4$export$b79014a8ad5d31bf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p1nn1 _11c81vlj _syaz1ddj _1p1dglyw",
            __cmplp.className
        ])
    });
});
const $d6c6325a34d6a2b4$var$commandPalleteShortcutStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    gap: 'space.025'
});
const $d6c6325a34d6a2b4$var$jiraCommandPalletteTipContainerStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    marginInlineStart: 'space.200',
    marginBlock: 'space.200',
    color: 'color.text.subtle'
});
const $d6c6325a34d6a2b4$var$keyboardShortcutStyles = (0, $1ZAYh.xcss)({
    minWidth: '14px',
    height: '14px',
    backgroundColor: 'color.background.accent.blue.subtlest',
    color: 'color.text.subtle',
    padding: 'space.025',
    borderRadius: 'border.radius',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});

});
parcelRegister("jxzG5", function(module, exports) {

$parcel$export(module.exports, "getEmceeDiscoverLink", () => $20f94d12e4a0a9d7$export$f26dabf284aefb17);
$parcel$export(module.exports, "getEmceeAppListingLink", () => $20f94d12e4a0a9d7$export$eb09695b9e9f6a3);
$parcel$export(module.exports, "getAppRequestsLink", () => $20f94d12e4a0a9d7$export$7ab8c48f9081e976);
$parcel$export(module.exports, "getManagePromotionsLink", () => $20f94d12e4a0a9d7$export$350ca33eed6a2742);

var $1ybV0 = parcelRequire("1ybV0");
const $20f94d12e4a0a9d7$var$sanitiseParams = (params)=>params ? Object.entries(params).reduce((res, [key, value])=>{
        if (value) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'EmceeQueryParams | JiraQueryParams'.
        res[key] = params[key];
        return res;
    }, {}) : {};
const $20f94d12e4a0a9d7$var$addQueryParamsToLink = (params, link)=>{
    // @ts-expect-error - TS2345 - Argument of type 'EmceeQueryParams | JiraQueryParams | null | undefined' is not assignable to parameter of type 'EmceeQueryParams | JiraQueryParams | undefined'.
    const queryParams = $20f94d12e4a0a9d7$var$sanitiseParams(params);
    const queryString = new URLSearchParams(queryParams).toString();
    return queryString ? `${link}?${queryString}` : link;
};
const $20f94d12e4a0a9d7$var$resolveConnectDiscoverUrl = (connectUrlDiscoverVariant = 'ENDUSER_DISCOVER', jiraQueryParams)=>{
    let connectDiscoverUrl = `/plugins/servlet/ac/com.atlassian.jira.emcee/${connectUrlDiscoverVariant === 'DISCOVER' ? 'discover' : 'enduser-discover'}`;
    if (jiraQueryParams) connectDiscoverUrl = $20f94d12e4a0a9d7$var$addQueryParamsToLink(jiraQueryParams, connectDiscoverUrl);
    return connectDiscoverUrl;
};
const $20f94d12e4a0a9d7$export$f26dabf284aefb17 = (params, connectUrlDiscoverVariant = 'ENDUSER_DISCOVER')=>{
    const link = (0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? '/jira/marketplace/discover' : $20f94d12e4a0a9d7$var$resolveConnectDiscoverUrl(connectUrlDiscoverVariant);
    return $20f94d12e4a0a9d7$var$addQueryParamsToLink(params, link);
};
const $20f94d12e4a0a9d7$export$eb09695b9e9f6a3 = (appKey, params, jiraQueryParams, connectUrlDiscoverVariant = 'ENDUSER_DISCOVER')=>(0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? $20f94d12e4a0a9d7$var$addQueryParamsToLink({
        ...jiraQueryParams,
        ...params
    }, `/jira/marketplace/discover/app/${appKey}`) : $20f94d12e4a0a9d7$var$addQueryParamsToLink(params, `${$20f94d12e4a0a9d7$var$resolveConnectDiscoverUrl(connectUrlDiscoverVariant, // @ts-expect-error - TS2345 - Argument of type 'JiraQueryParams | null | undefined' is not assignable to parameter of type 'JiraQueryParams | undefined'.
    jiraQueryParams)}#!/discover/app/${appKey}`);
const $20f94d12e4a0a9d7$export$7ab8c48f9081e976 = (params)=>{
    const link = (0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? '/jira/marketplace/manage/app-requests' : '/plugins/servlet/ac/com.atlassian.jira.emcee/app-requests';
    return $20f94d12e4a0a9d7$var$addQueryParamsToLink(params, link);
};
const $20f94d12e4a0a9d7$export$350ca33eed6a2742 = (params)=>{
    const link = (0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? '/jira/marketplace/manage/promotions' : '/plugins/servlet/ac/com.atlassian.jira.emcee/promotions';
    return $20f94d12e4a0a9d7$var$addQueryParamsToLink(params, link);
};

});

parcelRegister("bKRo5", function(module, exports) {

$parcel$export(module.exports, "emceeAppRoute", () => $d35d370905e3d2b9$export$5149e7851c6c4f53);
$parcel$export(module.exports, "manageAppsRoute", () => $d35d370905e3d2b9$export$d5409be3b4016aab);

var $exb0h = parcelRequire("exb0h");
const $d35d370905e3d2b9$export$5149e7851c6c4f53 = {
    name: (0, $exb0h.ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE),
    path: '/plugins/servlet/ac/com.atlassian.jira.emcee:environment(.?[\\w.]*)?/:page'
};
const $d35d370905e3d2b9$export$d5409be3b4016aab = {
    name: (0, $exb0h.ROUTE_NAMES_MARKETPLACE_MANAGE_APPS),
    path: '/plugins/servlet/upm'
};

});

parcelRegister("hrxXt", function(module, exports) {

$parcel$export(module.exports, "JIRA_SETTINGS_SECTION_IDS", () => $a88144c18eea020d$export$7266225366740ba0);
$parcel$export(module.exports, "ADMIN_SETTINGS_ITEM_IDS", () => $a88144c18eea020d$export$4718c8ac53a477e1);
$parcel$export(module.exports, "SITE_ADMIN_SETTINGS_ITEM_IDS", () => $a88144c18eea020d$export$b23679adb37958a8);
$parcel$export(module.exports, "SITE_ADMIN_SETTINGS_ITEM_HREFS", () => $a88144c18eea020d$export$9cc74e3c0b8831f9);
const $a88144c18eea020d$export$7266225366740ba0 = {
    SETTINGS_TITLE: 'settings-title',
    SITE_ADMIN: 'site-admin',
    SYSTEM_ADMIN: 'system-admin',
    TRUSTED_USER: 'trusted-user',
    PERSONAL: 'personal-settings'
};
const $a88144c18eea020d$export$4718c8ac53a477e1 = {
    SYSTEM: 'admin-system-menu',
    APPLICATIONS: 'admin-applications-menu',
    ISSUES: 'admin-issues-menu',
    PLUGINS: 'admin-plugins-menu',
    RECOMMENDATIONS: 'admin-recommendations',
    MANAGE_PROJECTS: 'admin-manage-project-menu'
};
const $a88144c18eea020d$export$b23679adb37958a8 = {
    USER_MANAGEMENT: 'user-management-section',
    BILLING: 'admin-billing-section'
};
const $a88144c18eea020d$export$58a409d1d7fded14 = {
    USER_MANAGEMENT: 'trusted-admin-user-management-section',
    DISCOVER_APPLICATIONS: 'discover-applications-section'
};
const $a88144c18eea020d$export$9cc74e3c0b8831f9 = {
    USER_MANAGEMENT: '/admin/users?referrerName=JIRA',
    BILLING: '/admin/billing-preview?referrerName=JIRA'
};

});

parcelRegister("GQMch", function(module, exports) {

$parcel$export(module.exports, "default", () => $b05caadb2f8bde77$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b05caadb2f8bde77$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    settings: {
        "id": "navigation-next.navigation-views.root.common.settings",
        "defaultMessage": "Jira settings"
    },
    system: {
        "id": "navigation-next.navigation-views.root.global-settings.home.system",
        "defaultMessage": "System"
    },
    applications: {
        "id": "navigation-next.navigation-views.root.global-settings.home.applications",
        "defaultMessage": "Products"
    },
    projects: {
        "id": "navigation-next.navigation-views.root.global-settings.home.projects",
        "defaultMessage": "Projects"
    },
    issues: {
        "id": "navigation-next.navigation-views.root.global-settings.home.issues",
        "defaultMessage": "Issues"
    },
    addons: {
        "id": "navigation-next.navigation-views.root.global-settings.home.addons",
        "defaultMessage": "Apps"
    },
    recommendations: {
        "id": "navigation-next.navigation-views.root.global-settings.home.recommendations",
        "defaultMessage": "Recommendations"
    },
    userManagement: {
        "id": "navigation-next.navigation-views.root.global-settings.home.user-management",
        "defaultMessage": "User management"
    },
    billing: {
        "id": "navigation-next.navigation-views.root.global-settings.home.billing",
        "defaultMessage": "Billing"
    },
    discoverApplications: {
        "id": "navigation-next.navigation-views.root.global-settings.home.discover-applications",
        "defaultMessage": "Discover applications"
    },
    jiraSettingsCommandPaletteMac: {
        "id": "navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-mac",
        "defaultMessage": "<strong>Tip:</strong> Try <wrapper><command>\u2318</command><key>K</key></wrapper> to search Jira settings"
    },
    jiraSettingsCommandPaletteOther: {
        "id": "navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-other",
        "defaultMessage": "<strong>Tip:</strong> Try <wrapper><key>Ctrl</key><key>K</key></wrapper> to search Jira settings"
    },
    jiraSettingsCommandPaletteMacScreenReader: {
        "id": "navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-mac-screen-reader",
        "defaultMessage": "Tip: Try command K to search Jira settings"
    },
    jiraSettingsCommandPaletteOtherScreenReader: {
        "id": "navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-other-screen-reader",
        "defaultMessage": "Tip: Try control K to search Jira settings"
    },
    'site-admin': {
        "id": "navigation-apps.settings-drawer.section.site-admin",
        "defaultMessage": "Atlassian admin"
    },
    'system-admin': {
        "id": "navigation-apps.settings-drawer.section.system-admin",
        "defaultMessage": "Jira settings"
    },
    'trusted-user': {
        "id": "navigation-apps.settings-drawer.section.trusted-user",
        "defaultMessage": "Atlassian admin"
    },
    'personal-settings': {
        "id": "navigation-apps.settings-drawer.section.personal-settings",
        "defaultMessage": "Personal settings"
    },
    'admin-system-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-system-menu",
        "defaultMessage": "Manage your general configuration, global permissions, look and feel and more."
    },
    'admin-applications-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-applications-menu",
        "defaultMessage": "Manage your Jira products' settings and integrations."
    },
    'admin-manage-project-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-manage-project-menu",
        "defaultMessage": "Manage your project settings, categories, and more."
    },
    'admin-issues-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-issues-menu",
        "defaultMessage": "Configure your issue types, workflows, screens, custom fields and more."
    },
    'admin-plugins-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-plugins-menu",
        "defaultMessage": "Add and manage Jira Marketplace apps."
    },
    'user-management-section': {
        "id": "navigation-apps.settings-drawer.section.item.user-management-section",
        "defaultMessage": "Add users, groups, and manage access requests."
    },
    'admin-billing-section': {
        "id": "navigation-apps.settings-drawer.section.item.admin-billing-section",
        "defaultMessage": "Update your billing details, manage your subscriptions and more."
    },
    'trusted-admin-user-management-section': {
        "id": "navigation-apps.settings-drawer.section.item.trusted-admin-user-management-section",
        "defaultMessage": "Invite users to your site."
    },
    'discover-applications-section': {
        "id": "navigation-apps.settings-drawer.section.item.discover-applications-section",
        "defaultMessage": "Try more Atlassian products."
    },
    // NAV4 Messages
    personalJiraSettingsNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.personal-jira-settings-non-final",
        "defaultMessage": "Personal Jira settings"
    },
    jiraAdminSettingsNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.jira-admin-settings-non-final",
        "defaultMessage": "Jira admin settings"
    },
    systemDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.system-description-non-final",
        "defaultMessage": "Manage general configuration, security, automation, user interface, and more"
    },
    productsDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.products-description-non-final",
        "defaultMessage": "Manage Jira products' access, settings, and integrations"
    },
    projectsDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.projects-description-non-final",
        "defaultMessage": "Manage project settings, categories, and more"
    },
    issuesDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.issues-description-non-final",
        "defaultMessage": "Configure issue types, workflows, screens, fields, and more"
    },
    appsDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.apps-description-non-final",
        "defaultMessage": "Add and manage Jira Marketplace apps and integrations"
    },
    atlassianAdminSettingsNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.atlassian-admin-settings-non-final",
        "defaultMessage": "Atlassian admin settings"
    },
    userManagementDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.user-management-description-non-final",
        "defaultMessage": "Manage users, groups, and access requests"
    },
    billingDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.billing-description-non-final",
        "defaultMessage": "Update your billing details, manage subscriptions, and more"
    }
});

});


parcelRegister("3rqlh", function(module, exports) {

$parcel$export(module.exports, "useAtlassianPersonalSettingsLink", () => $52b6ea6dc94a0795$export$8ac70acdad00754b);
$parcel$export(module.exports, "useProfileLink", () => $52b6ea6dc94a0795$export$b8f25e615dd30d7b);
$parcel$export(module.exports, "getBeforeEntity", () => $52b6ea6dc94a0795$export$5b8580d0254a9349);
$parcel$export(module.exports, "getBoardLink", () => $52b6ea6dc94a0795$export$ff5c49b7852aca68);
$parcel$export(module.exports, "getLinkFromProject", () => $52b6ea6dc94a0795$export$dd9458ee44edd0c6);
$parcel$export(module.exports, "getQueueLink", () => $52b6ea6dc94a0795$export$b44363840d1b683e);
$parcel$export(module.exports, "getIsClassicSoftwareProject", () => $52b6ea6dc94a0795$export$286ea82aef1c76e9);
$parcel$export(module.exports, "getUsersApps", () => $52b6ea6dc94a0795$export$ad0fd737fbd4a083);

var $53ciZ = parcelRequire("53ciZ");

var $bW292 = parcelRequire("bW292");

var $fXKgc = parcelRequire("fXKgc");

var $6wsEw = parcelRequire("6wsEw");

var $gcXWF = parcelRequire("gcXWF");

var $1a6Wh = parcelRequire("1a6Wh");

var $eD2UT = parcelRequire("eD2UT");

var $7yAHk = parcelRequire("7yAHk");

var $4PVYj = parcelRequire("4PVYj");

var $eaP1H = parcelRequire("eaP1H");

var $kHK5i = parcelRequire("kHK5i");

var $dxcfv = parcelRequire("dxcfv");

var $7vTKl = parcelRequire("7vTKl");

var $1YbJP = parcelRequire("1YbJP");
const $52b6ea6dc94a0795$export$ab902790e443b0ec = ()=>`${(0, $bW292.getATLContextUrl)('id')}/login`;
const $52b6ea6dc94a0795$export$8ac70acdad00754b = (destinationAccountEmail)=>{
    const loginLink = $52b6ea6dc94a0795$export$ab902790e443b0ec();
    const destinationUrl = `${(0, $bW292.getATLContextUrl)('id')}/manage-profile/profile-and-visibility`;
    return destinationAccountEmail ? `${loginLink}?${(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
        application: 'jira',
        continue: destinationUrl,
        login_hint: destinationAccountEmail,
        prompt: 'none'
    })}` : destinationUrl;
};
const $52b6ea6dc94a0795$export$b8f25e615dd30d7b = ()=>{
    const accountId = (0, $dxcfv.useAccountId)();
    return `/jira/people/${accountId || ''}`;
};
const $52b6ea6dc94a0795$export$5b8580d0254a9349 = (favoriteItems)=>favoriteItems && favoriteItems.length > 0 ? {
        id: String(favoriteItems[0].id),
        type: favoriteItems[0].type
    } : {
        id: undefined,
        type: undefined
    };
const $52b6ea6dc94a0795$export$ff5c49b7852aca68 = (item)=>{
    const { attributes: attributes, attributes: { parentType: parentType }, id: id } = item;
    const boardId = String(id);
    if (parentType === 'project') {
        // @ts-expect-error - TS2339 - Property 'nextgen' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'. | TS2339 - Property 'projectKey' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'. | TS2339 - Property 'projectType' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'.
        const { nextgen: nextgen, projectKey: projectKey, projectType: projectType } = attributes;
        if (projectType === 'business') return {
            params: {
                projectKey: projectKey
            },
            query: {},
            route: (0, $6wsEw.jiraBusinessProjectRedirectRoute)
        };
        if (projectType === 'service_desk') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $gcXWF.jsmBoardRoute)
        };
        if (nextgen === 'true') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $7yAHk.softwareBoardRoute)
        };
        return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $4PVYj.classicSoftwareBoardRoute)
        };
    }
    if (parentType === 'user') {
        // @ts-expect-error - TS2339 - Property 'userAccountId' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'.
        const { userAccountId: accountId } = attributes;
        return {
            params: {
                boardId: boardId,
                accountId: accountId
            },
            query: {},
            route: (0, $eaP1H.userBoardRoute)
        };
    }
    return {
        params: undefined,
        query: undefined,
        route: undefined
    };
};
const $52b6ea6dc94a0795$export$dd9458ee44edd0c6 = (item)=>{
    const { attributes: { projectType: projectType, boardId: boardId, nextgen: nextgen, projectKey: projectKey } } = item;
    if (projectType === 'business') return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $6wsEw.jiraBusinessProjectRedirectRoute)
    };
    if (boardId !== undefined) {
        if (nextgen === 'true') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $7yAHk.softwareBoardRoute)
        };
        return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $4PVYj.classicSoftwareBoardRoute)
        };
    }
    if (projectType === 'service_desk') return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $1a6Wh.projectServiceDeskRoute)
    };
    return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $fXKgc.browseProjectRedirectRoute)
    };
};
const $52b6ea6dc94a0795$export$b44363840d1b683e = (item)=>{
    const { attributes: { projectKey: projectKey, queuesCategory: queuesCategory }, id: id } = item;
    return {
        params: {
            projectKey: projectKey,
            ...queuesCategory != null && queuesCategory !== '' ? {
                practiceType: (0, $kHK5i.toShortFormItsmPractice)(queuesCategory)
            } : {},
            queueId: String(id)
        },
        route: queuesCategory != null && queuesCategory !== '' ? (0, $eD2UT.customPracticeQueueRoute) : (0, $eD2UT.customQueueRoute)
    };
};
const $52b6ea6dc94a0795$export$286ea82aef1c76e9 = (attributes)=>attributes.parentType === 'user' || attributes.parentType === 'project' && attributes.projectType === 'software' && attributes.nextgen === 'false';
const $52b6ea6dc94a0795$export$ad0fd737fbd4a083 = (items)=>items.filter((item)=>item.id !== (0, $7vTKl.ADDON_ID).DISCOVER);

});
parcelRegister("fXKgc", function(module, exports) {

$parcel$export(module.exports, "browseProjectRedirectRoute", () => $d7a8c211966f4d11$export$f9cac37753487f39);

var $exb0h = parcelRequire("exb0h");
const $d7a8c211966f4d11$export$f9cac37753487f39 = {
    group: (0, $exb0h.ROUTE_GROUPS_REDIRECTS),
    name: (0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT),
    path: '/browse/:projectKey([^-/]+)',
    exact: true,
    isRedirect: true
};

});

parcelRegister("6wsEw", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessProjectRedirectRoute", () => $5fcf01b1512d8afb$export$73b60789ceb8e1eb);
$parcel$export(module.exports, "jiraBusinessOverviewRedirectRoute", () => $5fcf01b1512d8afb$export$5ab0e07528c31349);

var $exb0h = parcelRequire("exb0h");
const $5fcf01b1512d8afb$export$73b60789ceb8e1eb = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT),
    path: '/jira/core/projects/:projectKey',
    exact: true,
    isRedirect: true
};
const $5fcf01b1512d8afb$export$5ab0e07528c31349 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT),
    path: '/jira/core/overviews/:overviewId',
    exact: true,
    isRedirect: true
};

});

parcelRegister("gcXWF", function(module, exports) {

$parcel$export(module.exports, "jsmBoardRoute", () => $2bd2ada1d304a75f$export$a192088aab559fa1);

var $exb0h = parcelRequire("exb0h");
const $2bd2ada1d304a75f$export$a192088aab559fa1 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId',
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_BOARDS)
};

});

parcelRegister("1a6Wh", function(module, exports) {

$parcel$export(module.exports, "projectServiceDeskRoute", () => $48d1c095208636aa$export$1cfc858068dd8718);

var $exb0h = parcelRequire("exb0h");
const $48d1c095208636aa$export$1cfc858068dd8718 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REDIRECT),
    path: '/jira/servicedesk/projects/:projectKey'
};

});

parcelRegister("eD2UT", function(module, exports) {

$parcel$export(module.exports, "customQueueRoute", () => $4782d0a5c5a44372$export$e1fac82ca0b0d637);
$parcel$export(module.exports, "customPracticeQueueRoute", () => $4782d0a5c5a44372$export$59d0bd42aa07faad);

var $exb0h = parcelRequire("exb0h");
const $4782d0a5c5a44372$export$e1fac82ca0b0d637 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE),
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey?'
};
const $4782d0a5c5a44372$export$59d0bd42aa07faad = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE),
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/:issueKey?'
};

});

parcelRegister("7yAHk", function(module, exports) {

$parcel$export(module.exports, "softwareBoardRoute", () => $650519e8b83fa4a8$export$9ae2c0a566d4e0f6);
$parcel$export(module.exports, "softwareBoardEmbedRoute", () => $650519e8b83fa4a8$export$f55626b64e3fcb4f);

var $exb0h = parcelRequire("exb0h");
const $650519e8b83fa4a8$export$9ae2c0a566d4e0f6 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_BOARDS),
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId'
};
const $650519e8b83fa4a8$export$f55626b64e3fcb4f = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_BOARDS_EMBED),
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId/embed'
};

});

parcelRegister("4PVYj", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardRoute", () => $9f593306e01ca1b5$export$131d51ca54849e97);
$parcel$export(module.exports, "classicSoftwareBoardEmbedRoute", () => $9f593306e01ca1b5$export$122afcef7dfd252);

var $exb0h = parcelRequire("exb0h");
const $9f593306e01ca1b5$export$131d51ca54849e97 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD),
    path: '/jira/software/c/projects/:projectKey/boards/:boardId',
    ufoName: 'classic-board'
};
const $9f593306e01ca1b5$export$122afcef7dfd252 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED),
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/embed',
    ufoName: 'classic-board-embed'
};

});

parcelRegister("eaP1H", function(module, exports) {

$parcel$export(module.exports, "userBoardRoute", () => $f203bcc70ddc17af$export$57a2a0fe739f16);

var $exb0h = parcelRequire("exb0h");

var $bmKiO = parcelRequire("bmKiO");
const $f203bcc70ddc17af$export$57a2a0fe739f16 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_BOARD),
    path: '/jira/people/:accountId/boards/:boardId',
    preloadOptions: {
        earlyChunks: [
            'rapidboard-early-entry'
        ]
    },
    earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
};

});
parcelRegister("bmKiO", function(module, exports) {

$parcel$export(module.exports, "NORMAL_EARLY_ASSET_STRATEGY", () => $3e02e9822ae54785$export$137d6d169f402a59);
$parcel$export(module.exports, "AGGRESSIVE_EARLY_ASSET_STRATEGY", () => $3e02e9822ae54785$export$ad16a91905cefb0a);
const $3e02e9822ae54785$var$COMMON_ASSET_REGEX = /.*\/commons(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $3e02e9822ae54785$var$VENDOR_ASSET_REGEX = /.*\/vendor(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $3e02e9822ae54785$var$PARCEL_COMMON_ASSET_REGEX = /.*\/shared~commons(~ar)?(\.[0-9a-z]*)\.js/;
const $3e02e9822ae54785$var$PARCEL_VENDOR_ASSET_REGEX = /.*\/shared~vendor(~ar)?(\.[0-9a-z]*)\.js/;
const $3e02e9822ae54785$export$137d6d169f402a59 = [
    $3e02e9822ae54785$var$VENDOR_ASSET_REGEX,
    $3e02e9822ae54785$var$PARCEL_VENDOR_ASSET_REGEX
];
const $3e02e9822ae54785$export$ad16a91905cefb0a = [
    $3e02e9822ae54785$var$VENDOR_ASSET_REGEX,
    $3e02e9822ae54785$var$COMMON_ASSET_REGEX,
    $3e02e9822ae54785$var$PARCEL_VENDOR_ASSET_REGEX,
    $3e02e9822ae54785$var$PARCEL_COMMON_ASSET_REGEX
];

});


parcelRegister("kHK5i", function(module, exports) {

$parcel$export(module.exports, "toShortFormItsmPractice", () => $3c2de4d4270495ab$export$db58a56259f511a2);

var $f1lMr = parcelRequire("f1lMr");
const $3c2de4d4270495ab$var$longToShortConversionMap = {
    [(0, $f1lMr.CHANGES)]: (0, $f1lMr.SHORT_FORM_CHANGES),
    [(0, $f1lMr.INCIDENTS)]: (0, $f1lMr.SHORT_FORM_INCIDENTS),
    [(0, $f1lMr.PROBLEMS)]: (0, $f1lMr.SHORT_FORM_PROBLEMS),
    [(0, $f1lMr.SERVICE_REQUEST)]: (0, $f1lMr.SHORT_FORM_SERVICE_REQUEST),
    [(0, $f1lMr.POST_INCIDENT_REVIEWS)]: (0, $f1lMr.SHORT_FORM_POST_INCIDENT_REVIEWS),
    [(0, $f1lMr.DEVELOPER_ESCALATION)]: (0, $f1lMr.SHORT_FORM_DEVELOPER_ESCALATION)
};
function $3c2de4d4270495ab$var$isLongForm(workCategoryKey) {
    return !!workCategoryKey && workCategoryKey in $3c2de4d4270495ab$var$longToShortConversionMap;
}
const $3c2de4d4270495ab$export$db58a56259f511a2 = (workCategoryKey)=>{
    if ($3c2de4d4270495ab$var$isLongForm(workCategoryKey)) return $3c2de4d4270495ab$var$longToShortConversionMap[workCategoryKey];
    return null;
};

});
parcelRegister("f1lMr", function(module, exports) {

$parcel$export(module.exports, "CHANGES", () => $d4363a603a2b1168$export$8598196f74460271);
$parcel$export(module.exports, "INCIDENTS", () => $d4363a603a2b1168$export$a50b49a533b5f7bc);
$parcel$export(module.exports, "PROBLEMS", () => $d4363a603a2b1168$export$ceba70db1edb1def);
$parcel$export(module.exports, "SERVICE_REQUEST", () => $d4363a603a2b1168$export$3d1cda9bd50505e8);
$parcel$export(module.exports, "POST_INCIDENT_REVIEWS", () => $d4363a603a2b1168$export$6ebf7b6bf1c580f);
$parcel$export(module.exports, "DEVELOPER_ESCALATION", () => $d4363a603a2b1168$export$81e62964cc725098);
$parcel$export(module.exports, "NO_CATEGORY", () => $d4363a603a2b1168$export$485b1216c42d8d4);
$parcel$export(module.exports, "NO_PRACTICE", () => $d4363a603a2b1168$export$52bf3f16b7812704);
$parcel$export(module.exports, "SHORT_FORM_CHANGES", () => $d4363a603a2b1168$export$a50185c8e9fb007e);
$parcel$export(module.exports, "SHORT_FORM_INCIDENTS", () => $d4363a603a2b1168$export$a54a30a3c3cce634);
$parcel$export(module.exports, "SHORT_FORM_PROBLEMS", () => $d4363a603a2b1168$export$354f3a4c6ac0c903);
$parcel$export(module.exports, "SHORT_FORM_SERVICE_REQUEST", () => $d4363a603a2b1168$export$335d3ac0c367f03f);
$parcel$export(module.exports, "SHORT_FORM_POST_INCIDENT_REVIEWS", () => $d4363a603a2b1168$export$7ffd7f2c2ae96b6f);
$parcel$export(module.exports, "SHORT_FORM_DEVELOPER_ESCALATION", () => $d4363a603a2b1168$export$cb41b99ca54e6bd);
$parcel$export(module.exports, "CHANGES_JQL_NAME", () => $d4363a603a2b1168$export$6c24c440228eac9c);
$parcel$export(module.exports, "INCIDENTS_JQL_NAME", () => $d4363a603a2b1168$export$5b65d27ec2d28d18);
$parcel$export(module.exports, "DEVELOPER_ESCALATION_JQL_NAME", () => $d4363a603a2b1168$export$3f757c5e00588ffd);
$parcel$export(module.exports, "practiceKeyJqlNameMapping", () => $d4363a603a2b1168$export$b78213db77524b5b);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP", () => $d4363a603a2b1168$export$fbf0dfd01228e38d);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP_LOWER_CASE", () => $d4363a603a2b1168$export$45ba5f49e9509c4d);

var $edAb7 = parcelRequire("edAb7");
const $d4363a603a2b1168$export$8598196f74460271 = 'change-management';
const $d4363a603a2b1168$export$a50b49a533b5f7bc = 'incident-management';
const $d4363a603a2b1168$export$ceba70db1edb1def = 'problem-management';
const $d4363a603a2b1168$export$3d1cda9bd50505e8 = 'service-request';
const $d4363a603a2b1168$export$6ebf7b6bf1c580f = 'post-incident-review';
const $d4363a603a2b1168$export$81e62964cc725098 = 'developer-escalation';
const $d4363a603a2b1168$export$a613d808168c7b25 = [
    $d4363a603a2b1168$export$8598196f74460271,
    $d4363a603a2b1168$export$a50b49a533b5f7bc,
    $d4363a603a2b1168$export$ceba70db1edb1def,
    $d4363a603a2b1168$export$3d1cda9bd50505e8,
    $d4363a603a2b1168$export$6ebf7b6bf1c580f,
    $d4363a603a2b1168$export$81e62964cc725098
]; // /!\ defines WorkCategoryApiResource type
const $d4363a603a2b1168$export$a2b1f8f055150f02 = [
    $d4363a603a2b1168$export$8598196f74460271,
    $d4363a603a2b1168$export$a50b49a533b5f7bc,
    $d4363a603a2b1168$export$ceba70db1edb1def,
    $d4363a603a2b1168$export$3d1cda9bd50505e8,
    $d4363a603a2b1168$export$6ebf7b6bf1c580f
]; // /!\ defines WorkCategoryQueueSupported type
const $d4363a603a2b1168$export$485b1216c42d8d4 = 'no-category';
const $d4363a603a2b1168$export$f929a394dd190451 = 'no-category-new';
const $d4363a603a2b1168$export$52bf3f16b7812704 = 'no-practice'; // BERRY-1358 should consolidate into NO_CATEGORY
const $d4363a603a2b1168$export$a50185c8e9fb007e = 'changes';
const $d4363a603a2b1168$export$a54a30a3c3cce634 = 'incidents';
const $d4363a603a2b1168$export$354f3a4c6ac0c903 = 'problems';
const $d4363a603a2b1168$export$335d3ac0c367f03f = 'service-requests';
const $d4363a603a2b1168$export$7ffd7f2c2ae96b6f = 'post-incident-reviews';
const $d4363a603a2b1168$export$cb41b99ca54e6bd = 'developer-escalations';
const $d4363a603a2b1168$export$f1b813cd23817ade = [
    $d4363a603a2b1168$export$a50185c8e9fb007e,
    $d4363a603a2b1168$export$a54a30a3c3cce634,
    $d4363a603a2b1168$export$354f3a4c6ac0c903,
    $d4363a603a2b1168$export$335d3ac0c367f03f,
    $d4363a603a2b1168$export$7ffd7f2c2ae96b6f,
    $d4363a603a2b1168$export$cb41b99ca54e6bd
]; // /!\ defines WorkCategoryShortForm type
const $d4363a603a2b1168$export$6c24c440228eac9c = 'Changes';
const $d4363a603a2b1168$export$5b65d27ec2d28d18 = 'Incidents';
const $d4363a603a2b1168$export$51618dc8334072b = 'Problems';
const $d4363a603a2b1168$export$a34586940ac9c374 = 'Service requests';
const $d4363a603a2b1168$export$5497b62b513b7853 = 'Post-incident reviews';
const $d4363a603a2b1168$export$3f757c5e00588ffd = 'Developer escalation';
const $d4363a603a2b1168$export$b78213db77524b5b = {
    [$d4363a603a2b1168$export$8598196f74460271]: $d4363a603a2b1168$export$6c24c440228eac9c,
    [$d4363a603a2b1168$export$a50b49a533b5f7bc]: $d4363a603a2b1168$export$5b65d27ec2d28d18,
    [$d4363a603a2b1168$export$ceba70db1edb1def]: $d4363a603a2b1168$export$51618dc8334072b,
    [$d4363a603a2b1168$export$3d1cda9bd50505e8]: $d4363a603a2b1168$export$a34586940ac9c374,
    [$d4363a603a2b1168$export$6ebf7b6bf1c580f]: $d4363a603a2b1168$export$5497b62b513b7853,
    [$d4363a603a2b1168$export$81e62964cc725098]: $d4363a603a2b1168$export$3f757c5e00588ffd
};
const $d4363a603a2b1168$export$fbf0dfd01228e38d = {
    [$d4363a603a2b1168$export$8598196f74460271]: (0, $edAb7.default).changes,
    [$d4363a603a2b1168$export$3d1cda9bd50505e8]: (0, $edAb7.default).serviceRequests,
    [$d4363a603a2b1168$export$ceba70db1edb1def]: (0, $edAb7.default).problems,
    [$d4363a603a2b1168$export$a50b49a533b5f7bc]: (0, $edAb7.default).incidents,
    [$d4363a603a2b1168$export$6ebf7b6bf1c580f]: (0, $edAb7.default).postIncidentReviews,
    [$d4363a603a2b1168$export$485b1216c42d8d4]: (0, $edAb7.default).queues,
    [$d4363a603a2b1168$export$81e62964cc725098]: (0, $edAb7.default).developerEscalation,
    [$d4363a603a2b1168$export$52bf3f16b7812704]: (0, $edAb7.default).noCategory
};
const $d4363a603a2b1168$export$45ba5f49e9509c4d = {
    [$d4363a603a2b1168$export$8598196f74460271]: (0, $edAb7.default).changesLower,
    [$d4363a603a2b1168$export$3d1cda9bd50505e8]: (0, $edAb7.default).serviceRequestsLower,
    [$d4363a603a2b1168$export$ceba70db1edb1def]: (0, $edAb7.default).problemsLower,
    [$d4363a603a2b1168$export$a50b49a533b5f7bc]: (0, $edAb7.default).incidentsLower,
    [$d4363a603a2b1168$export$6ebf7b6bf1c580f]: (0, $edAb7.default).postIncidentReviewsLower,
    [$d4363a603a2b1168$export$485b1216c42d8d4]: (0, $edAb7.default).queuesLower,
    [$d4363a603a2b1168$export$81e62964cc725098]: (0, $edAb7.default).developerEscalationLower,
    [$d4363a603a2b1168$export$52bf3f16b7812704]: (0, $edAb7.default).noCategoryLower
};

});
parcelRegister("edAb7", function(module, exports) {

$parcel$export(module.exports, "default", () => $716d4f665940f429$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $716d4f665940f429$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    queues: {
        "id": "work-category.common.queues",
        "defaultMessage": "Queues"
    },
    serviceRequests: {
        "id": "work-category.common.service-requests",
        "defaultMessage": "Service requests"
    },
    incidents: {
        "id": "work-category.common.incidents",
        "defaultMessage": "Incidents"
    },
    changes: {
        "id": "work-category.common.changes",
        "defaultMessage": "Changes"
    },
    problems: {
        "id": "work-category.common.problems",
        "defaultMessage": "Problems"
    },
    postIncidentReviews: {
        "id": "work-category.common.post-incident-reviews",
        "defaultMessage": "Post-incident reviews"
    },
    noCategory: {
        "id": "work-category.common.no-category",
        "defaultMessage": "General"
    },
    queuesLower: {
        "id": "work-category.common.queues-lower",
        "defaultMessage": "queues"
    },
    serviceRequestsLower: {
        "id": "work-category.common.service-requests-lower",
        "defaultMessage": "service requests"
    },
    incidentsLower: {
        "id": "work-category.common.incidents-lower",
        "defaultMessage": "incidents"
    },
    changesLower: {
        "id": "work-category.common.changes-lower",
        "defaultMessage": "changes"
    },
    problemsLower: {
        "id": "work-category.common.problems-lower",
        "defaultMessage": "problems"
    },
    postIncidentReviewsLower: {
        "id": "work-category.common.post-incident-reviews-lower",
        "defaultMessage": "post-incident reviews"
    },
    noCategoryLower: {
        "id": "work-category.common.no-category-lower",
        "defaultMessage": "general"
    },
    developerEscalation: {
        "id": "work-category.common.developer-escalation",
        "defaultMessage": "Developer escalations"
    },
    developerEscalationLower: {
        "id": "work-category.common.developer-escalation-lower",
        "defaultMessage": "developer escalations"
    }
});

});



parcelRegister("7vTKl", function(module, exports) {

$parcel$export(module.exports, "ADDON_ID", () => $d4390c4ef90a66f3$export$6c4866a933650d1d);
$parcel$export(module.exports, "MENU_ID", () => $d4390c4ef90a66f3$export$d4cd258d01c03112);
$parcel$export(module.exports, "SIDEBAR_ID", () => $d4390c4ef90a66f3$export$adf978edbdfaf080);
const $d4390c4ef90a66f3$export$6c4866a933650d1d = {
    DISCOVER: 'com.atlassian.jira.emcee__enduser-discover'
};
const $d4390c4ef90a66f3$export$d4cd258d01c03112 = {
    ADDONS: 'ADDONS',
    APP_SWITCHER: 'APP_SWITCHER',
    DASHBOARDS: 'DASHBOARDS',
    FILTERS: 'FILTERS',
    HELP: 'HELP',
    HOME: 'HOME',
    INSIGHT: 'INSIGHT',
    NOTIFICATIONS: 'NOTIFICATIONS',
    PEOPLE: 'PEOPLE',
    PLANS: 'PLANS',
    PROFILE: 'PROFILE',
    PROJECTS: 'PROJECTS',
    ROADMAPS: 'ROADMAPS',
    SEARCH: 'SEARCH',
    SERVICE_HUB: 'SERVICE_HUB',
    SETTINGS: 'SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};
const $d4390c4ef90a66f3$export$adf978edbdfaf080 = {
    BOARD_SETTINGS: 'BOARD_SETTINGS',
    GLOBAL_APPS_SETTINGS: 'GLOBAL_APPS_SETTINGS',
    GLOBAL_ISSUES_SETTINGS: 'GLOBAL_ISSUES_SETTINGS',
    GLOBAL_PRODUCTS_SETTINGS: 'GLOBAL_PRODUCTS_SETTINGS',
    GLOBAL_PROJECTS_SETTINGS: 'GLOBAL_PROJECTS_SETTINGS',
    GLOBAL_SYSTEM_SETTINGS: 'GLOBAL_SYSTEM_SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    PLAN_SETTINGS: 'PLAN_SETTINGS',
    PROJECT_SETTINGS: 'PROJECT_SETTINGS'
};

});

parcelRegister("1YbJP", function(module, exports) {

$parcel$export(module.exports, "testIdConcat", () => $b2302c46c1861a6c$export$794609946480f79c);
$parcel$export(module.exports, "testIdGenerate", () => $b2302c46c1861a6c$export$3b86b974ae586844);

var $1ybV0 = parcelRequire("1ybV0");
const $b2302c46c1861a6c$var$PREFIX = 'atlassian-navigation-';
const $b2302c46c1861a6c$var$SEPARATOR = '--';
const $b2302c46c1861a6c$var$isValid = (value)=>value != null && value !== '';
const $b2302c46c1861a6c$export$794609946480f79c = (id, ...items)=>(0, $1ybV0.ff)('navigation.disable-test-ids') ? undefined : [
        id,
        ...items
    ].filter(Boolean).join($b2302c46c1861a6c$var$SEPARATOR).toLowerCase();
const $b2302c46c1861a6c$export$3b86b974ae586844 = (first, ...rest)=>(0, $1ybV0.ff)('navigation.disable-test-ids') ? undefined // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | undefined'.
     : $b2302c46c1861a6c$export$794609946480f79c($b2302c46c1861a6c$var$PREFIX + ($b2302c46c1861a6c$var$isValid(first) ? `-${first}` : ''), ...rest);

});


parcelRegister("iJPUk", function(module, exports) {

$parcel$export(module.exports, "LEGACY_PERSONAL_SETTINGS_PATH", () => $97f48d3f13d5b88e$export$b468ccdb67523656);
$parcel$export(module.exports, "GENERAL_PERSONAL_SETTINGS_PATH", () => $97f48d3f13d5b88e$export$693b70d1bcef8627);
$parcel$export(module.exports, "NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $97f48d3f13d5b88e$export$21946ea4c58fd4c9);
$parcel$export(module.exports, "OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $97f48d3f13d5b88e$export$2321c59d517801c8);
$parcel$export(module.exports, "getGeneralPersonalSettingsPath", () => $97f48d3f13d5b88e$export$db9e3ccc1e5e3317);
$parcel$export(module.exports, "getNotificationsPersonalSettingsPath", () => $97f48d3f13d5b88e$export$64a672523a583594);

var $1ybV0 = parcelRequire("1ybV0");
const $97f48d3f13d5b88e$export$b468ccdb67523656 = '/secure/ViewPersonalSettings.jspa';
const $97f48d3f13d5b88e$export$a974f4af282a75ba = '/jira/settings/personal';
const $97f48d3f13d5b88e$export$693b70d1bcef8627 = `${$97f48d3f13d5b88e$export$a974f4af282a75ba}/general`;
const $97f48d3f13d5b88e$export$21946ea4c58fd4c9 = `${$97f48d3f13d5b88e$export$a974f4af282a75ba}/notifications`;
const $97f48d3f13d5b88e$export$2321c59d517801c8 = `${$97f48d3f13d5b88e$export$a974f4af282a75ba}/alert-notifications`;
function $97f48d3f13d5b88e$export$db9e3ccc1e5e3317() {
    return (0, $1ybV0.ff)('sea-1973-personal-settings-sidebar') ? $97f48d3f13d5b88e$export$693b70d1bcef8627 : $97f48d3f13d5b88e$export$b468ccdb67523656;
}
function $97f48d3f13d5b88e$export$88a45ae8c4b1c664() {
    return (0, $1ybV0.ff)('sea-1973-personal-settings-sidebar') ? $97f48d3f13d5b88e$export$2321c59d517801c8 : $97f48d3f13d5b88e$export$b468ccdb67523656;
}
function $97f48d3f13d5b88e$export$64a672523a583594() {
    if ((0, $1ybV0.ff)('sea-1973-personal-settings-sidebar')) {
        if ((0, $1ybV0.ff)('sea-1973-notifications-hub')) return $97f48d3f13d5b88e$export$21946ea4c58fd4c9;
        return $97f48d3f13d5b88e$export$693b70d1bcef8627;
    }
    return $97f48d3f13d5b88e$export$b468ccdb67523656;
}

});

parcelRegister("cWiVr", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $59f9598ada60a2a8$export$3901076af3749fa9);

var $eUqFw = parcelRequire("eUqFw");

var $ao0hp = parcelRequire("ao0hp");

var $gd0Sp = parcelRequire("gd0Sp");

var $lGLse = parcelRequire("lGLse");
const $59f9598ada60a2a8$var$useCurrentUserBasic = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return (0, $eUqFw.useMemo)(()=>({
            data: {
                user: {
                    accountId: tenantContext.atlassianAccountId,
                    isAdmin: tenantContext.isAdmin,
                    isAnonymous: tenantContext.isAnonymous,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    locale: tenantContext.locale || (0, $ao0hp.defaultLocale),
                    siteAdminStatus: tenantContext.siteAdminStatus,
                    userFullname: tenantContext.userFullname || ''
                }
            },
            loading: false,
            error: null
        }), [
        tenantContext.atlassianAccountId,
        tenantContext.isAdmin,
        tenantContext.isAnonymous,
        tenantContext.isSiteAdmin,
        tenantContext.locale,
        tenantContext.siteAdminStatus,
        tenantContext.userFullname
    ]);
};
const $59f9598ada60a2a8$var$useCurrentUserFull = ()=>{
    const { data: dataBasic } = $59f9598ada60a2a8$var$useCurrentUserBasic();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $lGLse.useUserSubscriber)();
    (0, $eUqFw.useEffect)(()=>{
        tenantContext.atlassianAccountId && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: tenantContext.atlassianAccountId
            }
        }, false);
    }, [
        fetch,
        tenantContext.atlassianAccountId
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: {
                ...dataBasic,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                user: {
                    ...dataBasic.user,
                    ...data
                }
            },
            loading: loading,
            error: error
        }), [
        data,
        dataBasic,
        error,
        loading
    ]);
};
const $59f9598ada60a2a8$export$3901076af3749fa9 = ()=>(0, $gd0Sp.useTenantContext)().isAnonymous ? $59f9598ada60a2a8$var$useCurrentUserBasic() : $59f9598ada60a2a8$var$useCurrentUserFull(); // eslint-disable-line react-hooks/rules-of-hooks
const $59f9598ada60a2a8$export$6414ebbbfff99d4c = ({ children: children })=>{
    const result = $59f9598ada60a2a8$export$3901076af3749fa9();
    return children(result);
};

});

parcelRegister("6JBWS", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryRoute", () => $13f76266b580a881$export$f0fc6f4e8be87e85);
$parcel$export(module.exports, "boardsDirectoryRedirectRoute", () => $13f76266b580a881$export$a4fba1ebd6ba91ee);

var $exb0h = parcelRequire("exb0h");
const $13f76266b580a881$export$f0fc6f4e8be87e85 = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: (0, $exb0h.ROUTE_NAMES_BOARDS_DIRECTORY),
    path: '/jira/boards'
};
const $13f76266b580a881$export$a4fba1ebd6ba91ee = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: `${(0, $exb0h.ROUTE_NAMES_BOARDS_DIRECTORY)}-redirect`,
    path: '/secure/ManageRapidViews.jspa'
};

});

parcelRegister("bLGeo", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRoute", () => $f1b3b12941e660c6$export$41bba408475cab16);
$parcel$export(module.exports, "dashboardsDirectoryRedirectRoute", () => $f1b3b12941e660c6$export$b96f6fb3c35a6fe5);

var $exb0h = parcelRequire("exb0h");
const $f1b3b12941e660c6$export$41bba408475cab16 = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: (0, $exb0h.ROUTE_NAMES_DASHBOARDS_DIRECTORY),
    path: '/jira/dashboards'
};
const $f1b3b12941e660c6$export$b96f6fb3c35a6fe5 = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: (0, $exb0h.ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE),
    path: '/secure/ConfigurePortalPages(!default.jspa|.jspa)'
};

});

parcelRegister("1cmFR", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRoute", () => $c5d476788b048c23$export$6350f52c8b40042d);
$parcel$export(module.exports, "filtersDirectoryRedirectRoute", () => $c5d476788b048c23$export$f4f86e1ddc30a625);
$parcel$export(module.exports, "secureFiltersDirectoryRedirectRoute", () => $c5d476788b048c23$export$50796f2aecd63181);

var $exb0h = parcelRequire("exb0h");
const $c5d476788b048c23$export$6350f52c8b40042d = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: (0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY),
    path: '/jira/filters'
};
const $c5d476788b048c23$export$f4f86e1ddc30a625 = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: `${(0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY)}-redirect`,
    path: '/ManageFilters.jspa'
};
const $c5d476788b048c23$export$50796f2aecd63181 = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: `${(0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY_SECURE)}-redirect`,
    path: '/secure/ManageFilters.jspa'
};

});

parcelRegister("jsQSa", function(module, exports) {

$parcel$export(module.exports, "plansDirectoryRoute", () => $31385c3fefa30f13$export$143b4a1ef2ffc051);

var $exb0h = parcelRequire("exb0h");
const $31385c3fefa30f13$export$143b4a1ef2ffc051 = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: (0, $exb0h.ROUTE_NAMES_PLANS_DIRECTORY),
    path: '/jira/plans'
};

});

parcelRegister("1iihP", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRoute", () => $24be186849539eb4$export$74114064f06cd71b);
$parcel$export(module.exports, "manageProjectsDirectoryRoute", () => $24be186849539eb4$export$281a4490a0f8fb4c);
$parcel$export(module.exports, "projectsDirectoryRedirectRoute", () => $24be186849539eb4$export$d44f1be3782f0fde);
$parcel$export(module.exports, "projectsDirectoryLegacyPathRedirectRoute", () => $24be186849539eb4$export$c713f57300a82898);
$parcel$export(module.exports, "projectsDirectoryManageRedirectRoute", () => $24be186849539eb4$export$dbd3b6c012e8b6dc);
$parcel$export(module.exports, "projectsDirectoryManageRootRedirectRoute", () => $24be186849539eb4$export$4531e3b2e25fad23);

var $exb0h = parcelRequire("exb0h");
const $24be186849539eb4$export$74114064f06cd71b = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: (0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY),
    path: '/jira/projects',
    exact: true
};
const $24be186849539eb4$export$281a4490a0f8fb4c = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: (0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE),
    path: '/jira/settings/projects/manage'
};
const $24be186849539eb4$export$d44f1be3782f0fde = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: `${(0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY)}-redirect`,
    path: '/projects',
    exact: true
};
const $24be186849539eb4$export$c713f57300a82898 = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: `${(0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA)}-redirect`,
    path: '/secure/BrowseProjects.jspa'
};
const $24be186849539eb4$export$dbd3b6c012e8b6dc = {
    name: `${(0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE)}-redirect`,
    path: '/secure/project/ViewProjects.jspa'
};
const $24be186849539eb4$export$4531e3b2e25fad23 = {
    name: `${(0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE)}-root-redirect`,
    path: '/jira/settings/projects',
    exact: true
};

});

parcelRegister("7lcEz", function(module, exports) {

$parcel$export(module.exports, "legacyPersonalSettingsRoute", () => $e67c038bcafcb183$export$dd556eb586bb36b8);
$parcel$export(module.exports, "generalPersonalSettingsRoute", () => $e67c038bcafcb183$export$7a6c9715a86f906b);
$parcel$export(module.exports, "notificationsPersonalSettingsRoute", () => $e67c038bcafcb183$export$55ab09b9d6beb8be);
$parcel$export(module.exports, "opsNotificationsPersonalSettingsRoute", () => $e67c038bcafcb183$export$68ebdd4eccb7b383);
$parcel$export(module.exports, "getGeneralPersonalSettingsRouteForLink", () => $e67c038bcafcb183$export$cbf079e07fb96768);
$parcel$export(module.exports, "getNotificationsPersonalSettingsRouteForLink", () => $e67c038bcafcb183$export$9b4c78a3c84b549f);

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $iJPUk = parcelRequire("iJPUk");

var $kZJn3 = parcelRequire("kZJn3");
const $e67c038bcafcb183$export$dd556eb586bb36b8 = {
    group: (0, $exb0h.ROUTE_GROUPS_PERSONAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PERSONAL_SETTINGS),
    path: (0, $iJPUk.LEGACY_PERSONAL_SETTINGS_PATH)
};
const $e67c038bcafcb183$export$7a6c9715a86f906b = {
    group: (0, $exb0h.ROUTE_GROUPS_PERSONAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PERSONAL_SETTINGS_GENERAL),
    path: (0, $iJPUk.GENERAL_PERSONAL_SETTINGS_PATH)
};
const $e67c038bcafcb183$export$55ab09b9d6beb8be = {
    group: (0, $exb0h.ROUTE_GROUPS_PERSONAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PERSONAL_SETTINGS_NOTIFICATIONS),
    path: (0, $iJPUk.NOTIFICATIONS_PERSONAL_SETTINGS_PATH),
    skeleton: (0, $kZJn3.PersonalSettingsNotificationsAppSkeleton)
};
const $e67c038bcafcb183$export$68ebdd4eccb7b383 = {
    group: (0, $exb0h.ROUTE_GROUPS_PERSONAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PERSONAL_SETTINGS_OPS_NOTIFICATIONS),
    path: (0, $iJPUk.OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH)
};
const $e67c038bcafcb183$export$cbf079e07fb96768 = ()=>{
    if ((0, $1ybV0.ff)('sea-1973-personal-settings-sidebar')) return $e67c038bcafcb183$export$7a6c9715a86f906b;
    return $e67c038bcafcb183$export$dd556eb586bb36b8;
};
const $e67c038bcafcb183$export$9b4c78a3c84b549f = ()=>{
    if ((0, $1ybV0.ff)('sea-1973-personal-settings-sidebar')) {
        if ((0, $1ybV0.ff)('sea-1973-notifications-hub')) return $e67c038bcafcb183$export$55ab09b9d6beb8be;
        return $e67c038bcafcb183$export$7a6c9715a86f906b;
    }
    return $e67c038bcafcb183$export$dd556eb586bb36b8;
};

});
parcelRegister("kZJn3", function(module, exports) {

$parcel$export(module.exports, "PersonalSettingsNotificationsAppSkeleton", () => $0cfb08a5fcfb6db6$export$b542eb2d3193b983);
$parcel$export(module.exports, "PersonalSettingsNotificationsGlobalTableSkeleton", () => $0cfb08a5fcfb6db6$export$d58f6bbbc1838cb2);
$parcel$export(module.exports, "MimetypeSelectSkeleton", () => $0cfb08a5fcfb6db6$export$46fc11a564484c9c);
$parcel$export(module.exports, "ProjectNotificationAccordionSkeleton", () => $0cfb08a5fcfb6db6$export$8cb773cb6fc17338);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8ICxF = parcelRequire("8ICxF");

var $cxmEy = parcelRequire("cxmEy");

var $iWH0v = parcelRequire("iWH0v");

var $cSzcb = parcelRequire("cSzcb");

var $fAR4b = parcelRequire("fAR4b");
const $0cfb08a5fcfb6db6$var$maxWidthCssStyles = null;
const $0cfb08a5fcfb6db6$var$customCssStyles = null;
const $0cfb08a5fcfb6db6$export$b542eb2d3193b983 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cSzcb))),
        className: (0, $7JEyt.default)([
            "_p12f8stt _19pkidpf _2hwx1wug _otyridpf _18u01wug"
        ])
    });
const $0cfb08a5fcfb6db6$export$d58f6bbbc1838cb2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0cfb08a5fcfb6db6$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cxmEy))),
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    }));
const $0cfb08a5fcfb6db6$export$46fc11a564484c9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0cfb08a5fcfb6db6$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iWH0v))),
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    }));
const $0cfb08a5fcfb6db6$export$8cb773cb6fc17338 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0cfb08a5fcfb6db6$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fAR4b))),
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0cfb08a5fcfb6db6$var$SkeletonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71ldgin _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cxmEy", function(module, exports) {
module.exports = new URL("global-table-skeleton-with-projects.tpl.5a5d24b9.svg", import.meta.url).toString();

});

parcelRegister("iWH0v", function(module, exports) {
module.exports = new URL("mimetype-skeleton.tpl.8b750352.svg", import.meta.url).toString();

});

parcelRegister("cSzcb", function(module, exports) {
module.exports = new URL("personal-settings-notifications-app-skeleton-with-projects.tpl.d18b3c58.svg", import.meta.url).toString();

});

parcelRegister("fAR4b", function(module, exports) {
module.exports = new URL("project-accordion-skeleton.tpl.cee2df62.svg", import.meta.url).toString();

});



const $d407c1f9c5a1b304$export$2d4af8d3471f446 = 'view-all-projects';
const $d407c1f9c5a1b304$export$bfa43d3c5bfbcf35 = 'view-all-filters';
const $d407c1f9c5a1b304$export$538e0daca84e7e29 = 'view-all-dashboards';
const $d407c1f9c5a1b304$export$f3211b812cd1a523 = 'go-to-issues';
const $d407c1f9c5a1b304$export$98cbb2f7230db2a1 = 'go-to-personal-settings';
const $d407c1f9c5a1b304$export$7e8556985118cd1e = 'view-all-boards';
const $d407c1f9c5a1b304$export$7976f2daa1e8078a = 'go-to-account-settings';
const $d407c1f9c5a1b304$export$653733b43ae1b993 = 'view-all-plans';
const $d407c1f9c5a1b304$export$9ede11404253696 = 'site-admin-user-management';
const $d407c1f9c5a1b304$export$bf77ae178e5e5984 = 'site-admin-billing';
const $d407c1f9c5a1b304$export$c85cfa6ec2ae0df7 = 'shortcut-icon';

parcelRegister("5eTF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3d65a30c63d4a5c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d3d65a30c63d4a5c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    viewAllProjects: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-projects",
        "defaultMessage": "View all projects"
    },
    viewAllFilters: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-filters",
        "defaultMessage": "View all filters"
    },
    viewAllDashboards: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-dashboards",
        "defaultMessage": "View all dashboards"
    },
    goToIssues: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-issues",
        "defaultMessage": "Go to issues"
    },
    goToPersonalSettings: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-personal-settings",
        "defaultMessage": "Go to personal settings"
    },
    viewAllBoards: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-boards",
        "defaultMessage": "View all boards"
    },
    goToAccountSettings: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-account-settings",
        "defaultMessage": "Go to account settings"
    },
    viewAllPlans: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-plans",
        "defaultMessage": "View all plans"
    },
    goToUserManagement: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-user-management",
        "defaultMessage": "Go to user management"
    },
    goToBilling: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-billing",
        "defaultMessage": "Go to billing"
    }
});

});



parcelRegister("cGl0F", function(module, exports) {

$parcel$export(module.exports, "messages", () => $79192bb5c7c2a86f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $79192bb5c7c2a86f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    // TODO: Remove when cleaning up compal-issue-actions-very-high-priority_f5w5r ff
    defaultPlaceholderWithQuickSearch: {
        "id": "command-palette-integration.default-placeholder-with-quick-search",
        "defaultMessage": "Type a command or {searchModeIcon} to search issues, projects, and more"
    },
    defaultPlaceholder: {
        "id": "command-palette-integration.default-placeholder",
        "defaultMessage": "Search actions, settings, or type \"/\" to search work"
    },
    noResultsFound: {
        "id": "command-palette-integration.no-results-found",
        "defaultMessage": "No commands match your search."
    },
    onErrorFallback: {
        "id": "command-palette-integration.on-error-fallback",
        "defaultMessage": "We're having trouble loading this data. Wait a few moments, then try again."
    },
    recommendedSection: {
        "id": "command-palette-integration.recommended-section",
        "defaultMessage": "Recommended"
    }
});

});

parcelRegister("fRDll", function(module, exports) {

$parcel$export(module.exports, "RegisterDynamicCommands", () => $41f6118dc78d880d$export$54040e80edbe5eaf);

var $eUqFw = parcelRequire("eUqFw");

var $37ZVI = parcelRequire("37ZVI");

var $7iyyo = parcelRequire("7iyyo");

var $l5V54 = parcelRequire("l5V54");
const $41f6118dc78d880d$export$54040e80edbe5eaf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7iyyo.InitialiseAdminNavCommands), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $37ZVI.QuickSearchCommands), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l5V54.ThemeModeCommands), null));

});
parcelRegister("37ZVI", function(module, exports) {

$parcel$export(module.exports, "QuickSearchCommands", () => $7c767310fb0ca041$export$6e94ce71acbaa493);

var $eUqFw = parcelRequire("eUqFw");

var $fmmnJ = parcelRequire("fmmnJ");
var $dK5FP = parcelRequire("dK5FP");

var $eyEYc = parcelRequire("eyEYc");

var $52i70 = parcelRequire("52i70");
const $7c767310fb0ca041$var$useQuickSearchCommands = ()=>{
    const subscribe = (0, $dK5FP.useSubscribeCommands)();
    const { quickSearchCommand: quickSearchCommand } = (0, $52i70.useQuickSearchCommand)({
        keepSearch: false
    });
    (0, $eUqFw.useEffect)(()=>subscribe((0, $fmmnJ.COMMAND_PALETTE_REGISTRY_IDS).QUICK_SEARCH, [
            quickSearchCommand
        ]), [
        quickSearchCommand,
        subscribe
    ]);
    return null;
};
const $7c767310fb0ca041$var$QuickSearchCommandsInner = ()=>{
    $7c767310fb0ca041$var$useQuickSearchCommands();
    return null;
};
const $7c767310fb0ca041$export$6e94ce71acbaa493 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eyEYc.QuickSearchWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c767310fb0ca041$var$QuickSearchCommandsInner, null));

});
parcelRegister("dK5FP", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommands", () => $882c857bed4a7f74$export$c13b008422be19c7);

var $7Xm2s = parcelRequire("7Xm2s");
const $882c857bed4a7f74$export$c13b008422be19c7 = (0, $7Xm2s.useSubscribeCommandsWithRegistry);

});


parcelRegister("7iyyo", function(module, exports) {

$parcel$export(module.exports, "InitialiseAdminNavCommands", () => $eedbfe714afa70ee$export$397d6a5dfe0b6bae);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");

var $eTKO4 = parcelRequire("eTKO4");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");
const $eedbfe714afa70ee$var$entryPointParams = {};
const $eedbfe714afa70ee$export$397d6a5dfe0b6bae = ()=>{
    const [initialised, setInitialised] = (0, $eUqFw.useState)(false);
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $6j4bv.useEntryPoint)((0, $eTKO4.compalAdminNavigationEntrypoint), $eedbfe714afa70ee$var$entryPointParams);
    const [{ isOpen: isOpen }] = (0, $gCtL7.useCommandPaletteIsOpen)();
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        if (!initialised) return;
        if (isOpen) entryPointActions.load();
        else entryPointActions.unload();
    }, [
        isOpen,
        entryPointActions,
        initialised
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!initialised && isOpen) setInitialised(true);
    }, [
        isOpen,
        initialised
    ]);
    const props = (0, $eUqFw.useMemo)(()=>({}), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "commandPaletteAsyncAdminNavigation",
        packageName: "jiraCommandPaletteIntegration",
        teamName: "deliveroo",
        fallback: null,
        errorFallback: "flag",
        runtimeProps: props
    });
};

});
parcelRegister("eTKO4", function(module, exports) {

$parcel$export(module.exports, "compalAdminNavigationEntrypoint", () => $336810f6b40ede8a$export$ec97befbb495acbe);
/* istanbul ignore file */ 
var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $336810f6b40ede8a$export$ec97befbb495acbe = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("drdCz")).then((module)=>module.AdminNavCommands), {
        moduleId: "1ee8a073"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("drdCz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ihAxt").then(()=>parcelRequire('k93NS'));

});


parcelRegister("6j4bv", function(module, exports) {

$parcel$export(module.exports, "useEntryPoint", () => $82c08dfbbf99b106$export$338256068bc140fb);

var $eUqFw = parcelRequire("eUqFw");

var $hRw7O = parcelRequire("hRw7O");

var $80LCQ = parcelRequire("80LCQ");

var $fn8UB = parcelRequire("fn8UB");

var $VvIn5 = parcelRequire("VvIn5");
const $82c08dfbbf99b106$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, $hRw7O.DEFAULT_OPTIONS))=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, $fn8UB.useEntryPointLoadManager)(entryPoint, entryPointParams);
    const { startMetric: startMetric, stopMetric: stopMetric } = (0, $VvIn5.useMetricLogger)(metric);
    const entryPointActions = (0, $80LCQ.useEntryPointActions)(loadActions, options, startMetric);
    return (0, $eUqFw.useMemo)(()=>({
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject,
            stopMetric: stopMetric
        }), [
        entryPointActions,
        entryPointReferenceSubject,
        stopMetric
    ]);
};

});
parcelRegister("hRw7O", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_OPTIONS", () => $8aa020919bcd63f9$export$93ca5d3f8675ae4c);
const $8aa020919bcd63f9$export$93ca5d3f8675ae4c = {
    preloadMaxAge: 2000,
    timeToIntent: 200
};

});

parcelRegister("80LCQ", function(module, exports) {

$parcel$export(module.exports, "useEntryPointActions", () => $5764a513c11cf0da$export$90681c8c3a56f09a);

var $eUqFw = parcelRequire("eUqFw");

var $gZ48R = parcelRequire("gZ48R");

var $hRw7O = parcelRequire("hRw7O");
const $5764a513c11cf0da$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
const $5764a513c11cf0da$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, $hRw7O.DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, $hRw7O.DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
    const preloadIntentTimeout = (0, $eUqFw.useRef)();
    const preloadMaxAgeTimeout = (0, $eUqFw.useRef)();
    const preloadLastRequested = (0, $eUqFw.useRef)(0);
    const cancelPreload = (0, $eUqFw.useCallback)(()=>{
        if (!(0, $gZ48R.default)($5764a513c11cf0da$var$PRELOAD_KILLSWITCH)) {
            clearTimeout(preloadIntentTimeout.current);
            clearTimeout(preloadMaxAgeTimeout.current);
        }
    }, []);
    const load = (0, $eUqFw.useCallback)(()=>{
        cancelPreload();
        startMetric(preloadLastRequested.current);
        if (preloadLastRequested.current > 0) commitPreload();
        else loadEntryPoint();
        preloadLastRequested.current = 0;
    }, [
        cancelPreload,
        commitPreload,
        loadEntryPoint,
        startMetric
    ]);
    const preload = (0, $eUqFw.useCallback)(()=>{
        if ((0, $gZ48R.default)($5764a513c11cf0da$var$PRELOAD_KILLSWITCH)) return;
        cancelPreload();
        preloadIntentTimeout.current = setTimeout(()=>{
            preloadLastRequested.current = Date.now();
            loadEntryPoint({
                isPreload: true
            });
            preloadMaxAgeTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = 0;
            }, preloadMaxAge);
        }, timeToIntent);
    }, [
        cancelPreload,
        loadEntryPoint,
        preloadMaxAge,
        timeToIntent
    ]);
    (0, $eUqFw.useEffect)(()=>cancelPreload, [
        cancelPreload
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            cancelPreload: cancelPreload,
            load: load,
            preload: preload,
            unload: unloadEntryPoint
        }), [
        cancelPreload,
        load,
        preload,
        unloadEntryPoint
    ]);
};

});

parcelRegister("fn8UB", function(module, exports) {

$parcel$export(module.exports, "useEntryPointLoadManager", () => $9075a0262fd7a4a5$export$bfae318f9651db2f);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $ln3W8 = parcelRequire("ln3W8");

var $boTUp = parcelRequire("boTUp");
const $9075a0262fd7a4a5$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
    const environmentProvider = (0, $ln3W8.useJiraRelayEnvironmentProvider)();
    const canLoad = (0, $eUqFw.useRef)(true);
    const timer = (0, $eUqFw.useRef)();
    const entryPointReferenceQueue = (0, $eUqFw.useRef)([]);
    const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, $boTUp.useEntryPointReferenceSubject)();
    const setNextUpdate = (0, $eUqFw.useCallback)((nextEntryPointReference)=>{
        setEntryPointReference(nextEntryPointReference);
        // Delay clean up to prioritise render cycle in case
        // prior queries get used again
        timer.current = setTimeout(()=>{
            const { current: currentQueue } = entryPointReferenceQueue;
            entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $boTUp.removeAll)(currentQueue) : (0, $boTUp.removeInactiveLoads)(currentQueue);
        }, 0);
    }, [
        setEntryPointReference
    ]);
    const load = (0, $eUqFw.useCallback)(({ isPreload: isPreload } = {
        isPreload: false
    })=>{
        if (canLoad.current) {
            const reference = (0, $iWLL0.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
            entryPointReferenceQueue.current.unshift({
                value: reference,
                isPreload: isPreload
            });
            if (isPreload) entryPointReferenceQueue.current = (0, $boTUp.removeRedundantPreloads)(entryPointReferenceQueue.current);
            else setNextUpdate(reference);
        }
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        setNextUpdate
    ]);
    const unload = (0, $eUqFw.useCallback)(()=>{
        setNextUpdate(null);
    }, [
        setNextUpdate
    ]);
    const commitPreload = (0, $eUqFw.useCallback)(()=>{
        const [firstItem] = entryPointReferenceQueue.current;
        if (firstItem?.isPreload) {
            firstItem.isPreload = false;
            setNextUpdate(firstItem.value);
        }
    }, [
        setNextUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            clearTimeout(timer.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $boTUp.removeAll)(entryPointReferenceQueue.current);
        }, []);
    return {
        entryPointReferenceSubject: (0, $eUqFw.useMemo)(()=>({
                getValue: getValue,
                subscribe: subscribe
            }), [
            getValue,
            subscribe
        ]),
        loadEntryPoint: load,
        unloadEntryPoint: unload,
        commitPreload: commitPreload
    };
};

});
parcelRegister("boTUp", function(module, exports) {

$parcel$export(module.exports, "removeRedundantPreloads", () => $f334fadd26cc659d$export$a5b3b808f05fede2);
$parcel$export(module.exports, "removeInactiveLoads", () => $f334fadd26cc659d$export$ae329fe3ea179cb4);
$parcel$export(module.exports, "removeAll", () => $f334fadd26cc659d$export$1cfc7aad5cb1833b);
$parcel$export(module.exports, "useEntryPointReferenceSubject", () => $f334fadd26cc659d$export$322c8997d351da6a);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");
const $f334fadd26cc659d$export$a5b3b808f05fede2 = (queue)=>{
    const [, ...potentialRedundantItems] = queue;
    potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
        if (isPreload) value.dispose();
    });
    return queue.filter(({ value: value })=>!value.isDisposed);
};
const $f334fadd26cc659d$export$ae329fe3ea179cb4 = (queue)=>{
    if (queue.length === 0) return [];
    const [activeItem, ...redundantItems] = queue;
    redundantItems.forEach(({ value: value })=>{
        value.dispose();
    });
    return [
        activeItem
    ];
};
const $f334fadd26cc659d$export$1cfc7aad5cb1833b = (queue)=>{
    queue.forEach(({ value: value })=>{
        value.dispose();
    });
    return [];
};
const $f334fadd26cc659d$export$322c8997d351da6a = ()=>{
    const value = (0, $eUqFw.useRef)(null);
    const subscribers = (0, $eUqFw.useRef)();
    const subscribe = (0, $eUqFw.useCallback)((subscriber)=>{
        if (!subscribers.current) subscribers.current = new Set();
        subscribers.current.add(subscriber);
        return ()=>{
            subscribers.current?.delete(subscriber);
        };
    }, []);
    const setEntryPointReference = (0, $eUqFw.useCallback)((entryPointReference)=>{
        value.current = entryPointReference;
        (0, $lEfVV.unstable_batchedUpdates)(()=>{
            if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                subscriber(entryPointReference);
            });
        });
    }, []);
    const getValue = (0, $eUqFw.useCallback)(()=>value.current, []);
    (0, $eUqFw.useEffect)(()=>()=>{
            subscribers.current?.clear();
        }, []);
    return {
        getValue: getValue,
        setEntryPointReference: setEntryPointReference,
        subscribe: subscribe
    };
};

});


parcelRegister("VvIn5", function(module, exports) {

$parcel$export(module.exports, "useMetricLogger", () => $df836dfb6cf1aa5a$export$f291ec7cea728e1);

var $eUqFw = parcelRequire("eUqFw");
const $df836dfb6cf1aa5a$export$f291ec7cea728e1 = (metric)=>{
    const preloadStartTime = (0, $eUqFw.useRef)(0);
    const loadStartTime = (0, $eUqFw.useRef)(0);
    const startMetric = (0, $eUqFw.useCallback)((preloadTime = 0)=>{
        if (metric) {
            metric.start();
            preloadStartTime.current = preloadTime;
            loadStartTime.current = Date.now();
        }
    }, [
        metric
    ]);
    const stopMetric = (0, $eUqFw.useCallback)((additionalCustomData)=>{
        if (metric) {
            const preloadData = preloadStartTime.current > 0 ? {
                preloadToStartDuration: loadStartTime.current - preloadStartTime.current
            } : undefined;
            const metricData = preloadData || additionalCustomData ? {
                customData: {
                    ...preloadData,
                    ...additionalCustomData
                }
            } : undefined;
            metric.stop(metricData);
        }
    }, [
        metric
    ]);
    return {
        startMetric: startMetric,
        stopMetric: stopMetric
    };
};

});


parcelRegister("1HzcR", function(module, exports) {

$parcel$export(module.exports, "JiraEntryPointContainer", () => $48716810ae87e4eb$export$ee1e46af8fa2fb93);

var $eUqFw = parcelRequire("eUqFw");

var $P6D7Q = parcelRequire("P6D7Q");

var $ioLN0 = parcelRequire("ioLN0");
const $48716810ae87e4eb$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
    const entryPointReference = (0, $P6D7Q.useEntryPointSubscription)(entryPointReferenceSubject);
    return entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ioLN0.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        placeholderName: "jira-entry-point-container"
    }) : null;
};
const $48716810ae87e4eb$export$54db9e88249c9162 = (0, $ioLN0.InternalEntryPointContainer);

});
parcelRegister("P6D7Q", function(module, exports) {

$parcel$export(module.exports, "useEntryPointSubscription", () => $f27db5d96682fc65$export$3cd1c81e13390c49);

var $eUqFw = parcelRequire("eUqFw");
const $f27db5d96682fc65$export$3cd1c81e13390c49 = (subject)=>{
    const [entryPointReference, setEntryPointReference] = (0, $eUqFw.useState)(subject.getValue);
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = subject.subscribe(setEntryPointReference);
        setEntryPointReference(subject.getValue());
        return unsubscribe;
    }, [
        subject
    ]);
    return entryPointReference;
};

});

parcelRegister("ioLN0", function(module, exports) {

$parcel$export(module.exports, "InternalEntryPointContainer", () => $d11d0c1bfdfee8c0$export$5d4dc37edd8a3adb);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $jK1pm = parcelRequire("jK1pm");
const $d11d0c1bfdfee8c0$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>/* eslint-disable-next-line jira/ufo/valid-labels */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: errorAttributes,
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: placeholderName ?? packageName ?? 'internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    }))));

});



parcelRegister("l5V54", function(module, exports) {

$parcel$export(module.exports, "ThemeModeCommands", () => $6618f0296182d1b9$export$cecc9cf59bb74e7d);

var $eUqFw = parcelRequire("eUqFw");

var $iw0Y6 = parcelRequire("iw0Y6");

var $6jiFZ = parcelRequire("6jiFZ");

var $9zALC = parcelRequire("9zALC");
var $gfXKy = parcelRequire("gfXKy");

var $fmmnJ = parcelRequire("fmmnJ");
var $gjNh9 = parcelRequire("gjNh9");

var $eM3G3 = parcelRequire("eM3G3");

var $hOlJh = parcelRequire("hOlJh");
var $ioGV4 = parcelRequire("ioGV4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3MEW8 = parcelRequire("3MEW8");

var $3OmVR = parcelRequire("3OmVR");
const $6618f0296182d1b9$export$17b41f710dd67667 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { theme: currentTheme = 'light', setTheme: setTheme } = (0, $3MEW8.useThemePreference)();
    const { triggerCustomNavBarColorsFlag: triggerCustomNavBarColorsFlag } = (0, $hOlJh.default)();
    const setThemeWithCustomNavBarFlag = (0, $eUqFw.useCallback)(async (newTheme)=>{
        await setTheme(newTheme);
        triggerCustomNavBarColorsFlag(newTheme);
    }, [
        setTheme,
        triggerCustomNavBarColorsFlag
    ]);
    const { getKeywords: getKeywords } = (0, $gfXKy.useCommandKeywords)();
    const createThemeCommand = (0, $eUqFw.useCallback)((theme, message, priority)=>({
            id: `command-palette-integration-change-theme-mode-${theme}`,
            name: formatMessage(message),
            keywords: theme === 'auto' ? getKeywords('matchSystemThemeSynonyms') : getKeywords('switchDarkThemeSynonyms'),
            primaryAction: {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: ()=>setThemeWithCustomNavBarFlag(theme)
            },
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iw0Y6))), {
                        label: formatMessage(message)
                    })
            },
            section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).personalSettings,
            priority: priority,
            analytics: {
                action: 'toggleTheme'
            }
        }), [
        formatMessage,
        getKeywords,
        setThemeWithCustomNavBarFlag
    ]);
    const themeModeCommands = (0, $eUqFw.useMemo)(()=>{
        const availableThemesMode = {
            dark: createThemeCommand('dark', (0, $3OmVR.messages).commandDarkTheme, (0, $9zALC.COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY).switchToDarkTheme),
            light: createThemeCommand('light', (0, $3OmVR.messages).commandLightTheme, (0, $9zALC.COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY).switchToLightTheme),
            auto: createThemeCommand('auto', (0, $3OmVR.messages).commandAutoTheme, (0, $9zALC.COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY).switchToSystemTheme)
        };
        const listOfCommands = [];
        Object.entries(availableThemesMode).forEach(([key, command])=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (key !== currentTheme && (0, $eM3G3.ThemeOptions).includes(key)) listOfCommands.push(command);
        });
        return listOfCommands;
    }, [
        createThemeCommand,
        currentTheme
    ]);
    return themeModeCommands;
};
const $6618f0296182d1b9$export$cecc9cf59bb74e7d = ()=>{
    const [{ flagIsDismissed: flagIsDismissed }] = (0, $ioGV4.useCustomNavBarColorWarnings)();
    const command = $6618f0296182d1b9$export$17b41f710dd67667();
    const commandIds = command.map(({ id: id })=>id).toString();
    (0, $gjNh9.useRegisterCommands)((0, $fmmnJ.COMMAND_PALETTE_REGISTRY_IDS).THEME_MODE, command, [
        commandIds,
        flagIsDismissed
    ]);
    return null;
};

});
parcelRegister("eM3G3", function(module, exports) {

$parcel$export(module.exports, "ThemeOptions", () => $65da877bf2b17a02$export$abe7936539cefefe);
$parcel$export(module.exports, "DEFAULT_THEME", () => $65da877bf2b17a02$export$2faeed762aac6741);
const $65da877bf2b17a02$export$abe7936539cefefe = [
    'light',
    'dark',
    'auto'
];
const $65da877bf2b17a02$export$2faeed762aac6741 = 'light';

});

parcelRegister("hOlJh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2170177bf8abd16$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7fSR6 = parcelRequire("7fSR6");

var $k8Qyf = parcelRequire("k8Qyf");

var $8QZQG = parcelRequire("8QZQG");

var $ioGV4 = parcelRequire("ioGV4");

var $1RtwN = parcelRequire("1RtwN");
/**
 * Manages the logic for showing a warning about custom navigation bar colors.
 * Determines whether the warning should be displayed based on feature flags, theme settings,
 * and whether the warning has been previously dismissed. Aimed at ensuring users are aware
 * of potential issues with custom color schemes in the navigation bar.
 */ const $e2170177bf8abd16$var$useCustomNavBarColorsFlag = ()=>{
    const { hasFlag: hasFlag, showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const [{ navigationTheme: navigationTheme }] = (0, $7fSR6.useTheme)();
    const [{ flagIsDismissed: flagIsDismissed, sectionMessageIsDismissed: sectionMessageIsDismissed, isLoading: isLoading }, { setFlagIsDismissed: setFlagIsDismissed, initialFetch: initialFetch }] = (0, $ioGV4.useCustomNavBarColorWarnings)();
    (0, $eUqFw.useEffect)(()=>{
        initialFetch();
    }, [
        initialFetch
    ]);
    const handleDismiss = (0, $eUqFw.useCallback)(()=>{
        dismissFlag((0, $8QZQG.CUSTOM_NAV_BAR_COLORS_FLAG_ID));
        setFlagIsDismissed();
    }, [
        dismissFlag,
        setFlagIsDismissed
    ]);
    const shouldShowFlag = (0, $eUqFw.useCallback)((theme)=>!isLoading && !hasFlag?.((0, $8QZQG.CUSTOM_NAV_BAR_COLORS_FLAG_ID)) && (theme === 'dark' || theme === 'auto') && navigationTheme.usesCustomColours && flagIsDismissed === false && sectionMessageIsDismissed === false, [
        hasFlag,
        navigationTheme.usesCustomColours,
        isLoading,
        flagIsDismissed,
        sectionMessageIsDismissed
    ]);
    const triggerCustomNavBarColorsFlag = (0, $eUqFw.useCallback)((newTheme)=>{
        if (shouldShowFlag(newTheme)) showFlag({
            id: (0, $8QZQG.CUSTOM_NAV_BAR_COLORS_FLAG_ID),
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1RtwN.default), {
                    ...props,
                    onDismiss: handleDismiss,
                    analyticsAttributes: {
                        backgroundColor: navigationTheme.backgroundColor,
                        highlightColor: navigationTheme.highlightColor
                    }
                })
        });
    }, [
        shouldShowFlag,
        handleDismiss,
        showFlag,
        navigationTheme
    ]);
    return {
        triggerCustomNavBarColorsFlag: triggerCustomNavBarColorsFlag
    };
};
var $e2170177bf8abd16$export$2e2bcd8739ae039 = $e2170177bf8abd16$var$useCustomNavBarColorsFlag;

});
parcelRegister("7fSR6", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $d3617e68561cf32c$export$93d4e7f90805808f);
$parcel$export(module.exports, "ThemeContainer", () => $d3617e68561cf32c$export$11eb671888ed6e7d);

var $WBLbN = parcelRequire("WBLbN");

var $g1FfP = parcelRequire("g1FfP");
const $d3617e68561cf32c$var$initialState = {
    navigationTheme: {
        shouldShowTitle: false,
        logoUrl: '',
        usesCustomColours: false,
        backgroundColor: '',
        highlightColor: ''
    }
};
const $d3617e68561cf32c$var$Store = (0, $WBLbN.createStore)({
    name: 'theme',
    initialState: $d3617e68561cf32c$var$initialState,
    actions: $g1FfP
});
const $d3617e68561cf32c$export$74e6aa5aeff5e82e = (0, $WBLbN.createSubscriber)($d3617e68561cf32c$var$Store);
const $d3617e68561cf32c$export$93d4e7f90805808f = (0, $WBLbN.createHook)($d3617e68561cf32c$var$Store);
const $d3617e68561cf32c$export$11eb671888ed6e7d = (0, $WBLbN.createContainer)($d3617e68561cf32c$var$Store, {
    onInit: $g1FfP.bootstrap
});

});
parcelRegister("g1FfP", function(module, exports) {

$parcel$export(module.exports, "bootstrap", () => $74d45e3f7106acfe$export$36aff1fbb4f5dfc6);
$parcel$export(module.exports, "update", () => $74d45e3f7106acfe$export$722fbec263ad908a);

const $74d45e3f7106acfe$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { getMeta: getMeta })=>{
        const ajsBackgroundColor = getMeta('ajs-lf-navigation-bgcolour');
        const ajsHighlightColor = getMeta('ajs-lf-navigation-highlightcolour');
        // we need to use color code directly here to compare it with hex code in meta tags
        const hasNavv3CustomColors = ajsBackgroundColor != null && ajsHighlightColor != null && (ajsBackgroundColor !== (0, $73a5c9d720aa66e1$exports).N0 || ajsHighlightColor !== (0, $73a5c9d720aa66e1$exports).B400);
        const navigationTheme = {
            shouldShowTitle: getMeta('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            logoUrl: getMeta('ajs-lf-top-adg3-logourl') || '',
            usesCustomColours: getMeta('ajs-lf-top-adg3-hascustomcolours') === 'true',
            backgroundColor: ajsBackgroundColor || `var(--ds-background-inverse-subtle, ${(0, $73a5c9d720aa66e1$exports).N0})`,
            highlightColor: ajsHighlightColor || `var(--ds-text-brand, ${(0, $73a5c9d720aa66e1$exports).B400})`
        };
        if (hasNavv3CustomColors) navigationTheme.usesCustomColours = true;
        setState({
            navigationTheme: navigationTheme
        });
    };
const $74d45e3f7106acfe$export$722fbec263ad908a = (item)=>({ setState: setState, getState: getState })=>{
        const navigationTheme = {
            ...getState().navigationTheme,
            ...item
        };
        setState({
            navigationTheme: navigationTheme
        });
    };

});


parcelRegister("8QZQG", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_NAV_BAR_COLORS_FLAG_DISMISSED_KEY", () => $8502a7ee64ee7a2e$export$e322337c75e7fd2e);
$parcel$export(module.exports, "CUSTOM_NAV_BAR_COLORS_SECTION_MESSAGE_DISMISSED_KEY", () => $8502a7ee64ee7a2e$export$d37f7f5db461e560);
$parcel$export(module.exports, "CUSTOM_NAV_BAR_COLORS_FLAG_ID", () => $8502a7ee64ee7a2e$export$385ef2d36e85217);
$parcel$export(module.exports, "HELP_ARTICLE_ID", () => $8502a7ee64ee7a2e$export$1da9e2242c8f1be7);

var $eo17r = parcelRequire("eo17r");
const $8502a7ee64ee7a2e$export$e322337c75e7fd2e = 'jira.user.theme.custom-nav-bar-flag.dismissed';
const $8502a7ee64ee7a2e$export$d37f7f5db461e560 = 'jira.user.theme.custom-nav-bar-section-message.dismissed';
const $8502a7ee64ee7a2e$export$385ef2d36e85217 = (0, $eo17r.toFlagId)('onThemeChangeCustomColorsFlag');
const $8502a7ee64ee7a2e$export$1da9e2242c8f1be7 = '1QC8AUgw7MAmoVtoYXQDxM';

});

parcelRegister("ioGV4", function(module, exports) {

$parcel$export(module.exports, "useCustomNavBarColorWarnings", () => $3539daec7f64e89d$export$c3d02c4eeb80172a);

var $WBLbN = parcelRequire("WBLbN");

var $70nR6 = parcelRequire("70nR6");
const $3539daec7f64e89d$var$initialState = {
    isLoading: true
};
const $3539daec7f64e89d$var$CustomNavBarColorsFlagDismissalStore = (0, $WBLbN.createStore)({
    initialState: $3539daec7f64e89d$var$initialState,
    actions: $70nR6.actions,
    name: 'custom-nav-bar-colors-flag-dismissal'
});
const $3539daec7f64e89d$export$c3d02c4eeb80172a = (0, $WBLbN.createHook)($3539daec7f64e89d$var$CustomNavBarColorsFlagDismissalStore);

});
parcelRegister("70nR6", function(module, exports) {

$parcel$export(module.exports, "actions", () => $6cc96ee3bc60e07e$export$e324594224ef24da);

var $A2VOy = parcelRequire("A2VOy");
const $6cc96ee3bc60e07e$export$e324594224ef24da = {
    initialFetch: ()=>async ({ setState: setState, getState: getState })=>{
            const { isLoading: isLoading } = getState();
            if (!isLoading) return;
            setState({
                isLoading: false
            });
            const [flagDismissedRes, sectionMessageDismissedRes] = await Promise.allSettled([
                (0, $A2VOy.getCustomNavBarFlagDismissed)(),
                (0, $A2VOy.getCustomNavBarMessageDismissed)()
            ]);
            setState({
                flagIsDismissed: flagDismissedRes.status === 'fulfilled' ? flagDismissedRes.value || false : false,
                sectionMessageIsDismissed: sectionMessageDismissedRes.status === 'fulfilled' ? sectionMessageDismissedRes.value || false : false
            });
        },
    setFlagIsDismissed: ()=>({ setState: setState })=>{
            setState({
                flagIsDismissed: true
            });
            (0, $A2VOy.setCustomNavBarFlagDismissed)(true);
        },
    setMessageIsDismissed: ()=>({ setState: setState })=>{
            setState({
                sectionMessageIsDismissed: true
            });
            (0, $A2VOy.setCustomNavBarMessageDismissed)(true);
        }
};

});
parcelRegister("A2VOy", function(module, exports) {

$parcel$export(module.exports, "setCustomNavBarFlagDismissed", () => $eb67785305422dde$export$96c3ac24c205921e);
$parcel$export(module.exports, "getCustomNavBarFlagDismissed", () => $eb67785305422dde$export$4875b5188973cc41);
$parcel$export(module.exports, "getCustomNavBarMessageDismissed", () => $eb67785305422dde$export$234ec7e66f5f0d80);
$parcel$export(module.exports, "setCustomNavBarMessageDismissed", () => $eb67785305422dde$export$81fcff1db07fc096);

var $guiFP = parcelRequire("guiFP");

var $cm5m0 = parcelRequire("cm5m0");

var $8QZQG = parcelRequire("8QZQG");
const $eb67785305422dde$export$96c3ac24c205921e = async (value)=>{
    try {
        await (0, $cm5m0.userPreferenceAPI).set((0, $8QZQG.CUSTOM_NAV_BAR_COLORS_FLAG_DISMISSED_KEY), value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $guiFP.default)({
            error: err,
            meta: {
                id: 'setCustomNavBarFlagDismissed',
                packageName: 'jiraCustomNavBarColorsFlag'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $eb67785305422dde$export$4875b5188973cc41 = async ()=>{
    try {
        return await (0, $cm5m0.userPreferenceAPI).get((0, $8QZQG.CUSTOM_NAV_BAR_COLORS_FLAG_DISMISSED_KEY));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        // 404 is acceptable as it means user hasn't dismissed it yet
        if (err.statusCode !== 404) (0, $guiFP.default)({
            error: err,
            meta: {
                id: 'getCustomNavBarFlagDismissed',
                packageName: 'jiraCustomNavBarColorsFlag'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return null;
    }
};
const $eb67785305422dde$export$234ec7e66f5f0d80 = async ()=>{
    try {
        return await (0, $cm5m0.userPreferenceAPI).get((0, $8QZQG.CUSTOM_NAV_BAR_COLORS_SECTION_MESSAGE_DISMISSED_KEY));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        // 404 is acceptable as it means user hasn't dismissed it yet
        if (err.statusCode !== 404) (0, $guiFP.default)({
            error: err,
            meta: {
                id: 'getCustomNavBarMessageDismissed',
                packageName: 'jiraCustomNavBarColorsFlag'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return null;
    }
};
const $eb67785305422dde$export$81fcff1db07fc096 = async (value)=>{
    try {
        await (0, $cm5m0.userPreferenceAPI).set((0, $8QZQG.CUSTOM_NAV_BAR_COLORS_SECTION_MESSAGE_DISMISSED_KEY), value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $guiFP.default)({
            error: err,
            meta: {
                id: 'setCustomTopNavDarkModeDismissed',
                packageName: 'jiraCustomNavBarColorsFlag'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});
parcelRegister("cm5m0", function(module, exports) {

$parcel$export(module.exports, "userPreferenceAPI", () => $65cd88220f00e257$export$4f7929ca6b50a436);


var $lRmyA = parcelRequire("lRmyA");
const $65cd88220f00e257$var$url = (key)=>`/rest/api/3/mypreferences?key=${key}`;
const $65cd88220f00e257$var$get = async (key)=>{
    try {
        const result = await (0, $lRmyA.performGetRequest)($65cd88220f00e257$var$url(key));
        return result?.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef)) return null;
        throw error;
    }
};
const $65cd88220f00e257$var$set = (key, value)=>(0, $lRmyA.performPutRequest)($65cd88220f00e257$var$url(key), {
        body: JSON.stringify({
            value: value
        })
    });
const $65cd88220f00e257$var$remove = (key)=>(0, $lRmyA.performDeleteRequest)($65cd88220f00e257$var$url(key));
const $65cd88220f00e257$export$4f7929ca6b50a436 = {
    get: $65cd88220f00e257$var$get,
    set: $65cd88220f00e257$var$set,
    remove: $65cd88220f00e257$var$remove
};

});
const $1c3fbb431a173cc6$export$ff39ebd4bb12b718 = 201;
const $1c3fbb431a173cc6$export$3288b14b6745c572 = 204;
const $1c3fbb431a173cc6$export$9de493bcd9b1d977 = 400;
const $1c3fbb431a173cc6$export$67d19e9a991baa07 = 401;
const $1c3fbb431a173cc6$export$a3269a3914b007e3 = 403;
const $1c3fbb431a173cc6$export$8bca792d963eb0ef = 404;
const $1c3fbb431a173cc6$export$4a3cb39801694eee = 407;
const $1c3fbb431a173cc6$export$fa405bbf47d510e2 = 408;
const $1c3fbb431a173cc6$export$c09e7ea0fc79f34f = 409;
const $1c3fbb431a173cc6$export$5244030134e99 = 412;
const $1c3fbb431a173cc6$export$f90ac1df0b60853d = 413;
const $1c3fbb431a173cc6$export$a447d0a965e16776 = 422;
const $1c3fbb431a173cc6$export$3b48aba8957000cd = 426;
const $1c3fbb431a173cc6$export$6763168a631449a2 = 429;
const $1c3fbb431a173cc6$export$e813cd7045fcc98d = 500;
const $1c3fbb431a173cc6$export$2ce38d41a306034e = 502;
const $1c3fbb431a173cc6$export$974c37534b0191b1 = 503;
const $1c3fbb431a173cc6$export$5400e8dddac3fcf3 = 504;





parcelRegister("1RtwN", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d787d5507bd4e01$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2bv8J = parcelRequire("2bv8J");


var $kQ0RL = parcelRequire("kQ0RL");

var $3QLcd = parcelRequire("3QLcd");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $8QZQG = parcelRequire("8QZQG");

var $4qU4R = parcelRequire("4qU4R");
const $2d787d5507bd4e01$export$e5995f97d3b9e5eb = 'router-resources.theme-preference.custom-nav-bar-colors-flag';
const $2d787d5507bd4e01$var$CustomNavBarColorsFlag = ({ onDismiss: onDismiss, analyticsAttributes: analyticsAttributes })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onOpenInProductHelpArticle = (0, $3QLcd.useHelpPanelLink)();
    const onDismissFn = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'customTopNavUserFlagWarningDismissButton', analyticsAttributes);
        onDismiss();
    }, [
        onDismiss,
        analyticsAttributes
    ]);
    return (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.InfoFlag), {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
                primaryColor: `var(--ds-icon-information, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
                label: ""
            }),
            testId: $2d787d5507bd4e01$export$e5995f97d3b9e5eb,
            id: (0, $8QZQG.CUSTOM_NAV_BAR_COLORS_FLAG_ID),
            title: formatMessage((0, $4qU4R.default).title),
            description: formatMessage((0, $4qU4R.default).description),
            onDismissed: onDismissFn,
            actions: [
                {
                    content: formatMessage((0, $4qU4R.default).learnMoreAction),
                    onClick: (_, analyticsEvent)=>{
                        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'customTopNavUserFlagWarningMoreButton', analyticsAttributes);
                        onOpenInProductHelpArticle?.((0, $8QZQG.HELP_ARTICLE_ID));
                    }
                },
                {
                    content: formatMessage((0, $4qU4R.default).dismissAction),
                    onClick: onDismissFn
                }
            ]
        }), [
        formatMessage,
        onDismissFn,
        onOpenInProductHelpArticle,
        analyticsAttributes
    ]);
};
var $2d787d5507bd4e01$export$2e2bcd8739ae039 = $2d787d5507bd4e01$var$CustomNavBarColorsFlag;

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintJiraCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("bmR0P")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintJiraCommonFlag = (0, $7rh0R.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("bmR0P")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("5L0Jp", function(module, exports) {

$parcel$export(module.exports, "FlagsBoundary", () => $3e0b01ebb413784c$export$8b4a0fffcddd96f4);

var $eUqFw = parcelRequire("eUqFw");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");
const $3e0b01ebb413784c$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "flags",
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "flags-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, children));

});

parcelRegister("bmR0P", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("eNmuD"),
    $d1Cng("hPzOn"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cCYJs")
]).then(()=>parcelRequire('kbpOk'));

});

parcelRegister("eWPgg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hkLGi").then(()=>parcelRequire('jkRT2'));

});


parcelRegister("3QLcd", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $82adde900735644c$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "default", () => $82adde900735644c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $cEaY5 = parcelRequire("cEaY5");

var $zcJ0y = parcelRequire("zcJ0y");

var $1ybV0 = parcelRequire("1ybV0");

var $f2Poq = parcelRequire("f2Poq");

var $1zRTT = parcelRequire("1zRTT");

var $bUi2Q = parcelRequire("bUi2Q");
const $82adde900735644c$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $1zRTT.useHelpPanelActions)();
    const isIphEnabled = (0, $1ybV0.ff)('iph.enabled') && !(0, $zcJ0y.isIE11)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $f2Poq.HELP_PANEL_ID), (0, $f2Poq.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            }
        });
    };
    return isIphEnabled ? handleOnClick : undefined;
};
const $82adde900735644c$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, ...props })=>{
    const onOpenInProductHelpArticle = $82adde900735644c$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle?.(articleId, (0, $cEaY5.ARTICLE_TYPE)[type]);
    };
    return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $7JEyt.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fallbackComponent);
};
var $82adde900735644c$export$2e2bcd8739ae039 = $82adde900735644c$var$HelpPanelLink;
const $82adde900735644c$var$buttonWrapperStyles = null;

});
parcelRegister("f2Poq", function(module, exports) {

$parcel$export(module.exports, "HELP_PANEL_VERSION", () => $482b44340b421724$export$c43c7444da662fa1);
$parcel$export(module.exports, "HELP_PANEL_ID", () => $482b44340b421724$export$e99efa3985fa3c26);
$parcel$export(module.exports, "HELP_PANEL_WIDTH", () => $482b44340b421724$export$23aa6670f346c214);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $c9TLT = parcelRequire("c9TLT");
const $482b44340b421724$export$c43c7444da662fa1 = '1';
const $482b44340b421724$export$e99efa3985fa3c26 = 'helpPanel';
const $482b44340b421724$export$23aa6670f346c214 = (0, $c9TLT.gridSize) * 46;

});

parcelRegister("1zRTT", function(module, exports) {

$parcel$export(module.exports, "useHelpPanel", () => $6594f144c6f69b94$export$3fe94d66377a53b8);
$parcel$export(module.exports, "useHelpPanelActions", () => $6594f144c6f69b94$export$c61f56f4797e22db);

var $WBLbN = parcelRequire("WBLbN");

var $kEkov = parcelRequire("kEkov");
const $6594f144c6f69b94$export$3fe94d66377a53b8 = (0, $WBLbN.createHook)((0, $kEkov.default));
const $6594f144c6f69b94$export$c61f56f4797e22db = (0, $WBLbN.createHook)((0, $kEkov.default), {
    selector: null
});
const $6594f144c6f69b94$export$513717a84f55db1a = (0, $WBLbN.createSubscriber)((0, $kEkov.default), {
    displayName: 'HelpPanelSubscriber'
});
const $6594f144c6f69b94$export$5f4de38bd79f4446 = (0, $WBLbN.createSubscriber)((0, $kEkov.default), {
    displayName: 'HelpPanelActionsSubscriber',
    selector: null
});

});
parcelRegister("kEkov", function(module, exports) {

$parcel$export(module.exports, "default", () => $4af29a8a37667189$export$2e2bcd8739ae039);

var $89bO2 = parcelRequire("89bO2");

var $WBLbN = parcelRequire("WBLbN");

var $47e0j = parcelRequire("47e0j");
const $4af29a8a37667189$var$iphStorage = (0, $89bO2.createSessionStorageProvider)('iph');
const $4af29a8a37667189$var$initialState = {
    navigationData: {
        // @ts-expect-error - TS2322 - Type '"HELP_ARTICLE"' is not assignable to type 'ARTICLE_TYPE'.
        articleId: {
            id: '',
            type: 'HELP_ARTICLE'
        },
        history: $4af29a8a37667189$var$iphStorage.get('history') || []
    },
    releaseNotesNotifications: 100
};
var $4af29a8a37667189$export$2e2bcd8739ae039 = (0, $WBLbN.createStore)({
    name: 'help-panel',
    initialState: $4af29a8a37667189$var$initialState,
    actions: $47e0j
});

});
parcelRegister("47e0j", function(module, exports) {

$parcel$export(module.exports, "setNavigationData", () => $a35d570ea28382ca$export$ab1b80f40ca898ed);
$parcel$export(module.exports, "setReleaseNotesNotifications", () => $a35d570ea28382ca$export$cdabe01d01a8da1e);

var $89bO2 = parcelRequire("89bO2");
const $a35d570ea28382ca$var$iphStorage = (0, $89bO2.createSessionStorageProvider)('iph');
const $a35d570ea28382ca$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            navigationData: {
                articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                history: navigationData.history ? navigationData.history : currentState.navigationData.history
            }
        });
        $a35d570ea28382ca$var$iphStorage.set('history', []);
    };
const $a35d570ea28382ca$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
        setState({
            releaseNotesNotifications: releaseNotesNotifications
        });
    };

});



parcelRegister("bUi2Q", function(module, exports) {

$parcel$export(module.exports, "useActiveRightSidebarState", () => $09e77c9f3f7f26ec$export$ba763ab7661c3103);
$parcel$export(module.exports, "useRightSidebarState", () => $09e77c9f3f7f26ec$export$d1828e7f46a4960b);
$parcel$export(module.exports, "useRightSidebarController", () => $09e77c9f3f7f26ec$export$ebe5e907fb0bb63a);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");

var $hqpfO = parcelRequire("hqpfO");

var $53ucm = parcelRequire("53ucm");
const $09e77c9f3f7f26ec$var$useActiveRightSidebar = (0, $WBLbN.createHook)((0, $53ucm.layoutStore), {
    selector: (state)=>{
        const rightSidebarState = (0, $hqpfO.selectCurrentRightSidebar)(state.content.rightSidebar);
        if (!rightSidebarState) return null;
        return {
            ...rightSidebarState,
            shouldRender: !state.isChromeless
        };
    }
});
const $09e77c9f3f7f26ec$export$ba763ab7661c3103 = ()=>{
    const [rightSidebar] = $09e77c9f3f7f26ec$var$useActiveRightSidebar();
    return rightSidebar;
};
const $09e77c9f3f7f26ec$var$useRightSidebar = (0, $WBLbN.createHook)((0, $53ucm.layoutStore), {
    selector: (state)=>state.content.rightSidebar
});
const $09e77c9f3f7f26ec$export$d1828e7f46a4960b = ()=>{
    const [rightSidebarState] = $09e77c9f3f7f26ec$var$useRightSidebar();
    return rightSidebarState;
};
const $09e77c9f3f7f26ec$export$ebe5e907fb0bb63a = ()=>{
    const [, { setRightSidebarState: setRightSidebarState, openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar, closeAllRightSidebar: closeAllRightSidebar, minimiseRightSidebar: minimiseRightSidebar }] = (0, $53ucm.useLayoutStoreActions)();
    return (0, $eUqFw.useMemo)(()=>({
            setRightSidebarState: setRightSidebarState,
            closeRightSidebar: closeRightSidebar,
            openRightSidebar: openRightSidebar,
            closeCurrentRightSidebar: closeCurrentRightSidebar,
            closeAllRightSidebar: closeAllRightSidebar,
            minimiseRightSidebar: minimiseRightSidebar
        }), [
        closeAllRightSidebar,
        closeCurrentRightSidebar,
        closeRightSidebar,
        openRightSidebar,
        setRightSidebarState,
        minimiseRightSidebar
    ]);
};

});
parcelRegister("hqpfO", function(module, exports) {

$parcel$export(module.exports, "selectCurrentRightSidebar", () => $bea3cfbec26c4bd1$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $bea3cfbec26c4bd1$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $bea3cfbec26c4bd1$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $bea3cfbec26c4bd1$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $bea3cfbec26c4bd1$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $bea3cfbec26c4bd1$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $bea3cfbec26c4bd1$export$c8dafe074328c4ca);

var $hTLlD = parcelRequire("hTLlD");
const $bea3cfbec26c4bd1$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $bea3cfbec26c4bd1$var$dedupe = (stackState = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $bea3cfbec26c4bd1$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $bea3cfbec26c4bd1$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $bea3cfbec26c4bd1$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $bea3cfbec26c4bd1$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $bea3cfbec26c4bd1$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});

parcelRegister("53ucm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $775b7b0f5d2674bd$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $775b7b0f5d2674bd$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $775b7b0f5d2674bd$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $775b7b0f5d2674bd$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $775b7b0f5d2674bd$export$99e05a60cac05e86);

var $WBLbN = parcelRequire("WBLbN");

var $3roBA = parcelRequire("3roBA");
const $775b7b0f5d2674bd$export$539e68c09584883a = 240;
const $775b7b0f5d2674bd$export$b92df8810d2fcd01 = 0;
const $775b7b0f5d2674bd$var$initialState = {
    isChromeless: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $775b7b0f5d2674bd$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false
        },
        rightSidebar: {
            stackState: []
        }
    }
};
const $775b7b0f5d2674bd$export$b8cdfd44cddaf07 = (0, $WBLbN.createStore)({
    initialState: $775b7b0f5d2674bd$var$initialState,
    actions: $3roBA.actions,
    name: 'JiraLayoutStore'
});
const $775b7b0f5d2674bd$export$6136bc3b9858cff4 = (0, $WBLbN.createHook)($775b7b0f5d2674bd$export$b8cdfd44cddaf07, {
    selector: null
});
const $775b7b0f5d2674bd$var$detailPanelWidthStore = (0, $WBLbN.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $775b7b0f5d2674bd$export$95fd7b6da3b9bbb0 = (0, $WBLbN.createHook)($775b7b0f5d2674bd$var$detailPanelWidthStore);
const $775b7b0f5d2674bd$export$99e05a60cac05e86 = (0, $WBLbN.createActionsHook)($775b7b0f5d2674bd$var$detailPanelWidthStore);

});
parcelRegister("3roBA", function(module, exports) {

$parcel$export(module.exports, "actions", () => $7de3ed8fccc77236$export$e324594224ef24da);

var $3OanE = parcelRequire("3OanE");

var $gDr9R = parcelRequire("gDr9R");

var $aoZTG = parcelRequire("aoZTG");

var $f9nrb = parcelRequire("f9nrb");

var $hqpfO = parcelRequire("hqpfO");
const $7de3ed8fccc77236$export$e324594224ef24da = {
    setIsChromeless: // global
    $aoZTG.setIsChromeless,
    showBanner: // banner
    $3OanE.showBanner,
    dismissCurrentBanner: $3OanE.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $f9nrb.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $hqpfO.setRightSidebarState,
    openRightSidebar: $hqpfO.openRightSidebar,
    closeRightSidebar: $hqpfO.closeRightSidebar,
    closeAllRightSidebar: $hqpfO.closeAllRightSidebar,
    closeCurrentRightSidebar: $hqpfO.closeCurrentRightSidebar,
    minimiseRightSidebar: $hqpfO.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $gDr9R.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $gDr9R.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $gDr9R.removeBottomRightCornerPortal
};

});
parcelRegister("3OanE", function(module, exports) {

$parcel$export(module.exports, "showBanner", () => $1ca96d140cb009a0$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $1ca96d140cb009a0$export$a45bccc0cc9ac424);
const $1ca96d140cb009a0$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $1ca96d140cb009a0$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($1ca96d140cb009a0$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("gDr9R", function(module, exports) {

$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $ce70661c3da7d088$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $ce70661c3da7d088$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $ce70661c3da7d088$export$928bf7e228ce06d2);
const $ce70661c3da7d088$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $ce70661c3da7d088$export$3ed25a6bee272520 = (item)=>// @ts-expect-error - TS2322 - Type '({ setState, getState }: StoreActionApi<LayoutState>) => number' is not assignable to type 'Action<LayoutState, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $ce70661c3da7d088$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("aoZTG", function(module, exports) {

$parcel$export(module.exports, "setIsChromeless", () => $1199e64f89ce3554$export$1998c4816ad37edb);
const $1199e64f89ce3554$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("f9nrb", function(module, exports) {

$parcel$export(module.exports, "setLeftSidebarState", () => $a9b20025b1de3529$export$3e0fd2d894ef83c8);
const $a9b20025b1de3529$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});





parcelRegister("4qU4R", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3307406a0d38c29$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e3307406a0d38c29$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "custom-nav-bar-colors-flag.title",
        "defaultMessage": "Your top navigation menu has custom colors"
    },
    description: {
        "id": "custom-nav-bar-colors-flag.description",
        "defaultMessage": "If the color of your navigation menu doesn't look right in this theme, notify your Jira admin."
    },
    learnMoreAction: {
        "id": "custom-nav-bar-colors-flag.learn-more-action",
        "defaultMessage": "Learn more"
    },
    dismissAction: {
        "id": "custom-nav-bar-colors-flag.dismiss-action",
        "defaultMessage": "Dismiss"
    }
});

});



parcelRegister("3MEW8", function(module, exports) {

$parcel$export(module.exports, "themePreferenceResource", () => $aa9979c4bb771fd9$export$e5a423d1eb1cf1d0);
$parcel$export(module.exports, "useThemePreference", () => $aa9979c4bb771fd9$export$3416635c8aeb5bab);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");


var $YWIXh = parcelRequire("YWIXh");

const $aa9979c4bb771fd9$var$getDataLoader = ()=>(parcelRequire("6OpTH"));
const $aa9979c4bb771fd9$export$e5a423d1eb1cf1d0 = (0, $6xFTe.createResource)({
    type: 'RESOURCE_THEME_PREFERENCE',
    getKey: ()=>'state',
    getDataLoader: $aa9979c4bb771fd9$var$getDataLoader,
    maxAge: 300000
});
const $aa9979c4bb771fd9$export$3416635c8aeb5bab = ()=>{
    const { data: data, update: updateThemePreferenceResource } = (0, $h5RgW.useResource)($aa9979c4bb771fd9$export$e5a423d1eb1cf1d0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireThemeAnalytics = (0, $eUqFw.useCallback)((current, next)=>{
        const OStheme = window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const analyticsEvent = createAnalyticsEvent({
            action: (0, $6f1b3f4a1b1409cf$export$89c5cf64ad15c3ea),
            actionSubject: (0, $6f1b3f4a1b1409cf$export$9e2cc65718a61846)
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
            newPreference: next,
            oldPreference: current,
            OStheme: OStheme
        });
    }, [
        createAnalyticsEvent
    ]);
    const setTheme = (0, $eUqFw.useCallback)(async (theme)=>{
        updateThemePreferenceResource(()=>({
                theme: theme
            }));
        if (data?.theme !== theme) {
            fireThemeAnalytics(data?.theme, theme);
            await (0, $YWIXh.setThemePreference)(theme);
        }
    }, [
        data?.theme,
        updateThemePreferenceResource,
        fireThemeAnalytics
    ]);
    return {
        theme: data?.theme,
        setTheme: setTheme
    };
};

});
const $6f1b3f4a1b1409cf$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $6f1b3f4a1b1409cf$export$9e2cc65718a61846 = 'themePreference';
const $6f1b3f4a1b1409cf$export$89c5cf64ad15c3ea = 'changed';

parcelRegister("YWIXh", function(module, exports) {

$parcel$export(module.exports, "setThemePreference", () => $31ba3788a5049b63$export$a6b84eebd33787e2);
$parcel$export(module.exports, "getThemePreference", () => $31ba3788a5049b63$export$2f7a12048d96237);

var $eM3G3 = parcelRequire("eM3G3");

var $guiFP = parcelRequire("guiFP");

var $cm5m0 = parcelRequire("cm5m0");

const $31ba3788a5049b63$export$a6b84eebd33787e2 = (theme)=>{
    const promise = (0, $cm5m0.userPreferenceAPI).set((0, $6f1b3f4a1b1409cf$export$40bd77e1c9f49c27), theme);
    promise.catch((error)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'put',
                errName: String(error.name),
                statusCode: error.statusCode,
                param: `to:${theme}`
            }
        });
    });
    return promise;
};
const $31ba3788a5049b63$export$2f7a12048d96237 = async ()=>{
    const promise = (0, $cm5m0.userPreferenceAPI).get((0, $6f1b3f4a1b1409cf$export$40bd77e1c9f49c27));
    promise.catch((error)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'get',
                errName: String(error.name),
                statusCode: error.statusCode
            }
        });
    });
    promise.then((theme)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (theme && !(0, $eM3G3.ThemeOptions).includes(theme)) // very unlikely but…
        (0, $guiFP.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: new Error('Unrecognized theme!'),
            attributes: {
                op: 'get',
                theme: theme,
                errName: 'unrecognized value!'
            }
        });
    });
    const theme = await promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return theme && (0, $eM3G3.ThemeOptions).includes(theme) ? theme : undefined;
};

});

parcelRegister("6OpTH", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("8mnLk")
]).then(()=>parcelRequire('foRwS'));

});


parcelRegister("3OmVR", function(module, exports) {

$parcel$export(module.exports, "messages", () => $23a2f9838c191bc0$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $23a2f9838c191bc0$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    commandLightTheme: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.command-light-theme",
        "defaultMessage": "Switch to light theme"
    },
    commandDarkTheme: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.command-dark-theme",
        "defaultMessage": "Switch to dark theme"
    },
    commandAutoTheme: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.command-auto-theme",
        "defaultMessage": "Match system theme"
    },
    themeKeywords: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.theme-keywords-no-translate",
        "defaultMessage": "switch to dark theme switch to light theme dark mode light mode change appearance change colors night mode day mode theme dark switch theme light switch theme switch switch theme appearance change colors change"
    },
    themeKeywordsMisspelt: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.theme-keywords-misspelt-no-translate",
        "defaultMessage": "lite theme darkmode lightmode nightmode daymode change colours change"
    },
    autoThemeKeywords: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.auto-theme-keywords-no-translate",
        "defaultMessage": "match system theme sync to system settings dark mode light mode change appearance change colors night mode day mode system theme match match theme system sync theme to system system theme sync theme dark switch theme light switch theme switch appearance change colors change"
    },
    autoThemeKeywordsMisspelt: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.auto-theme-keywords-misspelt-no-translate",
        "defaultMessage": "match sistem theme sinc system theme matxh system theme match sytem theme darkmode lightmode nightmode daymode change colours change"
    }
});

});





//# sourceMappingURL=async-command-palette-integration.ae0c33e3.js.map
